// This file is auto-generated by @hey-api/openapi-ts

import {
  type DefaultError,
  type InfiniteData,
  type UseMutationOptions,
  infiniteQueryOptions,
  queryOptions
} from '@tanstack/react-query'

import { client as _heyApiClient } from '../client.gen'
import {
  type Options,
  attachmentsCreateSignedUrlCreate,
  attachmentsDestroy,
  attachmentsList,
  attachmentsPartialUpdate,
  attachmentsRetrieve,
  attachmentsUpdate,
  attachmentsUpdateSignedUrlCreate,
  attachmentsVersionDestroy,
  attachmentsVersionRetrieve,
  branchesListList,
  callsCreate,
  callsDestroy,
  callsList,
  callsPartialUpdate,
  callsRetrieve,
  callsSubscriptionNotificationCreate,
  callsTriggerSubscribeCreate,
  callsUpdate,
  citiesList,
  citiesListList,
  citiesRetrieve,
  clientsContactsList,
  clientsContactsRetrieve,
  clientsContractsList,
  clientsContractsRetrieve,
  clientsOpportunitiesList,
  clientsOpportunitiesCreate,
  clientsOpportunitiesDestroy,
  clientsOpportunitiesRetrieve,
  clientsOpportunitiesPartialUpdate,
  clientsOpportunitiesUpdate,
  clientsTasksList,
  clientsTasksCreate,
  clientsTasksDestroy,
  clientsTasksRetrieve,
  clientsTasksPartialUpdate,
  clientsTasksUpdate,
  clientsRetrieve,
  clientsImportContractCreate,
  clientsLeadsList,
  clientsLeadsRetrieve,
  clientsList,
  clientsLogsList,
  clientsLogsRetrieve,
  clientStatusesList,
  clientStatusesListList,
  clientStatusesRetrieve,
  companySizesCreate,
  companySizesDestroy,
  companySizesList,
  companySizesListList,
  companySizesPartialUpdate,
  companySizesRetrieve,
  companySizesUpdate,
  connectorsBulkAddContactsCreate,
  connectorsListList,
  connectorsOptionsRetrieve,
  contactsConnectionsRetrieve,
  contactsCreate,
  contactsDestroy,
  contactsInitCallCreate,
  contactsList,
  contactsPartialUpdate,
  contactsPhoneNumbersCreate,
  contactsPhoneNumbersDestroy,
  contactsPhoneNumbersList,
  contactsPhoneNumbersPartialUpdate,
  contactsPhoneNumbersRetrieve,
  contactsPhoneNumbersUpdate,
  contactsRetrieve,
  contactsUpdate,
  contractsCreate,
  contractsDestroy,
  contractsFetchSiAsigCreate,
  contractsList,
  contractsPartialUpdate,
  contractsRetrieve,
  contractsUpdate,
  countriesContinentsList,
  countriesCreate,
  countriesDestroy,
  countriesList,
  countriesListList,
  countriesPartialUpdate,
  countriesRetrieve,
  countriesUpdate,
  currenciesCreate,
  currenciesDestroy,
  currenciesList,
  currenciesListList,
  currenciesPartialUpdate,
  currenciesRetrieve,
  currenciesUpdate,
  customFieldsCreate,
  customFieldsDestroy,
  customFieldsList,
  customFieldsPartialUpdate,
  customFieldsRetrieve,
  customFieldsUndeletePartialUpdate,
  customFieldsUpdate,
  dashboardLeadsList,
  dashboardReportsChartList,
  dashboardSalesReportList,
  dashboardTasksRetrieve,
  dashboardTopExpertsList,
  documentCategoriesCreate,
  documentCategoriesDestroy,
  documentCategoriesList,
  documentCategoriesListList,
  documentCategoriesPartialUpdate,
  documentCategoriesRetrieve,
  documentCategoriesUpdate,
  documentsBulkCreateCreate,
  documentsCreate,
  documentsDestroy,
  documentsList,
  documentsListList,
  documentsPartialUpdate,
  documentsRetrieve,
  documentsUpdate,
  expensesCreate,
  expensesList,
  healthRetrieve,
  industriesCreate,
  industriesDestroy,
  industriesList,
  industriesPartialUpdate,
  industriesUpdate,
  industriesListList,
  industriesRetrieve,
  industriesSubIndustriesCreate,
  industriesSubIndustriesDestroy,
  industriesSubIndustriesList,
  industriesSubIndustriesListList,
  industriesSubIndustriesPartialUpdate,
  industriesSubIndustriesRetrieve,
  industriesSubIndustriesUpdate,
  informationCreate,
  informationDestroy,
  informationList,
  informationListList,
  informationPartialUpdate,
  informationRetrieve,
  informationUpdate,
  integrationsGmailAuthCallbackCreate,
  integrationsGmailAuthUrlRetrieve,
  integrationsGmailCheckMailboxRetrieve,
  integrationsGmailCreate,
  integrationsGmailDestroy,
  integrationsGmailList,
  integrationsGmailListList,
  integrationsGmailLogoutMailboxCreate,
  integrationsGmailPartialUpdate,
  integrationsGmailRetrieve,
  integrationsGmailUpdate,
  integrationsMessengerAuthCallbackCreate,
  integrationsMessengerAuthUrlRetrieve,
  integrationsMessengerCheckMailboxRetrieve,
  integrationsMessengerCreate,
  integrationsMessengerDestroy,
  integrationsMessengerList,
  integrationsMessengerListList,
  integrationsMessengerLogoutMailboxCreate,
  integrationsMessengerPartialUpdate,
  integrationsMessengerRetrieve,
  integrationsMessengerUpdate,
  integrationsWhatsappConfigCreate,
  integrationsWhatsappConfigDestroy,
  integrationsWhatsappConfigList,
  integrationsWhatsappConfigPartialUpdate,
  integrationsWhatsappConfigRetrieve,
  integrationsWhatsappConfigTestCreate,
  integrationsWhatsappConfigUpdate,
  integrationsWhatsappMessagesList,
  integrationsWhatsappMessagesRetrieve,
  integrationsWhatsappMessagesRetryCreate,
  integrationsWhatsappMessagesSendCreate,
  integrationsWhatsappMessageTemplatesList,
  integrationsWhatsappMessageTemplatesSyncCreate,
  internalCitiesList,
  internalCitiesListList,
  internalCitiesRetrieve,
  internalCompanySizesCreate,
  internalCompanySizesDestroy,
  internalCompanySizesList,
  internalCompanySizesListList,
  internalCompanySizesPartialUpdate,
  internalCompanySizesRetrieve,
  internalCompanySizesUpdate,
  internalContactsConnectionsRetrieve,
  internalContactsCreate,
  internalContactsDestroy,
  internalContactsInitCallCreate,
  internalContactsList,
  internalContactsPartialUpdate,
  internalContactsPhoneNumbersCreate,
  internalContactsPhoneNumbersDestroy,
  internalContactsPhoneNumbersList,
  internalContactsPhoneNumbersPartialUpdate,
  internalContactsPhoneNumbersRetrieve,
  internalContactsPhoneNumbersUpdate,
  internalContactsRetrieve,
  internalContactsUpdate,
  internalCountriesContinentsList,
  internalCountriesCreate,
  internalCountriesDestroy,
  internalCountriesList,
  internalCountriesListList,
  internalCountriesPartialUpdate,
  internalCountriesRetrieve,
  internalCountriesUpdate,
  internalCurrenciesCreate,
  internalCurrenciesDestroy,
  internalCurrenciesList,
  internalCurrenciesListList,
  internalCurrenciesPartialUpdate,
  internalCurrenciesRetrieve,
  internalCurrenciesUpdate,
  internalIndustriesCreate,
  internalIndustriesDestroy,
  internalIndustriesList,
  internalIndustriesPartialUpdate,
  internalIndustriesUpdate,
  internalIndustriesListList,
  internalIndustriesRetrieve,
  internalIndustriesSubIndustriesCreate,
  internalIndustriesSubIndustriesDestroy,
  internalIndustriesSubIndustriesList,
  internalIndustriesSubIndustriesListList,
  internalIndustriesSubIndustriesPartialUpdate,
  internalIndustriesSubIndustriesRetrieve,
  internalIndustriesSubIndustriesUpdate,
  internalLeadsCreate,
  internalLeadsTypesList,
  internalLeadsTypesCreate,
  internalLeadsTypesDestroy,
  internalLeadsTypesRetrieve,
  internalLeadsTypesPartialUpdate,
  internalLeadsTypesUpdate,
  internalLeadsTypesListList,
  internalLeadsDestroy,
  internalLeadsList,
  internalLeadsPartialUpdate,
  internalLeadsUpdate,
  internalLeadsListList,
  internalLeadsRetrieve,
  internalLeadsStatusesCreate,
  internalLeadsStatusesDestroy,
  internalLeadsStatusesList,
  internalLeadsStatusesListList,
  internalLeadsStatusesPartialUpdate,
  internalLeadsStatusesRetrieve,
  internalLeadsStatusesUpdate,
  internalLogsCreate,
  internalLogsList,
  internalLogsRetrieve,
  internalOpportunitiesCreate,
  internalOpportunitiesDestroy,
  internalOpportunitiesPartialUpdate,
  internalOpportunitiesRetrieve,
  internalOpportunitiesStatusesCreate,
  internalOpportunitiesStatusesDestroy,
  internalOpportunitiesStatusesList,
  internalOpportunitiesStatusesListList,
  internalOpportunitiesStatusesPartialUpdate,
  internalOpportunitiesStatusesRetrieve,
  internalOpportunitiesStatusesUpdate,
  internalOpportunitiesUpdate,
  internalProductsCreate,
  internalProductsDestroy,
  internalProductsList,
  internalProductsListList,
  internalProductsPartialUpdate,
  internalProductsRetrieve,
  internalProductsUpdate,
  internalReasonsCreate,
  internalReasonsDestroy,
  internalReasonsList,
  internalReasonsListList,
  internalReasonsPartialUpdate,
  internalReasonsRetrieve,
  internalReasonsUpdate,
  internalRegionsList,
  internalRegionsListList,
  internalRegionsRetrieve,
  internalSequencesAddLeadsCreate,
  internalSequencesCreate,
  internalSequencesDestroy,
  internalSequencesDuplicateRetrieve,
  internalSequencesList,
  internalSequencesListList,
  internalSequencesPartialUpdate,
  internalSequencesRetrieve,
  internalSequencesUpdate,
  internalSourcesCreate,
  internalSourcesDestroy,
  internalSourcesList,
  internalSourcesListList,
  internalSourcesPartialUpdate,
  internalSourcesRetrieve,
  internalSourcesUpdate,
  internalTagsColorsRetrieve,
  internalTagsCreate,
  internalTagsDestroy,
  internalTagsList,
  internalTagsListList,
  internalTagsPartialUpdate,
  internalTagsRetrieve,
  internalTagsUpdate,
  internalTaskTypesAllRetrieve,
  internalTaskTypesCreate,
  internalTaskTypesDestroy,
  internalTaskTypesList,
  internalTaskTypesListList,
  internalTaskTypesPartialUpdate,
  internalTaskTypesRetrieve,
  internalTaskTypesUpdate,
  invoicesChangeStatusPartialUpdate,
  invoicesResendEmailRetrieve,
  invoicesContractorsCreate,
  invoicesCreate,
  invoicesDestroy,
  invoicesDownloadRetrieve,
  invoicesEmailRetrieve,
  invoicesList,
  invoicesPartialUpdate,
  invoicesReportsExportCreate,
  invoicesReportsRetrieve,
  invoicesRetrieve,
  invoicesSettingsCreate,
  invoicesSettingsRetrieve,
  invoicesUpdate,
  leadGenerationCampaignsList,
  leadGenerationCampaignsPartialUpdate,
  leadGenerationCampaignsRetrieve,
  leadGenerationCampaignsRunsList,
  leadGenerationCampaignsTriggerCreate,
  leadGenerationRunsRetrieve,
  leadsList,
  leadsCreate,
  leadsImportList,
  leadsImportCreate,
  leadsImportDestroy,
  leadsImportRetrieve,
  leadsImportPartialUpdate,
  leadsImportUpdate,
  leadsImportColumnUniqueValuesRetrieve,
  leadsImportPreviewRetrieve,
  leadsImportHeadersRetrieve,
  leadsImportUniqueFieldsRetrieve,
  leadsStatusesList,
  leadsStatusesCreate,
  leadsStatusesDestroy,
  leadsStatusesRetrieve,
  leadsStatusesPartialUpdate,
  leadsStatusesUpdate,
  leadsStatusesListList,
  leadsTypesList,
  leadsTypesCreate,
  leadsTypesLeadsStatusesList,
  leadsTypesLeadsStatusesCreate,
  leadsTypesLeadsStatusesDestroy,
  leadsTypesLeadsStatusesRetrieve,
  leadsTypesLeadsStatusesPartialUpdate,
  leadsTypesLeadsStatusesUpdate,
  leadsTypesLeadsStatusesListList,
  leadsTypesDestroy,
  leadsTypesRetrieve,
  leadsTypesPartialUpdate,
  leadsTypesUpdate,
  leadsTypesListList,
  leadsContactsList,
  leadsContractsList,
  leadsDocumentsList,
  leadsLogsList,
  leadsOpportunitiesList,
  leadsSequencesList,
  leadsSequencesCreate,
  leadsSequencesDestroy,
  leadsSequencesRetrieve,
  leadsSequencesPartialUpdate,
  leadsSequencesUpdate,
  leadsTasksList,
  leadsDestroy,
  leadsRetrieve,
  leadsPartialUpdate,
  leadsUpdate,
  leadsConvertToClientCreate,
  leadsInvoiceContactsRetrieve,
  leadsInvoicesList,
  leadsMergePartialUpdate,
  leadsSimilarRetrieve,
  leadsUndeletePartialUpdate,
  leadsBulkAssigneePartialUpdate,
  leadsBulkDeleteCreate,
  leadsBulkSetBranchPartialUpdate,
  leadScoreCreate,
  leadScoreDestroy,
  leadScoreFieldsRetrieve,
  leadScoreList,
  leadScoreListList,
  leadScorePartialUpdate,
  leadScoreRetrieve,
  leadScoreUpdate,
  leadsDeletedList,
  leadsExportRetrieve,
  leadsListList,
  leadsPipelineList,
  leadsSetTagPartialUpdate,
  leadsViewedList,
  listViewsCreate,
  listViewsDestroy,
  listViewsFieldsRetrieve,
  listViewsList,
  listViewsPartialUpdate,
  listViewsResultList,
  listViewsRetrieve,
  listViewsUpdate,
  logsList,
  logsMeetingCreate,
  logsNoteCreate,
  logsRetrieve,
  mailboxesCheckMailboxRetrieve,
  mailboxesCreate,
  mailboxesDestroy,
  mailboxesList,
  mailboxesListList,
  mailboxesLoginRetrieve,
  mailboxesOauthLogoutCreate,
  mailboxesOauthLogoutLinkRetrieve,
  mailboxesOauthOutlookCreate,
  mailboxesOutlookLinkRetrieve,
  mailboxesPartialUpdate,
  mailboxesRetrieve,
  mailboxesSendEmailCreate,
  mailboxesTemplatesCreate,
  mailboxesTemplatesDestroy,
  mailboxesTemplatesList,
  mailboxesTemplatesPartialUpdate,
  mailboxesTemplatesRetrieve,
  mailboxesTemplatesUpdate,
  mailboxesUpdate,
  opportunitiesStatusesListList,
  opportunitiesContactsList,
  opportunitiesContractsList,
  opportunitiesDocumentsList,
  opportunitiesLogsList,
  opportunitiesTasksList,
  opportunitiesDestroy,
  opportunitiesRetrieve,
  opportunitiesPartialUpdate,
  opportunitiesUpdate,
  opportunitiesConvertToClientCreate,
  opportunitiesCreate,
  opportunitiesDuplicateCreate,
  opportunitiesList,
  opportunitiesMergePartialUpdate,
  opportunitiesPipelineList,
  opportunitiesPipelinesCreate,
  opportunitiesPipelinesStatusesCreate,
  opportunitiesPipelinesStatusesDestroy,
  opportunitiesPipelinesStatusesRetrieve,
  opportunitiesPipelinesStatusesPartialUpdate,
  opportunitiesPipelinesStatusesUpdate,
  opportunitiesPipelinesStatusesListList,
  opportunitiesPipelinesDestroy,
  opportunitiesPipelinesList,
  opportunitiesPipelinesPartialUpdate,
  opportunitiesPipelinesUpdate,
  opportunitiesPipelinesListList,
  opportunitiesPipelinesRetrieve,
  opportunitiesPipelinesStatusesList,
  opportunitiesProductsDestroy,
  opportunitiesProductsRetrieve,
  opportunitiesProductsPartialUpdate,
  opportunitiesProductsUpdate,
  opportunitiesProductsBulkCreateCreate,
  opportunitiesProductsBulkUpdatePartialUpdate,
  opportunitiesProductsCreate,
  opportunitiesProductsList,
  opportunitiesStatusesCreate,
  opportunitiesStatusesDestroy,
  opportunitiesStatusesList,
  opportunitiesStatusesPartialUpdate,
  opportunitiesStatusesRetrieve,
  opportunitiesStatusesUpdate,
  presetTasksCreate,
  presetTasksDestroy,
  presetTasksList,
  presetTasksPartialUpdate,
  presetTasksRetrieve,
  presetTasksUpdate,
  productsCategoriesCreate,
  productsCategoriesDestroy,
  productsCategoriesList,
  productsCategoriesUpdate,
  productsCategoriesListList,
  productsCategoriesPartialUpdate,
  productsCategoriesRetrieve,
  productsCreate,
  productsDestroy,
  productsList,
  productsListList,
  productsPartialUpdate,
  productsRetrieve,
  productsUnitsOfMeasureCreate,
  productsUnitsOfMeasureDestroy,
  productsUnitsOfMeasureList,
  productsUnitsOfMeasureListList,
  productsUnitsOfMeasurePartialUpdate,
  productsUnitsOfMeasureRetrieve,
  productsUnitsOfMeasureUpdate,
  productsUpdate,
  reasonsCreate,
  reasonsDestroy,
  reasonsList,
  reasonsListList,
  reasonsPartialUpdate,
  reasonsRetrieve,
  reasonsUpdate,
  regionsList,
  regionsListList,
  regionsRetrieve,
  reportsModelFieldsRetrieve,
  reportsTableRetrieve,
  reportsAggTypesRetrieve,
  reportsCallsReportsList,
  reportsChartRetrieve,
  reportsCountryWeightDiagramRetrieve,
  reportsCreate,
  reportsDemoChartList,
  reportsDestroy,
  reportsDuplicateCreate,
  reportsExportsList,
  reportsExportsRetrieve,
  reportsLeadChartList,
  reportsList,
  reportsOfflineReportsList,
  reportsOnlineReportsList,
  reportsPartialUpdate,
  reportsPhoneCallsChartList,
  reportsPreviewChartCreate,
  reportsPreviewTableCreate,
  reportsReasonWeightDiagramRetrieve,
  reportsRetrieve,
  reportsSalesFunnelList,
  reportsScoreWeightDiagramRetrieve,
  reportsSourcePageWeightDiagramRetrieve,
  reportsSourceWebsiteWeightDiagramRetrieve,
  reportsSourceWeightDiagramRetrieve,
  reportsStatusWeightDiagramRetrieve,
  reportsTopProductsCategoryDistributionExportCreate,
  reportsTopProductsCategoryDistributionRetrieve,
  reportsTopProductsExportCreate,
  reportsTopProductsRetrieve,
  reportsTypesRetrieve,
  reportsUpdate,
  schemaRetrieve,
  searchDynamicExportRetrieve,
  searchDynamicList,
  searchDynamicModelFieldsRetrieve,
  searchDynamicModelsRetrieve,
  searchList,
  seniorPositionsCreate,
  seniorPositionsDestroy,
  seniorPositionsJobPositionsCreate,
  seniorPositionsJobPositionsDestroy,
  seniorPositionsJobPositionsList,
  seniorPositionsJobPositionsListList,
  seniorPositionsJobPositionsPartialUpdate,
  seniorPositionsJobPositionsRetrieve,
  seniorPositionsJobPositionsUpdate,
  seniorPositionsList,
  seniorPositionsListList,
  seniorPositionsPartialUpdate,
  seniorPositionsRetrieve,
  seniorPositionsUpdate,
  sequencesAddLeadsCreate,
  sequencesCreate,
  sequencesDestroy,
  sequencesDuplicateRetrieve,
  sequencesLeadsList,
  sequencesList,
  sequencesStepsUpdate,
  sequencesStepsListList,
  sequencesListList,
  sequencesPartialUpdate,
  sequencesRetrieve,
  sequencesStepsCreate,
  sequencesStepsDestroy,
  sequencesStepsList,
  sequencesStepsPartialUpdate,
  sequencesStepsRetrieve,
  sequencesUpdate,
  settingsCreate,
  settingsRetrieve,
  sourcesCreate,
  sourcesDestroy,
  sourcesList,
  sourcesListList,
  sourcesPartialUpdate,
  sourcesRetrieve,
  sourcesUpdate,
  tagsColorsRetrieve,
  tagsCreate,
  tagsDestroy,
  tagsList,
  tagsListList,
  tagsPartialUpdate,
  tagsRetrieve,
  tagsUpdate,
  taskTypesCreate,
  taskTypesDestroy,
  taskTypesRetrieve,
  taskTypesPartialUpdate,
  taskTypesUpdate,
  taskTypesAllRetrieve,
  taskTypesGenericList,
  taskTypesListList,
  taskTypesSystemList,
  tasksList,
  tasksCreate,
  tasksDestroy,
  tasksRetrieve,
  tasksPartialUpdate,
  tasksUpdate,
  tasksCompleteCreate,
  tasksKanbanList,
  taskStatusesCreate,
  taskStatusesDestroy,
  taskStatusesList,
  taskStatusesListList,
  taskStatusesPartialUpdate,
  taskStatusesRetrieve,
  taskStatusesUpdate,
  taskTypesList,
  usersAllList,
  usersAllowedModulesRetrieve,
  usersList,
  usersListList,
  usersPartialUpdate,
  usersProfileRetrieve,
  usersUpdate,
  voipConfigurationCreate,
  voipConfigurationDestroy,
  voipConfigurationList,
  voipConfigurationPartialUpdate,
  voipConfigurationRetrieve,
  voipConfigurationStatusRetrieve,
  voipConfigurationUpdate,
  webhookLeadCreate,
  webhookMinioCreate,
  webhookTaskCreate,
  webhookVoipCreate,
  webhookWhatsappCreate,
  webhookWhatsappRetrieve,
  widgetsRetrieve
} from '../sdk.gen'

import type {
  AttachmentsUpdateSignedUrlCreateData,
  AttachmentsUpdateSignedUrlCreateResponse,
  AttachmentsVersionDestroyData,
  AttachmentsVersionDestroyResponse,
  AttachmentsVersionRetrieveData,
  AttachmentsCreateSignedUrlCreateData,
  AttachmentsCreateSignedUrlCreateResponse,
  AttachmentsDestroyData,
  AttachmentsDestroyResponse,
  AttachmentsListData,
  AttachmentsListResponse,
  AttachmentsPartialUpdateData,
  AttachmentsPartialUpdateResponse,
  AttachmentsRetrieveData,
  AttachmentsUpdateData,
  AttachmentsUpdateResponse,
  BranchesListListData,
  BranchesListListResponse,
  CallsCreateData,
  CallsCreateResponse,
  CallsDestroyData,
  CallsDestroyResponse,
  CallsListData,
  CallsListResponse,
  CallsPartialUpdateData,
  CallsPartialUpdateResponse,
  CallsRetrieveData,
  CallsSubscriptionNotificationCreateData,
  CallsSubscriptionNotificationCreateResponse,
  CallsTriggerSubscribeCreateData,
  CallsTriggerSubscribeCreateResponse,
  CallsUpdateData,
  CallsUpdateResponse,
  CitiesListData,
  CitiesListListData,
  CitiesListListResponse,
  CitiesListResponse,
  CitiesRetrieveData,
  ClientsContactsListData,
  ClientsContactsListResponse,
  ClientsContactsRetrieveData,
  ClientsContractsListData,
  ClientsContractsListResponse,
  ClientsContractsRetrieveData,
  ClientsLeadsRetrieveData,
  ClientsLogsListData,
  ClientsLogsListResponse,
  ClientsLogsRetrieveData,
  ClientsOpportunitiesListData,
  ClientsOpportunitiesListResponse,
  ClientsOpportunitiesCreateData,
  ClientsOpportunitiesCreateResponse,
  ClientsOpportunitiesDestroyData,
  ClientsOpportunitiesDestroyResponse,
  ClientsOpportunitiesRetrieveData,
  ClientsOpportunitiesPartialUpdateData,
  ClientsOpportunitiesPartialUpdateResponse,
  ClientsOpportunitiesUpdateData,
  ClientsOpportunitiesUpdateResponse,
  ClientsTasksListData,
  ClientsTasksListResponse,
  ClientsTasksCreateData,
  ClientsTasksCreateResponse,
  ClientsTasksDestroyData,
  ClientsTasksDestroyResponse,
  ClientsTasksRetrieveData,
  ClientsTasksPartialUpdateData,
  ClientsTasksPartialUpdateResponse,
  ClientsTasksUpdateData,
  ClientsTasksUpdateResponse,
  ClientsRetrieveData,
  ClientsImportContractCreateData,
  ClientsImportContractCreateResponse,
  ClientsLeadsListData,
  ClientsLeadsListResponse,
  ClientsListData,
  ClientsListResponse,
  ClientStatusesListData,
  ClientStatusesListListData,
  ClientStatusesListListResponse,
  ClientStatusesListResponse,
  ClientStatusesRetrieveData,
  CompanySizesCreateData,
  CompanySizesCreateResponse,
  CompanySizesDestroyData,
  CompanySizesDestroyResponse,
  CompanySizesListData,
  CompanySizesListListData,
  CompanySizesListListResponse,
  CompanySizesListResponse,
  CompanySizesPartialUpdateData,
  CompanySizesPartialUpdateResponse,
  CompanySizesRetrieveData,
  CompanySizesUpdateData,
  CompanySizesUpdateResponse,
  ConnectorsBulkAddContactsCreateData,
  ConnectorsBulkAddContactsCreateResponse,
  ConnectorsListListData,
  ConnectorsOptionsRetrieveData,
  ContactsUpdateData,
  ContactsUpdateResponse,
  ContactsConnectionsRetrieveData,
  ContactsCreateData,
  ContactsCreateResponse,
  ContactsDestroyData,
  ContactsDestroyResponse,
  ContactsInitCallCreateData,
  ContactsInitCallCreateResponse,
  ContactsListData,
  ContactsListResponse,
  ContactsPartialUpdateData,
  ContactsPartialUpdateResponse,
  ContactsPhoneNumbersCreateData,
  ContactsPhoneNumbersCreateResponse,
  ContactsPhoneNumbersDestroyData,
  ContactsPhoneNumbersDestroyResponse,
  ContactsPhoneNumbersListData,
  ContactsPhoneNumbersListResponse,
  ContactsPhoneNumbersPartialUpdateData,
  ContactsPhoneNumbersPartialUpdateResponse,
  ContactsPhoneNumbersRetrieveData,
  ContactsPhoneNumbersUpdateData,
  ContactsPhoneNumbersUpdateResponse,
  ContactsRetrieveData,
  ContractsCreateData,
  ContractsCreateResponse,
  ContractsDestroyData,
  ContractsDestroyResponse,
  ContractsFetchSiAsigCreateData,
  ContractsFetchSiAsigCreateResponse,
  ContractsListData,
  ContractsListResponse,
  ContractsPartialUpdateData,
  ContractsPartialUpdateResponse,
  ContractsRetrieveData,
  ContractsUpdateData,
  ContractsUpdateResponse,
  CountriesUpdateData,
  CountriesUpdateResponse,
  CountriesContinentsListData,
  CountriesContinentsListResponse,
  CountriesCreateData,
  CountriesCreateResponse,
  CountriesDestroyData,
  CountriesDestroyResponse,
  CountriesListData,
  CountriesListListData,
  CountriesListListResponse,
  CountriesListResponse,
  CountriesPartialUpdateData,
  CountriesPartialUpdateResponse,
  CountriesRetrieveData,
  CurrenciesCreateData,
  CurrenciesCreateResponse,
  CurrenciesDestroyData,
  CurrenciesDestroyResponse,
  CurrenciesListData,
  CurrenciesListListData,
  CurrenciesListListResponse,
  CurrenciesListResponse,
  CurrenciesPartialUpdateData,
  CurrenciesPartialUpdateResponse,
  CurrenciesRetrieveData,
  CurrenciesUpdateData,
  CurrenciesUpdateResponse,
  CustomFieldsCreateData,
  CustomFieldsCreateResponse,
  CustomFieldsDestroyData,
  CustomFieldsDestroyResponse,
  CustomFieldsListData,
  CustomFieldsListResponse,
  CustomFieldsPartialUpdateData,
  CustomFieldsPartialUpdateResponse,
  CustomFieldsRetrieveData,
  CustomFieldsUndeletePartialUpdateData,
  CustomFieldsUndeletePartialUpdateResponse,
  CustomFieldsUpdateData,
  CustomFieldsUpdateResponse,
  DashboardLeadsListData,
  DashboardReportsChartListData,
  DashboardSalesReportListData,
  DashboardTasksRetrieveData,
  DashboardTopExpertsListData,
  DocumentCategoriesCreateData,
  DocumentCategoriesCreateResponse,
  DocumentCategoriesDestroyData,
  DocumentCategoriesDestroyResponse,
  DocumentCategoriesListData,
  DocumentCategoriesListListData,
  DocumentCategoriesListListResponse,
  DocumentCategoriesListResponse,
  DocumentCategoriesPartialUpdateData,
  DocumentCategoriesPartialUpdateResponse,
  DocumentCategoriesRetrieveData,
  DocumentCategoriesUpdateData,
  DocumentCategoriesUpdateResponse,
  DocumentsUpdateData,
  DocumentsUpdateResponse,
  DocumentsBulkCreateCreateData,
  DocumentsBulkCreateCreateResponse,
  DocumentsCreateData,
  DocumentsCreateResponse,
  DocumentsDestroyData,
  DocumentsDestroyResponse,
  DocumentsListData,
  DocumentsListListData,
  DocumentsListListResponse,
  DocumentsListResponse,
  DocumentsPartialUpdateData,
  DocumentsPartialUpdateResponse,
  DocumentsRetrieveData,
  ExpensesCreateData,
  ExpensesCreateResponse,
  ExpensesListData,
  HealthRetrieveData,
  IndustriesCreateData,
  IndustriesCreateResponse,
  IndustriesSubIndustriesPartialUpdateData,
  IndustriesSubIndustriesPartialUpdateResponse,
  IndustriesSubIndustriesUpdateData,
  IndustriesSubIndustriesUpdateResponse,
  IndustriesSubIndustriesListListData,
  IndustriesSubIndustriesListListResponse,
  IndustriesDestroyData,
  IndustriesDestroyResponse,
  IndustriesListData,
  IndustriesPartialUpdateData,
  IndustriesPartialUpdateResponse,
  IndustriesUpdateData,
  IndustriesUpdateResponse,
  IndustriesListListData,
  IndustriesListListResponse,
  IndustriesListResponse,
  IndustriesRetrieveData,
  IndustriesSubIndustriesCreateData,
  IndustriesSubIndustriesCreateResponse,
  IndustriesSubIndustriesDestroyData,
  IndustriesSubIndustriesDestroyResponse,
  IndustriesSubIndustriesListData,
  IndustriesSubIndustriesListResponse,
  IndustriesSubIndustriesRetrieveData,
  InformationCreateData,
  InformationCreateResponse,
  InformationDestroyData,
  InformationDestroyResponse,
  InformationListData,
  InformationListListData,
  InformationListListResponse,
  InformationListResponse,
  InformationPartialUpdateData,
  InformationPartialUpdateResponse,
  InformationRetrieveData,
  InformationUpdateData,
  InformationUpdateResponse,
  IntegrationsGmailUpdateData,
  IntegrationsGmailUpdateResponse,
  IntegrationsGmailCheckMailboxRetrieveData,
  IntegrationsGmailAuthCallbackCreateData,
  IntegrationsGmailAuthCallbackCreateResponse,
  IntegrationsGmailAuthUrlRetrieveData,
  IntegrationsGmailCreateData,
  IntegrationsGmailCreateResponse,
  IntegrationsGmailDestroyData,
  IntegrationsGmailDestroyResponse,
  IntegrationsGmailListData,
  IntegrationsGmailListListData,
  IntegrationsGmailListListResponse,
  IntegrationsGmailListResponse,
  IntegrationsGmailLogoutMailboxCreateData,
  IntegrationsGmailLogoutMailboxCreateResponse,
  IntegrationsGmailPartialUpdateData,
  IntegrationsGmailPartialUpdateResponse,
  IntegrationsGmailRetrieveData,
  IntegrationsMessengerUpdateData,
  IntegrationsMessengerUpdateResponse,
  IntegrationsMessengerCheckMailboxRetrieveData,
  IntegrationsMessengerAuthCallbackCreateData,
  IntegrationsMessengerAuthCallbackCreateResponse,
  IntegrationsMessengerAuthUrlRetrieveData,
  IntegrationsMessengerCreateData,
  IntegrationsMessengerCreateResponse,
  IntegrationsMessengerDestroyData,
  IntegrationsMessengerDestroyResponse,
  IntegrationsMessengerListData,
  IntegrationsMessengerListListData,
  IntegrationsMessengerListListResponse,
  IntegrationsMessengerListResponse,
  IntegrationsMessengerLogoutMailboxCreateData,
  IntegrationsMessengerLogoutMailboxCreateResponse,
  IntegrationsMessengerPartialUpdateData,
  IntegrationsMessengerPartialUpdateResponse,
  IntegrationsMessengerRetrieveData,
  IntegrationsWhatsappConfigCreateData,
  IntegrationsWhatsappConfigCreateResponse,
  IntegrationsWhatsappConfigDestroyData,
  IntegrationsWhatsappConfigDestroyResponse,
  IntegrationsWhatsappConfigListData,
  IntegrationsWhatsappConfigListResponse,
  IntegrationsWhatsappConfigPartialUpdateData,
  IntegrationsWhatsappConfigPartialUpdateResponse,
  IntegrationsWhatsappConfigRetrieveData,
  IntegrationsWhatsappConfigTestCreateData,
  IntegrationsWhatsappConfigTestCreateResponse,
  IntegrationsWhatsappConfigUpdateData,
  IntegrationsWhatsappConfigUpdateResponse,
  IntegrationsWhatsappMessagesListData,
  IntegrationsWhatsappMessagesListResponse,
  IntegrationsWhatsappMessagesRetrieveData,
  IntegrationsWhatsappMessagesRetryCreateData,
  IntegrationsWhatsappMessagesRetryCreateResponse,
  IntegrationsWhatsappMessagesSendCreateData,
  IntegrationsWhatsappMessagesSendCreateResponse,
  IntegrationsWhatsappMessageTemplatesListData,
  IntegrationsWhatsappMessageTemplatesListResponse,
  IntegrationsWhatsappMessageTemplatesSyncCreateData,
  IntegrationsWhatsappMessageTemplatesSyncCreateResponse,
  InternalCitiesListData,
  InternalCitiesListListData,
  InternalCitiesListListResponse,
  InternalCitiesListResponse,
  InternalCitiesRetrieveData,
  InternalCompanySizesCreateData,
  InternalCompanySizesCreateResponse,
  InternalCompanySizesDestroyData,
  InternalCompanySizesDestroyResponse,
  InternalCompanySizesListData,
  InternalCompanySizesListListData,
  InternalCompanySizesListListResponse,
  InternalCompanySizesListResponse,
  InternalCompanySizesPartialUpdateData,
  InternalCompanySizesPartialUpdateResponse,
  InternalCompanySizesRetrieveData,
  InternalCompanySizesUpdateData,
  InternalCompanySizesUpdateResponse,
  InternalContactsUpdateData,
  InternalContactsUpdateResponse,
  InternalContactsConnectionsRetrieveData,
  InternalContactsCreateData,
  InternalContactsCreateResponse,
  InternalContactsDestroyData,
  InternalContactsDestroyResponse,
  InternalContactsInitCallCreateData,
  InternalContactsInitCallCreateResponse,
  InternalContactsListData,
  InternalContactsListResponse,
  InternalContactsPartialUpdateData,
  InternalContactsPartialUpdateResponse,
  InternalContactsPhoneNumbersCreateData,
  InternalContactsPhoneNumbersCreateResponse,
  InternalContactsPhoneNumbersDestroyData,
  InternalContactsPhoneNumbersDestroyResponse,
  InternalContactsPhoneNumbersListData,
  InternalContactsPhoneNumbersListResponse,
  InternalContactsPhoneNumbersPartialUpdateData,
  InternalContactsPhoneNumbersPartialUpdateResponse,
  InternalContactsPhoneNumbersRetrieveData,
  InternalContactsPhoneNumbersUpdateData,
  InternalContactsPhoneNumbersUpdateResponse,
  InternalContactsRetrieveData,
  InternalCountriesUpdateData,
  InternalCountriesUpdateResponse,
  InternalCountriesContinentsListData,
  InternalCountriesContinentsListResponse,
  InternalCountriesCreateData,
  InternalCountriesCreateResponse,
  InternalCountriesDestroyData,
  InternalCountriesDestroyResponse,
  InternalCountriesListData,
  InternalCountriesListListData,
  InternalCountriesListListResponse,
  InternalCountriesListResponse,
  InternalCountriesPartialUpdateData,
  InternalCountriesPartialUpdateResponse,
  InternalCountriesRetrieveData,
  InternalCurrenciesCreateData,
  InternalCurrenciesCreateResponse,
  InternalCurrenciesDestroyData,
  InternalCurrenciesDestroyResponse,
  InternalCurrenciesListData,
  InternalCurrenciesListListData,
  InternalCurrenciesListListResponse,
  InternalCurrenciesListResponse,
  InternalCurrenciesPartialUpdateData,
  InternalCurrenciesPartialUpdateResponse,
  InternalCurrenciesRetrieveData,
  InternalCurrenciesUpdateData,
  InternalCurrenciesUpdateResponse,
  InternalIndustriesCreateData,
  InternalIndustriesCreateResponse,
  InternalIndustriesSubIndustriesPartialUpdateData,
  InternalIndustriesSubIndustriesPartialUpdateResponse,
  InternalIndustriesSubIndustriesUpdateData,
  InternalIndustriesSubIndustriesUpdateResponse,
  InternalIndustriesSubIndustriesListListData,
  InternalIndustriesSubIndustriesListListResponse,
  InternalIndustriesDestroyData,
  InternalIndustriesDestroyResponse,
  InternalIndustriesListData,
  InternalIndustriesPartialUpdateData,
  InternalIndustriesPartialUpdateResponse,
  InternalIndustriesUpdateData,
  InternalIndustriesUpdateResponse,
  InternalIndustriesListListData,
  InternalIndustriesListListResponse,
  InternalIndustriesListResponse,
  InternalIndustriesRetrieveData,
  InternalIndustriesSubIndustriesCreateData,
  InternalIndustriesSubIndustriesCreateResponse,
  InternalIndustriesSubIndustriesDestroyData,
  InternalIndustriesSubIndustriesDestroyResponse,
  InternalIndustriesSubIndustriesListData,
  InternalIndustriesSubIndustriesListResponse,
  InternalIndustriesSubIndustriesRetrieveData,
  InternalLeadsCreateData,
  InternalLeadsCreateResponse,
  InternalLeadsStatusesPartialUpdateData,
  InternalLeadsStatusesPartialUpdateResponse,
  InternalLeadsStatusesUpdateData,
  InternalLeadsStatusesUpdateResponse,
  InternalLeadsStatusesListListData,
  InternalLeadsStatusesListListResponse,
  InternalLeadsTypesListData,
  InternalLeadsTypesListResponse,
  InternalLeadsTypesCreateData,
  InternalLeadsTypesCreateResponse,
  InternalLeadsTypesDestroyData,
  InternalLeadsTypesDestroyResponse,
  InternalLeadsTypesRetrieveData,
  InternalLeadsTypesPartialUpdateData,
  InternalLeadsTypesPartialUpdateResponse,
  InternalLeadsTypesUpdateData,
  InternalLeadsTypesUpdateResponse,
  InternalLeadsTypesListListData,
  InternalLeadsTypesListListResponse,
  InternalLeadsDestroyData,
  InternalLeadsDestroyResponse,
  InternalLeadsListData,
  InternalLeadsPartialUpdateData,
  InternalLeadsPartialUpdateResponse,
  InternalLeadsUpdateData,
  InternalLeadsUpdateResponse,
  InternalLeadsListListData,
  InternalLeadsListListResponse,
  InternalLeadsListResponse,
  InternalLeadsRetrieveData,
  InternalLeadsStatusesCreateData,
  InternalLeadsStatusesCreateResponse,
  InternalLeadsStatusesDestroyData,
  InternalLeadsStatusesDestroyResponse,
  InternalLeadsStatusesListData,
  InternalLeadsStatusesListResponse,
  InternalLeadsStatusesRetrieveData,
  InternalLogsCreateData,
  InternalLogsCreateResponse,
  InternalLogsListData,
  InternalLogsListResponse,
  InternalLogsRetrieveData,
  InternalOpportunitiesCreateData,
  InternalOpportunitiesCreateResponse,
  InternalOpportunitiesStatusesUpdateData,
  InternalOpportunitiesStatusesUpdateResponse,
  InternalOpportunitiesStatusesListListData,
  InternalOpportunitiesStatusesListListResponse,
  InternalOpportunitiesDestroyData,
  InternalOpportunitiesDestroyResponse,
  InternalOpportunitiesRetrieveData,
  InternalOpportunitiesPartialUpdateData,
  InternalOpportunitiesPartialUpdateResponse,
  InternalOpportunitiesStatusesCreateData,
  InternalOpportunitiesStatusesCreateResponse,
  InternalOpportunitiesStatusesDestroyData,
  InternalOpportunitiesStatusesDestroyResponse,
  InternalOpportunitiesStatusesListData,
  InternalOpportunitiesStatusesListResponse,
  InternalOpportunitiesStatusesPartialUpdateData,
  InternalOpportunitiesStatusesPartialUpdateResponse,
  InternalOpportunitiesStatusesRetrieveData,
  InternalOpportunitiesUpdateData,
  InternalOpportunitiesUpdateResponse,
  InternalProductsCreateData,
  InternalProductsCreateResponse,
  InternalProductsDestroyData,
  InternalProductsDestroyResponse,
  InternalProductsListData,
  InternalProductsListListData,
  InternalProductsListListResponse,
  InternalProductsListResponse,
  InternalProductsPartialUpdateData,
  InternalProductsPartialUpdateResponse,
  InternalProductsRetrieveData,
  InternalProductsUpdateData,
  InternalProductsUpdateResponse,
  InternalReasonsCreateData,
  InternalReasonsCreateResponse,
  InternalReasonsDestroyData,
  InternalReasonsDestroyResponse,
  InternalReasonsListData,
  InternalReasonsListListData,
  InternalReasonsListListResponse,
  InternalReasonsListResponse,
  InternalReasonsPartialUpdateData,
  InternalReasonsPartialUpdateResponse,
  InternalReasonsRetrieveData,
  InternalReasonsUpdateData,
  InternalReasonsUpdateResponse,
  InternalRegionsListData,
  InternalRegionsListListData,
  InternalRegionsListListResponse,
  InternalRegionsListResponse,
  InternalRegionsRetrieveData,
  InternalSequencesUpdateData,
  InternalSequencesUpdateResponse,
  InternalSequencesAddLeadsCreateData,
  InternalSequencesAddLeadsCreateResponse,
  InternalSequencesCreateData,
  InternalSequencesCreateResponse,
  InternalSequencesDestroyData,
  InternalSequencesDestroyResponse,
  InternalSequencesDuplicateRetrieveData,
  InternalSequencesListData,
  InternalSequencesListListData,
  InternalSequencesListListResponse,
  InternalSequencesListResponse,
  InternalSequencesPartialUpdateData,
  InternalSequencesPartialUpdateResponse,
  InternalSequencesRetrieveData,
  InternalSourcesCreateData,
  InternalSourcesCreateResponse,
  InternalSourcesDestroyData,
  InternalSourcesDestroyResponse,
  InternalSourcesListData,
  InternalSourcesListListData,
  InternalSourcesListListResponse,
  InternalSourcesListResponse,
  InternalSourcesPartialUpdateData,
  InternalSourcesPartialUpdateResponse,
  InternalSourcesRetrieveData,
  InternalSourcesUpdateData,
  InternalSourcesUpdateResponse,
  InternalTagsUpdateData,
  InternalTagsUpdateResponse,
  InternalTagsColorsRetrieveData,
  InternalTagsCreateData,
  InternalTagsCreateResponse,
  InternalTagsDestroyData,
  InternalTagsDestroyResponse,
  InternalTagsListData,
  InternalTagsListListData,
  InternalTagsListListResponse,
  InternalTagsListResponse,
  InternalTagsPartialUpdateData,
  InternalTagsPartialUpdateResponse,
  InternalTagsRetrieveData,
  InternalTaskTypesUpdateData,
  InternalTaskTypesUpdateResponse,
  InternalTaskTypesAllRetrieveData,
  InternalTaskTypesCreateData,
  InternalTaskTypesCreateResponse,
  InternalTaskTypesDestroyData,
  InternalTaskTypesDestroyResponse,
  InternalTaskTypesListData,
  InternalTaskTypesListListData,
  InternalTaskTypesListListResponse,
  InternalTaskTypesListResponse,
  InternalTaskTypesPartialUpdateData,
  InternalTaskTypesPartialUpdateResponse,
  InternalTaskTypesRetrieveData,
  InvoicesUpdateData,
  InvoicesUpdateResponse,
  InvoicesChangeStatusPartialUpdateData,
  InvoicesChangeStatusPartialUpdateResponse,
  InvoicesDownloadRetrieveData,
  InvoicesEmailRetrieveData,
  InvoicesResendEmailRetrieveData,
  InvoicesContractorsCreateData,
  InvoicesContractorsCreateResponse,
  InvoicesCreateData,
  InvoicesCreateResponse,
  InvoicesDestroyData,
  InvoicesDestroyResponse,
  InvoicesListData,
  InvoicesListResponse,
  InvoicesPartialUpdateData,
  InvoicesPartialUpdateResponse,
  InvoicesReportsExportCreateData,
  InvoicesReportsExportCreateResponse,
  InvoicesReportsRetrieveData,
  InvoicesRetrieveData,
  InvoicesSettingsCreateData,
  InvoicesSettingsCreateResponse,
  InvoicesSettingsRetrieveData,
  LeadGenerationCampaignsListData,
  LeadGenerationCampaignsListResponse,
  LeadGenerationCampaignsPartialUpdateData,
  LeadGenerationCampaignsPartialUpdateResponse,
  LeadGenerationCampaignsRetrieveData,
  LeadGenerationCampaignsRunsListData,
  LeadGenerationCampaignsRunsListResponse,
  LeadGenerationCampaignsTriggerCreateData,
  LeadGenerationCampaignsTriggerCreateResponse,
  LeadGenerationRunsRetrieveData,
  LeadScoreUpdateData,
  LeadScoreUpdateResponse,
  LeadScoreFieldsRetrieveData,
  LeadScoreListListData,
  LeadScoreListListResponse,
  LeadsListData,
  LeadsListResponse,
  LeadsCreateData,
  LeadsCreateResponse,
  LeadsImportListData,
  LeadsImportListResponse,
  LeadsImportCreateData,
  LeadsImportCreateResponse,
  LeadsImportDestroyData,
  LeadsImportDestroyResponse,
  LeadsImportRetrieveData,
  LeadsImportPartialUpdateData,
  LeadsImportPartialUpdateResponse,
  LeadsImportUpdateData,
  LeadsImportUpdateResponse,
  LeadsImportColumnUniqueValuesRetrieveData,
  LeadsImportPreviewRetrieveData,
  LeadsImportHeadersRetrieveData,
  LeadsImportUniqueFieldsRetrieveData,
  LeadsStatusesListData,
  LeadsStatusesListResponse,
  LeadsStatusesCreateData,
  LeadsStatusesCreateResponse,
  LeadsStatusesDestroyData,
  LeadsStatusesDestroyResponse,
  LeadsStatusesRetrieveData,
  LeadsStatusesPartialUpdateData,
  LeadsStatusesPartialUpdateResponse,
  LeadsStatusesUpdateData,
  LeadsStatusesUpdateResponse,
  LeadsStatusesListListData,
  LeadsStatusesListListResponse,
  LeadsTypesListData,
  LeadsTypesListResponse,
  LeadsTypesCreateData,
  LeadsTypesCreateResponse,
  LeadsTypesLeadsStatusesListData,
  LeadsTypesLeadsStatusesListResponse,
  LeadsTypesLeadsStatusesCreateData,
  LeadsTypesLeadsStatusesCreateResponse,
  LeadsTypesLeadsStatusesDestroyData,
  LeadsTypesLeadsStatusesDestroyResponse,
  LeadsTypesLeadsStatusesRetrieveData,
  LeadsTypesLeadsStatusesPartialUpdateData,
  LeadsTypesLeadsStatusesPartialUpdateResponse,
  LeadsTypesLeadsStatusesUpdateData,
  LeadsTypesLeadsStatusesUpdateResponse,
  LeadsTypesLeadsStatusesListListData,
  LeadsTypesLeadsStatusesListListResponse,
  LeadsTypesDestroyData,
  LeadsTypesDestroyResponse,
  LeadsTypesRetrieveData,
  LeadsTypesPartialUpdateData,
  LeadsTypesPartialUpdateResponse,
  LeadsTypesUpdateData,
  LeadsTypesUpdateResponse,
  LeadsTypesListListData,
  LeadsTypesListListResponse,
  LeadsContactsListData,
  LeadsContactsListResponse,
  LeadsContractsListData,
  LeadsContractsListResponse,
  LeadsDocumentsListData,
  LeadsDocumentsListResponse,
  LeadsLogsListData,
  LeadsLogsListResponse,
  LeadsOpportunitiesListData,
  LeadsOpportunitiesListResponse,
  LeadsSequencesListData,
  LeadsSequencesListResponse,
  LeadsSequencesCreateData,
  LeadsSequencesCreateResponse,
  LeadsSequencesDestroyData,
  LeadsSequencesDestroyResponse,
  LeadsSequencesRetrieveData,
  LeadsSequencesPartialUpdateData,
  LeadsSequencesPartialUpdateResponse,
  LeadsSequencesUpdateData,
  LeadsSequencesUpdateResponse,
  LeadsTasksListData,
  LeadsTasksListResponse,
  LeadsDestroyData,
  LeadsDestroyResponse,
  LeadsRetrieveData,
  LeadsPartialUpdateData,
  LeadsPartialUpdateResponse,
  LeadsUpdateData,
  LeadsUpdateResponse,
  LeadsConvertToClientCreateData,
  LeadsConvertToClientCreateResponse,
  LeadsInvoiceContactsRetrieveData,
  LeadsInvoicesListData,
  LeadsInvoicesListResponse,
  LeadsMergePartialUpdateData,
  LeadsMergePartialUpdateResponse,
  LeadsSimilarRetrieveData,
  LeadsUndeletePartialUpdateData,
  LeadsUndeletePartialUpdateResponse,
  LeadsBulkAssigneePartialUpdateData,
  LeadsBulkAssigneePartialUpdateResponse,
  LeadsBulkDeleteCreateData,
  LeadsBulkDeleteCreateResponse,
  LeadsBulkSetBranchPartialUpdateData,
  LeadsBulkSetBranchPartialUpdateResponse,
  LeadScoreCreateData,
  LeadScoreCreateResponse,
  LeadScoreDestroyData,
  LeadScoreDestroyResponse,
  LeadScoreListData,
  LeadScoreListResponse,
  LeadScorePartialUpdateData,
  LeadScorePartialUpdateResponse,
  LeadScoreRetrieveData,
  LeadsDeletedListData,
  LeadsDeletedListResponse,
  LeadsExportRetrieveData,
  LeadsListListData,
  LeadsListListResponse,
  LeadsPipelineListData,
  LeadsPipelineListResponse,
  LeadsSetTagPartialUpdateData,
  LeadsSetTagPartialUpdateResponse,
  LeadsViewedListData,
  LeadsViewedListResponse,
  ListViewsCreateData,
  ListViewsCreateResponse,
  ListViewsDestroyData,
  ListViewsDestroyResponse,
  ListViewsFieldsRetrieveData,
  ListViewsListData,
  ListViewsListResponse,
  ListViewsPartialUpdateData,
  ListViewsPartialUpdateResponse,
  ListViewsResultListData,
  ListViewsResultListResponse,
  ListViewsRetrieveData,
  ListViewsUpdateData,
  ListViewsUpdateResponse,
  LogsListData,
  LogsListResponse,
  LogsMeetingCreateData,
  LogsMeetingCreateResponse,
  LogsNoteCreateData,
  LogsNoteCreateResponse,
  LogsRetrieveData,
  MailboxesUpdateData,
  MailboxesUpdateResponse,
  MailboxesCheckMailboxRetrieveData,
  MailboxesCreateData,
  MailboxesCreateResponse,
  MailboxesDestroyData,
  MailboxesDestroyResponse,
  MailboxesListData,
  MailboxesListListData,
  MailboxesListListResponse,
  MailboxesListResponse,
  MailboxesLoginRetrieveData,
  MailboxesOauthLogoutCreateData,
  MailboxesOauthLogoutCreateResponse,
  MailboxesOauthLogoutLinkRetrieveData,
  MailboxesOauthOutlookCreateData,
  MailboxesOauthOutlookCreateResponse,
  MailboxesOutlookLinkRetrieveData,
  MailboxesPartialUpdateData,
  MailboxesPartialUpdateResponse,
  MailboxesRetrieveData,
  MailboxesSendEmailCreateData,
  MailboxesTemplatesCreateData,
  MailboxesTemplatesCreateResponse,
  MailboxesTemplatesDestroyData,
  MailboxesTemplatesDestroyResponse,
  MailboxesTemplatesListData,
  MailboxesTemplatesListResponse,
  MailboxesTemplatesPartialUpdateData,
  MailboxesTemplatesPartialUpdateResponse,
  MailboxesTemplatesRetrieveData,
  MailboxesTemplatesUpdateData,
  MailboxesTemplatesUpdateResponse,
  OpportunitiesStatusesDestroyResponse,
  OpportunitiesStatusesRetrieveData,
  OpportunitiesStatusesPartialUpdateData,
  OpportunitiesStatusesPartialUpdateResponse,
  OpportunitiesStatusesUpdateData,
  OpportunitiesStatusesUpdateResponse,
  OpportunitiesStatusesListListData,
  OpportunitiesStatusesListListResponse,
  OpportunitiesContactsListData,
  OpportunitiesContactsListResponse,
  OpportunitiesContractsListData,
  OpportunitiesContractsListResponse,
  OpportunitiesDocumentsListData,
  OpportunitiesDocumentsListResponse,
  OpportunitiesLogsListData,
  OpportunitiesLogsListResponse,
  OpportunitiesTasksListData,
  OpportunitiesTasksListResponse,
  OpportunitiesDestroyData,
  OpportunitiesDestroyResponse,
  OpportunitiesRetrieveData,
  OpportunitiesPartialUpdateData,
  OpportunitiesPartialUpdateResponse,
  OpportunitiesUpdateData,
  OpportunitiesUpdateResponse,
  OpportunitiesConvertToClientCreateData,
  OpportunitiesConvertToClientCreateResponse,
  OpportunitiesCreateData,
  OpportunitiesCreateResponse,
  OpportunitiesDuplicateCreateData,
  OpportunitiesDuplicateCreateResponse,
  OpportunitiesListData,
  OpportunitiesListResponse,
  OpportunitiesMergePartialUpdateData,
  OpportunitiesMergePartialUpdateResponse,
  OpportunitiesPipelineListData,
  OpportunitiesPipelineListResponse,
  OpportunitiesPipelinesCreateData,
  OpportunitiesPipelinesCreateResponse,
  OpportunitiesPipelinesStatusesCreateData,
  OpportunitiesPipelinesStatusesCreateResponse,
  OpportunitiesPipelinesStatusesDestroyData,
  OpportunitiesPipelinesStatusesDestroyResponse,
  OpportunitiesPipelinesStatusesRetrieveData,
  OpportunitiesPipelinesStatusesPartialUpdateData,
  OpportunitiesPipelinesStatusesPartialUpdateResponse,
  OpportunitiesPipelinesStatusesUpdateData,
  OpportunitiesPipelinesStatusesUpdateResponse,
  OpportunitiesPipelinesStatusesListListData,
  OpportunitiesPipelinesStatusesListListResponse,
  OpportunitiesPipelinesDestroyData,
  OpportunitiesPipelinesDestroyResponse,
  OpportunitiesPipelinesListData,
  OpportunitiesPipelinesPartialUpdateData,
  OpportunitiesPipelinesPartialUpdateResponse,
  OpportunitiesPipelinesUpdateData,
  OpportunitiesPipelinesUpdateResponse,
  OpportunitiesPipelinesListListData,
  OpportunitiesPipelinesListListResponse,
  OpportunitiesPipelinesListResponse,
  OpportunitiesPipelinesRetrieveData,
  OpportunitiesPipelinesStatusesListData,
  OpportunitiesPipelinesStatusesListResponse,
  OpportunitiesProductsDestroyData,
  OpportunitiesProductsDestroyResponse,
  OpportunitiesProductsRetrieveData,
  OpportunitiesProductsPartialUpdateData,
  OpportunitiesProductsPartialUpdateResponse,
  OpportunitiesProductsUpdateData,
  OpportunitiesProductsUpdateResponse,
  OpportunitiesProductsBulkCreateCreateData,
  OpportunitiesProductsBulkCreateCreateResponse,
  OpportunitiesProductsBulkUpdatePartialUpdateData,
  OpportunitiesProductsBulkUpdatePartialUpdateResponse,
  OpportunitiesProductsCreateData,
  OpportunitiesProductsCreateResponse,
  OpportunitiesProductsListData,
  OpportunitiesProductsListResponse,
  OpportunitiesStatusesCreateData,
  OpportunitiesStatusesCreateResponse,
  OpportunitiesStatusesDestroyData,
  OpportunitiesStatusesListData,
  OpportunitiesStatusesListResponse,
  PresetTasksCreateData,
  PresetTasksCreateResponse,
  PresetTasksDestroyData,
  PresetTasksDestroyResponse,
  PresetTasksListData,
  PresetTasksListResponse,
  PresetTasksPartialUpdateData,
  PresetTasksPartialUpdateResponse,
  PresetTasksRetrieveData,
  PresetTasksUpdateData,
  PresetTasksUpdateResponse,
  ProductsUpdateData,
  ProductsUpdateResponse,
  ProductsCategoriesListData,
  ProductsCategoriesListResponse,
  ProductsCategoriesCreateData,
  ProductsCategoriesCreateResponse,
  ProductsCategoriesDestroyData,
  ProductsCategoriesDestroyResponse,
  ProductsCategoriesRetrieveData,
  ProductsCategoriesPartialUpdateData,
  ProductsCategoriesPartialUpdateResponse,
  ProductsCategoriesUpdateData,
  ProductsCategoriesUpdateResponse,
  ProductsCategoriesListListData,
  ProductsCategoriesListListResponse,
  ProductsCreateData,
  ProductsCreateResponse,
  ProductsDestroyData,
  ProductsDestroyResponse,
  ProductsListData,
  ProductsListListData,
  ProductsListListResponse,
  ProductsListResponse,
  ProductsPartialUpdateData,
  ProductsPartialUpdateResponse,
  ProductsRetrieveData,
  ProductsUnitsOfMeasureCreateData,
  ProductsUnitsOfMeasureCreateResponse,
  ProductsUnitsOfMeasureDestroyData,
  ProductsUnitsOfMeasureDestroyResponse,
  ProductsUnitsOfMeasureListData,
  ProductsUnitsOfMeasureListListData,
  ProductsUnitsOfMeasureListListResponse,
  ProductsUnitsOfMeasureListResponse,
  ProductsUnitsOfMeasurePartialUpdateData,
  ProductsUnitsOfMeasurePartialUpdateResponse,
  ProductsUnitsOfMeasureRetrieveData,
  ProductsUnitsOfMeasureUpdateData,
  ProductsUnitsOfMeasureUpdateResponse,
  ReasonsCreateData,
  ReasonsCreateResponse,
  ReasonsDestroyData,
  ReasonsDestroyResponse,
  ReasonsListData,
  ReasonsListListData,
  ReasonsListListResponse,
  ReasonsListResponse,
  ReasonsPartialUpdateData,
  ReasonsPartialUpdateResponse,
  ReasonsRetrieveData,
  ReasonsUpdateData,
  ReasonsUpdateResponse,
  RegionsListData,
  RegionsListListData,
  RegionsListListResponse,
  RegionsListResponse,
  RegionsRetrieveData,
  ReportsUpdateResponse,
  ReportsChartRetrieveData,
  ReportsDuplicateCreateData,
  ReportsDuplicateCreateResponse,
  ReportsModelFieldsRetrieveData,
  ReportsTableRetrieveData,
  ReportsAggTypesRetrieveData,
  ReportsCallsReportsListData,
  ReportsCountryWeightDiagramRetrieveData,
  ReportsCreateData,
  ReportsCreateResponse,
  ReportsDemoChartListData,
  ReportsDestroyData,
  ReportsDestroyResponse,
  ReportsExportsListData,
  ReportsExportsListResponse,
  ReportsExportsRetrieveData,
  ReportsLeadChartListData,
  ReportsListData,
  ReportsOfflineReportsListData,
  ReportsOnlineReportsListData,
  ReportsPartialUpdateData,
  ReportsPartialUpdateResponse,
  ReportsPhoneCallsChartListData,
  ReportsPreviewChartCreateData,
  ReportsPreviewChartCreateResponse,
  ReportsPreviewTableCreateData,
  ReportsPreviewTableCreateResponse,
  ReportsReasonWeightDiagramRetrieveData,
  ReportsRetrieveData,
  ReportsSalesFunnelListData,
  ReportsScoreWeightDiagramRetrieveData,
  ReportsSourcePageWeightDiagramRetrieveData,
  ReportsSourceWebsiteWeightDiagramRetrieveData,
  ReportsSourceWeightDiagramRetrieveData,
  ReportsStatusWeightDiagramRetrieveData,
  ReportsTopProductsCategoryDistributionExportCreateData,
  ReportsTopProductsCategoryDistributionExportCreateResponse,
  ReportsTopProductsCategoryDistributionRetrieveData,
  ReportsTopProductsExportCreateData,
  ReportsTopProductsExportCreateResponse,
  ReportsTopProductsRetrieveData,
  ReportsTypesRetrieveData,
  ReportsUpdateData,
  SchemaRetrieveData,
  SearchDynamicExportRetrieveData,
  SearchDynamicListData,
  SearchDynamicListResponse,
  SearchDynamicModelFieldsRetrieveData,
  SearchDynamicModelsRetrieveData,
  SearchListData,
  SearchListResponse,
  SeniorPositionsCreateData,
  SeniorPositionsCreateResponse,
  SeniorPositionsDestroyData,
  SeniorPositionsDestroyResponse,
  SeniorPositionsJobPositionsCreateData,
  SeniorPositionsJobPositionsCreateResponse,
  SeniorPositionsJobPositionsDestroyData,
  SeniorPositionsJobPositionsDestroyResponse,
  SeniorPositionsJobPositionsListData,
  SeniorPositionsJobPositionsPartialUpdateData,
  SeniorPositionsJobPositionsPartialUpdateResponse,
  SeniorPositionsJobPositionsUpdateData,
  SeniorPositionsJobPositionsUpdateResponse,
  SeniorPositionsJobPositionsListListData,
  SeniorPositionsJobPositionsListListResponse,
  SeniorPositionsJobPositionsListResponse,
  SeniorPositionsJobPositionsRetrieveData,
  SeniorPositionsListData,
  SeniorPositionsListListData,
  SeniorPositionsListListResponse,
  SeniorPositionsListResponse,
  SeniorPositionsPartialUpdateData,
  SeniorPositionsPartialUpdateResponse,
  SeniorPositionsRetrieveData,
  SeniorPositionsUpdateData,
  SeniorPositionsUpdateResponse,
  SequencesUpdateData,
  SequencesUpdateResponse,
  SequencesAddLeadsCreateData,
  SequencesAddLeadsCreateResponse,
  SequencesCreateData,
  SequencesCreateResponse,
  SequencesDestroyData,
  SequencesDestroyResponse,
  SequencesDuplicateRetrieveData,
  SequencesLeadsListData,
  SequencesLeadsListResponse,
  SequencesListData,
  SequencesStepsDestroyResponse,
  SequencesStepsRetrieveData,
  SequencesStepsPartialUpdateData,
  SequencesStepsPartialUpdateResponse,
  SequencesStepsUpdateData,
  SequencesStepsUpdateResponse,
  SequencesStepsListListData,
  SequencesStepsListListResponse,
  SequencesListListData,
  SequencesListListResponse,
  SequencesListResponse,
  SequencesPartialUpdateData,
  SequencesPartialUpdateResponse,
  SequencesRetrieveData,
  SequencesStepsCreateData,
  SequencesStepsCreateResponse,
  SequencesStepsDestroyData,
  SequencesStepsListData,
  SequencesStepsListResponse,
  SettingsCreateData,
  SettingsCreateResponse,
  SettingsRetrieveData,
  SourcesCreateData,
  SourcesCreateResponse,
  SourcesDestroyData,
  SourcesDestroyResponse,
  SourcesListData,
  SourcesListListData,
  SourcesListListResponse,
  SourcesListResponse,
  SourcesPartialUpdateData,
  SourcesPartialUpdateResponse,
  SourcesRetrieveData,
  SourcesUpdateData,
  SourcesUpdateResponse,
  TagsUpdateData,
  TagsUpdateResponse,
  TagsColorsRetrieveData,
  TagsCreateData,
  TagsCreateResponse,
  TagsDestroyData,
  TagsDestroyResponse,
  TagsListData,
  TagsListListData,
  TagsListListResponse,
  TagsListResponse,
  TagsPartialUpdateData,
  TagsPartialUpdateResponse,
  TagsRetrieveData,
  TaskStatusesUpdateData,
  TaskStatusesUpdateResponse,
  TaskStatusesListListData,
  TaskStatusesListListResponse,
  TaskTypesListData,
  TaskTypesListResponse,
  TaskTypesCreateData,
  TaskTypesCreateResponse,
  TaskTypesDestroyData,
  TaskTypesDestroyResponse,
  TaskTypesRetrieveData,
  TaskTypesPartialUpdateData,
  TaskTypesPartialUpdateResponse,
  TaskTypesUpdateData,
  TaskTypesUpdateResponse,
  TaskTypesAllRetrieveData,
  TaskTypesGenericListData,
  TaskTypesGenericListResponse,
  TaskTypesListListData,
  TaskTypesListListResponse,
  TaskTypesSystemListData,
  TaskTypesSystemListResponse,
  TasksListData,
  TasksListResponse,
  TasksCreateData,
  TasksCreateResponse,
  TasksDestroyData,
  TasksDestroyResponse,
  TasksRetrieveData,
  TasksPartialUpdateData,
  TasksPartialUpdateResponse,
  TasksUpdateData,
  TasksUpdateResponse,
  TasksCompleteCreateData,
  TasksCompleteCreateResponse,
  TasksKanbanListData,
  TasksKanbanListResponse,
  TaskStatusesCreateData,
  TaskStatusesCreateResponse,
  TaskStatusesDestroyData,
  TaskStatusesDestroyResponse,
  TaskStatusesListData,
  TaskStatusesListResponse,
  TaskStatusesPartialUpdateData,
  TaskStatusesPartialUpdateResponse,
  TaskStatusesRetrieveData,
  UsersAllListData,
  UsersAllListResponse,
  UsersAllowedModulesRetrieveData,
  UsersListData,
  UsersListListData,
  UsersListListResponse,
  UsersListResponse,
  UsersPartialUpdateData,
  UsersPartialUpdateResponse,
  UsersProfileRetrieveData,
  UsersUpdateData,
  UsersUpdateResponse,
  VoipConfigurationCreateData,
  VoipConfigurationCreateResponse,
  VoipConfigurationDestroyData,
  VoipConfigurationDestroyResponse,
  VoipConfigurationListData,
  VoipConfigurationListResponse,
  VoipConfigurationPartialUpdateData,
  VoipConfigurationPartialUpdateResponse,
  VoipConfigurationRetrieveData,
  VoipConfigurationStatusRetrieveData,
  VoipConfigurationUpdateData,
  VoipConfigurationUpdateResponse,
  WebhookLeadCreateData,
  WebhookLeadCreateResponse,
  WebhookMinioCreateData,
  WebhookMinioCreateResponse,
  WebhookTaskCreateData,
  WebhookTaskCreateResponse,
  WebhookVoipCreateData,
  WebhookWhatsappCreateData,
  WebhookWhatsappRetrieveData,
  WidgetsRetrieveData
} from '../types.gen'
import type { AxiosError } from 'axios'


export type QueryKey<TOptions extends Options> = [
  Pick<TOptions, 'baseURL' | 'body' | 'headers' | 'path' | 'query'> & {
    _id: string
    _infinite?: boolean
  }
]

const createQueryKey = <TOptions extends Options>(
  id: string,
  options?: TOptions,
  infinite?: boolean
): [QueryKey<TOptions>[0]] => {
  const params: QueryKey<TOptions>[0] = {
    _id: id,
    baseURL: (options?.client ?? _heyApiClient).getConfig().baseURL
  } as QueryKey<TOptions>[0]
  if (infinite) {
    params._infinite = infinite
  }
  if (options?.body) {
    params.body = options.body
  }
  if (options?.headers) {
    params.headers = options.headers
  }
  if (options?.path) {
    params.path = options.path
  }
  if (options?.query) {
    params.query = options.query
  }
  return [params]
}

export const attachmentsListQueryKey = (
  options?: Options<AttachmentsListData>
) => createQueryKey('attachmentsList', options)

export const attachmentsListOptions = (
  options?: Options<AttachmentsListData>
) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await attachmentsList({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true
      })

      return data
    },
    queryKey: attachmentsListQueryKey(options)
  })
}

const createInfiniteParams = <
  K extends Pick<QueryKey<Options>[0], 'body' | 'headers' | 'path' | 'query'>
>(
  queryKey: QueryKey<Options>,
  page: K
) => {
  const params = queryKey[0]
  if (page.body) {
    params.body = {
      ...(queryKey[0].body as any),
      ...(page.body as any)
    }
  }
  if (page.headers) {
    params.headers = {
      ...queryKey[0].headers,
      ...page.headers
    }
  }
  if (page.path) {
    params.path = {
      ...(queryKey[0].path as any),
      ...(page.path as any)
    }
  }
  if (page.query) {
    params.query = {
      ...(queryKey[0].query as any),
      ...(page.query as any)
    }
  }
  return params as unknown as typeof page
}

export const attachmentsListInfiniteQueryKey = (
  options?: Options<AttachmentsListData>
): QueryKey<Options<AttachmentsListData>> =>
  createQueryKey('attachmentsList', options, true)

export const attachmentsListInfiniteOptions = (
  options?: Options<AttachmentsListData>
) => {
  return infiniteQueryOptions<
    AttachmentsListResponse,
    AxiosError<DefaultError>,
    InfiniteData<AttachmentsListResponse>,
    QueryKey<Options<AttachmentsListData>>,
    | number
    | Pick<
        QueryKey<Options<AttachmentsListData>>[0],
        'body' | 'headers' | 'path' | 'query'
      >
  >(
    // @ts-ignore
    {
      queryFn: async ({ pageParam, queryKey, signal }) => {
        // @ts-ignore
        const page: Pick<
          QueryKey<Options<AttachmentsListData>>[0],
          'body' | 'headers' | 'path' | 'query'
        > =
          typeof pageParam === 'object'
            ? pageParam
            : {
                query: {
                  page: pageParam
                }
              }
        const params = createInfiniteParams(queryKey, page)
        const { data } = await attachmentsList({
          ...options,
          ...params,
          signal,
          throwOnError: true
        })

        return data
      },
      queryKey: attachmentsListInfiniteQueryKey(options)
    }
  )
}

export const attachmentsDestroyMutation = (
  options?: Partial<Options<AttachmentsDestroyData>>
): UseMutationOptions<
  AttachmentsDestroyResponse,
  AxiosError<DefaultError>,
  Options<AttachmentsDestroyData>
> => {
  const mutationOptions: UseMutationOptions<
    AttachmentsDestroyResponse,
    AxiosError<DefaultError>,
    Options<AttachmentsDestroyData>
  > = {
    mutationFn: async (localOptions) => {
      const { data } = await attachmentsDestroy({
        ...options,
        ...localOptions,
        throwOnError: true
      })

      return data
    }
  }

  return mutationOptions
}

export const attachmentsRetrieveQueryKey = (
  options: Options<AttachmentsRetrieveData>
) => createQueryKey('attachmentsRetrieve', options)

export const attachmentsRetrieveOptions = (
  options: Options<AttachmentsRetrieveData>
) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await attachmentsRetrieve({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true
      })

      return data
    },
    queryKey: attachmentsRetrieveQueryKey(options)
  })
}

export const attachmentsPartialUpdateMutation = (
  options?: Partial<Options<AttachmentsPartialUpdateData>>
): UseMutationOptions<
  AttachmentsPartialUpdateResponse,
  AxiosError<DefaultError>,
  Options<AttachmentsPartialUpdateData>
> => {
  const mutationOptions: UseMutationOptions<
    AttachmentsPartialUpdateResponse,
    AxiosError<DefaultError>,
    Options<AttachmentsPartialUpdateData>
  > = {
    mutationFn: async (localOptions) => {
      const { data } = await attachmentsPartialUpdate({
        ...options,
        ...localOptions,
        throwOnError: true
      })

      return data
    }
  }

  return mutationOptions
}

export const attachmentsUpdateMutation = (
  options?: Partial<Options<AttachmentsUpdateData>>
): UseMutationOptions<
  AttachmentsUpdateResponse,
  AxiosError<DefaultError>,
  Options<AttachmentsUpdateData>
> => {
  const mutationOptions: UseMutationOptions<
    AttachmentsUpdateResponse,
    AxiosError<DefaultError>,
    Options<AttachmentsUpdateData>
  > = {
    mutationFn: async (localOptions) => {
      const { data } = await attachmentsUpdate({
        ...options,
        ...localOptions,
        throwOnError: true
      })

      return data
    }
  }

  return mutationOptions
}

export const attachmentsUpdateSignedUrlCreateQueryKey = (
  options: Options<AttachmentsUpdateSignedUrlCreateData>
) => createQueryKey('attachmentsUpdateSignedUrlCreate', options)

export const attachmentsUpdateSignedUrlCreateOptions = (
  options: Options<AttachmentsUpdateSignedUrlCreateData>
) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await attachmentsUpdateSignedUrlCreate({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true
      })

      return data
    },
    queryKey: attachmentsUpdateSignedUrlCreateQueryKey(options)
  })
}

export const attachmentsUpdateSignedUrlCreateMutation = (
  options?: Partial<Options<AttachmentsUpdateSignedUrlCreateData>>
): UseMutationOptions<
  AttachmentsUpdateSignedUrlCreateResponse,
  AxiosError<DefaultError>,
  Options<AttachmentsUpdateSignedUrlCreateData>
> => {
  const mutationOptions: UseMutationOptions<
    AttachmentsUpdateSignedUrlCreateResponse,
    AxiosError<DefaultError>,
    Options<AttachmentsUpdateSignedUrlCreateData>
  > = {
    mutationFn: async (localOptions) => {
      const { data } = await attachmentsUpdateSignedUrlCreate({
        ...options,
        ...localOptions,
        throwOnError: true
      })

      return data
    }
  }

  return mutationOptions
}

export const attachmentsVersionDestroyMutation = (
  options?: Partial<Options<AttachmentsVersionDestroyData>>
): UseMutationOptions<
  AttachmentsVersionDestroyResponse,
  AxiosError<DefaultError>,
  Options<AttachmentsVersionDestroyData>
> => {
  const mutationOptions: UseMutationOptions<
    AttachmentsVersionDestroyResponse,
    AxiosError<DefaultError>,
    Options<AttachmentsVersionDestroyData>
  > = {
    mutationFn: async (localOptions) => {
      const { data } = await attachmentsVersionDestroy({
        ...options,
        ...localOptions,
        throwOnError: true
      })

      return data
    }
  }

  return mutationOptions
}

export const attachmentsVersionRetrieveQueryKey = (
  options: Options<AttachmentsVersionRetrieveData>
) => createQueryKey('attachmentsVersionRetrieve', options)

export const attachmentsVersionRetrieveOptions = (
  options: Options<AttachmentsVersionRetrieveData>
) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await attachmentsVersionRetrieve({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true
      })

      return data
    },
    queryKey: attachmentsVersionRetrieveQueryKey(options)
  })
}

export const attachmentsCreateSignedUrlCreateQueryKey = (
  options: Options<AttachmentsCreateSignedUrlCreateData>
) => createQueryKey('attachmentsCreateSignedUrlCreate', options)

export const attachmentsCreateSignedUrlCreateOptions = (
  options: Options<AttachmentsCreateSignedUrlCreateData>
) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await attachmentsCreateSignedUrlCreate({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true
      })

      return data
    },
    queryKey: attachmentsCreateSignedUrlCreateQueryKey(options)
  })
}

export const attachmentsCreateSignedUrlCreateMutation = (
  options?: Partial<Options<AttachmentsCreateSignedUrlCreateData>>
): UseMutationOptions<
  AttachmentsCreateSignedUrlCreateResponse,
  AxiosError<DefaultError>,
  Options<AttachmentsCreateSignedUrlCreateData>
> => {
  const mutationOptions: UseMutationOptions<
    AttachmentsCreateSignedUrlCreateResponse,
    AxiosError<DefaultError>,
    Options<AttachmentsCreateSignedUrlCreateData>
  > = {
    mutationFn: async (localOptions) => {
      const { data } = await attachmentsCreateSignedUrlCreate({
        ...options,
        ...localOptions,
        throwOnError: true
      })

      return data
    }
  }

  return mutationOptions
}

export const branchesListListQueryKey = (
  options?: Options<BranchesListListData>
) => createQueryKey('branchesListList', options)

export const branchesListListOptions = (
  options?: Options<BranchesListListData>
) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await branchesListList({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true
      })

      return data
    },
    queryKey: branchesListListQueryKey(options)
  })
}

export const branchesListListInfiniteQueryKey = (
  options?: Options<BranchesListListData>
): QueryKey<Options<BranchesListListData>> =>
  createQueryKey('branchesListList', options, true)

export const branchesListListInfiniteOptions = (
  options?: Options<BranchesListListData>
) => {
  return infiniteQueryOptions<
    BranchesListListResponse,
    AxiosError<DefaultError>,
    InfiniteData<BranchesListListResponse>,
    QueryKey<Options<BranchesListListData>>,
    | number
    | Pick<
        QueryKey<Options<BranchesListListData>>[0],
        'body' | 'headers' | 'path' | 'query'
      >
  >(
    // @ts-ignore
    {
      queryFn: async ({ pageParam, queryKey, signal }) => {
        // @ts-ignore
        const page: Pick<
          QueryKey<Options<BranchesListListData>>[0],
          'body' | 'headers' | 'path' | 'query'
        > =
          typeof pageParam === 'object'
            ? pageParam
            : {
                query: {
                  page: pageParam
                }
              }
        const params = createInfiniteParams(queryKey, page)
        const { data } = await branchesListList({
          ...options,
          ...params,
          signal,
          throwOnError: true
        })

        return data
      },
      queryKey: branchesListListInfiniteQueryKey(options)
    }
  )
}

export const callsListQueryKey = (options?: Options<CallsListData>) =>
  createQueryKey('callsList', options)

export const callsListOptions = (options?: Options<CallsListData>) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await callsList({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true
      })

      return data
    },
    queryKey: callsListQueryKey(options)
  })
}

export const callsListInfiniteQueryKey = (
  options?: Options<CallsListData>
): QueryKey<Options<CallsListData>> =>
  createQueryKey('callsList', options, true)

export const callsListInfiniteOptions = (options?: Options<CallsListData>) => {
  return infiniteQueryOptions<
    CallsListResponse,
    AxiosError<DefaultError>,
    InfiniteData<CallsListResponse>,
    QueryKey<Options<CallsListData>>,
    | number
    | Pick<
        QueryKey<Options<CallsListData>>[0],
        'body' | 'headers' | 'path' | 'query'
      >
  >(
    // @ts-ignore
    {
      queryFn: async ({ pageParam, queryKey, signal }) => {
        // @ts-ignore
        const page: Pick<
          QueryKey<Options<CallsListData>>[0],
          'body' | 'headers' | 'path' | 'query'
        > =
          typeof pageParam === 'object'
            ? pageParam
            : {
                query: {
                  page: pageParam
                }
              }
        const params = createInfiniteParams(queryKey, page)
        const { data } = await callsList({
          ...options,
          ...params,
          signal,
          throwOnError: true
        })

        return data
      },
      queryKey: callsListInfiniteQueryKey(options)
    }
  )
}

export const callsCreateQueryKey = (options: Options<CallsCreateData>) =>
  createQueryKey('callsCreate', options)

export const callsCreateOptions = (options: Options<CallsCreateData>) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await callsCreate({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true
      })

      return data
    },
    queryKey: callsCreateQueryKey(options)
  })
}

export const callsCreateMutation = (
  options?: Partial<Options<CallsCreateData>>
): UseMutationOptions<
  CallsCreateResponse,
  AxiosError<DefaultError>,
  Options<CallsCreateData>
> => {
  const mutationOptions: UseMutationOptions<
    CallsCreateResponse,
    AxiosError<DefaultError>,
    Options<CallsCreateData>
  > = {
    mutationFn: async (localOptions) => {
      const { data } = await callsCreate({
        ...options,
        ...localOptions,
        throwOnError: true
      })

      return data
    }
  }

  return mutationOptions
}

export const callsDestroyMutation = (
  options?: Partial<Options<CallsDestroyData>>
): UseMutationOptions<
  CallsDestroyResponse,
  AxiosError<DefaultError>,
  Options<CallsDestroyData>
> => {
  const mutationOptions: UseMutationOptions<
    CallsDestroyResponse,
    AxiosError<DefaultError>,
    Options<CallsDestroyData>
  > = {
    mutationFn: async (localOptions) => {
      const { data } = await callsDestroy({
        ...options,
        ...localOptions,
        throwOnError: true
      })

      return data
    }
  }

  return mutationOptions
}

export const callsRetrieveQueryKey = (options: Options<CallsRetrieveData>) =>
  createQueryKey('callsRetrieve', options)

export const callsRetrieveOptions = (options: Options<CallsRetrieveData>) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await callsRetrieve({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true
      })

      return data
    },
    queryKey: callsRetrieveQueryKey(options)
  })
}

export const callsPartialUpdateMutation = (
  options?: Partial<Options<CallsPartialUpdateData>>
): UseMutationOptions<
  CallsPartialUpdateResponse,
  AxiosError<DefaultError>,
  Options<CallsPartialUpdateData>
> => {
  const mutationOptions: UseMutationOptions<
    CallsPartialUpdateResponse,
    AxiosError<DefaultError>,
    Options<CallsPartialUpdateData>
  > = {
    mutationFn: async (localOptions) => {
      const { data } = await callsPartialUpdate({
        ...options,
        ...localOptions,
        throwOnError: true
      })

      return data
    }
  }

  return mutationOptions
}

export const callsUpdateMutation = (
  options?: Partial<Options<CallsUpdateData>>
): UseMutationOptions<
  CallsUpdateResponse,
  AxiosError<DefaultError>,
  Options<CallsUpdateData>
> => {
  const mutationOptions: UseMutationOptions<
    CallsUpdateResponse,
    AxiosError<DefaultError>,
    Options<CallsUpdateData>
  > = {
    mutationFn: async (localOptions) => {
      const { data } = await callsUpdate({
        ...options,
        ...localOptions,
        throwOnError: true
      })

      return data
    }
  }

  return mutationOptions
}

export const callsSubscriptionNotificationCreateQueryKey = (
  options: Options<CallsSubscriptionNotificationCreateData>
) => createQueryKey('callsSubscriptionNotificationCreate', options)

export const callsSubscriptionNotificationCreateOptions = (
  options: Options<CallsSubscriptionNotificationCreateData>
) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await callsSubscriptionNotificationCreate({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true
      })

      return data
    },
    queryKey: callsSubscriptionNotificationCreateQueryKey(options)
  })
}

export const callsSubscriptionNotificationCreateMutation = (
  options?: Partial<Options<CallsSubscriptionNotificationCreateData>>
): UseMutationOptions<
  CallsSubscriptionNotificationCreateResponse,
  AxiosError<DefaultError>,
  Options<CallsSubscriptionNotificationCreateData>
> => {
  const mutationOptions: UseMutationOptions<
    CallsSubscriptionNotificationCreateResponse,
    AxiosError<DefaultError>,
    Options<CallsSubscriptionNotificationCreateData>
  > = {
    mutationFn: async (localOptions) => {
      const { data } = await callsSubscriptionNotificationCreate({
        ...options,
        ...localOptions,
        throwOnError: true
      })

      return data
    }
  }

  return mutationOptions
}

export const callsTriggerSubscribeCreateQueryKey = (
  options: Options<CallsTriggerSubscribeCreateData>
) => createQueryKey('callsTriggerSubscribeCreate', options)

export const callsTriggerSubscribeCreateOptions = (
  options: Options<CallsTriggerSubscribeCreateData>
) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await callsTriggerSubscribeCreate({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true
      })

      return data
    },
    queryKey: callsTriggerSubscribeCreateQueryKey(options)
  })
}

export const callsTriggerSubscribeCreateMutation = (
  options?: Partial<Options<CallsTriggerSubscribeCreateData>>
): UseMutationOptions<
  CallsTriggerSubscribeCreateResponse,
  AxiosError<DefaultError>,
  Options<CallsTriggerSubscribeCreateData>
> => {
  const mutationOptions: UseMutationOptions<
    CallsTriggerSubscribeCreateResponse,
    AxiosError<DefaultError>,
    Options<CallsTriggerSubscribeCreateData>
  > = {
    mutationFn: async (localOptions) => {
      const { data } = await callsTriggerSubscribeCreate({
        ...options,
        ...localOptions,
        throwOnError: true
      })

      return data
    }
  }

  return mutationOptions
}

export const citiesListQueryKey = (options?: Options<CitiesListData>) =>
  createQueryKey('citiesList', options)

export const citiesListOptions = (options?: Options<CitiesListData>) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await citiesList({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true
      })

      return data
    },
    queryKey: citiesListQueryKey(options)
  })
}

export const citiesListInfiniteQueryKey = (
  options?: Options<CitiesListData>
): QueryKey<Options<CitiesListData>> =>
  createQueryKey('citiesList', options, true)

export const citiesListInfiniteOptions = (
  options?: Options<CitiesListData>
) => {
  return infiniteQueryOptions<
    CitiesListResponse,
    AxiosError<DefaultError>,
    InfiniteData<CitiesListResponse>,
    QueryKey<Options<CitiesListData>>,
    | number
    | Pick<
        QueryKey<Options<CitiesListData>>[0],
        'body' | 'headers' | 'path' | 'query'
      >
  >(
    // @ts-ignore
    {
      queryFn: async ({ pageParam, queryKey, signal }) => {
        // @ts-ignore
        const page: Pick<
          QueryKey<Options<CitiesListData>>[0],
          'body' | 'headers' | 'path' | 'query'
        > =
          typeof pageParam === 'object'
            ? pageParam
            : {
                query: {
                  page: pageParam
                }
              }
        const params = createInfiniteParams(queryKey, page)
        const { data } = await citiesList({
          ...options,
          ...params,
          signal,
          throwOnError: true
        })

        return data
      },
      queryKey: citiesListInfiniteQueryKey(options)
    }
  )
}

export const citiesRetrieveQueryKey = (options: Options<CitiesRetrieveData>) =>
  createQueryKey('citiesRetrieve', options)

export const citiesRetrieveOptions = (options: Options<CitiesRetrieveData>) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await citiesRetrieve({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true
      })

      return data
    },
    queryKey: citiesRetrieveQueryKey(options)
  })
}

export const citiesListListQueryKey = (options?: Options<CitiesListListData>) =>
  createQueryKey('citiesListList', options)

export const citiesListListOptions = (
  options?: Options<CitiesListListData>
) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await citiesListList({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true
      })

      return data
    },
    queryKey: citiesListListQueryKey(options)
  })
}

export const citiesListListInfiniteQueryKey = (
  options?: Options<CitiesListListData>
): QueryKey<Options<CitiesListListData>> =>
  createQueryKey('citiesListList', options, true)

export const citiesListListInfiniteOptions = (
  options?: Options<CitiesListListData>
) => {
  return infiniteQueryOptions<
    CitiesListListResponse,
    AxiosError<DefaultError>,
    InfiniteData<CitiesListListResponse>,
    QueryKey<Options<CitiesListListData>>,
    | number
    | Pick<
        QueryKey<Options<CitiesListListData>>[0],
        'body' | 'headers' | 'path' | 'query'
      >
  >(
    // @ts-ignore
    {
      queryFn: async ({ pageParam, queryKey, signal }) => {
        // @ts-ignore
        const page: Pick<
          QueryKey<Options<CitiesListListData>>[0],
          'body' | 'headers' | 'path' | 'query'
        > =
          typeof pageParam === 'object'
            ? pageParam
            : {
                query: {
                  page: pageParam
                }
              }
        const params = createInfiniteParams(queryKey, page)
        const { data } = await citiesListList({
          ...options,
          ...params,
          signal,
          throwOnError: true
        })

        return data
      },
      queryKey: citiesListListInfiniteQueryKey(options)
    }
  )
}

export const clientStatusesListQueryKey = (
  options?: Options<ClientStatusesListData>
) => createQueryKey('clientStatusesList', options)

export const clientStatusesListOptions = (
  options?: Options<ClientStatusesListData>
) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await clientStatusesList({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true
      })

      return data
    },
    queryKey: clientStatusesListQueryKey(options)
  })
}

export const clientStatusesListInfiniteQueryKey = (
  options?: Options<ClientStatusesListData>
): QueryKey<Options<ClientStatusesListData>> =>
  createQueryKey('clientStatusesList', options, true)

export const clientStatusesListInfiniteOptions = (
  options?: Options<ClientStatusesListData>
) => {
  return infiniteQueryOptions<
    ClientStatusesListResponse,
    AxiosError<DefaultError>,
    InfiniteData<ClientStatusesListResponse>,
    QueryKey<Options<ClientStatusesListData>>,
    | number
    | Pick<
        QueryKey<Options<ClientStatusesListData>>[0],
        'body' | 'headers' | 'path' | 'query'
      >
  >(
    // @ts-ignore
    {
      queryFn: async ({ pageParam, queryKey, signal }) => {
        // @ts-ignore
        const page: Pick<
          QueryKey<Options<ClientStatusesListData>>[0],
          'body' | 'headers' | 'path' | 'query'
        > =
          typeof pageParam === 'object'
            ? pageParam
            : {
                query: {
                  page: pageParam
                }
              }
        const params = createInfiniteParams(queryKey, page)
        const { data } = await clientStatusesList({
          ...options,
          ...params,
          signal,
          throwOnError: true
        })

        return data
      },
      queryKey: clientStatusesListInfiniteQueryKey(options)
    }
  )
}

export const clientStatusesRetrieveQueryKey = (
  options: Options<ClientStatusesRetrieveData>
) => createQueryKey('clientStatusesRetrieve', options)

export const clientStatusesRetrieveOptions = (
  options: Options<ClientStatusesRetrieveData>
) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await clientStatusesRetrieve({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true
      })

      return data
    },
    queryKey: clientStatusesRetrieveQueryKey(options)
  })
}

export const clientStatusesListListQueryKey = (
  options?: Options<ClientStatusesListListData>
) => createQueryKey('clientStatusesListList', options)

export const clientStatusesListListOptions = (
  options?: Options<ClientStatusesListListData>
) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await clientStatusesListList({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true
      })

      return data
    },
    queryKey: clientStatusesListListQueryKey(options)
  })
}

export const clientStatusesListListInfiniteQueryKey = (
  options?: Options<ClientStatusesListListData>
): QueryKey<Options<ClientStatusesListListData>> =>
  createQueryKey('clientStatusesListList', options, true)

export const clientStatusesListListInfiniteOptions = (
  options?: Options<ClientStatusesListListData>
) => {
  return infiniteQueryOptions<
    ClientStatusesListListResponse,
    AxiosError<DefaultError>,
    InfiniteData<ClientStatusesListListResponse>,
    QueryKey<Options<ClientStatusesListListData>>,
    | number
    | Pick<
        QueryKey<Options<ClientStatusesListListData>>[0],
        'body' | 'headers' | 'path' | 'query'
      >
  >(
    // @ts-ignore
    {
      queryFn: async ({ pageParam, queryKey, signal }) => {
        // @ts-ignore
        const page: Pick<
          QueryKey<Options<ClientStatusesListListData>>[0],
          'body' | 'headers' | 'path' | 'query'
        > =
          typeof pageParam === 'object'
            ? pageParam
            : {
                query: {
                  page: pageParam
                }
              }
        const params = createInfiniteParams(queryKey, page)
        const { data } = await clientStatusesListList({
          ...options,
          ...params,
          signal,
          throwOnError: true
        })

        return data
      },
      queryKey: clientStatusesListListInfiniteQueryKey(options)
    }
  )
}

export const clientsListQueryKey = (options?: Options<ClientsListData>) =>
  createQueryKey('clientsList', options)

export const clientsListOptions = (options?: Options<ClientsListData>) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await clientsList({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true
      })

      return data
    },
    queryKey: clientsListQueryKey(options)
  })
}

export const clientsListInfiniteQueryKey = (
  options?: Options<ClientsListData>
): QueryKey<Options<ClientsListData>> =>
  createQueryKey('clientsList', options, true)

export const clientsListInfiniteOptions = (
  options?: Options<ClientsListData>
) => {
  return infiniteQueryOptions<
    ClientsListResponse,
    AxiosError<DefaultError>,
    InfiniteData<ClientsListResponse>,
    QueryKey<Options<ClientsListData>>,
    | number
    | Pick<
        QueryKey<Options<ClientsListData>>[0],
        'body' | 'headers' | 'path' | 'query'
      >
  >(
    // @ts-ignore
    {
      queryFn: async ({ pageParam, queryKey, signal }) => {
        // @ts-ignore
        const page: Pick<
          QueryKey<Options<ClientsListData>>[0],
          'body' | 'headers' | 'path' | 'query'
        > =
          typeof pageParam === 'object'
            ? pageParam
            : {
                query: {
                  page: pageParam
                }
              }
        const params = createInfiniteParams(queryKey, page)
        const { data } = await clientsList({
          ...options,
          ...params,
          signal,
          throwOnError: true
        })

        return data
      },
      queryKey: clientsListInfiniteQueryKey(options)
    }
  )
}

export const clientsContactsListQueryKey = (
  options: Options<ClientsContactsListData>
) => createQueryKey('clientsContactsList', options)

export const clientsContactsListOptions = (
  options: Options<ClientsContactsListData>
) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await clientsContactsList({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true
      })

      return data
    },
    queryKey: clientsContactsListQueryKey(options)
  })
}

export const clientsContactsListInfiniteQueryKey = (
  options: Options<ClientsContactsListData>
): QueryKey<Options<ClientsContactsListData>> =>
  createQueryKey('clientsContactsList', options, true)

export const clientsContactsListInfiniteOptions = (
  options: Options<ClientsContactsListData>
) => {
  return infiniteQueryOptions<
    ClientsContactsListResponse,
    AxiosError<DefaultError>,
    InfiniteData<ClientsContactsListResponse>,
    QueryKey<Options<ClientsContactsListData>>,
    | number
    | Pick<
        QueryKey<Options<ClientsContactsListData>>[0],
        'body' | 'headers' | 'path' | 'query'
      >
  >(
    // @ts-ignore
    {
      queryFn: async ({ pageParam, queryKey, signal }) => {
        // @ts-ignore
        const page: Pick<
          QueryKey<Options<ClientsContactsListData>>[0],
          'body' | 'headers' | 'path' | 'query'
        > =
          typeof pageParam === 'object'
            ? pageParam
            : {
                query: {
                  page: pageParam
                }
              }
        const params = createInfiniteParams(queryKey, page)
        const { data } = await clientsContactsList({
          ...options,
          ...params,
          signal,
          throwOnError: true
        })

        return data
      },
      queryKey: clientsContactsListInfiniteQueryKey(options)
    }
  )
}

export const clientsContactsRetrieveQueryKey = (
  options: Options<ClientsContactsRetrieveData>
) => createQueryKey('clientsContactsRetrieve', options)

export const clientsContactsRetrieveOptions = (
  options: Options<ClientsContactsRetrieveData>
) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await clientsContactsRetrieve({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true
      })

      return data
    },
    queryKey: clientsContactsRetrieveQueryKey(options)
  })
}

export const clientsContractsListQueryKey = (
  options: Options<ClientsContractsListData>
) => createQueryKey('clientsContractsList', options)

export const clientsContractsListOptions = (
  options: Options<ClientsContractsListData>
) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await clientsContractsList({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true
      })

      return data
    },
    queryKey: clientsContractsListQueryKey(options)
  })
}

export const clientsContractsListInfiniteQueryKey = (
  options: Options<ClientsContractsListData>
): QueryKey<Options<ClientsContractsListData>> =>
  createQueryKey('clientsContractsList', options, true)

export const clientsContractsListInfiniteOptions = (
  options: Options<ClientsContractsListData>
) => {
  return infiniteQueryOptions<
    ClientsContractsListResponse,
    AxiosError<DefaultError>,
    InfiniteData<ClientsContractsListResponse>,
    QueryKey<Options<ClientsContractsListData>>,
    | number
    | Pick<
        QueryKey<Options<ClientsContractsListData>>[0],
        'body' | 'headers' | 'path' | 'query'
      >
  >(
    // @ts-ignore
    {
      queryFn: async ({ pageParam, queryKey, signal }) => {
        // @ts-ignore
        const page: Pick<
          QueryKey<Options<ClientsContractsListData>>[0],
          'body' | 'headers' | 'path' | 'query'
        > =
          typeof pageParam === 'object'
            ? pageParam
            : {
                query: {
                  page: pageParam
                }
              }
        const params = createInfiniteParams(queryKey, page)
        const { data } = await clientsContractsList({
          ...options,
          ...params,
          signal,
          throwOnError: true
        })

        return data
      },
      queryKey: clientsContractsListInfiniteQueryKey(options)
    }
  )
}

export const clientsContractsRetrieveQueryKey = (
  options: Options<ClientsContractsRetrieveData>
) => createQueryKey('clientsContractsRetrieve', options)

export const clientsContractsRetrieveOptions = (
  options: Options<ClientsContractsRetrieveData>
) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await clientsContractsRetrieve({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true
      })

      return data
    },
    queryKey: clientsContractsRetrieveQueryKey(options)
  })
}

export const clientsLeadsListQueryKey = (
  options: Options<ClientsLeadsListData>
) => createQueryKey('clientsLeadsList', options)

export const clientsLeadsListOptions = (
  options: Options<ClientsLeadsListData>
) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await clientsLeadsList({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true
      })

      return data
    },
    queryKey: clientsLeadsListQueryKey(options)
  })
}

export const clientsLeadsListInfiniteQueryKey = (
  options: Options<ClientsLeadsListData>
): QueryKey<Options<ClientsLeadsListData>> =>
  createQueryKey('clientsLeadsList', options, true)

export const clientsLeadsListInfiniteOptions = (
  options: Options<ClientsLeadsListData>
) => {
  return infiniteQueryOptions<
    ClientsLeadsListResponse,
    AxiosError<DefaultError>,
    InfiniteData<ClientsLeadsListResponse>,
    QueryKey<Options<ClientsLeadsListData>>,
    | number
    | Pick<
        QueryKey<Options<ClientsLeadsListData>>[0],
        'body' | 'headers' | 'path' | 'query'
      >
  >(
    // @ts-ignore
    {
      queryFn: async ({ pageParam, queryKey, signal }) => {
        // @ts-ignore
        const page: Pick<
          QueryKey<Options<ClientsLeadsListData>>[0],
          'body' | 'headers' | 'path' | 'query'
        > =
          typeof pageParam === 'object'
            ? pageParam
            : {
                query: {
                  page: pageParam
                }
              }
        const params = createInfiniteParams(queryKey, page)
        const { data } = await clientsLeadsList({
          ...options,
          ...params,
          signal,
          throwOnError: true
        })

        return data
      },
      queryKey: clientsLeadsListInfiniteQueryKey(options)
    }
  )
}

export const clientsLeadsRetrieveQueryKey = (
  options: Options<ClientsLeadsRetrieveData>
) => createQueryKey('clientsLeadsRetrieve', options)

export const clientsLeadsRetrieveOptions = (
  options: Options<ClientsLeadsRetrieveData>
) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await clientsLeadsRetrieve({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true
      })

      return data
    },
    queryKey: clientsLeadsRetrieveQueryKey(options)
  })
}

export const clientsLogsListQueryKey = (
  options: Options<ClientsLogsListData>
) => createQueryKey('clientsLogsList', options)

export const clientsLogsListOptions = (
  options: Options<ClientsLogsListData>
) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await clientsLogsList({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true
      })

      return data
    },
    queryKey: clientsLogsListQueryKey(options)
  })
}

export const clientsLogsListInfiniteQueryKey = (
  options: Options<ClientsLogsListData>
): QueryKey<Options<ClientsLogsListData>> =>
  createQueryKey('clientsLogsList', options, true)

export const clientsLogsListInfiniteOptions = (
  options: Options<ClientsLogsListData>
) => {
  return infiniteQueryOptions<
    ClientsLogsListResponse,
    AxiosError<DefaultError>,
    InfiniteData<ClientsLogsListResponse>,
    QueryKey<Options<ClientsLogsListData>>,
    | number
    | Pick<
        QueryKey<Options<ClientsLogsListData>>[0],
        'body' | 'headers' | 'path' | 'query'
      >
  >(
    // @ts-ignore
    {
      queryFn: async ({ pageParam, queryKey, signal }) => {
        // @ts-ignore
        const page: Pick<
          QueryKey<Options<ClientsLogsListData>>[0],
          'body' | 'headers' | 'path' | 'query'
        > =
          typeof pageParam === 'object'
            ? pageParam
            : {
                query: {
                  page: pageParam
                }
              }
        const params = createInfiniteParams(queryKey, page)
        const { data } = await clientsLogsList({
          ...options,
          ...params,
          signal,
          throwOnError: true
        })

        return data
      },
      queryKey: clientsLogsListInfiniteQueryKey(options)
    }
  )
}

export const clientsLogsRetrieveQueryKey = (
  options: Options<ClientsLogsRetrieveData>
) => createQueryKey('clientsLogsRetrieve', options)

export const clientsLogsRetrieveOptions = (
  options: Options<ClientsLogsRetrieveData>
) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await clientsLogsRetrieve({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true
      })

      return data
    },
    queryKey: clientsLogsRetrieveQueryKey(options)
  })
}

export const clientsOpportunitiesListQueryKey = (
  options: Options<ClientsOpportunitiesListData>
) => createQueryKey('clientsOpportunitiesList', options)

export const clientsOpportunitiesListOptions = (
  options: Options<ClientsOpportunitiesListData>
) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await clientsOpportunitiesList({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true
      })

      return data
    },
    queryKey: clientsOpportunitiesListQueryKey(options)
  })
}

export const clientsOpportunitiesListInfiniteQueryKey = (
  options: Options<ClientsOpportunitiesListData>
): QueryKey<Options<ClientsOpportunitiesListData>> =>
  createQueryKey('clientsOpportunitiesList', options, true)

export const clientsOpportunitiesListInfiniteOptions = (
  options: Options<ClientsOpportunitiesListData>
) => {
  return infiniteQueryOptions<
    ClientsOpportunitiesListResponse,
    AxiosError<DefaultError>,
    InfiniteData<ClientsOpportunitiesListResponse>,
    QueryKey<Options<ClientsOpportunitiesListData>>,
    | number
    | Pick<
        QueryKey<Options<ClientsOpportunitiesListData>>[0],
        'body' | 'headers' | 'path' | 'query'
      >
  >(
    // @ts-ignore
    {
      queryFn: async ({ pageParam, queryKey, signal }) => {
        // @ts-ignore
        const page: Pick<
          QueryKey<Options<ClientsOpportunitiesListData>>[0],
          'body' | 'headers' | 'path' | 'query'
        > =
          typeof pageParam === 'object'
            ? pageParam
            : {
                query: {
                  page: pageParam
                }
              }
        const params = createInfiniteParams(queryKey, page)
        const { data } = await clientsOpportunitiesList({
          ...options,
          ...params,
          signal,
          throwOnError: true
        })

        return data
      },
      queryKey: clientsOpportunitiesListInfiniteQueryKey(options)
    }
  )
}

export const clientsOpportunitiesCreateQueryKey = (
  options: Options<ClientsOpportunitiesCreateData>
) => createQueryKey('clientsOpportunitiesCreate', options)

export const clientsOpportunitiesCreateOptions = (
  options: Options<ClientsOpportunitiesCreateData>
) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await clientsOpportunitiesCreate({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true
      })

      return data
    },
    queryKey: clientsOpportunitiesCreateQueryKey(options)
  })
}

export const clientsOpportunitiesCreateMutation = (
  options?: Partial<Options<ClientsOpportunitiesCreateData>>
): UseMutationOptions<
  ClientsOpportunitiesCreateResponse,
  AxiosError<DefaultError>,
  Options<ClientsOpportunitiesCreateData>
> => {
  const mutationOptions: UseMutationOptions<
    ClientsOpportunitiesCreateResponse,
    AxiosError<DefaultError>,
    Options<ClientsOpportunitiesCreateData>
  > = {
    mutationFn: async (localOptions) => {
      const { data } = await clientsOpportunitiesCreate({
        ...options,
        ...localOptions,
        throwOnError: true
      })

      return data
    }
  }

  return mutationOptions
}

export const clientsOpportunitiesDestroyMutation = (
  options?: Partial<Options<ClientsOpportunitiesDestroyData>>
): UseMutationOptions<
  ClientsOpportunitiesDestroyResponse,
  AxiosError<DefaultError>,
  Options<ClientsOpportunitiesDestroyData>
> => {
  const mutationOptions: UseMutationOptions<
    ClientsOpportunitiesDestroyResponse,
    AxiosError<DefaultError>,
    Options<ClientsOpportunitiesDestroyData>
  > = {
    mutationFn: async (localOptions) => {
      const { data } = await clientsOpportunitiesDestroy({
        ...options,
        ...localOptions,
        throwOnError: true
      })

      return data
    }
  }

  return mutationOptions
}

export const clientsOpportunitiesRetrieveQueryKey = (
  options: Options<ClientsOpportunitiesRetrieveData>
) => createQueryKey('clientsOpportunitiesRetrieve', options)

export const clientsOpportunitiesRetrieveOptions = (
  options: Options<ClientsOpportunitiesRetrieveData>
) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await clientsOpportunitiesRetrieve({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true
      })

      return data
    },
    queryKey: clientsOpportunitiesRetrieveQueryKey(options)
  })
}

export const clientsOpportunitiesPartialUpdateMutation = (
  options?: Partial<Options<ClientsOpportunitiesPartialUpdateData>>
): UseMutationOptions<
  ClientsOpportunitiesPartialUpdateResponse,
  AxiosError<DefaultError>,
  Options<ClientsOpportunitiesPartialUpdateData>
> => {
  const mutationOptions: UseMutationOptions<
    ClientsOpportunitiesPartialUpdateResponse,
    AxiosError<DefaultError>,
    Options<ClientsOpportunitiesPartialUpdateData>
  > = {
    mutationFn: async (localOptions) => {
      const { data } = await clientsOpportunitiesPartialUpdate({
        ...options,
        ...localOptions,
        throwOnError: true
      })

      return data
    }
  }

  return mutationOptions
}

export const clientsOpportunitiesUpdateMutation = (
  options?: Partial<Options<ClientsOpportunitiesUpdateData>>
): UseMutationOptions<
  ClientsOpportunitiesUpdateResponse,
  AxiosError<DefaultError>,
  Options<ClientsOpportunitiesUpdateData>
> => {
  const mutationOptions: UseMutationOptions<
    ClientsOpportunitiesUpdateResponse,
    AxiosError<DefaultError>,
    Options<ClientsOpportunitiesUpdateData>
  > = {
    mutationFn: async (localOptions) => {
      const { data } = await clientsOpportunitiesUpdate({
        ...options,
        ...localOptions,
        throwOnError: true
      })

      return data
    }
  }

  return mutationOptions
}

export const clientsTasksListQueryKey = (
  options: Options<ClientsTasksListData>
) => createQueryKey('clientsTasksList', options)

export const clientsTasksListOptions = (
  options: Options<ClientsTasksListData>
) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await clientsTasksList({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true
      })

      return data
    },
    queryKey: clientsTasksListQueryKey(options)
  })
}

export const clientsTasksListInfiniteQueryKey = (
  options: Options<ClientsTasksListData>
): QueryKey<Options<ClientsTasksListData>> =>
  createQueryKey('clientsTasksList', options, true)

export const clientsTasksListInfiniteOptions = (
  options: Options<ClientsTasksListData>
) => {
  return infiniteQueryOptions<
    ClientsTasksListResponse,
    AxiosError<DefaultError>,
    InfiniteData<ClientsTasksListResponse>,
    QueryKey<Options<ClientsTasksListData>>,
    | number
    | Pick<
        QueryKey<Options<ClientsTasksListData>>[0],
        'body' | 'headers' | 'path' | 'query'
      >
  >(
    // @ts-ignore
    {
      queryFn: async ({ pageParam, queryKey, signal }) => {
        // @ts-ignore
        const page: Pick<
          QueryKey<Options<ClientsTasksListData>>[0],
          'body' | 'headers' | 'path' | 'query'
        > =
          typeof pageParam === 'object'
            ? pageParam
            : {
                query: {
                  page: pageParam
                }
              }
        const params = createInfiniteParams(queryKey, page)
        const { data } = await clientsTasksList({
          ...options,
          ...params,
          signal,
          throwOnError: true
        })

        return data
      },
      queryKey: clientsTasksListInfiniteQueryKey(options)
    }
  )
}

export const clientsTasksCreateQueryKey = (
  options: Options<ClientsTasksCreateData>
) => createQueryKey('clientsTasksCreate', options)

export const clientsTasksCreateOptions = (
  options: Options<ClientsTasksCreateData>
) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await clientsTasksCreate({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true
      })

      return data
    },
    queryKey: clientsTasksCreateQueryKey(options)
  })
}

export const clientsTasksCreateMutation = (
  options?: Partial<Options<ClientsTasksCreateData>>
): UseMutationOptions<
  ClientsTasksCreateResponse,
  AxiosError<DefaultError>,
  Options<ClientsTasksCreateData>
> => {
  const mutationOptions: UseMutationOptions<
    ClientsTasksCreateResponse,
    AxiosError<DefaultError>,
    Options<ClientsTasksCreateData>
  > = {
    mutationFn: async (localOptions) => {
      const { data } = await clientsTasksCreate({
        ...options,
        ...localOptions,
        throwOnError: true
      })

      return data
    }
  }

  return mutationOptions
}

export const clientsTasksDestroyMutation = (
  options?: Partial<Options<ClientsTasksDestroyData>>
): UseMutationOptions<
  ClientsTasksDestroyResponse,
  AxiosError<DefaultError>,
  Options<ClientsTasksDestroyData>
> => {
  const mutationOptions: UseMutationOptions<
    ClientsTasksDestroyResponse,
    AxiosError<DefaultError>,
    Options<ClientsTasksDestroyData>
  > = {
    mutationFn: async (localOptions) => {
      const { data } = await clientsTasksDestroy({
        ...options,
        ...localOptions,
        throwOnError: true
      })

      return data
    }
  }

  return mutationOptions
}

export const clientsTasksRetrieveQueryKey = (
  options: Options<ClientsTasksRetrieveData>
) => createQueryKey('clientsTasksRetrieve', options)

export const clientsTasksRetrieveOptions = (
  options: Options<ClientsTasksRetrieveData>
) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await clientsTasksRetrieve({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true
      })

      return data
    },
    queryKey: clientsTasksRetrieveQueryKey(options)
  })
}

export const clientsTasksPartialUpdateMutation = (
  options?: Partial<Options<ClientsTasksPartialUpdateData>>
): UseMutationOptions<
  ClientsTasksPartialUpdateResponse,
  AxiosError<DefaultError>,
  Options<ClientsTasksPartialUpdateData>
> => {
  const mutationOptions: UseMutationOptions<
    ClientsTasksPartialUpdateResponse,
    AxiosError<DefaultError>,
    Options<ClientsTasksPartialUpdateData>
  > = {
    mutationFn: async (localOptions) => {
      const { data } = await clientsTasksPartialUpdate({
        ...options,
        ...localOptions,
        throwOnError: true
      })

      return data
    }
  }

  return mutationOptions
}

export const clientsTasksUpdateMutation = (
  options?: Partial<Options<ClientsTasksUpdateData>>
): UseMutationOptions<
  ClientsTasksUpdateResponse,
  AxiosError<DefaultError>,
  Options<ClientsTasksUpdateData>
> => {
  const mutationOptions: UseMutationOptions<
    ClientsTasksUpdateResponse,
    AxiosError<DefaultError>,
    Options<ClientsTasksUpdateData>
  > = {
    mutationFn: async (localOptions) => {
      const { data } = await clientsTasksUpdate({
        ...options,
        ...localOptions,
        throwOnError: true
      })

      return data
    }
  }

  return mutationOptions
}

export const clientsRetrieveQueryKey = (
  options: Options<ClientsRetrieveData>
) => createQueryKey('clientsRetrieve', options)

export const clientsRetrieveOptions = (
  options: Options<ClientsRetrieveData>
) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await clientsRetrieve({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true
      })

      return data
    },
    queryKey: clientsRetrieveQueryKey(options)
  })
}

export const clientsImportContractCreateQueryKey = (
  options: Options<ClientsImportContractCreateData>
) => createQueryKey('clientsImportContractCreate', options)

export const clientsImportContractCreateOptions = (
  options: Options<ClientsImportContractCreateData>
) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await clientsImportContractCreate({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true
      })

      return data
    },
    queryKey: clientsImportContractCreateQueryKey(options)
  })
}

export const clientsImportContractCreateMutation = (
  options?: Partial<Options<ClientsImportContractCreateData>>
): UseMutationOptions<
  ClientsImportContractCreateResponse,
  AxiosError<DefaultError>,
  Options<ClientsImportContractCreateData>
> => {
  const mutationOptions: UseMutationOptions<
    ClientsImportContractCreateResponse,
    AxiosError<DefaultError>,
    Options<ClientsImportContractCreateData>
  > = {
    mutationFn: async (localOptions) => {
      const { data } = await clientsImportContractCreate({
        ...options,
        ...localOptions,
        throwOnError: true
      })

      return data
    }
  }

  return mutationOptions
}

export const companySizesListQueryKey = (
  options?: Options<CompanySizesListData>
) => createQueryKey('companySizesList', options)

export const companySizesListOptions = (
  options?: Options<CompanySizesListData>
) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await companySizesList({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true
      })

      return data
    },
    queryKey: companySizesListQueryKey(options)
  })
}

export const companySizesListInfiniteQueryKey = (
  options?: Options<CompanySizesListData>
): QueryKey<Options<CompanySizesListData>> =>
  createQueryKey('companySizesList', options, true)

export const companySizesListInfiniteOptions = (
  options?: Options<CompanySizesListData>
) => {
  return infiniteQueryOptions<
    CompanySizesListResponse,
    AxiosError<DefaultError>,
    InfiniteData<CompanySizesListResponse>,
    QueryKey<Options<CompanySizesListData>>,
    | number
    | Pick<
        QueryKey<Options<CompanySizesListData>>[0],
        'body' | 'headers' | 'path' | 'query'
      >
  >(
    // @ts-ignore
    {
      queryFn: async ({ pageParam, queryKey, signal }) => {
        // @ts-ignore
        const page: Pick<
          QueryKey<Options<CompanySizesListData>>[0],
          'body' | 'headers' | 'path' | 'query'
        > =
          typeof pageParam === 'object'
            ? pageParam
            : {
                query: {
                  page: pageParam
                }
              }
        const params = createInfiniteParams(queryKey, page)
        const { data } = await companySizesList({
          ...options,
          ...params,
          signal,
          throwOnError: true
        })

        return data
      },
      queryKey: companySizesListInfiniteQueryKey(options)
    }
  )
}

export const companySizesCreateQueryKey = (
  options: Options<CompanySizesCreateData>
) => createQueryKey('companySizesCreate', options)

export const companySizesCreateOptions = (
  options: Options<CompanySizesCreateData>
) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await companySizesCreate({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true
      })

      return data
    },
    queryKey: companySizesCreateQueryKey(options)
  })
}

export const companySizesCreateMutation = (
  options?: Partial<Options<CompanySizesCreateData>>
): UseMutationOptions<
  CompanySizesCreateResponse,
  AxiosError<DefaultError>,
  Options<CompanySizesCreateData>
> => {
  const mutationOptions: UseMutationOptions<
    CompanySizesCreateResponse,
    AxiosError<DefaultError>,
    Options<CompanySizesCreateData>
  > = {
    mutationFn: async (localOptions) => {
      const { data } = await companySizesCreate({
        ...options,
        ...localOptions,
        throwOnError: true
      })

      return data
    }
  }

  return mutationOptions
}

export const companySizesDestroyMutation = (
  options?: Partial<Options<CompanySizesDestroyData>>
): UseMutationOptions<
  CompanySizesDestroyResponse,
  AxiosError<DefaultError>,
  Options<CompanySizesDestroyData>
> => {
  const mutationOptions: UseMutationOptions<
    CompanySizesDestroyResponse,
    AxiosError<DefaultError>,
    Options<CompanySizesDestroyData>
  > = {
    mutationFn: async (localOptions) => {
      const { data } = await companySizesDestroy({
        ...options,
        ...localOptions,
        throwOnError: true
      })

      return data
    }
  }

  return mutationOptions
}

export const companySizesRetrieveQueryKey = (
  options: Options<CompanySizesRetrieveData>
) => createQueryKey('companySizesRetrieve', options)

export const companySizesRetrieveOptions = (
  options: Options<CompanySizesRetrieveData>
) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await companySizesRetrieve({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true
      })

      return data
    },
    queryKey: companySizesRetrieveQueryKey(options)
  })
}

export const companySizesPartialUpdateMutation = (
  options?: Partial<Options<CompanySizesPartialUpdateData>>
): UseMutationOptions<
  CompanySizesPartialUpdateResponse,
  AxiosError<DefaultError>,
  Options<CompanySizesPartialUpdateData>
> => {
  const mutationOptions: UseMutationOptions<
    CompanySizesPartialUpdateResponse,
    AxiosError<DefaultError>,
    Options<CompanySizesPartialUpdateData>
  > = {
    mutationFn: async (localOptions) => {
      const { data } = await companySizesPartialUpdate({
        ...options,
        ...localOptions,
        throwOnError: true
      })

      return data
    }
  }

  return mutationOptions
}

export const companySizesUpdateMutation = (
  options?: Partial<Options<CompanySizesUpdateData>>
): UseMutationOptions<
  CompanySizesUpdateResponse,
  AxiosError<DefaultError>,
  Options<CompanySizesUpdateData>
> => {
  const mutationOptions: UseMutationOptions<
    CompanySizesUpdateResponse,
    AxiosError<DefaultError>,
    Options<CompanySizesUpdateData>
  > = {
    mutationFn: async (localOptions) => {
      const { data } = await companySizesUpdate({
        ...options,
        ...localOptions,
        throwOnError: true
      })

      return data
    }
  }

  return mutationOptions
}

export const companySizesListListQueryKey = (
  options?: Options<CompanySizesListListData>
) => createQueryKey('companySizesListList', options)

export const companySizesListListOptions = (
  options?: Options<CompanySizesListListData>
) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await companySizesListList({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true
      })

      return data
    },
    queryKey: companySizesListListQueryKey(options)
  })
}

export const companySizesListListInfiniteQueryKey = (
  options?: Options<CompanySizesListListData>
): QueryKey<Options<CompanySizesListListData>> =>
  createQueryKey('companySizesListList', options, true)

export const companySizesListListInfiniteOptions = (
  options?: Options<CompanySizesListListData>
) => {
  return infiniteQueryOptions<
    CompanySizesListListResponse,
    AxiosError<DefaultError>,
    InfiniteData<CompanySizesListListResponse>,
    QueryKey<Options<CompanySizesListListData>>,
    | number
    | Pick<
        QueryKey<Options<CompanySizesListListData>>[0],
        'body' | 'headers' | 'path' | 'query'
      >
  >(
    // @ts-ignore
    {
      queryFn: async ({ pageParam, queryKey, signal }) => {
        // @ts-ignore
        const page: Pick<
          QueryKey<Options<CompanySizesListListData>>[0],
          'body' | 'headers' | 'path' | 'query'
        > =
          typeof pageParam === 'object'
            ? pageParam
            : {
                query: {
                  page: pageParam
                }
              }
        const params = createInfiniteParams(queryKey, page)
        const { data } = await companySizesListList({
          ...options,
          ...params,
          signal,
          throwOnError: true
        })

        return data
      },
      queryKey: companySizesListListInfiniteQueryKey(options)
    }
  )
}

export const connectorsBulkAddContactsCreateQueryKey = (
  options: Options<ConnectorsBulkAddContactsCreateData>
) => createQueryKey('connectorsBulkAddContactsCreate', options)

export const connectorsBulkAddContactsCreateOptions = (
  options: Options<ConnectorsBulkAddContactsCreateData>
) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await connectorsBulkAddContactsCreate({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true
      })

      return data
    },
    queryKey: connectorsBulkAddContactsCreateQueryKey(options)
  })
}

export const connectorsBulkAddContactsCreateMutation = (
  options?: Partial<Options<ConnectorsBulkAddContactsCreateData>>
): UseMutationOptions<
  ConnectorsBulkAddContactsCreateResponse,
  AxiosError<DefaultError>,
  Options<ConnectorsBulkAddContactsCreateData>
> => {
  const mutationOptions: UseMutationOptions<
    ConnectorsBulkAddContactsCreateResponse,
    AxiosError<DefaultError>,
    Options<ConnectorsBulkAddContactsCreateData>
  > = {
    mutationFn: async (localOptions) => {
      const { data } = await connectorsBulkAddContactsCreate({
        ...options,
        ...localOptions,
        throwOnError: true
      })

      return data
    }
  }

  return mutationOptions
}

export const connectorsListListQueryKey = (
  options?: Options<ConnectorsListListData>
) => createQueryKey('connectorsListList', options)

export const connectorsListListOptions = (
  options?: Options<ConnectorsListListData>
) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await connectorsListList({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true
      })

      return data
    },
    queryKey: connectorsListListQueryKey(options)
  })
}

export const connectorsOptionsRetrieveQueryKey = (
  options?: Options<ConnectorsOptionsRetrieveData>
) => createQueryKey('connectorsOptionsRetrieve', options)

export const connectorsOptionsRetrieveOptions = (
  options?: Options<ConnectorsOptionsRetrieveData>
) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await connectorsOptionsRetrieve({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true
      })

      return data
    },
    queryKey: connectorsOptionsRetrieveQueryKey(options)
  })
}

export const contactsListQueryKey = (options?: Options<ContactsListData>) =>
  createQueryKey('contactsList', options)

export const contactsListOptions = (options?: Options<ContactsListData>) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await contactsList({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true
      })

      return data
    },
    queryKey: contactsListQueryKey(options)
  })
}

export const contactsListInfiniteQueryKey = (
  options?: Options<ContactsListData>
): QueryKey<Options<ContactsListData>> =>
  createQueryKey('contactsList', options, true)

export const contactsListInfiniteOptions = (
  options?: Options<ContactsListData>
) => {
  return infiniteQueryOptions<
    ContactsListResponse,
    AxiosError<DefaultError>,
    InfiniteData<ContactsListResponse>,
    QueryKey<Options<ContactsListData>>,
    | number
    | Pick<
        QueryKey<Options<ContactsListData>>[0],
        'body' | 'headers' | 'path' | 'query'
      >
  >(
    // @ts-ignore
    {
      queryFn: async ({ pageParam, queryKey, signal }) => {
        // @ts-ignore
        const page: Pick<
          QueryKey<Options<ContactsListData>>[0],
          'body' | 'headers' | 'path' | 'query'
        > =
          typeof pageParam === 'object'
            ? pageParam
            : {
                query: {
                  page: pageParam
                }
              }
        const params = createInfiniteParams(queryKey, page)
        const { data } = await contactsList({
          ...options,
          ...params,
          signal,
          throwOnError: true
        })

        return data
      },
      queryKey: contactsListInfiniteQueryKey(options)
    }
  )
}

export const contactsCreateQueryKey = (options?: Options<ContactsCreateData>) =>
  createQueryKey('contactsCreate', options)

export const contactsCreateOptions = (
  options?: Options<ContactsCreateData>
) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await contactsCreate({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true
      })

      return data
    },
    queryKey: contactsCreateQueryKey(options)
  })
}

export const contactsCreateMutation = (
  options?: Partial<Options<ContactsCreateData>>
): UseMutationOptions<
  ContactsCreateResponse,
  AxiosError<DefaultError>,
  Options<ContactsCreateData>
> => {
  const mutationOptions: UseMutationOptions<
    ContactsCreateResponse,
    AxiosError<DefaultError>,
    Options<ContactsCreateData>
  > = {
    mutationFn: async (localOptions) => {
      const { data } = await contactsCreate({
        ...options,
        ...localOptions,
        throwOnError: true
      })

      return data
    }
  }

  return mutationOptions
}

export const contactsDestroyMutation = (
  options?: Partial<Options<ContactsDestroyData>>
): UseMutationOptions<
  ContactsDestroyResponse,
  AxiosError<DefaultError>,
  Options<ContactsDestroyData>
> => {
  const mutationOptions: UseMutationOptions<
    ContactsDestroyResponse,
    AxiosError<DefaultError>,
    Options<ContactsDestroyData>
  > = {
    mutationFn: async (localOptions) => {
      const { data } = await contactsDestroy({
        ...options,
        ...localOptions,
        throwOnError: true
      })

      return data
    }
  }

  return mutationOptions
}

export const contactsRetrieveQueryKey = (
  options: Options<ContactsRetrieveData>
) => createQueryKey('contactsRetrieve', options)

export const contactsRetrieveOptions = (
  options: Options<ContactsRetrieveData>
) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await contactsRetrieve({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true
      })

      return data
    },
    queryKey: contactsRetrieveQueryKey(options)
  })
}

export const contactsPartialUpdateMutation = (
  options?: Partial<Options<ContactsPartialUpdateData>>
): UseMutationOptions<
  ContactsPartialUpdateResponse,
  AxiosError<DefaultError>,
  Options<ContactsPartialUpdateData>
> => {
  const mutationOptions: UseMutationOptions<
    ContactsPartialUpdateResponse,
    AxiosError<DefaultError>,
    Options<ContactsPartialUpdateData>
  > = {
    mutationFn: async (localOptions) => {
      const { data } = await contactsPartialUpdate({
        ...options,
        ...localOptions,
        throwOnError: true
      })

      return data
    }
  }

  return mutationOptions
}

export const contactsUpdateMutation = (
  options?: Partial<Options<ContactsUpdateData>>
): UseMutationOptions<
  ContactsUpdateResponse,
  AxiosError<DefaultError>,
  Options<ContactsUpdateData>
> => {
  const mutationOptions: UseMutationOptions<
    ContactsUpdateResponse,
    AxiosError<DefaultError>,
    Options<ContactsUpdateData>
  > = {
    mutationFn: async (localOptions) => {
      const { data } = await contactsUpdate({
        ...options,
        ...localOptions,
        throwOnError: true
      })

      return data
    }
  }

  return mutationOptions
}

export const contactsConnectionsRetrieveQueryKey = (
  options: Options<ContactsConnectionsRetrieveData>
) => createQueryKey('contactsConnectionsRetrieve', options)

/**
 * Get contact connection graph
 * Returns graph nodes representing all contact connections such as leads and opportunities.
 */
export const contactsConnectionsRetrieveOptions = (
  options: Options<ContactsConnectionsRetrieveData>
) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await contactsConnectionsRetrieve({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true
      })

      return data
    },
    queryKey: contactsConnectionsRetrieveQueryKey(options)
  })
}

export const contactsInitCallCreateQueryKey = (
  options: Options<ContactsInitCallCreateData>
) => createQueryKey('contactsInitCallCreate', options)

export const contactsInitCallCreateOptions = (
  options: Options<ContactsInitCallCreateData>
) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await contactsInitCallCreate({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true
      })

      return data
    },
    queryKey: contactsInitCallCreateQueryKey(options)
  })
}

export const contactsInitCallCreateMutation = (
  options?: Partial<Options<ContactsInitCallCreateData>>
): UseMutationOptions<
  ContactsInitCallCreateResponse,
  AxiosError<DefaultError>,
  Options<ContactsInitCallCreateData>
> => {
  const mutationOptions: UseMutationOptions<
    ContactsInitCallCreateResponse,
    AxiosError<DefaultError>,
    Options<ContactsInitCallCreateData>
  > = {
    mutationFn: async (localOptions) => {
      const { data } = await contactsInitCallCreate({
        ...options,
        ...localOptions,
        throwOnError: true
      })

      return data
    }
  }

  return mutationOptions
}

export const contactsPhoneNumbersListQueryKey = (
  options?: Options<ContactsPhoneNumbersListData>
) => createQueryKey('contactsPhoneNumbersList', options)

export const contactsPhoneNumbersListOptions = (
  options?: Options<ContactsPhoneNumbersListData>
) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await contactsPhoneNumbersList({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true
      })

      return data
    },
    queryKey: contactsPhoneNumbersListQueryKey(options)
  })
}

export const contactsPhoneNumbersListInfiniteQueryKey = (
  options?: Options<ContactsPhoneNumbersListData>
): QueryKey<Options<ContactsPhoneNumbersListData>> =>
  createQueryKey('contactsPhoneNumbersList', options, true)

export const contactsPhoneNumbersListInfiniteOptions = (
  options?: Options<ContactsPhoneNumbersListData>
) => {
  return infiniteQueryOptions<
    ContactsPhoneNumbersListResponse,
    AxiosError<DefaultError>,
    InfiniteData<ContactsPhoneNumbersListResponse>,
    QueryKey<Options<ContactsPhoneNumbersListData>>,
    | number
    | Pick<
        QueryKey<Options<ContactsPhoneNumbersListData>>[0],
        'body' | 'headers' | 'path' | 'query'
      >
  >(
    // @ts-ignore
    {
      queryFn: async ({ pageParam, queryKey, signal }) => {
        // @ts-ignore
        const page: Pick<
          QueryKey<Options<ContactsPhoneNumbersListData>>[0],
          'body' | 'headers' | 'path' | 'query'
        > =
          typeof pageParam === 'object'
            ? pageParam
            : {
                query: {
                  page: pageParam
                }
              }
        const params = createInfiniteParams(queryKey, page)
        const { data } = await contactsPhoneNumbersList({
          ...options,
          ...params,
          signal,
          throwOnError: true
        })

        return data
      },
      queryKey: contactsPhoneNumbersListInfiniteQueryKey(options)
    }
  )
}

export const contactsPhoneNumbersCreateQueryKey = (
  options: Options<ContactsPhoneNumbersCreateData>
) => createQueryKey('contactsPhoneNumbersCreate', options)

export const contactsPhoneNumbersCreateOptions = (
  options: Options<ContactsPhoneNumbersCreateData>
) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await contactsPhoneNumbersCreate({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true
      })

      return data
    },
    queryKey: contactsPhoneNumbersCreateQueryKey(options)
  })
}

export const contactsPhoneNumbersCreateMutation = (
  options?: Partial<Options<ContactsPhoneNumbersCreateData>>
): UseMutationOptions<
  ContactsPhoneNumbersCreateResponse,
  AxiosError<DefaultError>,
  Options<ContactsPhoneNumbersCreateData>
> => {
  const mutationOptions: UseMutationOptions<
    ContactsPhoneNumbersCreateResponse,
    AxiosError<DefaultError>,
    Options<ContactsPhoneNumbersCreateData>
  > = {
    mutationFn: async (localOptions) => {
      const { data } = await contactsPhoneNumbersCreate({
        ...options,
        ...localOptions,
        throwOnError: true
      })

      return data
    }
  }

  return mutationOptions
}

export const contactsPhoneNumbersDestroyMutation = (
  options?: Partial<Options<ContactsPhoneNumbersDestroyData>>
): UseMutationOptions<
  ContactsPhoneNumbersDestroyResponse,
  AxiosError<DefaultError>,
  Options<ContactsPhoneNumbersDestroyData>
> => {
  const mutationOptions: UseMutationOptions<
    ContactsPhoneNumbersDestroyResponse,
    AxiosError<DefaultError>,
    Options<ContactsPhoneNumbersDestroyData>
  > = {
    mutationFn: async (localOptions) => {
      const { data } = await contactsPhoneNumbersDestroy({
        ...options,
        ...localOptions,
        throwOnError: true
      })

      return data
    }
  }

  return mutationOptions
}

export const contactsPhoneNumbersRetrieveQueryKey = (
  options: Options<ContactsPhoneNumbersRetrieveData>
) => createQueryKey('contactsPhoneNumbersRetrieve', options)

export const contactsPhoneNumbersRetrieveOptions = (
  options: Options<ContactsPhoneNumbersRetrieveData>
) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await contactsPhoneNumbersRetrieve({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true
      })

      return data
    },
    queryKey: contactsPhoneNumbersRetrieveQueryKey(options)
  })
}

export const contactsPhoneNumbersPartialUpdateMutation = (
  options?: Partial<Options<ContactsPhoneNumbersPartialUpdateData>>
): UseMutationOptions<
  ContactsPhoneNumbersPartialUpdateResponse,
  AxiosError<DefaultError>,
  Options<ContactsPhoneNumbersPartialUpdateData>
> => {
  const mutationOptions: UseMutationOptions<
    ContactsPhoneNumbersPartialUpdateResponse,
    AxiosError<DefaultError>,
    Options<ContactsPhoneNumbersPartialUpdateData>
  > = {
    mutationFn: async (localOptions) => {
      const { data } = await contactsPhoneNumbersPartialUpdate({
        ...options,
        ...localOptions,
        throwOnError: true
      })

      return data
    }
  }

  return mutationOptions
}

export const contactsPhoneNumbersUpdateMutation = (
  options?: Partial<Options<ContactsPhoneNumbersUpdateData>>
): UseMutationOptions<
  ContactsPhoneNumbersUpdateResponse,
  AxiosError<DefaultError>,
  Options<ContactsPhoneNumbersUpdateData>
> => {
  const mutationOptions: UseMutationOptions<
    ContactsPhoneNumbersUpdateResponse,
    AxiosError<DefaultError>,
    Options<ContactsPhoneNumbersUpdateData>
  > = {
    mutationFn: async (localOptions) => {
      const { data } = await contactsPhoneNumbersUpdate({
        ...options,
        ...localOptions,
        throwOnError: true
      })

      return data
    }
  }

  return mutationOptions
}

export const contractsListQueryKey = (options?: Options<ContractsListData>) =>
  createQueryKey('contractsList', options)

export const contractsListOptions = (options?: Options<ContractsListData>) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await contractsList({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true
      })

      return data
    },
    queryKey: contractsListQueryKey(options)
  })
}

export const contractsListInfiniteQueryKey = (
  options?: Options<ContractsListData>
): QueryKey<Options<ContractsListData>> =>
  createQueryKey('contractsList', options, true)

export const contractsListInfiniteOptions = (
  options?: Options<ContractsListData>
) => {
  return infiniteQueryOptions<
    ContractsListResponse,
    AxiosError<DefaultError>,
    InfiniteData<ContractsListResponse>,
    QueryKey<Options<ContractsListData>>,
    | number
    | Pick<
        QueryKey<Options<ContractsListData>>[0],
        'body' | 'headers' | 'path' | 'query'
      >
  >(
    // @ts-ignore
    {
      queryFn: async ({ pageParam, queryKey, signal }) => {
        // @ts-ignore
        const page: Pick<
          QueryKey<Options<ContractsListData>>[0],
          'body' | 'headers' | 'path' | 'query'
        > =
          typeof pageParam === 'object'
            ? pageParam
            : {
                query: {
                  page: pageParam
                }
              }
        const params = createInfiniteParams(queryKey, page)
        const { data } = await contractsList({
          ...options,
          ...params,
          signal,
          throwOnError: true
        })

        return data
      },
      queryKey: contractsListInfiniteQueryKey(options)
    }
  )
}

export const contractsCreateQueryKey = (
  options: Options<ContractsCreateData>
) => createQueryKey('contractsCreate', options)

export const contractsCreateOptions = (
  options: Options<ContractsCreateData>
) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await contractsCreate({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true
      })

      return data
    },
    queryKey: contractsCreateQueryKey(options)
  })
}

export const contractsCreateMutation = (
  options?: Partial<Options<ContractsCreateData>>
): UseMutationOptions<
  ContractsCreateResponse,
  AxiosError<DefaultError>,
  Options<ContractsCreateData>
> => {
  const mutationOptions: UseMutationOptions<
    ContractsCreateResponse,
    AxiosError<DefaultError>,
    Options<ContractsCreateData>
  > = {
    mutationFn: async (localOptions) => {
      const { data } = await contractsCreate({
        ...options,
        ...localOptions,
        throwOnError: true
      })

      return data
    }
  }

  return mutationOptions
}

export const contractsDestroyMutation = (
  options?: Partial<Options<ContractsDestroyData>>
): UseMutationOptions<
  ContractsDestroyResponse,
  AxiosError<DefaultError>,
  Options<ContractsDestroyData>
> => {
  const mutationOptions: UseMutationOptions<
    ContractsDestroyResponse,
    AxiosError<DefaultError>,
    Options<ContractsDestroyData>
  > = {
    mutationFn: async (localOptions) => {
      const { data } = await contractsDestroy({
        ...options,
        ...localOptions,
        throwOnError: true
      })

      return data
    }
  }

  return mutationOptions
}

export const contractsRetrieveQueryKey = (
  options: Options<ContractsRetrieveData>
) => createQueryKey('contractsRetrieve', options)

export const contractsRetrieveOptions = (
  options: Options<ContractsRetrieveData>
) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await contractsRetrieve({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true
      })

      return data
    },
    queryKey: contractsRetrieveQueryKey(options)
  })
}

export const contractsPartialUpdateMutation = (
  options?: Partial<Options<ContractsPartialUpdateData>>
): UseMutationOptions<
  ContractsPartialUpdateResponse,
  AxiosError<DefaultError>,
  Options<ContractsPartialUpdateData>
> => {
  const mutationOptions: UseMutationOptions<
    ContractsPartialUpdateResponse,
    AxiosError<DefaultError>,
    Options<ContractsPartialUpdateData>
  > = {
    mutationFn: async (localOptions) => {
      const { data } = await contractsPartialUpdate({
        ...options,
        ...localOptions,
        throwOnError: true
      })

      return data
    }
  }

  return mutationOptions
}

export const contractsUpdateMutation = (
  options?: Partial<Options<ContractsUpdateData>>
): UseMutationOptions<
  ContractsUpdateResponse,
  AxiosError<DefaultError>,
  Options<ContractsUpdateData>
> => {
  const mutationOptions: UseMutationOptions<
    ContractsUpdateResponse,
    AxiosError<DefaultError>,
    Options<ContractsUpdateData>
  > = {
    mutationFn: async (localOptions) => {
      const { data } = await contractsUpdate({
        ...options,
        ...localOptions,
        throwOnError: true
      })

      return data
    }
  }

  return mutationOptions
}

export const contractsFetchSiAsigCreateQueryKey = (
  options: Options<ContractsFetchSiAsigCreateData>
) => createQueryKey('contractsFetchSiAsigCreate', options)

export const contractsFetchSiAsigCreateOptions = (
  options: Options<ContractsFetchSiAsigCreateData>
) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await contractsFetchSiAsigCreate({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true
      })

      return data
    },
    queryKey: contractsFetchSiAsigCreateQueryKey(options)
  })
}

export const contractsFetchSiAsigCreateMutation = (
  options?: Partial<Options<ContractsFetchSiAsigCreateData>>
): UseMutationOptions<
  ContractsFetchSiAsigCreateResponse,
  AxiosError<DefaultError>,
  Options<ContractsFetchSiAsigCreateData>
> => {
  const mutationOptions: UseMutationOptions<
    ContractsFetchSiAsigCreateResponse,
    AxiosError<DefaultError>,
    Options<ContractsFetchSiAsigCreateData>
  > = {
    mutationFn: async (localOptions) => {
      const { data } = await contractsFetchSiAsigCreate({
        ...options,
        ...localOptions,
        throwOnError: true
      })

      return data
    }
  }

  return mutationOptions
}

export const countriesListQueryKey = (options?: Options<CountriesListData>) =>
  createQueryKey('countriesList', options)

export const countriesListOptions = (options?: Options<CountriesListData>) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await countriesList({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true
      })

      return data
    },
    queryKey: countriesListQueryKey(options)
  })
}

export const countriesListInfiniteQueryKey = (
  options?: Options<CountriesListData>
): QueryKey<Options<CountriesListData>> =>
  createQueryKey('countriesList', options, true)

export const countriesListInfiniteOptions = (
  options?: Options<CountriesListData>
) => {
  return infiniteQueryOptions<
    CountriesListResponse,
    AxiosError<DefaultError>,
    InfiniteData<CountriesListResponse>,
    QueryKey<Options<CountriesListData>>,
    | number
    | Pick<
        QueryKey<Options<CountriesListData>>[0],
        'body' | 'headers' | 'path' | 'query'
      >
  >(
    // @ts-ignore
    {
      queryFn: async ({ pageParam, queryKey, signal }) => {
        // @ts-ignore
        const page: Pick<
          QueryKey<Options<CountriesListData>>[0],
          'body' | 'headers' | 'path' | 'query'
        > =
          typeof pageParam === 'object'
            ? pageParam
            : {
                query: {
                  page: pageParam
                }
              }
        const params = createInfiniteParams(queryKey, page)
        const { data } = await countriesList({
          ...options,
          ...params,
          signal,
          throwOnError: true
        })

        return data
      },
      queryKey: countriesListInfiniteQueryKey(options)
    }
  )
}

export const countriesCreateQueryKey = (
  options: Options<CountriesCreateData>
) => createQueryKey('countriesCreate', options)

export const countriesCreateOptions = (
  options: Options<CountriesCreateData>
) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await countriesCreate({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true
      })

      return data
    },
    queryKey: countriesCreateQueryKey(options)
  })
}

export const countriesCreateMutation = (
  options?: Partial<Options<CountriesCreateData>>
): UseMutationOptions<
  CountriesCreateResponse,
  AxiosError<DefaultError>,
  Options<CountriesCreateData>
> => {
  const mutationOptions: UseMutationOptions<
    CountriesCreateResponse,
    AxiosError<DefaultError>,
    Options<CountriesCreateData>
  > = {
    mutationFn: async (localOptions) => {
      const { data } = await countriesCreate({
        ...options,
        ...localOptions,
        throwOnError: true
      })

      return data
    }
  }

  return mutationOptions
}

export const countriesDestroyMutation = (
  options?: Partial<Options<CountriesDestroyData>>
): UseMutationOptions<
  CountriesDestroyResponse,
  AxiosError<DefaultError>,
  Options<CountriesDestroyData>
> => {
  const mutationOptions: UseMutationOptions<
    CountriesDestroyResponse,
    AxiosError<DefaultError>,
    Options<CountriesDestroyData>
  > = {
    mutationFn: async (localOptions) => {
      const { data } = await countriesDestroy({
        ...options,
        ...localOptions,
        throwOnError: true
      })

      return data
    }
  }

  return mutationOptions
}

export const countriesRetrieveQueryKey = (
  options: Options<CountriesRetrieveData>
) => createQueryKey('countriesRetrieve', options)

export const countriesRetrieveOptions = (
  options: Options<CountriesRetrieveData>
) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await countriesRetrieve({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true
      })

      return data
    },
    queryKey: countriesRetrieveQueryKey(options)
  })
}

export const countriesPartialUpdateMutation = (
  options?: Partial<Options<CountriesPartialUpdateData>>
): UseMutationOptions<
  CountriesPartialUpdateResponse,
  AxiosError<DefaultError>,
  Options<CountriesPartialUpdateData>
> => {
  const mutationOptions: UseMutationOptions<
    CountriesPartialUpdateResponse,
    AxiosError<DefaultError>,
    Options<CountriesPartialUpdateData>
  > = {
    mutationFn: async (localOptions) => {
      const { data } = await countriesPartialUpdate({
        ...options,
        ...localOptions,
        throwOnError: true
      })

      return data
    }
  }

  return mutationOptions
}

export const countriesUpdateMutation = (
  options?: Partial<Options<CountriesUpdateData>>
): UseMutationOptions<
  CountriesUpdateResponse,
  AxiosError<DefaultError>,
  Options<CountriesUpdateData>
> => {
  const mutationOptions: UseMutationOptions<
    CountriesUpdateResponse,
    AxiosError<DefaultError>,
    Options<CountriesUpdateData>
  > = {
    mutationFn: async (localOptions) => {
      const { data } = await countriesUpdate({
        ...options,
        ...localOptions,
        throwOnError: true
      })

      return data
    }
  }

  return mutationOptions
}

export const countriesContinentsListQueryKey = (
  options?: Options<CountriesContinentsListData>
) => createQueryKey('countriesContinentsList', options)

export const countriesContinentsListOptions = (
  options?: Options<CountriesContinentsListData>
) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await countriesContinentsList({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true
      })

      return data
    },
    queryKey: countriesContinentsListQueryKey(options)
  })
}

export const countriesContinentsListInfiniteQueryKey = (
  options?: Options<CountriesContinentsListData>
): QueryKey<Options<CountriesContinentsListData>> =>
  createQueryKey('countriesContinentsList', options, true)

export const countriesContinentsListInfiniteOptions = (
  options?: Options<CountriesContinentsListData>
) => {
  return infiniteQueryOptions<
    CountriesContinentsListResponse,
    AxiosError<DefaultError>,
    InfiniteData<CountriesContinentsListResponse>,
    QueryKey<Options<CountriesContinentsListData>>,
    | number
    | Pick<
        QueryKey<Options<CountriesContinentsListData>>[0],
        'body' | 'headers' | 'path' | 'query'
      >
  >(
    // @ts-ignore
    {
      queryFn: async ({ pageParam, queryKey, signal }) => {
        // @ts-ignore
        const page: Pick<
          QueryKey<Options<CountriesContinentsListData>>[0],
          'body' | 'headers' | 'path' | 'query'
        > =
          typeof pageParam === 'object'
            ? pageParam
            : {
                query: {
                  page: pageParam
                }
              }
        const params = createInfiniteParams(queryKey, page)
        const { data } = await countriesContinentsList({
          ...options,
          ...params,
          signal,
          throwOnError: true
        })

        return data
      },
      queryKey: countriesContinentsListInfiniteQueryKey(options)
    }
  )
}

export const countriesListListQueryKey = (
  options?: Options<CountriesListListData>
) => createQueryKey('countriesListList', options)

export const countriesListListOptions = (
  options?: Options<CountriesListListData>
) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await countriesListList({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true
      })

      return data
    },
    queryKey: countriesListListQueryKey(options)
  })
}

export const countriesListListInfiniteQueryKey = (
  options?: Options<CountriesListListData>
): QueryKey<Options<CountriesListListData>> =>
  createQueryKey('countriesListList', options, true)

export const countriesListListInfiniteOptions = (
  options?: Options<CountriesListListData>
) => {
  return infiniteQueryOptions<
    CountriesListListResponse,
    AxiosError<DefaultError>,
    InfiniteData<CountriesListListResponse>,
    QueryKey<Options<CountriesListListData>>,
    | number
    | Pick<
        QueryKey<Options<CountriesListListData>>[0],
        'body' | 'headers' | 'path' | 'query'
      >
  >(
    // @ts-ignore
    {
      queryFn: async ({ pageParam, queryKey, signal }) => {
        // @ts-ignore
        const page: Pick<
          QueryKey<Options<CountriesListListData>>[0],
          'body' | 'headers' | 'path' | 'query'
        > =
          typeof pageParam === 'object'
            ? pageParam
            : {
                query: {
                  page: pageParam
                }
              }
        const params = createInfiniteParams(queryKey, page)
        const { data } = await countriesListList({
          ...options,
          ...params,
          signal,
          throwOnError: true
        })

        return data
      },
      queryKey: countriesListListInfiniteQueryKey(options)
    }
  )
}

export const currenciesListQueryKey = (options?: Options<CurrenciesListData>) =>
  createQueryKey('currenciesList', options)

export const currenciesListOptions = (
  options?: Options<CurrenciesListData>
) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await currenciesList({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true
      })

      return data
    },
    queryKey: currenciesListQueryKey(options)
  })
}

export const currenciesListInfiniteQueryKey = (
  options?: Options<CurrenciesListData>
): QueryKey<Options<CurrenciesListData>> =>
  createQueryKey('currenciesList', options, true)

export const currenciesListInfiniteOptions = (
  options?: Options<CurrenciesListData>
) => {
  return infiniteQueryOptions<
    CurrenciesListResponse,
    AxiosError<DefaultError>,
    InfiniteData<CurrenciesListResponse>,
    QueryKey<Options<CurrenciesListData>>,
    | number
    | Pick<
        QueryKey<Options<CurrenciesListData>>[0],
        'body' | 'headers' | 'path' | 'query'
      >
  >(
    // @ts-ignore
    {
      queryFn: async ({ pageParam, queryKey, signal }) => {
        // @ts-ignore
        const page: Pick<
          QueryKey<Options<CurrenciesListData>>[0],
          'body' | 'headers' | 'path' | 'query'
        > =
          typeof pageParam === 'object'
            ? pageParam
            : {
                query: {
                  page: pageParam
                }
              }
        const params = createInfiniteParams(queryKey, page)
        const { data } = await currenciesList({
          ...options,
          ...params,
          signal,
          throwOnError: true
        })

        return data
      },
      queryKey: currenciesListInfiniteQueryKey(options)
    }
  )
}

export const currenciesCreateQueryKey = (
  options: Options<CurrenciesCreateData>
) => createQueryKey('currenciesCreate', options)

export const currenciesCreateOptions = (
  options: Options<CurrenciesCreateData>
) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await currenciesCreate({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true
      })

      return data
    },
    queryKey: currenciesCreateQueryKey(options)
  })
}

export const currenciesCreateMutation = (
  options?: Partial<Options<CurrenciesCreateData>>
): UseMutationOptions<
  CurrenciesCreateResponse,
  AxiosError<DefaultError>,
  Options<CurrenciesCreateData>
> => {
  const mutationOptions: UseMutationOptions<
    CurrenciesCreateResponse,
    AxiosError<DefaultError>,
    Options<CurrenciesCreateData>
  > = {
    mutationFn: async (localOptions) => {
      const { data } = await currenciesCreate({
        ...options,
        ...localOptions,
        throwOnError: true
      })

      return data
    }
  }

  return mutationOptions
}

export const currenciesDestroyMutation = (
  options?: Partial<Options<CurrenciesDestroyData>>
): UseMutationOptions<
  CurrenciesDestroyResponse,
  AxiosError<DefaultError>,
  Options<CurrenciesDestroyData>
> => {
  const mutationOptions: UseMutationOptions<
    CurrenciesDestroyResponse,
    AxiosError<DefaultError>,
    Options<CurrenciesDestroyData>
  > = {
    mutationFn: async (localOptions) => {
      const { data } = await currenciesDestroy({
        ...options,
        ...localOptions,
        throwOnError: true
      })

      return data
    }
  }

  return mutationOptions
}

export const currenciesRetrieveQueryKey = (
  options: Options<CurrenciesRetrieveData>
) => createQueryKey('currenciesRetrieve', options)

export const currenciesRetrieveOptions = (
  options: Options<CurrenciesRetrieveData>
) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await currenciesRetrieve({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true
      })

      return data
    },
    queryKey: currenciesRetrieveQueryKey(options)
  })
}

export const currenciesPartialUpdateMutation = (
  options?: Partial<Options<CurrenciesPartialUpdateData>>
): UseMutationOptions<
  CurrenciesPartialUpdateResponse,
  AxiosError<DefaultError>,
  Options<CurrenciesPartialUpdateData>
> => {
  const mutationOptions: UseMutationOptions<
    CurrenciesPartialUpdateResponse,
    AxiosError<DefaultError>,
    Options<CurrenciesPartialUpdateData>
  > = {
    mutationFn: async (localOptions) => {
      const { data } = await currenciesPartialUpdate({
        ...options,
        ...localOptions,
        throwOnError: true
      })

      return data
    }
  }

  return mutationOptions
}

export const currenciesUpdateMutation = (
  options?: Partial<Options<CurrenciesUpdateData>>
): UseMutationOptions<
  CurrenciesUpdateResponse,
  AxiosError<DefaultError>,
  Options<CurrenciesUpdateData>
> => {
  const mutationOptions: UseMutationOptions<
    CurrenciesUpdateResponse,
    AxiosError<DefaultError>,
    Options<CurrenciesUpdateData>
  > = {
    mutationFn: async (localOptions) => {
      const { data } = await currenciesUpdate({
        ...options,
        ...localOptions,
        throwOnError: true
      })

      return data
    }
  }

  return mutationOptions
}

export const currenciesListListQueryKey = (
  options?: Options<CurrenciesListListData>
) => createQueryKey('currenciesListList', options)

export const currenciesListListOptions = (
  options?: Options<CurrenciesListListData>
) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await currenciesListList({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true
      })

      return data
    },
    queryKey: currenciesListListQueryKey(options)
  })
}

export const currenciesListListInfiniteQueryKey = (
  options?: Options<CurrenciesListListData>
): QueryKey<Options<CurrenciesListListData>> =>
  createQueryKey('currenciesListList', options, true)

export const currenciesListListInfiniteOptions = (
  options?: Options<CurrenciesListListData>
) => {
  return infiniteQueryOptions<
    CurrenciesListListResponse,
    AxiosError<DefaultError>,
    InfiniteData<CurrenciesListListResponse>,
    QueryKey<Options<CurrenciesListListData>>,
    | number
    | Pick<
        QueryKey<Options<CurrenciesListListData>>[0],
        'body' | 'headers' | 'path' | 'query'
      >
  >(
    // @ts-ignore
    {
      queryFn: async ({ pageParam, queryKey, signal }) => {
        // @ts-ignore
        const page: Pick<
          QueryKey<Options<CurrenciesListListData>>[0],
          'body' | 'headers' | 'path' | 'query'
        > =
          typeof pageParam === 'object'
            ? pageParam
            : {
                query: {
                  page: pageParam
                }
              }
        const params = createInfiniteParams(queryKey, page)
        const { data } = await currenciesListList({
          ...options,
          ...params,
          signal,
          throwOnError: true
        })

        return data
      },
      queryKey: currenciesListListInfiniteQueryKey(options)
    }
  )
}

export const customFieldsListQueryKey = (
  options?: Options<CustomFieldsListData>
) => createQueryKey('customFieldsList', options)

export const customFieldsListOptions = (
  options?: Options<CustomFieldsListData>
) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await customFieldsList({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true
      })

      return data
    },
    queryKey: customFieldsListQueryKey(options)
  })
}

export const customFieldsListInfiniteQueryKey = (
  options?: Options<CustomFieldsListData>
): QueryKey<Options<CustomFieldsListData>> =>
  createQueryKey('customFieldsList', options, true)

export const customFieldsListInfiniteOptions = (
  options?: Options<CustomFieldsListData>
) => {
  return infiniteQueryOptions<
    CustomFieldsListResponse,
    AxiosError<DefaultError>,
    InfiniteData<CustomFieldsListResponse>,
    QueryKey<Options<CustomFieldsListData>>,
    | number
    | Pick<
        QueryKey<Options<CustomFieldsListData>>[0],
        'body' | 'headers' | 'path' | 'query'
      >
  >(
    // @ts-ignore
    {
      queryFn: async ({ pageParam, queryKey, signal }) => {
        // @ts-ignore
        const page: Pick<
          QueryKey<Options<CustomFieldsListData>>[0],
          'body' | 'headers' | 'path' | 'query'
        > =
          typeof pageParam === 'object'
            ? pageParam
            : {
                query: {
                  page: pageParam
                }
              }
        const params = createInfiniteParams(queryKey, page)
        const { data } = await customFieldsList({
          ...options,
          ...params,
          signal,
          throwOnError: true
        })

        return data
      },
      queryKey: customFieldsListInfiniteQueryKey(options)
    }
  )
}

export const customFieldsCreateQueryKey = (
  options?: Options<CustomFieldsCreateData>
) => createQueryKey('customFieldsCreate', options)

export const customFieldsCreateOptions = (
  options?: Options<CustomFieldsCreateData>
) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await customFieldsCreate({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true
      })

      return data
    },
    queryKey: customFieldsCreateQueryKey(options)
  })
}

export const customFieldsCreateMutation = (
  options?: Partial<Options<CustomFieldsCreateData>>
): UseMutationOptions<
  CustomFieldsCreateResponse,
  AxiosError<DefaultError>,
  Options<CustomFieldsCreateData>
> => {
  const mutationOptions: UseMutationOptions<
    CustomFieldsCreateResponse,
    AxiosError<DefaultError>,
    Options<CustomFieldsCreateData>
  > = {
    mutationFn: async (localOptions) => {
      const { data } = await customFieldsCreate({
        ...options,
        ...localOptions,
        throwOnError: true
      })

      return data
    }
  }

  return mutationOptions
}

export const customFieldsDestroyMutation = (
  options?: Partial<Options<CustomFieldsDestroyData>>
): UseMutationOptions<
  CustomFieldsDestroyResponse,
  AxiosError<DefaultError>,
  Options<CustomFieldsDestroyData>
> => {
  const mutationOptions: UseMutationOptions<
    CustomFieldsDestroyResponse,
    AxiosError<DefaultError>,
    Options<CustomFieldsDestroyData>
  > = {
    mutationFn: async (localOptions) => {
      const { data } = await customFieldsDestroy({
        ...options,
        ...localOptions,
        throwOnError: true
      })

      return data
    }
  }

  return mutationOptions
}

export const customFieldsRetrieveQueryKey = (
  options: Options<CustomFieldsRetrieveData>
) => createQueryKey('customFieldsRetrieve', options)

export const customFieldsRetrieveOptions = (
  options: Options<CustomFieldsRetrieveData>
) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await customFieldsRetrieve({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true
      })

      return data
    },
    queryKey: customFieldsRetrieveQueryKey(options)
  })
}

export const customFieldsPartialUpdateMutation = (
  options?: Partial<Options<CustomFieldsPartialUpdateData>>
): UseMutationOptions<
  CustomFieldsPartialUpdateResponse,
  AxiosError<DefaultError>,
  Options<CustomFieldsPartialUpdateData>
> => {
  const mutationOptions: UseMutationOptions<
    CustomFieldsPartialUpdateResponse,
    AxiosError<DefaultError>,
    Options<CustomFieldsPartialUpdateData>
  > = {
    mutationFn: async (localOptions) => {
      const { data } = await customFieldsPartialUpdate({
        ...options,
        ...localOptions,
        throwOnError: true
      })

      return data
    }
  }

  return mutationOptions
}

export const customFieldsUpdateMutation = (
  options?: Partial<Options<CustomFieldsUpdateData>>
): UseMutationOptions<
  CustomFieldsUpdateResponse,
  AxiosError<DefaultError>,
  Options<CustomFieldsUpdateData>
> => {
  const mutationOptions: UseMutationOptions<
    CustomFieldsUpdateResponse,
    AxiosError<DefaultError>,
    Options<CustomFieldsUpdateData>
  > = {
    mutationFn: async (localOptions) => {
      const { data } = await customFieldsUpdate({
        ...options,
        ...localOptions,
        throwOnError: true
      })

      return data
    }
  }

  return mutationOptions
}

export const customFieldsUndeletePartialUpdateMutation = (
  options?: Partial<Options<CustomFieldsUndeletePartialUpdateData>>
): UseMutationOptions<
  CustomFieldsUndeletePartialUpdateResponse,
  AxiosError<DefaultError>,
  Options<CustomFieldsUndeletePartialUpdateData>
> => {
  const mutationOptions: UseMutationOptions<
    CustomFieldsUndeletePartialUpdateResponse,
    AxiosError<DefaultError>,
    Options<CustomFieldsUndeletePartialUpdateData>
  > = {
    mutationFn: async (localOptions) => {
      const { data } = await customFieldsUndeletePartialUpdate({
        ...options,
        ...localOptions,
        throwOnError: true
      })

      return data
    }
  }

  return mutationOptions
}

export const dashboardLeadsListQueryKey = (
  options?: Options<DashboardLeadsListData>
) => createQueryKey('dashboardLeadsList', options)

export const dashboardLeadsListOptions = (
  options?: Options<DashboardLeadsListData>
) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await dashboardLeadsList({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true
      })

      return data
    },
    queryKey: dashboardLeadsListQueryKey(options)
  })
}

export const dashboardReportsChartListQueryKey = (
  options: Options<DashboardReportsChartListData>
) => createQueryKey('dashboardReportsChartList', options)

export const dashboardReportsChartListOptions = (
  options: Options<DashboardReportsChartListData>
) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await dashboardReportsChartList({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true
      })

      return data
    },
    queryKey: dashboardReportsChartListQueryKey(options)
  })
}

export const dashboardSalesReportListQueryKey = (
  options?: Options<DashboardSalesReportListData>
) => createQueryKey('dashboardSalesReportList', options)

export const dashboardSalesReportListOptions = (
  options?: Options<DashboardSalesReportListData>
) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await dashboardSalesReportList({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true
      })

      return data
    },
    queryKey: dashboardSalesReportListQueryKey(options)
  })
}

export const dashboardTasksRetrieveQueryKey = (
  options?: Options<DashboardTasksRetrieveData>
) => createQueryKey('dashboardTasksRetrieve', options)

/**
 * Retrieves and categorizes tasks for the current user or a specified user.
 *
 * This method organizes tasks into "past," "current," and "future" based on their deadline.
 * - **Admins, Billing, and Managers** can see tasks for any user (or filter by a specific user ID).
 * - Other users can only view their own tasks.
 *
 * Returns a dictionary with task counts and up to 3 serialized tasks for each category.
 */
export const dashboardTasksRetrieveOptions = (
  options?: Options<DashboardTasksRetrieveData>
) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await dashboardTasksRetrieve({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true
      })

      return data
    },
    queryKey: dashboardTasksRetrieveQueryKey(options)
  })
}

export const dashboardTopExpertsListQueryKey = (
  options?: Options<DashboardTopExpertsListData>
) => createQueryKey('dashboardTopExpertsList', options)

export const dashboardTopExpertsListOptions = (
  options?: Options<DashboardTopExpertsListData>
) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await dashboardTopExpertsList({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true
      })

      return data
    },
    queryKey: dashboardTopExpertsListQueryKey(options)
  })
}

export const documentCategoriesListQueryKey = (
  options?: Options<DocumentCategoriesListData>
) => createQueryKey('documentCategoriesList', options)

export const documentCategoriesListOptions = (
  options?: Options<DocumentCategoriesListData>
) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await documentCategoriesList({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true
      })

      return data
    },
    queryKey: documentCategoriesListQueryKey(options)
  })
}

export const documentCategoriesListInfiniteQueryKey = (
  options?: Options<DocumentCategoriesListData>
): QueryKey<Options<DocumentCategoriesListData>> =>
  createQueryKey('documentCategoriesList', options, true)

export const documentCategoriesListInfiniteOptions = (
  options?: Options<DocumentCategoriesListData>
) => {
  return infiniteQueryOptions<
    DocumentCategoriesListResponse,
    AxiosError<DefaultError>,
    InfiniteData<DocumentCategoriesListResponse>,
    QueryKey<Options<DocumentCategoriesListData>>,
    | number
    | Pick<
        QueryKey<Options<DocumentCategoriesListData>>[0],
        'body' | 'headers' | 'path' | 'query'
      >
  >(
    // @ts-ignore
    {
      queryFn: async ({ pageParam, queryKey, signal }) => {
        // @ts-ignore
        const page: Pick<
          QueryKey<Options<DocumentCategoriesListData>>[0],
          'body' | 'headers' | 'path' | 'query'
        > =
          typeof pageParam === 'object'
            ? pageParam
            : {
                query: {
                  page: pageParam
                }
              }
        const params = createInfiniteParams(queryKey, page)
        const { data } = await documentCategoriesList({
          ...options,
          ...params,
          signal,
          throwOnError: true
        })

        return data
      },
      queryKey: documentCategoriesListInfiniteQueryKey(options)
    }
  )
}

export const documentCategoriesCreateQueryKey = (
  options: Options<DocumentCategoriesCreateData>
) => createQueryKey('documentCategoriesCreate', options)

export const documentCategoriesCreateOptions = (
  options: Options<DocumentCategoriesCreateData>
) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await documentCategoriesCreate({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true
      })

      return data
    },
    queryKey: documentCategoriesCreateQueryKey(options)
  })
}

export const documentCategoriesCreateMutation = (
  options?: Partial<Options<DocumentCategoriesCreateData>>
): UseMutationOptions<
  DocumentCategoriesCreateResponse,
  AxiosError<DefaultError>,
  Options<DocumentCategoriesCreateData>
> => {
  const mutationOptions: UseMutationOptions<
    DocumentCategoriesCreateResponse,
    AxiosError<DefaultError>,
    Options<DocumentCategoriesCreateData>
  > = {
    mutationFn: async (localOptions) => {
      const { data } = await documentCategoriesCreate({
        ...options,
        ...localOptions,
        throwOnError: true
      })

      return data
    }
  }

  return mutationOptions
}

export const documentCategoriesDestroyMutation = (
  options?: Partial<Options<DocumentCategoriesDestroyData>>
): UseMutationOptions<
  DocumentCategoriesDestroyResponse,
  AxiosError<DefaultError>,
  Options<DocumentCategoriesDestroyData>
> => {
  const mutationOptions: UseMutationOptions<
    DocumentCategoriesDestroyResponse,
    AxiosError<DefaultError>,
    Options<DocumentCategoriesDestroyData>
  > = {
    mutationFn: async (localOptions) => {
      const { data } = await documentCategoriesDestroy({
        ...options,
        ...localOptions,
        throwOnError: true
      })

      return data
    }
  }

  return mutationOptions
}

export const documentCategoriesRetrieveQueryKey = (
  options: Options<DocumentCategoriesRetrieveData>
) => createQueryKey('documentCategoriesRetrieve', options)

export const documentCategoriesRetrieveOptions = (
  options: Options<DocumentCategoriesRetrieveData>
) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await documentCategoriesRetrieve({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true
      })

      return data
    },
    queryKey: documentCategoriesRetrieveQueryKey(options)
  })
}

export const documentCategoriesPartialUpdateMutation = (
  options?: Partial<Options<DocumentCategoriesPartialUpdateData>>
): UseMutationOptions<
  DocumentCategoriesPartialUpdateResponse,
  AxiosError<DefaultError>,
  Options<DocumentCategoriesPartialUpdateData>
> => {
  const mutationOptions: UseMutationOptions<
    DocumentCategoriesPartialUpdateResponse,
    AxiosError<DefaultError>,
    Options<DocumentCategoriesPartialUpdateData>
  > = {
    mutationFn: async (localOptions) => {
      const { data } = await documentCategoriesPartialUpdate({
        ...options,
        ...localOptions,
        throwOnError: true
      })

      return data
    }
  }

  return mutationOptions
}

export const documentCategoriesUpdateMutation = (
  options?: Partial<Options<DocumentCategoriesUpdateData>>
): UseMutationOptions<
  DocumentCategoriesUpdateResponse,
  AxiosError<DefaultError>,
  Options<DocumentCategoriesUpdateData>
> => {
  const mutationOptions: UseMutationOptions<
    DocumentCategoriesUpdateResponse,
    AxiosError<DefaultError>,
    Options<DocumentCategoriesUpdateData>
  > = {
    mutationFn: async (localOptions) => {
      const { data } = await documentCategoriesUpdate({
        ...options,
        ...localOptions,
        throwOnError: true
      })

      return data
    }
  }

  return mutationOptions
}

export const documentCategoriesListListQueryKey = (
  options?: Options<DocumentCategoriesListListData>
) => createQueryKey('documentCategoriesListList', options)

export const documentCategoriesListListOptions = (
  options?: Options<DocumentCategoriesListListData>
) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await documentCategoriesListList({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true
      })

      return data
    },
    queryKey: documentCategoriesListListQueryKey(options)
  })
}

export const documentCategoriesListListInfiniteQueryKey = (
  options?: Options<DocumentCategoriesListListData>
): QueryKey<Options<DocumentCategoriesListListData>> =>
  createQueryKey('documentCategoriesListList', options, true)

export const documentCategoriesListListInfiniteOptions = (
  options?: Options<DocumentCategoriesListListData>
) => {
  return infiniteQueryOptions<
    DocumentCategoriesListListResponse,
    AxiosError<DefaultError>,
    InfiniteData<DocumentCategoriesListListResponse>,
    QueryKey<Options<DocumentCategoriesListListData>>,
    | number
    | Pick<
        QueryKey<Options<DocumentCategoriesListListData>>[0],
        'body' | 'headers' | 'path' | 'query'
      >
  >(
    // @ts-ignore
    {
      queryFn: async ({ pageParam, queryKey, signal }) => {
        // @ts-ignore
        const page: Pick<
          QueryKey<Options<DocumentCategoriesListListData>>[0],
          'body' | 'headers' | 'path' | 'query'
        > =
          typeof pageParam === 'object'
            ? pageParam
            : {
                query: {
                  page: pageParam
                }
              }
        const params = createInfiniteParams(queryKey, page)
        const { data } = await documentCategoriesListList({
          ...options,
          ...params,
          signal,
          throwOnError: true
        })

        return data
      },
      queryKey: documentCategoriesListListInfiniteQueryKey(options)
    }
  )
}

export const documentsListQueryKey = (options?: Options<DocumentsListData>) =>
  createQueryKey('documentsList', options)

export const documentsListOptions = (options?: Options<DocumentsListData>) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await documentsList({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true
      })

      return data
    },
    queryKey: documentsListQueryKey(options)
  })
}

export const documentsListInfiniteQueryKey = (
  options?: Options<DocumentsListData>
): QueryKey<Options<DocumentsListData>> =>
  createQueryKey('documentsList', options, true)

export const documentsListInfiniteOptions = (
  options?: Options<DocumentsListData>
) => {
  return infiniteQueryOptions<
    DocumentsListResponse,
    AxiosError<DefaultError>,
    InfiniteData<DocumentsListResponse>,
    QueryKey<Options<DocumentsListData>>,
    | number
    | Pick<
        QueryKey<Options<DocumentsListData>>[0],
        'body' | 'headers' | 'path' | 'query'
      >
  >(
    // @ts-ignore
    {
      queryFn: async ({ pageParam, queryKey, signal }) => {
        // @ts-ignore
        const page: Pick<
          QueryKey<Options<DocumentsListData>>[0],
          'body' | 'headers' | 'path' | 'query'
        > =
          typeof pageParam === 'object'
            ? pageParam
            : {
                query: {
                  page: pageParam
                }
              }
        const params = createInfiniteParams(queryKey, page)
        const { data } = await documentsList({
          ...options,
          ...params,
          signal,
          throwOnError: true
        })

        return data
      },
      queryKey: documentsListInfiniteQueryKey(options)
    }
  )
}

export const documentsCreateQueryKey = (
  options?: Options<DocumentsCreateData>
) => createQueryKey('documentsCreate', options)

export const documentsCreateOptions = (
  options?: Options<DocumentsCreateData>
) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await documentsCreate({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true
      })

      return data
    },
    queryKey: documentsCreateQueryKey(options)
  })
}

export const documentsCreateMutation = (
  options?: Partial<Options<DocumentsCreateData>>
): UseMutationOptions<
  DocumentsCreateResponse,
  AxiosError<DefaultError>,
  Options<DocumentsCreateData>
> => {
  const mutationOptions: UseMutationOptions<
    DocumentsCreateResponse,
    AxiosError<DefaultError>,
    Options<DocumentsCreateData>
  > = {
    mutationFn: async (localOptions) => {
      const { data } = await documentsCreate({
        ...options,
        ...localOptions,
        throwOnError: true
      })

      return data
    }
  }

  return mutationOptions
}

export const documentsDestroyMutation = (
  options?: Partial<Options<DocumentsDestroyData>>
): UseMutationOptions<
  DocumentsDestroyResponse,
  AxiosError<DefaultError>,
  Options<DocumentsDestroyData>
> => {
  const mutationOptions: UseMutationOptions<
    DocumentsDestroyResponse,
    AxiosError<DefaultError>,
    Options<DocumentsDestroyData>
  > = {
    mutationFn: async (localOptions) => {
      const { data } = await documentsDestroy({
        ...options,
        ...localOptions,
        throwOnError: true
      })

      return data
    }
  }

  return mutationOptions
}

export const documentsRetrieveQueryKey = (
  options: Options<DocumentsRetrieveData>
) => createQueryKey('documentsRetrieve', options)

export const documentsRetrieveOptions = (
  options: Options<DocumentsRetrieveData>
) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await documentsRetrieve({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true
      })

      return data
    },
    queryKey: documentsRetrieveQueryKey(options)
  })
}

export const documentsPartialUpdateMutation = (
  options?: Partial<Options<DocumentsPartialUpdateData>>
): UseMutationOptions<
  DocumentsPartialUpdateResponse,
  AxiosError<DefaultError>,
  Options<DocumentsPartialUpdateData>
> => {
  const mutationOptions: UseMutationOptions<
    DocumentsPartialUpdateResponse,
    AxiosError<DefaultError>,
    Options<DocumentsPartialUpdateData>
  > = {
    mutationFn: async (localOptions) => {
      const { data } = await documentsPartialUpdate({
        ...options,
        ...localOptions,
        throwOnError: true
      })

      return data
    }
  }

  return mutationOptions
}

export const documentsUpdateMutation = (
  options?: Partial<Options<DocumentsUpdateData>>
): UseMutationOptions<
  DocumentsUpdateResponse,
  AxiosError<DefaultError>,
  Options<DocumentsUpdateData>
> => {
  const mutationOptions: UseMutationOptions<
    DocumentsUpdateResponse,
    AxiosError<DefaultError>,
    Options<DocumentsUpdateData>
  > = {
    mutationFn: async (localOptions) => {
      const { data } = await documentsUpdate({
        ...options,
        ...localOptions,
        throwOnError: true
      })

      return data
    }
  }

  return mutationOptions
}

export const documentsBulkCreateCreateQueryKey = (
  options?: Options<DocumentsBulkCreateCreateData>
) => createQueryKey('documentsBulkCreateCreate', options)

export const documentsBulkCreateCreateOptions = (
  options?: Options<DocumentsBulkCreateCreateData>
) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await documentsBulkCreateCreate({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true
      })

      return data
    },
    queryKey: documentsBulkCreateCreateQueryKey(options)
  })
}

export const documentsBulkCreateCreateMutation = (
  options?: Partial<Options<DocumentsBulkCreateCreateData>>
): UseMutationOptions<
  DocumentsBulkCreateCreateResponse,
  AxiosError<DefaultError>,
  Options<DocumentsBulkCreateCreateData>
> => {
  const mutationOptions: UseMutationOptions<
    DocumentsBulkCreateCreateResponse,
    AxiosError<DefaultError>,
    Options<DocumentsBulkCreateCreateData>
  > = {
    mutationFn: async (localOptions) => {
      const { data } = await documentsBulkCreateCreate({
        ...options,
        ...localOptions,
        throwOnError: true
      })

      return data
    }
  }

  return mutationOptions
}

export const documentsListListQueryKey = (
  options?: Options<DocumentsListListData>
) => createQueryKey('documentsListList', options)

export const documentsListListOptions = (
  options?: Options<DocumentsListListData>
) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await documentsListList({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true
      })

      return data
    },
    queryKey: documentsListListQueryKey(options)
  })
}

export const documentsListListInfiniteQueryKey = (
  options?: Options<DocumentsListListData>
): QueryKey<Options<DocumentsListListData>> =>
  createQueryKey('documentsListList', options, true)

export const documentsListListInfiniteOptions = (
  options?: Options<DocumentsListListData>
) => {
  return infiniteQueryOptions<
    DocumentsListListResponse,
    AxiosError<DefaultError>,
    InfiniteData<DocumentsListListResponse>,
    QueryKey<Options<DocumentsListListData>>,
    | number
    | Pick<
        QueryKey<Options<DocumentsListListData>>[0],
        'body' | 'headers' | 'path' | 'query'
      >
  >(
    // @ts-ignore
    {
      queryFn: async ({ pageParam, queryKey, signal }) => {
        // @ts-ignore
        const page: Pick<
          QueryKey<Options<DocumentsListListData>>[0],
          'body' | 'headers' | 'path' | 'query'
        > =
          typeof pageParam === 'object'
            ? pageParam
            : {
                query: {
                  page: pageParam
                }
              }
        const params = createInfiniteParams(queryKey, page)
        const { data } = await documentsListList({
          ...options,
          ...params,
          signal,
          throwOnError: true
        })

        return data
      },
      queryKey: documentsListListInfiniteQueryKey(options)
    }
  )
}

export const expensesListQueryKey = (options?: Options<ExpensesListData>) =>
  createQueryKey('expensesList', options)

export const expensesListOptions = (options?: Options<ExpensesListData>) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await expensesList({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true
      })

      return data
    },
    queryKey: expensesListQueryKey(options)
  })
}

export const expensesCreateQueryKey = (options: Options<ExpensesCreateData>) =>
  createQueryKey('expensesCreate', options)

export const expensesCreateOptions = (options: Options<ExpensesCreateData>) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await expensesCreate({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true
      })

      return data
    },
    queryKey: expensesCreateQueryKey(options)
  })
}

export const expensesCreateMutation = (
  options?: Partial<Options<ExpensesCreateData>>
): UseMutationOptions<
  ExpensesCreateResponse,
  AxiosError<DefaultError>,
  Options<ExpensesCreateData>
> => {
  const mutationOptions: UseMutationOptions<
    ExpensesCreateResponse,
    AxiosError<DefaultError>,
    Options<ExpensesCreateData>
  > = {
    mutationFn: async (localOptions) => {
      const { data } = await expensesCreate({
        ...options,
        ...localOptions,
        throwOnError: true
      })

      return data
    }
  }

  return mutationOptions
}

export const healthRetrieveQueryKey = (options?: Options<HealthRetrieveData>) =>
  createQueryKey('healthRetrieve', options)

export const healthRetrieveOptions = (
  options?: Options<HealthRetrieveData>
) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await healthRetrieve({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true
      })

      return data
    },
    queryKey: healthRetrieveQueryKey(options)
  })
}

export const industriesListQueryKey = (options?: Options<IndustriesListData>) =>
  createQueryKey('industriesList', options)

export const industriesListOptions = (
  options?: Options<IndustriesListData>
) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await industriesList({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true
      })

      return data
    },
    queryKey: industriesListQueryKey(options)
  })
}

export const industriesListInfiniteQueryKey = (
  options?: Options<IndustriesListData>
): QueryKey<Options<IndustriesListData>> =>
  createQueryKey('industriesList', options, true)

export const industriesListInfiniteOptions = (
  options?: Options<IndustriesListData>
) => {
  return infiniteQueryOptions<
    IndustriesListResponse,
    AxiosError<DefaultError>,
    InfiniteData<IndustriesListResponse>,
    QueryKey<Options<IndustriesListData>>,
    | number
    | Pick<
        QueryKey<Options<IndustriesListData>>[0],
        'body' | 'headers' | 'path' | 'query'
      >
  >(
    // @ts-ignore
    {
      queryFn: async ({ pageParam, queryKey, signal }) => {
        // @ts-ignore
        const page: Pick<
          QueryKey<Options<IndustriesListData>>[0],
          'body' | 'headers' | 'path' | 'query'
        > =
          typeof pageParam === 'object'
            ? pageParam
            : {
                query: {
                  page: pageParam
                }
              }
        const params = createInfiniteParams(queryKey, page)
        const { data } = await industriesList({
          ...options,
          ...params,
          signal,
          throwOnError: true
        })

        return data
      },
      queryKey: industriesListInfiniteQueryKey(options)
    }
  )
}

export const industriesCreateQueryKey = (
  options: Options<IndustriesCreateData>
) => createQueryKey('industriesCreate', options)

export const industriesCreateOptions = (
  options: Options<IndustriesCreateData>
) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await industriesCreate({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true
      })

      return data
    },
    queryKey: industriesCreateQueryKey(options)
  })
}

export const industriesCreateMutation = (
  options?: Partial<Options<IndustriesCreateData>>
): UseMutationOptions<
  IndustriesCreateResponse,
  AxiosError<DefaultError>,
  Options<IndustriesCreateData>
> => {
  const mutationOptions: UseMutationOptions<
    IndustriesCreateResponse,
    AxiosError<DefaultError>,
    Options<IndustriesCreateData>
  > = {
    mutationFn: async (localOptions) => {
      const { data } = await industriesCreate({
        ...options,
        ...localOptions,
        throwOnError: true
      })

      return data
    }
  }

  return mutationOptions
}

export const industriesSubIndustriesListQueryKey = (
  options: Options<IndustriesSubIndustriesListData>
) => createQueryKey('industriesSubIndustriesList', options)

export const industriesSubIndustriesListOptions = (
  options: Options<IndustriesSubIndustriesListData>
) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await industriesSubIndustriesList({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true
      })

      return data
    },
    queryKey: industriesSubIndustriesListQueryKey(options)
  })
}

export const industriesSubIndustriesListInfiniteQueryKey = (
  options: Options<IndustriesSubIndustriesListData>
): QueryKey<Options<IndustriesSubIndustriesListData>> =>
  createQueryKey('industriesSubIndustriesList', options, true)

export const industriesSubIndustriesListInfiniteOptions = (
  options: Options<IndustriesSubIndustriesListData>
) => {
  return infiniteQueryOptions<
    IndustriesSubIndustriesListResponse,
    AxiosError<DefaultError>,
    InfiniteData<IndustriesSubIndustriesListResponse>,
    QueryKey<Options<IndustriesSubIndustriesListData>>,
    | number
    | Pick<
        QueryKey<Options<IndustriesSubIndustriesListData>>[0],
        'body' | 'headers' | 'path' | 'query'
      >
  >(
    // @ts-ignore
    {
      queryFn: async ({ pageParam, queryKey, signal }) => {
        // @ts-ignore
        const page: Pick<
          QueryKey<Options<IndustriesSubIndustriesListData>>[0],
          'body' | 'headers' | 'path' | 'query'
        > =
          typeof pageParam === 'object'
            ? pageParam
            : {
                query: {
                  page: pageParam
                }
              }
        const params = createInfiniteParams(queryKey, page)
        const { data } = await industriesSubIndustriesList({
          ...options,
          ...params,
          signal,
          throwOnError: true
        })

        return data
      },
      queryKey: industriesSubIndustriesListInfiniteQueryKey(options)
    }
  )
}

export const industriesSubIndustriesCreateQueryKey = (
  options: Options<IndustriesSubIndustriesCreateData>
) => createQueryKey('industriesSubIndustriesCreate', options)

export const industriesSubIndustriesCreateOptions = (
  options: Options<IndustriesSubIndustriesCreateData>
) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await industriesSubIndustriesCreate({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true
      })

      return data
    },
    queryKey: industriesSubIndustriesCreateQueryKey(options)
  })
}

export const industriesSubIndustriesCreateMutation = (
  options?: Partial<Options<IndustriesSubIndustriesCreateData>>
): UseMutationOptions<
  IndustriesSubIndustriesCreateResponse,
  AxiosError<DefaultError>,
  Options<IndustriesSubIndustriesCreateData>
> => {
  const mutationOptions: UseMutationOptions<
    IndustriesSubIndustriesCreateResponse,
    AxiosError<DefaultError>,
    Options<IndustriesSubIndustriesCreateData>
  > = {
    mutationFn: async (localOptions) => {
      const { data } = await industriesSubIndustriesCreate({
        ...options,
        ...localOptions,
        throwOnError: true
      })

      return data
    }
  }

  return mutationOptions
}

export const industriesSubIndustriesDestroyMutation = (
  options?: Partial<Options<IndustriesSubIndustriesDestroyData>>
): UseMutationOptions<
  IndustriesSubIndustriesDestroyResponse,
  AxiosError<DefaultError>,
  Options<IndustriesSubIndustriesDestroyData>
> => {
  const mutationOptions: UseMutationOptions<
    IndustriesSubIndustriesDestroyResponse,
    AxiosError<DefaultError>,
    Options<IndustriesSubIndustriesDestroyData>
  > = {
    mutationFn: async (localOptions) => {
      const { data } = await industriesSubIndustriesDestroy({
        ...options,
        ...localOptions,
        throwOnError: true
      })

      return data
    }
  }

  return mutationOptions
}

export const industriesSubIndustriesRetrieveQueryKey = (
  options: Options<IndustriesSubIndustriesRetrieveData>
) => createQueryKey('industriesSubIndustriesRetrieve', options)

export const industriesSubIndustriesRetrieveOptions = (
  options: Options<IndustriesSubIndustriesRetrieveData>
) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await industriesSubIndustriesRetrieve({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true
      })

      return data
    },
    queryKey: industriesSubIndustriesRetrieveQueryKey(options)
  })
}

export const industriesSubIndustriesPartialUpdateMutation = (
  options?: Partial<Options<IndustriesSubIndustriesPartialUpdateData>>
): UseMutationOptions<
  IndustriesSubIndustriesPartialUpdateResponse,
  AxiosError<DefaultError>,
  Options<IndustriesSubIndustriesPartialUpdateData>
> => {
  const mutationOptions: UseMutationOptions<
    IndustriesSubIndustriesPartialUpdateResponse,
    AxiosError<DefaultError>,
    Options<IndustriesSubIndustriesPartialUpdateData>
  > = {
    mutationFn: async (localOptions) => {
      const { data } = await industriesSubIndustriesPartialUpdate({
        ...options,
        ...localOptions,
        throwOnError: true
      })

      return data
    }
  }

  return mutationOptions
}

export const industriesSubIndustriesUpdateMutation = (
  options?: Partial<Options<IndustriesSubIndustriesUpdateData>>
): UseMutationOptions<
  IndustriesSubIndustriesUpdateResponse,
  AxiosError<DefaultError>,
  Options<IndustriesSubIndustriesUpdateData>
> => {
  const mutationOptions: UseMutationOptions<
    IndustriesSubIndustriesUpdateResponse,
    AxiosError<DefaultError>,
    Options<IndustriesSubIndustriesUpdateData>
  > = {
    mutationFn: async (localOptions) => {
      const { data } = await industriesSubIndustriesUpdate({
        ...options,
        ...localOptions,
        throwOnError: true
      })

      return data
    }
  }

  return mutationOptions
}

export const industriesSubIndustriesListListQueryKey = (
  options: Options<IndustriesSubIndustriesListListData>
) => createQueryKey('industriesSubIndustriesListList', options)

export const industriesSubIndustriesListListOptions = (
  options: Options<IndustriesSubIndustriesListListData>
) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await industriesSubIndustriesListList({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true
      })

      return data
    },
    queryKey: industriesSubIndustriesListListQueryKey(options)
  })
}

export const industriesSubIndustriesListListInfiniteQueryKey = (
  options: Options<IndustriesSubIndustriesListListData>
): QueryKey<Options<IndustriesSubIndustriesListListData>> =>
  createQueryKey('industriesSubIndustriesListList', options, true)

export const industriesSubIndustriesListListInfiniteOptions = (
  options: Options<IndustriesSubIndustriesListListData>
) => {
  return infiniteQueryOptions<
    IndustriesSubIndustriesListListResponse,
    AxiosError<DefaultError>,
    InfiniteData<IndustriesSubIndustriesListListResponse>,
    QueryKey<Options<IndustriesSubIndustriesListListData>>,
    | number
    | Pick<
        QueryKey<Options<IndustriesSubIndustriesListListData>>[0],
        'body' | 'headers' | 'path' | 'query'
      >
  >(
    // @ts-ignore
    {
      queryFn: async ({ pageParam, queryKey, signal }) => {
        // @ts-ignore
        const page: Pick<
          QueryKey<Options<IndustriesSubIndustriesListListData>>[0],
          'body' | 'headers' | 'path' | 'query'
        > =
          typeof pageParam === 'object'
            ? pageParam
            : {
                query: {
                  page: pageParam
                }
              }
        const params = createInfiniteParams(queryKey, page)
        const { data } = await industriesSubIndustriesListList({
          ...options,
          ...params,
          signal,
          throwOnError: true
        })

        return data
      },
      queryKey: industriesSubIndustriesListListInfiniteQueryKey(options)
    }
  )
}

export const industriesDestroyMutation = (
  options?: Partial<Options<IndustriesDestroyData>>
): UseMutationOptions<
  IndustriesDestroyResponse,
  AxiosError<DefaultError>,
  Options<IndustriesDestroyData>
> => {
  const mutationOptions: UseMutationOptions<
    IndustriesDestroyResponse,
    AxiosError<DefaultError>,
    Options<IndustriesDestroyData>
  > = {
    mutationFn: async (localOptions) => {
      const { data } = await industriesDestroy({
        ...options,
        ...localOptions,
        throwOnError: true
      })

      return data
    }
  }

  return mutationOptions
}

export const industriesRetrieveQueryKey = (
  options: Options<IndustriesRetrieveData>
) => createQueryKey('industriesRetrieve', options)

export const industriesRetrieveOptions = (
  options: Options<IndustriesRetrieveData>
) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await industriesRetrieve({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true
      })

      return data
    },
    queryKey: industriesRetrieveQueryKey(options)
  })
}

export const industriesPartialUpdateMutation = (
  options?: Partial<Options<IndustriesPartialUpdateData>>
): UseMutationOptions<
  IndustriesPartialUpdateResponse,
  AxiosError<DefaultError>,
  Options<IndustriesPartialUpdateData>
> => {
  const mutationOptions: UseMutationOptions<
    IndustriesPartialUpdateResponse,
    AxiosError<DefaultError>,
    Options<IndustriesPartialUpdateData>
  > = {
    mutationFn: async (localOptions) => {
      const { data } = await industriesPartialUpdate({
        ...options,
        ...localOptions,
        throwOnError: true
      })

      return data
    }
  }

  return mutationOptions
}

export const industriesUpdateMutation = (
  options?: Partial<Options<IndustriesUpdateData>>
): UseMutationOptions<
  IndustriesUpdateResponse,
  AxiosError<DefaultError>,
  Options<IndustriesUpdateData>
> => {
  const mutationOptions: UseMutationOptions<
    IndustriesUpdateResponse,
    AxiosError<DefaultError>,
    Options<IndustriesUpdateData>
  > = {
    mutationFn: async (localOptions) => {
      const { data } = await industriesUpdate({
        ...options,
        ...localOptions,
        throwOnError: true
      })

      return data
    }
  }

  return mutationOptions
}

export const industriesListListQueryKey = (
  options?: Options<IndustriesListListData>
) => createQueryKey('industriesListList', options)

export const industriesListListOptions = (
  options?: Options<IndustriesListListData>
) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await industriesListList({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true
      })

      return data
    },
    queryKey: industriesListListQueryKey(options)
  })
}

export const industriesListListInfiniteQueryKey = (
  options?: Options<IndustriesListListData>
): QueryKey<Options<IndustriesListListData>> =>
  createQueryKey('industriesListList', options, true)

export const industriesListListInfiniteOptions = (
  options?: Options<IndustriesListListData>
) => {
  return infiniteQueryOptions<
    IndustriesListListResponse,
    AxiosError<DefaultError>,
    InfiniteData<IndustriesListListResponse>,
    QueryKey<Options<IndustriesListListData>>,
    | number
    | Pick<
        QueryKey<Options<IndustriesListListData>>[0],
        'body' | 'headers' | 'path' | 'query'
      >
  >(
    // @ts-ignore
    {
      queryFn: async ({ pageParam, queryKey, signal }) => {
        // @ts-ignore
        const page: Pick<
          QueryKey<Options<IndustriesListListData>>[0],
          'body' | 'headers' | 'path' | 'query'
        > =
          typeof pageParam === 'object'
            ? pageParam
            : {
                query: {
                  page: pageParam
                }
              }
        const params = createInfiniteParams(queryKey, page)
        const { data } = await industriesListList({
          ...options,
          ...params,
          signal,
          throwOnError: true
        })

        return data
      },
      queryKey: industriesListListInfiniteQueryKey(options)
    }
  )
}

export const informationListQueryKey = (
  options?: Options<InformationListData>
) => createQueryKey('informationList', options)

export const informationListOptions = (
  options?: Options<InformationListData>
) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await informationList({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true
      })

      return data
    },
    queryKey: informationListQueryKey(options)
  })
}

export const informationListInfiniteQueryKey = (
  options?: Options<InformationListData>
): QueryKey<Options<InformationListData>> =>
  createQueryKey('informationList', options, true)

export const informationListInfiniteOptions = (
  options?: Options<InformationListData>
) => {
  return infiniteQueryOptions<
    InformationListResponse,
    AxiosError<DefaultError>,
    InfiniteData<InformationListResponse>,
    QueryKey<Options<InformationListData>>,
    | number
    | Pick<
        QueryKey<Options<InformationListData>>[0],
        'body' | 'headers' | 'path' | 'query'
      >
  >(
    // @ts-ignore
    {
      queryFn: async ({ pageParam, queryKey, signal }) => {
        // @ts-ignore
        const page: Pick<
          QueryKey<Options<InformationListData>>[0],
          'body' | 'headers' | 'path' | 'query'
        > =
          typeof pageParam === 'object'
            ? pageParam
            : {
                query: {
                  page: pageParam
                }
              }
        const params = createInfiniteParams(queryKey, page)
        const { data } = await informationList({
          ...options,
          ...params,
          signal,
          throwOnError: true
        })

        return data
      },
      queryKey: informationListInfiniteQueryKey(options)
    }
  )
}

export const informationCreateQueryKey = (
  options: Options<InformationCreateData>
) => createQueryKey('informationCreate', options)

export const informationCreateOptions = (
  options: Options<InformationCreateData>
) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await informationCreate({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true
      })

      return data
    },
    queryKey: informationCreateQueryKey(options)
  })
}

export const informationCreateMutation = (
  options?: Partial<Options<InformationCreateData>>
): UseMutationOptions<
  InformationCreateResponse,
  AxiosError<DefaultError>,
  Options<InformationCreateData>
> => {
  const mutationOptions: UseMutationOptions<
    InformationCreateResponse,
    AxiosError<DefaultError>,
    Options<InformationCreateData>
  > = {
    mutationFn: async (localOptions) => {
      const { data } = await informationCreate({
        ...options,
        ...localOptions,
        throwOnError: true
      })

      return data
    }
  }

  return mutationOptions
}

export const informationDestroyMutation = (
  options?: Partial<Options<InformationDestroyData>>
): UseMutationOptions<
  InformationDestroyResponse,
  AxiosError<DefaultError>,
  Options<InformationDestroyData>
> => {
  const mutationOptions: UseMutationOptions<
    InformationDestroyResponse,
    AxiosError<DefaultError>,
    Options<InformationDestroyData>
  > = {
    mutationFn: async (localOptions) => {
      const { data } = await informationDestroy({
        ...options,
        ...localOptions,
        throwOnError: true
      })

      return data
    }
  }

  return mutationOptions
}

export const informationRetrieveQueryKey = (
  options: Options<InformationRetrieveData>
) => createQueryKey('informationRetrieve', options)

export const informationRetrieveOptions = (
  options: Options<InformationRetrieveData>
) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await informationRetrieve({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true
      })

      return data
    },
    queryKey: informationRetrieveQueryKey(options)
  })
}

export const informationPartialUpdateMutation = (
  options?: Partial<Options<InformationPartialUpdateData>>
): UseMutationOptions<
  InformationPartialUpdateResponse,
  AxiosError<DefaultError>,
  Options<InformationPartialUpdateData>
> => {
  const mutationOptions: UseMutationOptions<
    InformationPartialUpdateResponse,
    AxiosError<DefaultError>,
    Options<InformationPartialUpdateData>
  > = {
    mutationFn: async (localOptions) => {
      const { data } = await informationPartialUpdate({
        ...options,
        ...localOptions,
        throwOnError: true
      })

      return data
    }
  }

  return mutationOptions
}

export const informationUpdateMutation = (
  options?: Partial<Options<InformationUpdateData>>
): UseMutationOptions<
  InformationUpdateResponse,
  AxiosError<DefaultError>,
  Options<InformationUpdateData>
> => {
  const mutationOptions: UseMutationOptions<
    InformationUpdateResponse,
    AxiosError<DefaultError>,
    Options<InformationUpdateData>
  > = {
    mutationFn: async (localOptions) => {
      const { data } = await informationUpdate({
        ...options,
        ...localOptions,
        throwOnError: true
      })

      return data
    }
  }

  return mutationOptions
}

export const informationListListQueryKey = (
  options?: Options<InformationListListData>
) => createQueryKey('informationListList', options)

export const informationListListOptions = (
  options?: Options<InformationListListData>
) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await informationListList({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true
      })

      return data
    },
    queryKey: informationListListQueryKey(options)
  })
}

export const informationListListInfiniteQueryKey = (
  options?: Options<InformationListListData>
): QueryKey<Options<InformationListListData>> =>
  createQueryKey('informationListList', options, true)

export const informationListListInfiniteOptions = (
  options?: Options<InformationListListData>
) => {
  return infiniteQueryOptions<
    InformationListListResponse,
    AxiosError<DefaultError>,
    InfiniteData<InformationListListResponse>,
    QueryKey<Options<InformationListListData>>,
    | number
    | Pick<
        QueryKey<Options<InformationListListData>>[0],
        'body' | 'headers' | 'path' | 'query'
      >
  >(
    // @ts-ignore
    {
      queryFn: async ({ pageParam, queryKey, signal }) => {
        // @ts-ignore
        const page: Pick<
          QueryKey<Options<InformationListListData>>[0],
          'body' | 'headers' | 'path' | 'query'
        > =
          typeof pageParam === 'object'
            ? pageParam
            : {
                query: {
                  page: pageParam
                }
              }
        const params = createInfiniteParams(queryKey, page)
        const { data } = await informationListList({
          ...options,
          ...params,
          signal,
          throwOnError: true
        })

        return data
      },
      queryKey: informationListListInfiniteQueryKey(options)
    }
  )
}

export const integrationsGmailListQueryKey = (
  options?: Options<IntegrationsGmailListData>
) => createQueryKey('integrationsGmailList', options)

export const integrationsGmailListOptions = (
  options?: Options<IntegrationsGmailListData>
) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await integrationsGmailList({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true
      })

      return data
    },
    queryKey: integrationsGmailListQueryKey(options)
  })
}

export const integrationsGmailListInfiniteQueryKey = (
  options?: Options<IntegrationsGmailListData>
): QueryKey<Options<IntegrationsGmailListData>> =>
  createQueryKey('integrationsGmailList', options, true)

export const integrationsGmailListInfiniteOptions = (
  options?: Options<IntegrationsGmailListData>
) => {
  return infiniteQueryOptions<
    IntegrationsGmailListResponse,
    AxiosError<DefaultError>,
    InfiniteData<IntegrationsGmailListResponse>,
    QueryKey<Options<IntegrationsGmailListData>>,
    | number
    | Pick<
        QueryKey<Options<IntegrationsGmailListData>>[0],
        'body' | 'headers' | 'path' | 'query'
      >
  >(
    // @ts-ignore
    {
      queryFn: async ({ pageParam, queryKey, signal }) => {
        // @ts-ignore
        const page: Pick<
          QueryKey<Options<IntegrationsGmailListData>>[0],
          'body' | 'headers' | 'path' | 'query'
        > =
          typeof pageParam === 'object'
            ? pageParam
            : {
                query: {
                  page: pageParam
                }
              }
        const params = createInfiniteParams(queryKey, page)
        const { data } = await integrationsGmailList({
          ...options,
          ...params,
          signal,
          throwOnError: true
        })

        return data
      },
      queryKey: integrationsGmailListInfiniteQueryKey(options)
    }
  )
}

export const integrationsGmailCreateQueryKey = (
  options: Options<IntegrationsGmailCreateData>
) => createQueryKey('integrationsGmailCreate', options)

export const integrationsGmailCreateOptions = (
  options: Options<IntegrationsGmailCreateData>
) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await integrationsGmailCreate({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true
      })

      return data
    },
    queryKey: integrationsGmailCreateQueryKey(options)
  })
}

export const integrationsGmailCreateMutation = (
  options?: Partial<Options<IntegrationsGmailCreateData>>
): UseMutationOptions<
  IntegrationsGmailCreateResponse,
  AxiosError<DefaultError>,
  Options<IntegrationsGmailCreateData>
> => {
  const mutationOptions: UseMutationOptions<
    IntegrationsGmailCreateResponse,
    AxiosError<DefaultError>,
    Options<IntegrationsGmailCreateData>
  > = {
    mutationFn: async (localOptions) => {
      const { data } = await integrationsGmailCreate({
        ...options,
        ...localOptions,
        throwOnError: true
      })

      return data
    }
  }

  return mutationOptions
}

export const integrationsGmailDestroyMutation = (
  options?: Partial<Options<IntegrationsGmailDestroyData>>
): UseMutationOptions<
  IntegrationsGmailDestroyResponse,
  AxiosError<DefaultError>,
  Options<IntegrationsGmailDestroyData>
> => {
  const mutationOptions: UseMutationOptions<
    IntegrationsGmailDestroyResponse,
    AxiosError<DefaultError>,
    Options<IntegrationsGmailDestroyData>
  > = {
    mutationFn: async (localOptions) => {
      const { data } = await integrationsGmailDestroy({
        ...options,
        ...localOptions,
        throwOnError: true
      })

      return data
    }
  }

  return mutationOptions
}

export const integrationsGmailRetrieveQueryKey = (
  options: Options<IntegrationsGmailRetrieveData>
) => createQueryKey('integrationsGmailRetrieve', options)

export const integrationsGmailRetrieveOptions = (
  options: Options<IntegrationsGmailRetrieveData>
) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await integrationsGmailRetrieve({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true
      })

      return data
    },
    queryKey: integrationsGmailRetrieveQueryKey(options)
  })
}

export const integrationsGmailPartialUpdateMutation = (
  options?: Partial<Options<IntegrationsGmailPartialUpdateData>>
): UseMutationOptions<
  IntegrationsGmailPartialUpdateResponse,
  AxiosError<DefaultError>,
  Options<IntegrationsGmailPartialUpdateData>
> => {
  const mutationOptions: UseMutationOptions<
    IntegrationsGmailPartialUpdateResponse,
    AxiosError<DefaultError>,
    Options<IntegrationsGmailPartialUpdateData>
  > = {
    mutationFn: async (localOptions) => {
      const { data } = await integrationsGmailPartialUpdate({
        ...options,
        ...localOptions,
        throwOnError: true
      })

      return data
    }
  }

  return mutationOptions
}

export const integrationsGmailUpdateMutation = (
  options?: Partial<Options<IntegrationsGmailUpdateData>>
): UseMutationOptions<
  IntegrationsGmailUpdateResponse,
  AxiosError<DefaultError>,
  Options<IntegrationsGmailUpdateData>
> => {
  const mutationOptions: UseMutationOptions<
    IntegrationsGmailUpdateResponse,
    AxiosError<DefaultError>,
    Options<IntegrationsGmailUpdateData>
  > = {
    mutationFn: async (localOptions) => {
      const { data } = await integrationsGmailUpdate({
        ...options,
        ...localOptions,
        throwOnError: true
      })

      return data
    }
  }

  return mutationOptions
}

export const integrationsGmailCheckMailboxRetrieveQueryKey = (
  options: Options<IntegrationsGmailCheckMailboxRetrieveData>
) => createQueryKey('integrationsGmailCheckMailboxRetrieve', options)

export const integrationsGmailCheckMailboxRetrieveOptions = (
  options: Options<IntegrationsGmailCheckMailboxRetrieveData>
) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await integrationsGmailCheckMailboxRetrieve({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true
      })

      return data
    },
    queryKey: integrationsGmailCheckMailboxRetrieveQueryKey(options)
  })
}

export const integrationsGmailAuthCallbackCreateQueryKey = (
  options: Options<IntegrationsGmailAuthCallbackCreateData>
) => createQueryKey('integrationsGmailAuthCallbackCreate', options)

export const integrationsGmailAuthCallbackCreateOptions = (
  options: Options<IntegrationsGmailAuthCallbackCreateData>
) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await integrationsGmailAuthCallbackCreate({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true
      })

      return data
    },
    queryKey: integrationsGmailAuthCallbackCreateQueryKey(options)
  })
}

export const integrationsGmailAuthCallbackCreateMutation = (
  options?: Partial<Options<IntegrationsGmailAuthCallbackCreateData>>
): UseMutationOptions<
  IntegrationsGmailAuthCallbackCreateResponse,
  AxiosError<DefaultError>,
  Options<IntegrationsGmailAuthCallbackCreateData>
> => {
  const mutationOptions: UseMutationOptions<
    IntegrationsGmailAuthCallbackCreateResponse,
    AxiosError<DefaultError>,
    Options<IntegrationsGmailAuthCallbackCreateData>
  > = {
    mutationFn: async (localOptions) => {
      const { data } = await integrationsGmailAuthCallbackCreate({
        ...options,
        ...localOptions,
        throwOnError: true
      })

      return data
    }
  }

  return mutationOptions
}

export const integrationsGmailAuthUrlRetrieveQueryKey = (
  options?: Options<IntegrationsGmailAuthUrlRetrieveData>
) => createQueryKey('integrationsGmailAuthUrlRetrieve', options)

export const integrationsGmailAuthUrlRetrieveOptions = (
  options?: Options<IntegrationsGmailAuthUrlRetrieveData>
) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await integrationsGmailAuthUrlRetrieve({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true
      })

      return data
    },
    queryKey: integrationsGmailAuthUrlRetrieveQueryKey(options)
  })
}

export const integrationsGmailListListQueryKey = (
  options?: Options<IntegrationsGmailListListData>
) => createQueryKey('integrationsGmailListList', options)

export const integrationsGmailListListOptions = (
  options?: Options<IntegrationsGmailListListData>
) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await integrationsGmailListList({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true
      })

      return data
    },
    queryKey: integrationsGmailListListQueryKey(options)
  })
}

export const integrationsGmailListListInfiniteQueryKey = (
  options?: Options<IntegrationsGmailListListData>
): QueryKey<Options<IntegrationsGmailListListData>> =>
  createQueryKey('integrationsGmailListList', options, true)

export const integrationsGmailListListInfiniteOptions = (
  options?: Options<IntegrationsGmailListListData>
) => {
  return infiniteQueryOptions<
    IntegrationsGmailListListResponse,
    AxiosError<DefaultError>,
    InfiniteData<IntegrationsGmailListListResponse>,
    QueryKey<Options<IntegrationsGmailListListData>>,
    | number
    | Pick<
        QueryKey<Options<IntegrationsGmailListListData>>[0],
        'body' | 'headers' | 'path' | 'query'
      >
  >(
    // @ts-ignore
    {
      queryFn: async ({ pageParam, queryKey, signal }) => {
        // @ts-ignore
        const page: Pick<
          QueryKey<Options<IntegrationsGmailListListData>>[0],
          'body' | 'headers' | 'path' | 'query'
        > =
          typeof pageParam === 'object'
            ? pageParam
            : {
                query: {
                  page: pageParam
                }
              }
        const params = createInfiniteParams(queryKey, page)
        const { data } = await integrationsGmailListList({
          ...options,
          ...params,
          signal,
          throwOnError: true
        })

        return data
      },
      queryKey: integrationsGmailListListInfiniteQueryKey(options)
    }
  )
}

export const integrationsGmailLogoutMailboxCreateQueryKey = (
  options: Options<IntegrationsGmailLogoutMailboxCreateData>
) => createQueryKey('integrationsGmailLogoutMailboxCreate', options)

export const integrationsGmailLogoutMailboxCreateOptions = (
  options: Options<IntegrationsGmailLogoutMailboxCreateData>
) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await integrationsGmailLogoutMailboxCreate({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true
      })

      return data
    },
    queryKey: integrationsGmailLogoutMailboxCreateQueryKey(options)
  })
}

export const integrationsGmailLogoutMailboxCreateMutation = (
  options?: Partial<Options<IntegrationsGmailLogoutMailboxCreateData>>
): UseMutationOptions<
  IntegrationsGmailLogoutMailboxCreateResponse,
  AxiosError<DefaultError>,
  Options<IntegrationsGmailLogoutMailboxCreateData>
> => {
  const mutationOptions: UseMutationOptions<
    IntegrationsGmailLogoutMailboxCreateResponse,
    AxiosError<DefaultError>,
    Options<IntegrationsGmailLogoutMailboxCreateData>
  > = {
    mutationFn: async (localOptions) => {
      const { data } = await integrationsGmailLogoutMailboxCreate({
        ...options,
        ...localOptions,
        throwOnError: true
      })

      return data
    }
  }

  return mutationOptions
}

export const integrationsMessengerListQueryKey = (
  options?: Options<IntegrationsMessengerListData>
) => createQueryKey('integrationsMessengerList', options)

export const integrationsMessengerListOptions = (
  options?: Options<IntegrationsMessengerListData>
) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await integrationsMessengerList({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true
      })

      return data
    },
    queryKey: integrationsMessengerListQueryKey(options)
  })
}

export const integrationsMessengerListInfiniteQueryKey = (
  options?: Options<IntegrationsMessengerListData>
): QueryKey<Options<IntegrationsMessengerListData>> =>
  createQueryKey('integrationsMessengerList', options, true)

export const integrationsMessengerListInfiniteOptions = (
  options?: Options<IntegrationsMessengerListData>
) => {
  return infiniteQueryOptions<
    IntegrationsMessengerListResponse,
    AxiosError<DefaultError>,
    InfiniteData<IntegrationsMessengerListResponse>,
    QueryKey<Options<IntegrationsMessengerListData>>,
    | number
    | Pick<
        QueryKey<Options<IntegrationsMessengerListData>>[0],
        'body' | 'headers' | 'path' | 'query'
      >
  >(
    // @ts-ignore
    {
      queryFn: async ({ pageParam, queryKey, signal }) => {
        // @ts-ignore
        const page: Pick<
          QueryKey<Options<IntegrationsMessengerListData>>[0],
          'body' | 'headers' | 'path' | 'query'
        > =
          typeof pageParam === 'object'
            ? pageParam
            : {
                query: {
                  page: pageParam
                }
              }
        const params = createInfiniteParams(queryKey, page)
        const { data } = await integrationsMessengerList({
          ...options,
          ...params,
          signal,
          throwOnError: true
        })

        return data
      },
      queryKey: integrationsMessengerListInfiniteQueryKey(options)
    }
  )
}

export const integrationsMessengerCreateQueryKey = (
  options: Options<IntegrationsMessengerCreateData>
) => createQueryKey('integrationsMessengerCreate', options)

export const integrationsMessengerCreateOptions = (
  options: Options<IntegrationsMessengerCreateData>
) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await integrationsMessengerCreate({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true
      })

      return data
    },
    queryKey: integrationsMessengerCreateQueryKey(options)
  })
}

export const integrationsMessengerCreateMutation = (
  options?: Partial<Options<IntegrationsMessengerCreateData>>
): UseMutationOptions<
  IntegrationsMessengerCreateResponse,
  AxiosError<DefaultError>,
  Options<IntegrationsMessengerCreateData>
> => {
  const mutationOptions: UseMutationOptions<
    IntegrationsMessengerCreateResponse,
    AxiosError<DefaultError>,
    Options<IntegrationsMessengerCreateData>
  > = {
    mutationFn: async (localOptions) => {
      const { data } = await integrationsMessengerCreate({
        ...options,
        ...localOptions,
        throwOnError: true
      })

      return data
    }
  }

  return mutationOptions
}

export const integrationsMessengerDestroyMutation = (
  options?: Partial<Options<IntegrationsMessengerDestroyData>>
): UseMutationOptions<
  IntegrationsMessengerDestroyResponse,
  AxiosError<DefaultError>,
  Options<IntegrationsMessengerDestroyData>
> => {
  const mutationOptions: UseMutationOptions<
    IntegrationsMessengerDestroyResponse,
    AxiosError<DefaultError>,
    Options<IntegrationsMessengerDestroyData>
  > = {
    mutationFn: async (localOptions) => {
      const { data } = await integrationsMessengerDestroy({
        ...options,
        ...localOptions,
        throwOnError: true
      })

      return data
    }
  }

  return mutationOptions
}

export const integrationsMessengerRetrieveQueryKey = (
  options: Options<IntegrationsMessengerRetrieveData>
) => createQueryKey('integrationsMessengerRetrieve', options)

export const integrationsMessengerRetrieveOptions = (
  options: Options<IntegrationsMessengerRetrieveData>
) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await integrationsMessengerRetrieve({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true
      })

      return data
    },
    queryKey: integrationsMessengerRetrieveQueryKey(options)
  })
}

export const integrationsMessengerPartialUpdateMutation = (
  options?: Partial<Options<IntegrationsMessengerPartialUpdateData>>
): UseMutationOptions<
  IntegrationsMessengerPartialUpdateResponse,
  AxiosError<DefaultError>,
  Options<IntegrationsMessengerPartialUpdateData>
> => {
  const mutationOptions: UseMutationOptions<
    IntegrationsMessengerPartialUpdateResponse,
    AxiosError<DefaultError>,
    Options<IntegrationsMessengerPartialUpdateData>
  > = {
    mutationFn: async (localOptions) => {
      const { data } = await integrationsMessengerPartialUpdate({
        ...options,
        ...localOptions,
        throwOnError: true
      })

      return data
    }
  }

  return mutationOptions
}

export const integrationsMessengerUpdateMutation = (
  options?: Partial<Options<IntegrationsMessengerUpdateData>>
): UseMutationOptions<
  IntegrationsMessengerUpdateResponse,
  AxiosError<DefaultError>,
  Options<IntegrationsMessengerUpdateData>
> => {
  const mutationOptions: UseMutationOptions<
    IntegrationsMessengerUpdateResponse,
    AxiosError<DefaultError>,
    Options<IntegrationsMessengerUpdateData>
  > = {
    mutationFn: async (localOptions) => {
      const { data } = await integrationsMessengerUpdate({
        ...options,
        ...localOptions,
        throwOnError: true
      })

      return data
    }
  }

  return mutationOptions
}

export const integrationsMessengerCheckMailboxRetrieveQueryKey = (
  options: Options<IntegrationsMessengerCheckMailboxRetrieveData>
) => createQueryKey('integrationsMessengerCheckMailboxRetrieve', options)

export const integrationsMessengerCheckMailboxRetrieveOptions = (
  options: Options<IntegrationsMessengerCheckMailboxRetrieveData>
) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await integrationsMessengerCheckMailboxRetrieve({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true
      })

      return data
    },
    queryKey: integrationsMessengerCheckMailboxRetrieveQueryKey(options)
  })
}

export const integrationsMessengerAuthCallbackCreateQueryKey = (
  options: Options<IntegrationsMessengerAuthCallbackCreateData>
) => createQueryKey('integrationsMessengerAuthCallbackCreate', options)

export const integrationsMessengerAuthCallbackCreateOptions = (
  options: Options<IntegrationsMessengerAuthCallbackCreateData>
) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await integrationsMessengerAuthCallbackCreate({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true
      })

      return data
    },
    queryKey: integrationsMessengerAuthCallbackCreateQueryKey(options)
  })
}

export const integrationsMessengerAuthCallbackCreateMutation = (
  options?: Partial<Options<IntegrationsMessengerAuthCallbackCreateData>>
): UseMutationOptions<
  IntegrationsMessengerAuthCallbackCreateResponse,
  AxiosError<DefaultError>,
  Options<IntegrationsMessengerAuthCallbackCreateData>
> => {
  const mutationOptions: UseMutationOptions<
    IntegrationsMessengerAuthCallbackCreateResponse,
    AxiosError<DefaultError>,
    Options<IntegrationsMessengerAuthCallbackCreateData>
  > = {
    mutationFn: async (localOptions) => {
      const { data } = await integrationsMessengerAuthCallbackCreate({
        ...options,
        ...localOptions,
        throwOnError: true
      })

      return data
    }
  }

  return mutationOptions
}

export const integrationsMessengerAuthUrlRetrieveQueryKey = (
  options?: Options<IntegrationsMessengerAuthUrlRetrieveData>
) => createQueryKey('integrationsMessengerAuthUrlRetrieve', options)

export const integrationsMessengerAuthUrlRetrieveOptions = (
  options?: Options<IntegrationsMessengerAuthUrlRetrieveData>
) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await integrationsMessengerAuthUrlRetrieve({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true
      })

      return data
    },
    queryKey: integrationsMessengerAuthUrlRetrieveQueryKey(options)
  })
}

export const integrationsMessengerListListQueryKey = (
  options?: Options<IntegrationsMessengerListListData>
) => createQueryKey('integrationsMessengerListList', options)

export const integrationsMessengerListListOptions = (
  options?: Options<IntegrationsMessengerListListData>
) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await integrationsMessengerListList({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true
      })

      return data
    },
    queryKey: integrationsMessengerListListQueryKey(options)
  })
}

export const integrationsMessengerListListInfiniteQueryKey = (
  options?: Options<IntegrationsMessengerListListData>
): QueryKey<Options<IntegrationsMessengerListListData>> =>
  createQueryKey('integrationsMessengerListList', options, true)

export const integrationsMessengerListListInfiniteOptions = (
  options?: Options<IntegrationsMessengerListListData>
) => {
  return infiniteQueryOptions<
    IntegrationsMessengerListListResponse,
    AxiosError<DefaultError>,
    InfiniteData<IntegrationsMessengerListListResponse>,
    QueryKey<Options<IntegrationsMessengerListListData>>,
    | number
    | Pick<
        QueryKey<Options<IntegrationsMessengerListListData>>[0],
        'body' | 'headers' | 'path' | 'query'
      >
  >(
    // @ts-ignore
    {
      queryFn: async ({ pageParam, queryKey, signal }) => {
        // @ts-ignore
        const page: Pick<
          QueryKey<Options<IntegrationsMessengerListListData>>[0],
          'body' | 'headers' | 'path' | 'query'
        > =
          typeof pageParam === 'object'
            ? pageParam
            : {
                query: {
                  page: pageParam
                }
              }
        const params = createInfiniteParams(queryKey, page)
        const { data } = await integrationsMessengerListList({
          ...options,
          ...params,
          signal,
          throwOnError: true
        })

        return data
      },
      queryKey: integrationsMessengerListListInfiniteQueryKey(options)
    }
  )
}

export const integrationsMessengerLogoutMailboxCreateQueryKey = (
  options: Options<IntegrationsMessengerLogoutMailboxCreateData>
) => createQueryKey('integrationsMessengerLogoutMailboxCreate', options)

export const integrationsMessengerLogoutMailboxCreateOptions = (
  options: Options<IntegrationsMessengerLogoutMailboxCreateData>
) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await integrationsMessengerLogoutMailboxCreate({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true
      })

      return data
    },
    queryKey: integrationsMessengerLogoutMailboxCreateQueryKey(options)
  })
}

export const integrationsMessengerLogoutMailboxCreateMutation = (
  options?: Partial<Options<IntegrationsMessengerLogoutMailboxCreateData>>
): UseMutationOptions<
  IntegrationsMessengerLogoutMailboxCreateResponse,
  AxiosError<DefaultError>,
  Options<IntegrationsMessengerLogoutMailboxCreateData>
> => {
  const mutationOptions: UseMutationOptions<
    IntegrationsMessengerLogoutMailboxCreateResponse,
    AxiosError<DefaultError>,
    Options<IntegrationsMessengerLogoutMailboxCreateData>
  > = {
    mutationFn: async (localOptions) => {
      const { data } = await integrationsMessengerLogoutMailboxCreate({
        ...options,
        ...localOptions,
        throwOnError: true
      })

      return data
    }
  }

  return mutationOptions
}

export const integrationsWhatsappConfigListQueryKey = (
  options?: Options<IntegrationsWhatsappConfigListData>
) => createQueryKey('integrationsWhatsappConfigList', options)

export const integrationsWhatsappConfigListOptions = (
  options?: Options<IntegrationsWhatsappConfigListData>
) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await integrationsWhatsappConfigList({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true
      })

      return data
    },
    queryKey: integrationsWhatsappConfigListQueryKey(options)
  })
}

export const integrationsWhatsappConfigListInfiniteQueryKey = (
  options?: Options<IntegrationsWhatsappConfigListData>
): QueryKey<Options<IntegrationsWhatsappConfigListData>> =>
  createQueryKey('integrationsWhatsappConfigList', options, true)

export const integrationsWhatsappConfigListInfiniteOptions = (
  options?: Options<IntegrationsWhatsappConfigListData>
) => {
  return infiniteQueryOptions<
    IntegrationsWhatsappConfigListResponse,
    AxiosError<DefaultError>,
    InfiniteData<IntegrationsWhatsappConfigListResponse>,
    QueryKey<Options<IntegrationsWhatsappConfigListData>>,
    | number
    | Pick<
        QueryKey<Options<IntegrationsWhatsappConfigListData>>[0],
        'body' | 'headers' | 'path' | 'query'
      >
  >(
    // @ts-ignore
    {
      queryFn: async ({ pageParam, queryKey, signal }) => {
        // @ts-ignore
        const page: Pick<
          QueryKey<Options<IntegrationsWhatsappConfigListData>>[0],
          'body' | 'headers' | 'path' | 'query'
        > =
          typeof pageParam === 'object'
            ? pageParam
            : {
                query: {
                  page: pageParam
                }
              }
        const params = createInfiniteParams(queryKey, page)
        const { data } = await integrationsWhatsappConfigList({
          ...options,
          ...params,
          signal,
          throwOnError: true
        })

        return data
      },
      queryKey: integrationsWhatsappConfigListInfiniteQueryKey(options)
    }
  )
}

export const integrationsWhatsappConfigCreateQueryKey = (
  options: Options<IntegrationsWhatsappConfigCreateData>
) => createQueryKey('integrationsWhatsappConfigCreate', options)

export const integrationsWhatsappConfigCreateOptions = (
  options: Options<IntegrationsWhatsappConfigCreateData>
) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await integrationsWhatsappConfigCreate({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true
      })

      return data
    },
    queryKey: integrationsWhatsappConfigCreateQueryKey(options)
  })
}

export const integrationsWhatsappConfigCreateMutation = (
  options?: Partial<Options<IntegrationsWhatsappConfigCreateData>>
): UseMutationOptions<
  IntegrationsWhatsappConfigCreateResponse,
  AxiosError<DefaultError>,
  Options<IntegrationsWhatsappConfigCreateData>
> => {
  const mutationOptions: UseMutationOptions<
    IntegrationsWhatsappConfigCreateResponse,
    AxiosError<DefaultError>,
    Options<IntegrationsWhatsappConfigCreateData>
  > = {
    mutationFn: async (localOptions) => {
      const { data } = await integrationsWhatsappConfigCreate({
        ...options,
        ...localOptions,
        throwOnError: true
      })

      return data
    }
  }

  return mutationOptions
}

export const integrationsWhatsappConfigDestroyMutation = (
  options?: Partial<Options<IntegrationsWhatsappConfigDestroyData>>
): UseMutationOptions<
  IntegrationsWhatsappConfigDestroyResponse,
  AxiosError<DefaultError>,
  Options<IntegrationsWhatsappConfigDestroyData>
> => {
  const mutationOptions: UseMutationOptions<
    IntegrationsWhatsappConfigDestroyResponse,
    AxiosError<DefaultError>,
    Options<IntegrationsWhatsappConfigDestroyData>
  > = {
    mutationFn: async (localOptions) => {
      const { data } = await integrationsWhatsappConfigDestroy({
        ...options,
        ...localOptions,
        throwOnError: true
      })

      return data
    }
  }

  return mutationOptions
}

export const integrationsWhatsappConfigRetrieveQueryKey = (
  options: Options<IntegrationsWhatsappConfigRetrieveData>
) => createQueryKey('integrationsWhatsappConfigRetrieve', options)

export const integrationsWhatsappConfigRetrieveOptions = (
  options: Options<IntegrationsWhatsappConfigRetrieveData>
) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await integrationsWhatsappConfigRetrieve({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true
      })

      return data
    },
    queryKey: integrationsWhatsappConfigRetrieveQueryKey(options)
  })
}

export const integrationsWhatsappConfigPartialUpdateMutation = (
  options?: Partial<Options<IntegrationsWhatsappConfigPartialUpdateData>>
): UseMutationOptions<
  IntegrationsWhatsappConfigPartialUpdateResponse,
  AxiosError<DefaultError>,
  Options<IntegrationsWhatsappConfigPartialUpdateData>
> => {
  const mutationOptions: UseMutationOptions<
    IntegrationsWhatsappConfigPartialUpdateResponse,
    AxiosError<DefaultError>,
    Options<IntegrationsWhatsappConfigPartialUpdateData>
  > = {
    mutationFn: async (localOptions) => {
      const { data } = await integrationsWhatsappConfigPartialUpdate({
        ...options,
        ...localOptions,
        throwOnError: true
      })

      return data
    }
  }

  return mutationOptions
}

export const integrationsWhatsappConfigUpdateMutation = (
  options?: Partial<Options<IntegrationsWhatsappConfigUpdateData>>
): UseMutationOptions<
  IntegrationsWhatsappConfigUpdateResponse,
  AxiosError<DefaultError>,
  Options<IntegrationsWhatsappConfigUpdateData>
> => {
  const mutationOptions: UseMutationOptions<
    IntegrationsWhatsappConfigUpdateResponse,
    AxiosError<DefaultError>,
    Options<IntegrationsWhatsappConfigUpdateData>
  > = {
    mutationFn: async (localOptions) => {
      const { data } = await integrationsWhatsappConfigUpdate({
        ...options,
        ...localOptions,
        throwOnError: true
      })

      return data
    }
  }

  return mutationOptions
}

export const integrationsWhatsappConfigTestCreateQueryKey = (
  options: Options<IntegrationsWhatsappConfigTestCreateData>
) => createQueryKey('integrationsWhatsappConfigTestCreate', options)

export const integrationsWhatsappConfigTestCreateOptions = (
  options: Options<IntegrationsWhatsappConfigTestCreateData>
) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await integrationsWhatsappConfigTestCreate({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true
      })

      return data
    },
    queryKey: integrationsWhatsappConfigTestCreateQueryKey(options)
  })
}

export const integrationsWhatsappConfigTestCreateMutation = (
  options?: Partial<Options<IntegrationsWhatsappConfigTestCreateData>>
): UseMutationOptions<
  IntegrationsWhatsappConfigTestCreateResponse,
  AxiosError<DefaultError>,
  Options<IntegrationsWhatsappConfigTestCreateData>
> => {
  const mutationOptions: UseMutationOptions<
    IntegrationsWhatsappConfigTestCreateResponse,
    AxiosError<DefaultError>,
    Options<IntegrationsWhatsappConfigTestCreateData>
  > = {
    mutationFn: async (localOptions) => {
      const { data } = await integrationsWhatsappConfigTestCreate({
        ...options,
        ...localOptions,
        throwOnError: true
      })

      return data
    }
  }

  return mutationOptions
}

export const integrationsWhatsappMessageTemplatesListQueryKey = (
  options?: Options<IntegrationsWhatsappMessageTemplatesListData>
) => createQueryKey('integrationsWhatsappMessageTemplatesList', options)

export const integrationsWhatsappMessageTemplatesListOptions = (
  options?: Options<IntegrationsWhatsappMessageTemplatesListData>
) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await integrationsWhatsappMessageTemplatesList({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true
      })

      return data
    },
    queryKey: integrationsWhatsappMessageTemplatesListQueryKey(options)
  })
}

export const integrationsWhatsappMessageTemplatesListInfiniteQueryKey = (
  options?: Options<IntegrationsWhatsappMessageTemplatesListData>
): QueryKey<Options<IntegrationsWhatsappMessageTemplatesListData>> =>
  createQueryKey('integrationsWhatsappMessageTemplatesList', options, true)

export const integrationsWhatsappMessageTemplatesListInfiniteOptions = (
  options?: Options<IntegrationsWhatsappMessageTemplatesListData>
) => {
  return infiniteQueryOptions<
    IntegrationsWhatsappMessageTemplatesListResponse,
    AxiosError<DefaultError>,
    InfiniteData<IntegrationsWhatsappMessageTemplatesListResponse>,
    QueryKey<Options<IntegrationsWhatsappMessageTemplatesListData>>,
    | number
    | Pick<
        QueryKey<Options<IntegrationsWhatsappMessageTemplatesListData>>[0],
        'body' | 'headers' | 'path' | 'query'
      >
  >(
    // @ts-ignore
    {
      queryFn: async ({ pageParam, queryKey, signal }) => {
        // @ts-ignore
        const page: Pick<
          QueryKey<Options<IntegrationsWhatsappMessageTemplatesListData>>[0],
          'body' | 'headers' | 'path' | 'query'
        > =
          typeof pageParam === 'object'
            ? pageParam
            : {
                query: {
                  page: pageParam
                }
              }
        const params = createInfiniteParams(queryKey, page)
        const { data } = await integrationsWhatsappMessageTemplatesList({
          ...options,
          ...params,
          signal,
          throwOnError: true
        })

        return data
      },
      queryKey:
        integrationsWhatsappMessageTemplatesListInfiniteQueryKey(options)
    }
  )
}

export const integrationsWhatsappMessageTemplatesSyncCreateQueryKey = (
  options?: Options<IntegrationsWhatsappMessageTemplatesSyncCreateData>
) => createQueryKey('integrationsWhatsappMessageTemplatesSyncCreate', options)

export const integrationsWhatsappMessageTemplatesSyncCreateOptions = (
  options?: Options<IntegrationsWhatsappMessageTemplatesSyncCreateData>
) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await integrationsWhatsappMessageTemplatesSyncCreate({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true
      })

      return data
    },
    queryKey: integrationsWhatsappMessageTemplatesSyncCreateQueryKey(options)
  })
}

export const integrationsWhatsappMessageTemplatesSyncCreateMutation = (
  options?: Partial<Options<IntegrationsWhatsappMessageTemplatesSyncCreateData>>
): UseMutationOptions<
  IntegrationsWhatsappMessageTemplatesSyncCreateResponse,
  AxiosError<DefaultError>,
  Options<IntegrationsWhatsappMessageTemplatesSyncCreateData>
> => {
  const mutationOptions: UseMutationOptions<
    IntegrationsWhatsappMessageTemplatesSyncCreateResponse,
    AxiosError<DefaultError>,
    Options<IntegrationsWhatsappMessageTemplatesSyncCreateData>
  > = {
    mutationFn: async (localOptions) => {
      const { data } = await integrationsWhatsappMessageTemplatesSyncCreate({
        ...options,
        ...localOptions,
        throwOnError: true
      })

      return data
    }
  }

  return mutationOptions
}

export const integrationsWhatsappMessagesListQueryKey = (
  options?: Options<IntegrationsWhatsappMessagesListData>
) => createQueryKey('integrationsWhatsappMessagesList', options)

export const integrationsWhatsappMessagesListOptions = (
  options?: Options<IntegrationsWhatsappMessagesListData>
) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await integrationsWhatsappMessagesList({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true
      })

      return data
    },
    queryKey: integrationsWhatsappMessagesListQueryKey(options)
  })
}

export const integrationsWhatsappMessagesListInfiniteQueryKey = (
  options?: Options<IntegrationsWhatsappMessagesListData>
): QueryKey<Options<IntegrationsWhatsappMessagesListData>> =>
  createQueryKey('integrationsWhatsappMessagesList', options, true)

export const integrationsWhatsappMessagesListInfiniteOptions = (
  options?: Options<IntegrationsWhatsappMessagesListData>
) => {
  return infiniteQueryOptions<
    IntegrationsWhatsappMessagesListResponse,
    AxiosError<DefaultError>,
    InfiniteData<IntegrationsWhatsappMessagesListResponse>,
    QueryKey<Options<IntegrationsWhatsappMessagesListData>>,
    | number
    | Pick<
        QueryKey<Options<IntegrationsWhatsappMessagesListData>>[0],
        'body' | 'headers' | 'path' | 'query'
      >
  >(
    // @ts-ignore
    {
      queryFn: async ({ pageParam, queryKey, signal }) => {
        // @ts-ignore
        const page: Pick<
          QueryKey<Options<IntegrationsWhatsappMessagesListData>>[0],
          'body' | 'headers' | 'path' | 'query'
        > =
          typeof pageParam === 'object'
            ? pageParam
            : {
                query: {
                  page: pageParam
                }
              }
        const params = createInfiniteParams(queryKey, page)
        const { data } = await integrationsWhatsappMessagesList({
          ...options,
          ...params,
          signal,
          throwOnError: true
        })

        return data
      },
      queryKey: integrationsWhatsappMessagesListInfiniteQueryKey(options)
    }
  )
}

export const integrationsWhatsappMessagesRetrieveQueryKey = (
  options: Options<IntegrationsWhatsappMessagesRetrieveData>
) => createQueryKey('integrationsWhatsappMessagesRetrieve', options)

export const integrationsWhatsappMessagesRetrieveOptions = (
  options: Options<IntegrationsWhatsappMessagesRetrieveData>
) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await integrationsWhatsappMessagesRetrieve({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true
      })

      return data
    },
    queryKey: integrationsWhatsappMessagesRetrieveQueryKey(options)
  })
}

export const integrationsWhatsappMessagesRetryCreateQueryKey = (
  options: Options<IntegrationsWhatsappMessagesRetryCreateData>
) => createQueryKey('integrationsWhatsappMessagesRetryCreate', options)

export const integrationsWhatsappMessagesRetryCreateOptions = (
  options: Options<IntegrationsWhatsappMessagesRetryCreateData>
) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await integrationsWhatsappMessagesRetryCreate({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true
      })

      return data
    },
    queryKey: integrationsWhatsappMessagesRetryCreateQueryKey(options)
  })
}

export const integrationsWhatsappMessagesRetryCreateMutation = (
  options?: Partial<Options<IntegrationsWhatsappMessagesRetryCreateData>>
): UseMutationOptions<
  IntegrationsWhatsappMessagesRetryCreateResponse,
  AxiosError<DefaultError>,
  Options<IntegrationsWhatsappMessagesRetryCreateData>
> => {
  const mutationOptions: UseMutationOptions<
    IntegrationsWhatsappMessagesRetryCreateResponse,
    AxiosError<DefaultError>,
    Options<IntegrationsWhatsappMessagesRetryCreateData>
  > = {
    mutationFn: async (localOptions) => {
      const { data } = await integrationsWhatsappMessagesRetryCreate({
        ...options,
        ...localOptions,
        throwOnError: true
      })

      return data
    }
  }

  return mutationOptions
}

export const integrationsWhatsappMessagesSendCreateQueryKey = (
  options: Options<IntegrationsWhatsappMessagesSendCreateData>
) => createQueryKey('integrationsWhatsappMessagesSendCreate', options)

export const integrationsWhatsappMessagesSendCreateOptions = (
  options: Options<IntegrationsWhatsappMessagesSendCreateData>
) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await integrationsWhatsappMessagesSendCreate({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true
      })

      return data
    },
    queryKey: integrationsWhatsappMessagesSendCreateQueryKey(options)
  })
}

export const integrationsWhatsappMessagesSendCreateMutation = (
  options?: Partial<Options<IntegrationsWhatsappMessagesSendCreateData>>
): UseMutationOptions<
  IntegrationsWhatsappMessagesSendCreateResponse,
  AxiosError<DefaultError>,
  Options<IntegrationsWhatsappMessagesSendCreateData>
> => {
  const mutationOptions: UseMutationOptions<
    IntegrationsWhatsappMessagesSendCreateResponse,
    AxiosError<DefaultError>,
    Options<IntegrationsWhatsappMessagesSendCreateData>
  > = {
    mutationFn: async (localOptions) => {
      const { data } = await integrationsWhatsappMessagesSendCreate({
        ...options,
        ...localOptions,
        throwOnError: true
      })

      return data
    }
  }

  return mutationOptions
}

export const internalCitiesListQueryKey = (
  options?: Options<InternalCitiesListData>
) => createQueryKey('internalCitiesList', options)

export const internalCitiesListOptions = (
  options?: Options<InternalCitiesListData>
) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await internalCitiesList({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true
      })

      return data
    },
    queryKey: internalCitiesListQueryKey(options)
  })
}

export const internalCitiesListInfiniteQueryKey = (
  options?: Options<InternalCitiesListData>
): QueryKey<Options<InternalCitiesListData>> =>
  createQueryKey('internalCitiesList', options, true)

export const internalCitiesListInfiniteOptions = (
  options?: Options<InternalCitiesListData>
) => {
  return infiniteQueryOptions<
    InternalCitiesListResponse,
    AxiosError<DefaultError>,
    InfiniteData<InternalCitiesListResponse>,
    QueryKey<Options<InternalCitiesListData>>,
    | number
    | Pick<
        QueryKey<Options<InternalCitiesListData>>[0],
        'body' | 'headers' | 'path' | 'query'
      >
  >(
    // @ts-ignore
    {
      queryFn: async ({ pageParam, queryKey, signal }) => {
        // @ts-ignore
        const page: Pick<
          QueryKey<Options<InternalCitiesListData>>[0],
          'body' | 'headers' | 'path' | 'query'
        > =
          typeof pageParam === 'object'
            ? pageParam
            : {
                query: {
                  page: pageParam
                }
              }
        const params = createInfiniteParams(queryKey, page)
        const { data } = await internalCitiesList({
          ...options,
          ...params,
          signal,
          throwOnError: true
        })

        return data
      },
      queryKey: internalCitiesListInfiniteQueryKey(options)
    }
  )
}

export const internalCitiesRetrieveQueryKey = (
  options: Options<InternalCitiesRetrieveData>
) => createQueryKey('internalCitiesRetrieve', options)

export const internalCitiesRetrieveOptions = (
  options: Options<InternalCitiesRetrieveData>
) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await internalCitiesRetrieve({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true
      })

      return data
    },
    queryKey: internalCitiesRetrieveQueryKey(options)
  })
}

export const internalCitiesListListQueryKey = (
  options?: Options<InternalCitiesListListData>
) => createQueryKey('internalCitiesListList', options)

export const internalCitiesListListOptions = (
  options?: Options<InternalCitiesListListData>
) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await internalCitiesListList({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true
      })

      return data
    },
    queryKey: internalCitiesListListQueryKey(options)
  })
}

export const internalCitiesListListInfiniteQueryKey = (
  options?: Options<InternalCitiesListListData>
): QueryKey<Options<InternalCitiesListListData>> =>
  createQueryKey('internalCitiesListList', options, true)

export const internalCitiesListListInfiniteOptions = (
  options?: Options<InternalCitiesListListData>
) => {
  return infiniteQueryOptions<
    InternalCitiesListListResponse,
    AxiosError<DefaultError>,
    InfiniteData<InternalCitiesListListResponse>,
    QueryKey<Options<InternalCitiesListListData>>,
    | number
    | Pick<
        QueryKey<Options<InternalCitiesListListData>>[0],
        'body' | 'headers' | 'path' | 'query'
      >
  >(
    // @ts-ignore
    {
      queryFn: async ({ pageParam, queryKey, signal }) => {
        // @ts-ignore
        const page: Pick<
          QueryKey<Options<InternalCitiesListListData>>[0],
          'body' | 'headers' | 'path' | 'query'
        > =
          typeof pageParam === 'object'
            ? pageParam
            : {
                query: {
                  page: pageParam
                }
              }
        const params = createInfiniteParams(queryKey, page)
        const { data } = await internalCitiesListList({
          ...options,
          ...params,
          signal,
          throwOnError: true
        })

        return data
      },
      queryKey: internalCitiesListListInfiniteQueryKey(options)
    }
  )
}

export const internalCompanySizesListQueryKey = (
  options?: Options<InternalCompanySizesListData>
) => createQueryKey('internalCompanySizesList', options)

export const internalCompanySizesListOptions = (
  options?: Options<InternalCompanySizesListData>
) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await internalCompanySizesList({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true
      })

      return data
    },
    queryKey: internalCompanySizesListQueryKey(options)
  })
}

export const internalCompanySizesListInfiniteQueryKey = (
  options?: Options<InternalCompanySizesListData>
): QueryKey<Options<InternalCompanySizesListData>> =>
  createQueryKey('internalCompanySizesList', options, true)

export const internalCompanySizesListInfiniteOptions = (
  options?: Options<InternalCompanySizesListData>
) => {
  return infiniteQueryOptions<
    InternalCompanySizesListResponse,
    AxiosError<DefaultError>,
    InfiniteData<InternalCompanySizesListResponse>,
    QueryKey<Options<InternalCompanySizesListData>>,
    | number
    | Pick<
        QueryKey<Options<InternalCompanySizesListData>>[0],
        'body' | 'headers' | 'path' | 'query'
      >
  >(
    // @ts-ignore
    {
      queryFn: async ({ pageParam, queryKey, signal }) => {
        // @ts-ignore
        const page: Pick<
          QueryKey<Options<InternalCompanySizesListData>>[0],
          'body' | 'headers' | 'path' | 'query'
        > =
          typeof pageParam === 'object'
            ? pageParam
            : {
                query: {
                  page: pageParam
                }
              }
        const params = createInfiniteParams(queryKey, page)
        const { data } = await internalCompanySizesList({
          ...options,
          ...params,
          signal,
          throwOnError: true
        })

        return data
      },
      queryKey: internalCompanySizesListInfiniteQueryKey(options)
    }
  )
}

export const internalCompanySizesCreateQueryKey = (
  options: Options<InternalCompanySizesCreateData>
) => createQueryKey('internalCompanySizesCreate', options)

export const internalCompanySizesCreateOptions = (
  options: Options<InternalCompanySizesCreateData>
) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await internalCompanySizesCreate({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true
      })

      return data
    },
    queryKey: internalCompanySizesCreateQueryKey(options)
  })
}

export const internalCompanySizesCreateMutation = (
  options?: Partial<Options<InternalCompanySizesCreateData>>
): UseMutationOptions<
  InternalCompanySizesCreateResponse,
  AxiosError<DefaultError>,
  Options<InternalCompanySizesCreateData>
> => {
  const mutationOptions: UseMutationOptions<
    InternalCompanySizesCreateResponse,
    AxiosError<DefaultError>,
    Options<InternalCompanySizesCreateData>
  > = {
    mutationFn: async (localOptions) => {
      const { data } = await internalCompanySizesCreate({
        ...options,
        ...localOptions,
        throwOnError: true
      })

      return data
    }
  }

  return mutationOptions
}

export const internalCompanySizesDestroyMutation = (
  options?: Partial<Options<InternalCompanySizesDestroyData>>
): UseMutationOptions<
  InternalCompanySizesDestroyResponse,
  AxiosError<DefaultError>,
  Options<InternalCompanySizesDestroyData>
> => {
  const mutationOptions: UseMutationOptions<
    InternalCompanySizesDestroyResponse,
    AxiosError<DefaultError>,
    Options<InternalCompanySizesDestroyData>
  > = {
    mutationFn: async (localOptions) => {
      const { data } = await internalCompanySizesDestroy({
        ...options,
        ...localOptions,
        throwOnError: true
      })

      return data
    }
  }

  return mutationOptions
}

export const internalCompanySizesRetrieveQueryKey = (
  options: Options<InternalCompanySizesRetrieveData>
) => createQueryKey('internalCompanySizesRetrieve', options)

export const internalCompanySizesRetrieveOptions = (
  options: Options<InternalCompanySizesRetrieveData>
) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await internalCompanySizesRetrieve({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true
      })

      return data
    },
    queryKey: internalCompanySizesRetrieveQueryKey(options)
  })
}

export const internalCompanySizesPartialUpdateMutation = (
  options?: Partial<Options<InternalCompanySizesPartialUpdateData>>
): UseMutationOptions<
  InternalCompanySizesPartialUpdateResponse,
  AxiosError<DefaultError>,
  Options<InternalCompanySizesPartialUpdateData>
> => {
  const mutationOptions: UseMutationOptions<
    InternalCompanySizesPartialUpdateResponse,
    AxiosError<DefaultError>,
    Options<InternalCompanySizesPartialUpdateData>
  > = {
    mutationFn: async (localOptions) => {
      const { data } = await internalCompanySizesPartialUpdate({
        ...options,
        ...localOptions,
        throwOnError: true
      })

      return data
    }
  }

  return mutationOptions
}

export const internalCompanySizesUpdateMutation = (
  options?: Partial<Options<InternalCompanySizesUpdateData>>
): UseMutationOptions<
  InternalCompanySizesUpdateResponse,
  AxiosError<DefaultError>,
  Options<InternalCompanySizesUpdateData>
> => {
  const mutationOptions: UseMutationOptions<
    InternalCompanySizesUpdateResponse,
    AxiosError<DefaultError>,
    Options<InternalCompanySizesUpdateData>
  > = {
    mutationFn: async (localOptions) => {
      const { data } = await internalCompanySizesUpdate({
        ...options,
        ...localOptions,
        throwOnError: true
      })

      return data
    }
  }

  return mutationOptions
}

export const internalCompanySizesListListQueryKey = (
  options?: Options<InternalCompanySizesListListData>
) => createQueryKey('internalCompanySizesListList', options)

export const internalCompanySizesListListOptions = (
  options?: Options<InternalCompanySizesListListData>
) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await internalCompanySizesListList({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true
      })

      return data
    },
    queryKey: internalCompanySizesListListQueryKey(options)
  })
}

export const internalCompanySizesListListInfiniteQueryKey = (
  options?: Options<InternalCompanySizesListListData>
): QueryKey<Options<InternalCompanySizesListListData>> =>
  createQueryKey('internalCompanySizesListList', options, true)

export const internalCompanySizesListListInfiniteOptions = (
  options?: Options<InternalCompanySizesListListData>
) => {
  return infiniteQueryOptions<
    InternalCompanySizesListListResponse,
    AxiosError<DefaultError>,
    InfiniteData<InternalCompanySizesListListResponse>,
    QueryKey<Options<InternalCompanySizesListListData>>,
    | number
    | Pick<
        QueryKey<Options<InternalCompanySizesListListData>>[0],
        'body' | 'headers' | 'path' | 'query'
      >
  >(
    // @ts-ignore
    {
      queryFn: async ({ pageParam, queryKey, signal }) => {
        // @ts-ignore
        const page: Pick<
          QueryKey<Options<InternalCompanySizesListListData>>[0],
          'body' | 'headers' | 'path' | 'query'
        > =
          typeof pageParam === 'object'
            ? pageParam
            : {
                query: {
                  page: pageParam
                }
              }
        const params = createInfiniteParams(queryKey, page)
        const { data } = await internalCompanySizesListList({
          ...options,
          ...params,
          signal,
          throwOnError: true
        })

        return data
      },
      queryKey: internalCompanySizesListListInfiniteQueryKey(options)
    }
  )
}

export const internalContactsListQueryKey = (
  options?: Options<InternalContactsListData>
) => createQueryKey('internalContactsList', options)

export const internalContactsListOptions = (
  options?: Options<InternalContactsListData>
) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await internalContactsList({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true
      })

      return data
    },
    queryKey: internalContactsListQueryKey(options)
  })
}

export const internalContactsListInfiniteQueryKey = (
  options?: Options<InternalContactsListData>
): QueryKey<Options<InternalContactsListData>> =>
  createQueryKey('internalContactsList', options, true)

export const internalContactsListInfiniteOptions = (
  options?: Options<InternalContactsListData>
) => {
  return infiniteQueryOptions<
    InternalContactsListResponse,
    AxiosError<DefaultError>,
    InfiniteData<InternalContactsListResponse>,
    QueryKey<Options<InternalContactsListData>>,
    | number
    | Pick<
        QueryKey<Options<InternalContactsListData>>[0],
        'body' | 'headers' | 'path' | 'query'
      >
  >(
    // @ts-ignore
    {
      queryFn: async ({ pageParam, queryKey, signal }) => {
        // @ts-ignore
        const page: Pick<
          QueryKey<Options<InternalContactsListData>>[0],
          'body' | 'headers' | 'path' | 'query'
        > =
          typeof pageParam === 'object'
            ? pageParam
            : {
                query: {
                  page: pageParam
                }
              }
        const params = createInfiniteParams(queryKey, page)
        const { data } = await internalContactsList({
          ...options,
          ...params,
          signal,
          throwOnError: true
        })

        return data
      },
      queryKey: internalContactsListInfiniteQueryKey(options)
    }
  )
}

export const internalContactsCreateQueryKey = (
  options?: Options<InternalContactsCreateData>
) => createQueryKey('internalContactsCreate', options)

export const internalContactsCreateOptions = (
  options?: Options<InternalContactsCreateData>
) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await internalContactsCreate({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true
      })

      return data
    },
    queryKey: internalContactsCreateQueryKey(options)
  })
}

export const internalContactsCreateMutation = (
  options?: Partial<Options<InternalContactsCreateData>>
): UseMutationOptions<
  InternalContactsCreateResponse,
  AxiosError<DefaultError>,
  Options<InternalContactsCreateData>
> => {
  const mutationOptions: UseMutationOptions<
    InternalContactsCreateResponse,
    AxiosError<DefaultError>,
    Options<InternalContactsCreateData>
  > = {
    mutationFn: async (localOptions) => {
      const { data } = await internalContactsCreate({
        ...options,
        ...localOptions,
        throwOnError: true
      })

      return data
    }
  }

  return mutationOptions
}

export const internalContactsDestroyMutation = (
  options?: Partial<Options<InternalContactsDestroyData>>
): UseMutationOptions<
  InternalContactsDestroyResponse,
  AxiosError<DefaultError>,
  Options<InternalContactsDestroyData>
> => {
  const mutationOptions: UseMutationOptions<
    InternalContactsDestroyResponse,
    AxiosError<DefaultError>,
    Options<InternalContactsDestroyData>
  > = {
    mutationFn: async (localOptions) => {
      const { data } = await internalContactsDestroy({
        ...options,
        ...localOptions,
        throwOnError: true
      })

      return data
    }
  }

  return mutationOptions
}

export const internalContactsRetrieveQueryKey = (
  options: Options<InternalContactsRetrieveData>
) => createQueryKey('internalContactsRetrieve', options)

export const internalContactsRetrieveOptions = (
  options: Options<InternalContactsRetrieveData>
) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await internalContactsRetrieve({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true
      })

      return data
    },
    queryKey: internalContactsRetrieveQueryKey(options)
  })
}

export const internalContactsPartialUpdateMutation = (
  options?: Partial<Options<InternalContactsPartialUpdateData>>
): UseMutationOptions<
  InternalContactsPartialUpdateResponse,
  AxiosError<DefaultError>,
  Options<InternalContactsPartialUpdateData>
> => {
  const mutationOptions: UseMutationOptions<
    InternalContactsPartialUpdateResponse,
    AxiosError<DefaultError>,
    Options<InternalContactsPartialUpdateData>
  > = {
    mutationFn: async (localOptions) => {
      const { data } = await internalContactsPartialUpdate({
        ...options,
        ...localOptions,
        throwOnError: true
      })

      return data
    }
  }

  return mutationOptions
}

export const internalContactsUpdateMutation = (
  options?: Partial<Options<InternalContactsUpdateData>>
): UseMutationOptions<
  InternalContactsUpdateResponse,
  AxiosError<DefaultError>,
  Options<InternalContactsUpdateData>
> => {
  const mutationOptions: UseMutationOptions<
    InternalContactsUpdateResponse,
    AxiosError<DefaultError>,
    Options<InternalContactsUpdateData>
  > = {
    mutationFn: async (localOptions) => {
      const { data } = await internalContactsUpdate({
        ...options,
        ...localOptions,
        throwOnError: true
      })

      return data
    }
  }

  return mutationOptions
}

export const internalContactsConnectionsRetrieveQueryKey = (
  options: Options<InternalContactsConnectionsRetrieveData>
) => createQueryKey('internalContactsConnectionsRetrieve', options)

/**
 * Get contact connection graph
 * Returns graph nodes representing all contact connections such as leads and opportunities.
 */
export const internalContactsConnectionsRetrieveOptions = (
  options: Options<InternalContactsConnectionsRetrieveData>
) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await internalContactsConnectionsRetrieve({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true
      })

      return data
    },
    queryKey: internalContactsConnectionsRetrieveQueryKey(options)
  })
}

export const internalContactsInitCallCreateQueryKey = (
  options: Options<InternalContactsInitCallCreateData>
) => createQueryKey('internalContactsInitCallCreate', options)

export const internalContactsInitCallCreateOptions = (
  options: Options<InternalContactsInitCallCreateData>
) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await internalContactsInitCallCreate({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true
      })

      return data
    },
    queryKey: internalContactsInitCallCreateQueryKey(options)
  })
}

export const internalContactsInitCallCreateMutation = (
  options?: Partial<Options<InternalContactsInitCallCreateData>>
): UseMutationOptions<
  InternalContactsInitCallCreateResponse,
  AxiosError<DefaultError>,
  Options<InternalContactsInitCallCreateData>
> => {
  const mutationOptions: UseMutationOptions<
    InternalContactsInitCallCreateResponse,
    AxiosError<DefaultError>,
    Options<InternalContactsInitCallCreateData>
  > = {
    mutationFn: async (localOptions) => {
      const { data } = await internalContactsInitCallCreate({
        ...options,
        ...localOptions,
        throwOnError: true
      })

      return data
    }
  }

  return mutationOptions
}

export const internalContactsPhoneNumbersListQueryKey = (
  options?: Options<InternalContactsPhoneNumbersListData>
) => createQueryKey('internalContactsPhoneNumbersList', options)

export const internalContactsPhoneNumbersListOptions = (
  options?: Options<InternalContactsPhoneNumbersListData>
) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await internalContactsPhoneNumbersList({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true
      })

      return data
    },
    queryKey: internalContactsPhoneNumbersListQueryKey(options)
  })
}

export const internalContactsPhoneNumbersListInfiniteQueryKey = (
  options?: Options<InternalContactsPhoneNumbersListData>
): QueryKey<Options<InternalContactsPhoneNumbersListData>> =>
  createQueryKey('internalContactsPhoneNumbersList', options, true)

export const internalContactsPhoneNumbersListInfiniteOptions = (
  options?: Options<InternalContactsPhoneNumbersListData>
) => {
  return infiniteQueryOptions<
    InternalContactsPhoneNumbersListResponse,
    AxiosError<DefaultError>,
    InfiniteData<InternalContactsPhoneNumbersListResponse>,
    QueryKey<Options<InternalContactsPhoneNumbersListData>>,
    | number
    | Pick<
        QueryKey<Options<InternalContactsPhoneNumbersListData>>[0],
        'body' | 'headers' | 'path' | 'query'
      >
  >(
    // @ts-ignore
    {
      queryFn: async ({ pageParam, queryKey, signal }) => {
        // @ts-ignore
        const page: Pick<
          QueryKey<Options<InternalContactsPhoneNumbersListData>>[0],
          'body' | 'headers' | 'path' | 'query'
        > =
          typeof pageParam === 'object'
            ? pageParam
            : {
                query: {
                  page: pageParam
                }
              }
        const params = createInfiniteParams(queryKey, page)
        const { data } = await internalContactsPhoneNumbersList({
          ...options,
          ...params,
          signal,
          throwOnError: true
        })

        return data
      },
      queryKey: internalContactsPhoneNumbersListInfiniteQueryKey(options)
    }
  )
}

export const internalContactsPhoneNumbersCreateQueryKey = (
  options: Options<InternalContactsPhoneNumbersCreateData>
) => createQueryKey('internalContactsPhoneNumbersCreate', options)

export const internalContactsPhoneNumbersCreateOptions = (
  options: Options<InternalContactsPhoneNumbersCreateData>
) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await internalContactsPhoneNumbersCreate({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true
      })

      return data
    },
    queryKey: internalContactsPhoneNumbersCreateQueryKey(options)
  })
}

export const internalContactsPhoneNumbersCreateMutation = (
  options?: Partial<Options<InternalContactsPhoneNumbersCreateData>>
): UseMutationOptions<
  InternalContactsPhoneNumbersCreateResponse,
  AxiosError<DefaultError>,
  Options<InternalContactsPhoneNumbersCreateData>
> => {
  const mutationOptions: UseMutationOptions<
    InternalContactsPhoneNumbersCreateResponse,
    AxiosError<DefaultError>,
    Options<InternalContactsPhoneNumbersCreateData>
  > = {
    mutationFn: async (localOptions) => {
      const { data } = await internalContactsPhoneNumbersCreate({
        ...options,
        ...localOptions,
        throwOnError: true
      })

      return data
    }
  }

  return mutationOptions
}

export const internalContactsPhoneNumbersDestroyMutation = (
  options?: Partial<Options<InternalContactsPhoneNumbersDestroyData>>
): UseMutationOptions<
  InternalContactsPhoneNumbersDestroyResponse,
  AxiosError<DefaultError>,
  Options<InternalContactsPhoneNumbersDestroyData>
> => {
  const mutationOptions: UseMutationOptions<
    InternalContactsPhoneNumbersDestroyResponse,
    AxiosError<DefaultError>,
    Options<InternalContactsPhoneNumbersDestroyData>
  > = {
    mutationFn: async (localOptions) => {
      const { data } = await internalContactsPhoneNumbersDestroy({
        ...options,
        ...localOptions,
        throwOnError: true
      })

      return data
    }
  }

  return mutationOptions
}

export const internalContactsPhoneNumbersRetrieveQueryKey = (
  options: Options<InternalContactsPhoneNumbersRetrieveData>
) => createQueryKey('internalContactsPhoneNumbersRetrieve', options)

export const internalContactsPhoneNumbersRetrieveOptions = (
  options: Options<InternalContactsPhoneNumbersRetrieveData>
) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await internalContactsPhoneNumbersRetrieve({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true
      })

      return data
    },
    queryKey: internalContactsPhoneNumbersRetrieveQueryKey(options)
  })
}

export const internalContactsPhoneNumbersPartialUpdateMutation = (
  options?: Partial<Options<InternalContactsPhoneNumbersPartialUpdateData>>
): UseMutationOptions<
  InternalContactsPhoneNumbersPartialUpdateResponse,
  AxiosError<DefaultError>,
  Options<InternalContactsPhoneNumbersPartialUpdateData>
> => {
  const mutationOptions: UseMutationOptions<
    InternalContactsPhoneNumbersPartialUpdateResponse,
    AxiosError<DefaultError>,
    Options<InternalContactsPhoneNumbersPartialUpdateData>
  > = {
    mutationFn: async (localOptions) => {
      const { data } = await internalContactsPhoneNumbersPartialUpdate({
        ...options,
        ...localOptions,
        throwOnError: true
      })

      return data
    }
  }

  return mutationOptions
}

export const internalContactsPhoneNumbersUpdateMutation = (
  options?: Partial<Options<InternalContactsPhoneNumbersUpdateData>>
): UseMutationOptions<
  InternalContactsPhoneNumbersUpdateResponse,
  AxiosError<DefaultError>,
  Options<InternalContactsPhoneNumbersUpdateData>
> => {
  const mutationOptions: UseMutationOptions<
    InternalContactsPhoneNumbersUpdateResponse,
    AxiosError<DefaultError>,
    Options<InternalContactsPhoneNumbersUpdateData>
  > = {
    mutationFn: async (localOptions) => {
      const { data } = await internalContactsPhoneNumbersUpdate({
        ...options,
        ...localOptions,
        throwOnError: true
      })

      return data
    }
  }

  return mutationOptions
}

export const internalCountriesListQueryKey = (
  options?: Options<InternalCountriesListData>
) => createQueryKey('internalCountriesList', options)

export const internalCountriesListOptions = (
  options?: Options<InternalCountriesListData>
) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await internalCountriesList({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true
      })

      return data
    },
    queryKey: internalCountriesListQueryKey(options)
  })
}

export const internalCountriesListInfiniteQueryKey = (
  options?: Options<InternalCountriesListData>
): QueryKey<Options<InternalCountriesListData>> =>
  createQueryKey('internalCountriesList', options, true)

export const internalCountriesListInfiniteOptions = (
  options?: Options<InternalCountriesListData>
) => {
  return infiniteQueryOptions<
    InternalCountriesListResponse,
    AxiosError<DefaultError>,
    InfiniteData<InternalCountriesListResponse>,
    QueryKey<Options<InternalCountriesListData>>,
    | number
    | Pick<
        QueryKey<Options<InternalCountriesListData>>[0],
        'body' | 'headers' | 'path' | 'query'
      >
  >(
    // @ts-ignore
    {
      queryFn: async ({ pageParam, queryKey, signal }) => {
        // @ts-ignore
        const page: Pick<
          QueryKey<Options<InternalCountriesListData>>[0],
          'body' | 'headers' | 'path' | 'query'
        > =
          typeof pageParam === 'object'
            ? pageParam
            : {
                query: {
                  page: pageParam
                }
              }
        const params = createInfiniteParams(queryKey, page)
        const { data } = await internalCountriesList({
          ...options,
          ...params,
          signal,
          throwOnError: true
        })

        return data
      },
      queryKey: internalCountriesListInfiniteQueryKey(options)
    }
  )
}

export const internalCountriesCreateQueryKey = (
  options: Options<InternalCountriesCreateData>
) => createQueryKey('internalCountriesCreate', options)

export const internalCountriesCreateOptions = (
  options: Options<InternalCountriesCreateData>
) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await internalCountriesCreate({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true
      })

      return data
    },
    queryKey: internalCountriesCreateQueryKey(options)
  })
}

export const internalCountriesCreateMutation = (
  options?: Partial<Options<InternalCountriesCreateData>>
): UseMutationOptions<
  InternalCountriesCreateResponse,
  AxiosError<DefaultError>,
  Options<InternalCountriesCreateData>
> => {
  const mutationOptions: UseMutationOptions<
    InternalCountriesCreateResponse,
    AxiosError<DefaultError>,
    Options<InternalCountriesCreateData>
  > = {
    mutationFn: async (localOptions) => {
      const { data } = await internalCountriesCreate({
        ...options,
        ...localOptions,
        throwOnError: true
      })

      return data
    }
  }

  return mutationOptions
}

export const internalCountriesDestroyMutation = (
  options?: Partial<Options<InternalCountriesDestroyData>>
): UseMutationOptions<
  InternalCountriesDestroyResponse,
  AxiosError<DefaultError>,
  Options<InternalCountriesDestroyData>
> => {
  const mutationOptions: UseMutationOptions<
    InternalCountriesDestroyResponse,
    AxiosError<DefaultError>,
    Options<InternalCountriesDestroyData>
  > = {
    mutationFn: async (localOptions) => {
      const { data } = await internalCountriesDestroy({
        ...options,
        ...localOptions,
        throwOnError: true
      })

      return data
    }
  }

  return mutationOptions
}

export const internalCountriesRetrieveQueryKey = (
  options: Options<InternalCountriesRetrieveData>
) => createQueryKey('internalCountriesRetrieve', options)

export const internalCountriesRetrieveOptions = (
  options: Options<InternalCountriesRetrieveData>
) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await internalCountriesRetrieve({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true
      })

      return data
    },
    queryKey: internalCountriesRetrieveQueryKey(options)
  })
}

export const internalCountriesPartialUpdateMutation = (
  options?: Partial<Options<InternalCountriesPartialUpdateData>>
): UseMutationOptions<
  InternalCountriesPartialUpdateResponse,
  AxiosError<DefaultError>,
  Options<InternalCountriesPartialUpdateData>
> => {
  const mutationOptions: UseMutationOptions<
    InternalCountriesPartialUpdateResponse,
    AxiosError<DefaultError>,
    Options<InternalCountriesPartialUpdateData>
  > = {
    mutationFn: async (localOptions) => {
      const { data } = await internalCountriesPartialUpdate({
        ...options,
        ...localOptions,
        throwOnError: true
      })

      return data
    }
  }

  return mutationOptions
}

export const internalCountriesUpdateMutation = (
  options?: Partial<Options<InternalCountriesUpdateData>>
): UseMutationOptions<
  InternalCountriesUpdateResponse,
  AxiosError<DefaultError>,
  Options<InternalCountriesUpdateData>
> => {
  const mutationOptions: UseMutationOptions<
    InternalCountriesUpdateResponse,
    AxiosError<DefaultError>,
    Options<InternalCountriesUpdateData>
  > = {
    mutationFn: async (localOptions) => {
      const { data } = await internalCountriesUpdate({
        ...options,
        ...localOptions,
        throwOnError: true
      })

      return data
    }
  }

  return mutationOptions
}

export const internalCountriesContinentsListQueryKey = (
  options?: Options<InternalCountriesContinentsListData>
) => createQueryKey('internalCountriesContinentsList', options)

export const internalCountriesContinentsListOptions = (
  options?: Options<InternalCountriesContinentsListData>
) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await internalCountriesContinentsList({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true
      })

      return data
    },
    queryKey: internalCountriesContinentsListQueryKey(options)
  })
}

export const internalCountriesContinentsListInfiniteQueryKey = (
  options?: Options<InternalCountriesContinentsListData>
): QueryKey<Options<InternalCountriesContinentsListData>> =>
  createQueryKey('internalCountriesContinentsList', options, true)

export const internalCountriesContinentsListInfiniteOptions = (
  options?: Options<InternalCountriesContinentsListData>
) => {
  return infiniteQueryOptions<
    InternalCountriesContinentsListResponse,
    AxiosError<DefaultError>,
    InfiniteData<InternalCountriesContinentsListResponse>,
    QueryKey<Options<InternalCountriesContinentsListData>>,
    | number
    | Pick<
        QueryKey<Options<InternalCountriesContinentsListData>>[0],
        'body' | 'headers' | 'path' | 'query'
      >
  >(
    // @ts-ignore
    {
      queryFn: async ({ pageParam, queryKey, signal }) => {
        // @ts-ignore
        const page: Pick<
          QueryKey<Options<InternalCountriesContinentsListData>>[0],
          'body' | 'headers' | 'path' | 'query'
        > =
          typeof pageParam === 'object'
            ? pageParam
            : {
                query: {
                  page: pageParam
                }
              }
        const params = createInfiniteParams(queryKey, page)
        const { data } = await internalCountriesContinentsList({
          ...options,
          ...params,
          signal,
          throwOnError: true
        })

        return data
      },
      queryKey: internalCountriesContinentsListInfiniteQueryKey(options)
    }
  )
}

export const internalCountriesListListQueryKey = (
  options?: Options<InternalCountriesListListData>
) => createQueryKey('internalCountriesListList', options)

export const internalCountriesListListOptions = (
  options?: Options<InternalCountriesListListData>
) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await internalCountriesListList({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true
      })

      return data
    },
    queryKey: internalCountriesListListQueryKey(options)
  })
}

export const internalCountriesListListInfiniteQueryKey = (
  options?: Options<InternalCountriesListListData>
): QueryKey<Options<InternalCountriesListListData>> =>
  createQueryKey('internalCountriesListList', options, true)

export const internalCountriesListListInfiniteOptions = (
  options?: Options<InternalCountriesListListData>
) => {
  return infiniteQueryOptions<
    InternalCountriesListListResponse,
    AxiosError<DefaultError>,
    InfiniteData<InternalCountriesListListResponse>,
    QueryKey<Options<InternalCountriesListListData>>,
    | number
    | Pick<
        QueryKey<Options<InternalCountriesListListData>>[0],
        'body' | 'headers' | 'path' | 'query'
      >
  >(
    // @ts-ignore
    {
      queryFn: async ({ pageParam, queryKey, signal }) => {
        // @ts-ignore
        const page: Pick<
          QueryKey<Options<InternalCountriesListListData>>[0],
          'body' | 'headers' | 'path' | 'query'
        > =
          typeof pageParam === 'object'
            ? pageParam
            : {
                query: {
                  page: pageParam
                }
              }
        const params = createInfiniteParams(queryKey, page)
        const { data } = await internalCountriesListList({
          ...options,
          ...params,
          signal,
          throwOnError: true
        })

        return data
      },
      queryKey: internalCountriesListListInfiniteQueryKey(options)
    }
  )
}

export const internalCurrenciesListQueryKey = (
  options?: Options<InternalCurrenciesListData>
) => createQueryKey('internalCurrenciesList', options)

export const internalCurrenciesListOptions = (
  options?: Options<InternalCurrenciesListData>
) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await internalCurrenciesList({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true
      })

      return data
    },
    queryKey: internalCurrenciesListQueryKey(options)
  })
}

export const internalCurrenciesListInfiniteQueryKey = (
  options?: Options<InternalCurrenciesListData>
): QueryKey<Options<InternalCurrenciesListData>> =>
  createQueryKey('internalCurrenciesList', options, true)

export const internalCurrenciesListInfiniteOptions = (
  options?: Options<InternalCurrenciesListData>
) => {
  return infiniteQueryOptions<
    InternalCurrenciesListResponse,
    AxiosError<DefaultError>,
    InfiniteData<InternalCurrenciesListResponse>,
    QueryKey<Options<InternalCurrenciesListData>>,
    | number
    | Pick<
        QueryKey<Options<InternalCurrenciesListData>>[0],
        'body' | 'headers' | 'path' | 'query'
      >
  >(
    // @ts-ignore
    {
      queryFn: async ({ pageParam, queryKey, signal }) => {
        // @ts-ignore
        const page: Pick<
          QueryKey<Options<InternalCurrenciesListData>>[0],
          'body' | 'headers' | 'path' | 'query'
        > =
          typeof pageParam === 'object'
            ? pageParam
            : {
                query: {
                  page: pageParam
                }
              }
        const params = createInfiniteParams(queryKey, page)
        const { data } = await internalCurrenciesList({
          ...options,
          ...params,
          signal,
          throwOnError: true
        })

        return data
      },
      queryKey: internalCurrenciesListInfiniteQueryKey(options)
    }
  )
}

export const internalCurrenciesCreateQueryKey = (
  options: Options<InternalCurrenciesCreateData>
) => createQueryKey('internalCurrenciesCreate', options)

export const internalCurrenciesCreateOptions = (
  options: Options<InternalCurrenciesCreateData>
) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await internalCurrenciesCreate({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true
      })

      return data
    },
    queryKey: internalCurrenciesCreateQueryKey(options)
  })
}

export const internalCurrenciesCreateMutation = (
  options?: Partial<Options<InternalCurrenciesCreateData>>
): UseMutationOptions<
  InternalCurrenciesCreateResponse,
  AxiosError<DefaultError>,
  Options<InternalCurrenciesCreateData>
> => {
  const mutationOptions: UseMutationOptions<
    InternalCurrenciesCreateResponse,
    AxiosError<DefaultError>,
    Options<InternalCurrenciesCreateData>
  > = {
    mutationFn: async (localOptions) => {
      const { data } = await internalCurrenciesCreate({
        ...options,
        ...localOptions,
        throwOnError: true
      })

      return data
    }
  }

  return mutationOptions
}

export const internalCurrenciesDestroyMutation = (
  options?: Partial<Options<InternalCurrenciesDestroyData>>
): UseMutationOptions<
  InternalCurrenciesDestroyResponse,
  AxiosError<DefaultError>,
  Options<InternalCurrenciesDestroyData>
> => {
  const mutationOptions: UseMutationOptions<
    InternalCurrenciesDestroyResponse,
    AxiosError<DefaultError>,
    Options<InternalCurrenciesDestroyData>
  > = {
    mutationFn: async (localOptions) => {
      const { data } = await internalCurrenciesDestroy({
        ...options,
        ...localOptions,
        throwOnError: true
      })

      return data
    }
  }

  return mutationOptions
}

export const internalCurrenciesRetrieveQueryKey = (
  options: Options<InternalCurrenciesRetrieveData>
) => createQueryKey('internalCurrenciesRetrieve', options)

export const internalCurrenciesRetrieveOptions = (
  options: Options<InternalCurrenciesRetrieveData>
) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await internalCurrenciesRetrieve({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true
      })

      return data
    },
    queryKey: internalCurrenciesRetrieveQueryKey(options)
  })
}

export const internalCurrenciesPartialUpdateMutation = (
  options?: Partial<Options<InternalCurrenciesPartialUpdateData>>
): UseMutationOptions<
  InternalCurrenciesPartialUpdateResponse,
  AxiosError<DefaultError>,
  Options<InternalCurrenciesPartialUpdateData>
> => {
  const mutationOptions: UseMutationOptions<
    InternalCurrenciesPartialUpdateResponse,
    AxiosError<DefaultError>,
    Options<InternalCurrenciesPartialUpdateData>
  > = {
    mutationFn: async (localOptions) => {
      const { data } = await internalCurrenciesPartialUpdate({
        ...options,
        ...localOptions,
        throwOnError: true
      })

      return data
    }
  }

  return mutationOptions
}

export const internalCurrenciesUpdateMutation = (
  options?: Partial<Options<InternalCurrenciesUpdateData>>
): UseMutationOptions<
  InternalCurrenciesUpdateResponse,
  AxiosError<DefaultError>,
  Options<InternalCurrenciesUpdateData>
> => {
  const mutationOptions: UseMutationOptions<
    InternalCurrenciesUpdateResponse,
    AxiosError<DefaultError>,
    Options<InternalCurrenciesUpdateData>
  > = {
    mutationFn: async (localOptions) => {
      const { data } = await internalCurrenciesUpdate({
        ...options,
        ...localOptions,
        throwOnError: true
      })

      return data
    }
  }

  return mutationOptions
}

export const internalCurrenciesListListQueryKey = (
  options?: Options<InternalCurrenciesListListData>
) => createQueryKey('internalCurrenciesListList', options)

export const internalCurrenciesListListOptions = (
  options?: Options<InternalCurrenciesListListData>
) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await internalCurrenciesListList({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true
      })

      return data
    },
    queryKey: internalCurrenciesListListQueryKey(options)
  })
}

export const internalCurrenciesListListInfiniteQueryKey = (
  options?: Options<InternalCurrenciesListListData>
): QueryKey<Options<InternalCurrenciesListListData>> =>
  createQueryKey('internalCurrenciesListList', options, true)

export const internalCurrenciesListListInfiniteOptions = (
  options?: Options<InternalCurrenciesListListData>
) => {
  return infiniteQueryOptions<
    InternalCurrenciesListListResponse,
    AxiosError<DefaultError>,
    InfiniteData<InternalCurrenciesListListResponse>,
    QueryKey<Options<InternalCurrenciesListListData>>,
    | number
    | Pick<
        QueryKey<Options<InternalCurrenciesListListData>>[0],
        'body' | 'headers' | 'path' | 'query'
      >
  >(
    // @ts-ignore
    {
      queryFn: async ({ pageParam, queryKey, signal }) => {
        // @ts-ignore
        const page: Pick<
          QueryKey<Options<InternalCurrenciesListListData>>[0],
          'body' | 'headers' | 'path' | 'query'
        > =
          typeof pageParam === 'object'
            ? pageParam
            : {
                query: {
                  page: pageParam
                }
              }
        const params = createInfiniteParams(queryKey, page)
        const { data } = await internalCurrenciesListList({
          ...options,
          ...params,
          signal,
          throwOnError: true
        })

        return data
      },
      queryKey: internalCurrenciesListListInfiniteQueryKey(options)
    }
  )
}

export const internalIndustriesListQueryKey = (
  options?: Options<InternalIndustriesListData>
) => createQueryKey('internalIndustriesList', options)

export const internalIndustriesListOptions = (
  options?: Options<InternalIndustriesListData>
) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await internalIndustriesList({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true
      })

      return data
    },
    queryKey: internalIndustriesListQueryKey(options)
  })
}

export const internalIndustriesListInfiniteQueryKey = (
  options?: Options<InternalIndustriesListData>
): QueryKey<Options<InternalIndustriesListData>> =>
  createQueryKey('internalIndustriesList', options, true)

export const internalIndustriesListInfiniteOptions = (
  options?: Options<InternalIndustriesListData>
) => {
  return infiniteQueryOptions<
    InternalIndustriesListResponse,
    AxiosError<DefaultError>,
    InfiniteData<InternalIndustriesListResponse>,
    QueryKey<Options<InternalIndustriesListData>>,
    | number
    | Pick<
        QueryKey<Options<InternalIndustriesListData>>[0],
        'body' | 'headers' | 'path' | 'query'
      >
  >(
    // @ts-ignore
    {
      queryFn: async ({ pageParam, queryKey, signal }) => {
        // @ts-ignore
        const page: Pick<
          QueryKey<Options<InternalIndustriesListData>>[0],
          'body' | 'headers' | 'path' | 'query'
        > =
          typeof pageParam === 'object'
            ? pageParam
            : {
                query: {
                  page: pageParam
                }
              }
        const params = createInfiniteParams(queryKey, page)
        const { data } = await internalIndustriesList({
          ...options,
          ...params,
          signal,
          throwOnError: true
        })

        return data
      },
      queryKey: internalIndustriesListInfiniteQueryKey(options)
    }
  )
}

export const internalIndustriesCreateQueryKey = (
  options: Options<InternalIndustriesCreateData>
) => createQueryKey('internalIndustriesCreate', options)

export const internalIndustriesCreateOptions = (
  options: Options<InternalIndustriesCreateData>
) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await internalIndustriesCreate({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true
      })

      return data
    },
    queryKey: internalIndustriesCreateQueryKey(options)
  })
}

export const internalIndustriesCreateMutation = (
  options?: Partial<Options<InternalIndustriesCreateData>>
): UseMutationOptions<
  InternalIndustriesCreateResponse,
  AxiosError<DefaultError>,
  Options<InternalIndustriesCreateData>
> => {
  const mutationOptions: UseMutationOptions<
    InternalIndustriesCreateResponse,
    AxiosError<DefaultError>,
    Options<InternalIndustriesCreateData>
  > = {
    mutationFn: async (localOptions) => {
      const { data } = await internalIndustriesCreate({
        ...options,
        ...localOptions,
        throwOnError: true
      })

      return data
    }
  }

  return mutationOptions
}

export const internalIndustriesSubIndustriesListQueryKey = (
  options: Options<InternalIndustriesSubIndustriesListData>
) => createQueryKey('internalIndustriesSubIndustriesList', options)

export const internalIndustriesSubIndustriesListOptions = (
  options: Options<InternalIndustriesSubIndustriesListData>
) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await internalIndustriesSubIndustriesList({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true
      })

      return data
    },
    queryKey: internalIndustriesSubIndustriesListQueryKey(options)
  })
}

export const internalIndustriesSubIndustriesListInfiniteQueryKey = (
  options: Options<InternalIndustriesSubIndustriesListData>
): QueryKey<Options<InternalIndustriesSubIndustriesListData>> =>
  createQueryKey('internalIndustriesSubIndustriesList', options, true)

export const internalIndustriesSubIndustriesListInfiniteOptions = (
  options: Options<InternalIndustriesSubIndustriesListData>
) => {
  return infiniteQueryOptions<
    InternalIndustriesSubIndustriesListResponse,
    AxiosError<DefaultError>,
    InfiniteData<InternalIndustriesSubIndustriesListResponse>,
    QueryKey<Options<InternalIndustriesSubIndustriesListData>>,
    | number
    | Pick<
        QueryKey<Options<InternalIndustriesSubIndustriesListData>>[0],
        'body' | 'headers' | 'path' | 'query'
      >
  >(
    // @ts-ignore
    {
      queryFn: async ({ pageParam, queryKey, signal }) => {
        // @ts-ignore
        const page: Pick<
          QueryKey<Options<InternalIndustriesSubIndustriesListData>>[0],
          'body' | 'headers' | 'path' | 'query'
        > =
          typeof pageParam === 'object'
            ? pageParam
            : {
                query: {
                  page: pageParam
                }
              }
        const params = createInfiniteParams(queryKey, page)
        const { data } = await internalIndustriesSubIndustriesList({
          ...options,
          ...params,
          signal,
          throwOnError: true
        })

        return data
      },
      queryKey: internalIndustriesSubIndustriesListInfiniteQueryKey(options)
    }
  )
}

export const internalIndustriesSubIndustriesCreateQueryKey = (
  options: Options<InternalIndustriesSubIndustriesCreateData>
) => createQueryKey('internalIndustriesSubIndustriesCreate', options)

export const internalIndustriesSubIndustriesCreateOptions = (
  options: Options<InternalIndustriesSubIndustriesCreateData>
) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await internalIndustriesSubIndustriesCreate({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true
      })

      return data
    },
    queryKey: internalIndustriesSubIndustriesCreateQueryKey(options)
  })
}

export const internalIndustriesSubIndustriesCreateMutation = (
  options?: Partial<Options<InternalIndustriesSubIndustriesCreateData>>
): UseMutationOptions<
  InternalIndustriesSubIndustriesCreateResponse,
  AxiosError<DefaultError>,
  Options<InternalIndustriesSubIndustriesCreateData>
> => {
  const mutationOptions: UseMutationOptions<
    InternalIndustriesSubIndustriesCreateResponse,
    AxiosError<DefaultError>,
    Options<InternalIndustriesSubIndustriesCreateData>
  > = {
    mutationFn: async (localOptions) => {
      const { data } = await internalIndustriesSubIndustriesCreate({
        ...options,
        ...localOptions,
        throwOnError: true
      })

      return data
    }
  }

  return mutationOptions
}

export const internalIndustriesSubIndustriesDestroyMutation = (
  options?: Partial<Options<InternalIndustriesSubIndustriesDestroyData>>
): UseMutationOptions<
  InternalIndustriesSubIndustriesDestroyResponse,
  AxiosError<DefaultError>,
  Options<InternalIndustriesSubIndustriesDestroyData>
> => {
  const mutationOptions: UseMutationOptions<
    InternalIndustriesSubIndustriesDestroyResponse,
    AxiosError<DefaultError>,
    Options<InternalIndustriesSubIndustriesDestroyData>
  > = {
    mutationFn: async (localOptions) => {
      const { data } = await internalIndustriesSubIndustriesDestroy({
        ...options,
        ...localOptions,
        throwOnError: true
      })

      return data
    }
  }

  return mutationOptions
}

export const internalIndustriesSubIndustriesRetrieveQueryKey = (
  options: Options<InternalIndustriesSubIndustriesRetrieveData>
) => createQueryKey('internalIndustriesSubIndustriesRetrieve', options)

export const internalIndustriesSubIndustriesRetrieveOptions = (
  options: Options<InternalIndustriesSubIndustriesRetrieveData>
) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await internalIndustriesSubIndustriesRetrieve({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true
      })

      return data
    },
    queryKey: internalIndustriesSubIndustriesRetrieveQueryKey(options)
  })
}

export const internalIndustriesSubIndustriesPartialUpdateMutation = (
  options?: Partial<Options<InternalIndustriesSubIndustriesPartialUpdateData>>
): UseMutationOptions<
  InternalIndustriesSubIndustriesPartialUpdateResponse,
  AxiosError<DefaultError>,
  Options<InternalIndustriesSubIndustriesPartialUpdateData>
> => {
  const mutationOptions: UseMutationOptions<
    InternalIndustriesSubIndustriesPartialUpdateResponse,
    AxiosError<DefaultError>,
    Options<InternalIndustriesSubIndustriesPartialUpdateData>
  > = {
    mutationFn: async (localOptions) => {
      const { data } = await internalIndustriesSubIndustriesPartialUpdate({
        ...options,
        ...localOptions,
        throwOnError: true
      })

      return data
    }
  }

  return mutationOptions
}

export const internalIndustriesSubIndustriesUpdateMutation = (
  options?: Partial<Options<InternalIndustriesSubIndustriesUpdateData>>
): UseMutationOptions<
  InternalIndustriesSubIndustriesUpdateResponse,
  AxiosError<DefaultError>,
  Options<InternalIndustriesSubIndustriesUpdateData>
> => {
  const mutationOptions: UseMutationOptions<
    InternalIndustriesSubIndustriesUpdateResponse,
    AxiosError<DefaultError>,
    Options<InternalIndustriesSubIndustriesUpdateData>
  > = {
    mutationFn: async (localOptions) => {
      const { data } = await internalIndustriesSubIndustriesUpdate({
        ...options,
        ...localOptions,
        throwOnError: true
      })

      return data
    }
  }

  return mutationOptions
}

export const internalIndustriesSubIndustriesListListQueryKey = (
  options: Options<InternalIndustriesSubIndustriesListListData>
) => createQueryKey('internalIndustriesSubIndustriesListList', options)

export const internalIndustriesSubIndustriesListListOptions = (
  options: Options<InternalIndustriesSubIndustriesListListData>
) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await internalIndustriesSubIndustriesListList({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true
      })

      return data
    },
    queryKey: internalIndustriesSubIndustriesListListQueryKey(options)
  })
}

export const internalIndustriesSubIndustriesListListInfiniteQueryKey = (
  options: Options<InternalIndustriesSubIndustriesListListData>
): QueryKey<Options<InternalIndustriesSubIndustriesListListData>> =>
  createQueryKey('internalIndustriesSubIndustriesListList', options, true)

export const internalIndustriesSubIndustriesListListInfiniteOptions = (
  options: Options<InternalIndustriesSubIndustriesListListData>
) => {
  return infiniteQueryOptions<
    InternalIndustriesSubIndustriesListListResponse,
    AxiosError<DefaultError>,
    InfiniteData<InternalIndustriesSubIndustriesListListResponse>,
    QueryKey<Options<InternalIndustriesSubIndustriesListListData>>,
    | number
    | Pick<
        QueryKey<Options<InternalIndustriesSubIndustriesListListData>>[0],
        'body' | 'headers' | 'path' | 'query'
      >
  >(
    // @ts-ignore
    {
      queryFn: async ({ pageParam, queryKey, signal }) => {
        // @ts-ignore
        const page: Pick<
          QueryKey<Options<InternalIndustriesSubIndustriesListListData>>[0],
          'body' | 'headers' | 'path' | 'query'
        > =
          typeof pageParam === 'object'
            ? pageParam
            : {
                query: {
                  page: pageParam
                }
              }
        const params = createInfiniteParams(queryKey, page)
        const { data } = await internalIndustriesSubIndustriesListList({
          ...options,
          ...params,
          signal,
          throwOnError: true
        })

        return data
      },
      queryKey: internalIndustriesSubIndustriesListListInfiniteQueryKey(options)
    }
  )
}

export const internalIndustriesDestroyMutation = (
  options?: Partial<Options<InternalIndustriesDestroyData>>
): UseMutationOptions<
  InternalIndustriesDestroyResponse,
  AxiosError<DefaultError>,
  Options<InternalIndustriesDestroyData>
> => {
  const mutationOptions: UseMutationOptions<
    InternalIndustriesDestroyResponse,
    AxiosError<DefaultError>,
    Options<InternalIndustriesDestroyData>
  > = {
    mutationFn: async (localOptions) => {
      const { data } = await internalIndustriesDestroy({
        ...options,
        ...localOptions,
        throwOnError: true
      })

      return data
    }
  }

  return mutationOptions
}

export const internalIndustriesRetrieveQueryKey = (
  options: Options<InternalIndustriesRetrieveData>
) => createQueryKey('internalIndustriesRetrieve', options)

export const internalIndustriesRetrieveOptions = (
  options: Options<InternalIndustriesRetrieveData>
) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await internalIndustriesRetrieve({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true
      })

      return data
    },
    queryKey: internalIndustriesRetrieveQueryKey(options)
  })
}

export const internalIndustriesPartialUpdateMutation = (
  options?: Partial<Options<InternalIndustriesPartialUpdateData>>
): UseMutationOptions<
  InternalIndustriesPartialUpdateResponse,
  AxiosError<DefaultError>,
  Options<InternalIndustriesPartialUpdateData>
> => {
  const mutationOptions: UseMutationOptions<
    InternalIndustriesPartialUpdateResponse,
    AxiosError<DefaultError>,
    Options<InternalIndustriesPartialUpdateData>
  > = {
    mutationFn: async (localOptions) => {
      const { data } = await internalIndustriesPartialUpdate({
        ...options,
        ...localOptions,
        throwOnError: true
      })

      return data
    }
  }

  return mutationOptions
}

export const internalIndustriesUpdateMutation = (
  options?: Partial<Options<InternalIndustriesUpdateData>>
): UseMutationOptions<
  InternalIndustriesUpdateResponse,
  AxiosError<DefaultError>,
  Options<InternalIndustriesUpdateData>
> => {
  const mutationOptions: UseMutationOptions<
    InternalIndustriesUpdateResponse,
    AxiosError<DefaultError>,
    Options<InternalIndustriesUpdateData>
  > = {
    mutationFn: async (localOptions) => {
      const { data } = await internalIndustriesUpdate({
        ...options,
        ...localOptions,
        throwOnError: true
      })

      return data
    }
  }

  return mutationOptions
}

export const internalIndustriesListListQueryKey = (
  options?: Options<InternalIndustriesListListData>
) => createQueryKey('internalIndustriesListList', options)

export const internalIndustriesListListOptions = (
  options?: Options<InternalIndustriesListListData>
) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await internalIndustriesListList({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true
      })

      return data
    },
    queryKey: internalIndustriesListListQueryKey(options)
  })
}

export const internalIndustriesListListInfiniteQueryKey = (
  options?: Options<InternalIndustriesListListData>
): QueryKey<Options<InternalIndustriesListListData>> =>
  createQueryKey('internalIndustriesListList', options, true)

export const internalIndustriesListListInfiniteOptions = (
  options?: Options<InternalIndustriesListListData>
) => {
  return infiniteQueryOptions<
    InternalIndustriesListListResponse,
    AxiosError<DefaultError>,
    InfiniteData<InternalIndustriesListListResponse>,
    QueryKey<Options<InternalIndustriesListListData>>,
    | number
    | Pick<
        QueryKey<Options<InternalIndustriesListListData>>[0],
        'body' | 'headers' | 'path' | 'query'
      >
  >(
    // @ts-ignore
    {
      queryFn: async ({ pageParam, queryKey, signal }) => {
        // @ts-ignore
        const page: Pick<
          QueryKey<Options<InternalIndustriesListListData>>[0],
          'body' | 'headers' | 'path' | 'query'
        > =
          typeof pageParam === 'object'
            ? pageParam
            : {
                query: {
                  page: pageParam
                }
              }
        const params = createInfiniteParams(queryKey, page)
        const { data } = await internalIndustriesListList({
          ...options,
          ...params,
          signal,
          throwOnError: true
        })

        return data
      },
      queryKey: internalIndustriesListListInfiniteQueryKey(options)
    }
  )
}

export const internalLeadsListQueryKey = (
  options?: Options<InternalLeadsListData>
) => createQueryKey('internalLeadsList', options)

export const internalLeadsListOptions = (
  options?: Options<InternalLeadsListData>
) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await internalLeadsList({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true
      })

      return data
    },
    queryKey: internalLeadsListQueryKey(options)
  })
}

export const internalLeadsListInfiniteQueryKey = (
  options?: Options<InternalLeadsListData>
): QueryKey<Options<InternalLeadsListData>> =>
  createQueryKey('internalLeadsList', options, true)

export const internalLeadsListInfiniteOptions = (
  options?: Options<InternalLeadsListData>
) => {
  return infiniteQueryOptions<
    InternalLeadsListResponse,
    AxiosError<DefaultError>,
    InfiniteData<InternalLeadsListResponse>,
    QueryKey<Options<InternalLeadsListData>>,
    | number
    | Pick<
        QueryKey<Options<InternalLeadsListData>>[0],
        'body' | 'headers' | 'path' | 'query'
      >
  >(
    // @ts-ignore
    {
      queryFn: async ({ pageParam, queryKey, signal }) => {
        // @ts-ignore
        const page: Pick<
          QueryKey<Options<InternalLeadsListData>>[0],
          'body' | 'headers' | 'path' | 'query'
        > =
          typeof pageParam === 'object'
            ? pageParam
            : {
                query: {
                  page: pageParam
                }
              }
        const params = createInfiniteParams(queryKey, page)
        const { data } = await internalLeadsList({
          ...options,
          ...params,
          signal,
          throwOnError: true
        })

        return data
      },
      queryKey: internalLeadsListInfiniteQueryKey(options)
    }
  )
}

export const internalLeadsCreateQueryKey = (
  options: Options<InternalLeadsCreateData>
) => createQueryKey('internalLeadsCreate', options)

export const internalLeadsCreateOptions = (
  options: Options<InternalLeadsCreateData>
) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await internalLeadsCreate({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true
      })

      return data
    },
    queryKey: internalLeadsCreateQueryKey(options)
  })
}

export const internalLeadsCreateMutation = (
  options?: Partial<Options<InternalLeadsCreateData>>
): UseMutationOptions<
  InternalLeadsCreateResponse,
  AxiosError<DefaultError>,
  Options<InternalLeadsCreateData>
> => {
  const mutationOptions: UseMutationOptions<
    InternalLeadsCreateResponse,
    AxiosError<DefaultError>,
    Options<InternalLeadsCreateData>
  > = {
    mutationFn: async (localOptions) => {
      const { data } = await internalLeadsCreate({
        ...options,
        ...localOptions,
        throwOnError: true
      })

      return data
    }
  }

  return mutationOptions
}

export const internalLeadsStatusesListQueryKey = (
  options?: Options<InternalLeadsStatusesListData>
) => createQueryKey('internalLeadsStatusesList', options)

export const internalLeadsStatusesListOptions = (
  options?: Options<InternalLeadsStatusesListData>
) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await internalLeadsStatusesList({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true
      })

      return data
    },
    queryKey: internalLeadsStatusesListQueryKey(options)
  })
}

export const internalLeadsStatusesListInfiniteQueryKey = (
  options?: Options<InternalLeadsStatusesListData>
): QueryKey<Options<InternalLeadsStatusesListData>> =>
  createQueryKey('internalLeadsStatusesList', options, true)

export const internalLeadsStatusesListInfiniteOptions = (
  options?: Options<InternalLeadsStatusesListData>
) => {
  return infiniteQueryOptions<
    InternalLeadsStatusesListResponse,
    AxiosError<DefaultError>,
    InfiniteData<InternalLeadsStatusesListResponse>,
    QueryKey<Options<InternalLeadsStatusesListData>>,
    | number
    | Pick<
        QueryKey<Options<InternalLeadsStatusesListData>>[0],
        'body' | 'headers' | 'path' | 'query'
      >
  >(
    // @ts-ignore
    {
      queryFn: async ({ pageParam, queryKey, signal }) => {
        // @ts-ignore
        const page: Pick<
          QueryKey<Options<InternalLeadsStatusesListData>>[0],
          'body' | 'headers' | 'path' | 'query'
        > =
          typeof pageParam === 'object'
            ? pageParam
            : {
                query: {
                  page: pageParam
                }
              }
        const params = createInfiniteParams(queryKey, page)
        const { data } = await internalLeadsStatusesList({
          ...options,
          ...params,
          signal,
          throwOnError: true
        })

        return data
      },
      queryKey: internalLeadsStatusesListInfiniteQueryKey(options)
    }
  )
}

export const internalLeadsStatusesCreateQueryKey = (
  options: Options<InternalLeadsStatusesCreateData>
) => createQueryKey('internalLeadsStatusesCreate', options)

export const internalLeadsStatusesCreateOptions = (
  options: Options<InternalLeadsStatusesCreateData>
) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await internalLeadsStatusesCreate({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true
      })

      return data
    },
    queryKey: internalLeadsStatusesCreateQueryKey(options)
  })
}

export const internalLeadsStatusesCreateMutation = (
  options?: Partial<Options<InternalLeadsStatusesCreateData>>
): UseMutationOptions<
  InternalLeadsStatusesCreateResponse,
  AxiosError<DefaultError>,
  Options<InternalLeadsStatusesCreateData>
> => {
  const mutationOptions: UseMutationOptions<
    InternalLeadsStatusesCreateResponse,
    AxiosError<DefaultError>,
    Options<InternalLeadsStatusesCreateData>
  > = {
    mutationFn: async (localOptions) => {
      const { data } = await internalLeadsStatusesCreate({
        ...options,
        ...localOptions,
        throwOnError: true
      })

      return data
    }
  }

  return mutationOptions
}

export const internalLeadsStatusesDestroyMutation = (
  options?: Partial<Options<InternalLeadsStatusesDestroyData>>
): UseMutationOptions<
  InternalLeadsStatusesDestroyResponse,
  AxiosError<DefaultError>,
  Options<InternalLeadsStatusesDestroyData>
> => {
  const mutationOptions: UseMutationOptions<
    InternalLeadsStatusesDestroyResponse,
    AxiosError<DefaultError>,
    Options<InternalLeadsStatusesDestroyData>
  > = {
    mutationFn: async (localOptions) => {
      const { data } = await internalLeadsStatusesDestroy({
        ...options,
        ...localOptions,
        throwOnError: true
      })

      return data
    }
  }

  return mutationOptions
}

export const internalLeadsStatusesRetrieveQueryKey = (
  options: Options<InternalLeadsStatusesRetrieveData>
) => createQueryKey('internalLeadsStatusesRetrieve', options)

export const internalLeadsStatusesRetrieveOptions = (
  options: Options<InternalLeadsStatusesRetrieveData>
) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await internalLeadsStatusesRetrieve({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true
      })

      return data
    },
    queryKey: internalLeadsStatusesRetrieveQueryKey(options)
  })
}

export const internalLeadsStatusesPartialUpdateMutation = (
  options?: Partial<Options<InternalLeadsStatusesPartialUpdateData>>
): UseMutationOptions<
  InternalLeadsStatusesPartialUpdateResponse,
  AxiosError<DefaultError>,
  Options<InternalLeadsStatusesPartialUpdateData>
> => {
  const mutationOptions: UseMutationOptions<
    InternalLeadsStatusesPartialUpdateResponse,
    AxiosError<DefaultError>,
    Options<InternalLeadsStatusesPartialUpdateData>
  > = {
    mutationFn: async (localOptions) => {
      const { data } = await internalLeadsStatusesPartialUpdate({
        ...options,
        ...localOptions,
        throwOnError: true
      })

      return data
    }
  }

  return mutationOptions
}

export const internalLeadsStatusesUpdateMutation = (
  options?: Partial<Options<InternalLeadsStatusesUpdateData>>
): UseMutationOptions<
  InternalLeadsStatusesUpdateResponse,
  AxiosError<DefaultError>,
  Options<InternalLeadsStatusesUpdateData>
> => {
  const mutationOptions: UseMutationOptions<
    InternalLeadsStatusesUpdateResponse,
    AxiosError<DefaultError>,
    Options<InternalLeadsStatusesUpdateData>
  > = {
    mutationFn: async (localOptions) => {
      const { data } = await internalLeadsStatusesUpdate({
        ...options,
        ...localOptions,
        throwOnError: true
      })

      return data
    }
  }

  return mutationOptions
}

export const internalLeadsStatusesListListQueryKey = (
  options?: Options<InternalLeadsStatusesListListData>
) => createQueryKey('internalLeadsStatusesListList', options)

export const internalLeadsStatusesListListOptions = (
  options?: Options<InternalLeadsStatusesListListData>
) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await internalLeadsStatusesListList({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true
      })

      return data
    },
    queryKey: internalLeadsStatusesListListQueryKey(options)
  })
}

export const internalLeadsStatusesListListInfiniteQueryKey = (
  options?: Options<InternalLeadsStatusesListListData>
): QueryKey<Options<InternalLeadsStatusesListListData>> =>
  createQueryKey('internalLeadsStatusesListList', options, true)

export const internalLeadsStatusesListListInfiniteOptions = (
  options?: Options<InternalLeadsStatusesListListData>
) => {
  return infiniteQueryOptions<
    InternalLeadsStatusesListListResponse,
    AxiosError<DefaultError>,
    InfiniteData<InternalLeadsStatusesListListResponse>,
    QueryKey<Options<InternalLeadsStatusesListListData>>,
    | number
    | Pick<
        QueryKey<Options<InternalLeadsStatusesListListData>>[0],
        'body' | 'headers' | 'path' | 'query'
      >
  >(
    // @ts-ignore
    {
      queryFn: async ({ pageParam, queryKey, signal }) => {
        // @ts-ignore
        const page: Pick<
          QueryKey<Options<InternalLeadsStatusesListListData>>[0],
          'body' | 'headers' | 'path' | 'query'
        > =
          typeof pageParam === 'object'
            ? pageParam
            : {
                query: {
                  page: pageParam
                }
              }
        const params = createInfiniteParams(queryKey, page)
        const { data } = await internalLeadsStatusesListList({
          ...options,
          ...params,
          signal,
          throwOnError: true
        })

        return data
      },
      queryKey: internalLeadsStatusesListListInfiniteQueryKey(options)
    }
  )
}

export const internalLeadsTypesListQueryKey = (
  options?: Options<InternalLeadsTypesListData>
) => createQueryKey('internalLeadsTypesList', options)

export const internalLeadsTypesListOptions = (
  options?: Options<InternalLeadsTypesListData>
) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await internalLeadsTypesList({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true
      })

      return data
    },
    queryKey: internalLeadsTypesListQueryKey(options)
  })
}

export const internalLeadsTypesListInfiniteQueryKey = (
  options?: Options<InternalLeadsTypesListData>
): QueryKey<Options<InternalLeadsTypesListData>> =>
  createQueryKey('internalLeadsTypesList', options, true)

export const internalLeadsTypesListInfiniteOptions = (
  options?: Options<InternalLeadsTypesListData>
) => {
  return infiniteQueryOptions<
    InternalLeadsTypesListResponse,
    AxiosError<DefaultError>,
    InfiniteData<InternalLeadsTypesListResponse>,
    QueryKey<Options<InternalLeadsTypesListData>>,
    | number
    | Pick<
        QueryKey<Options<InternalLeadsTypesListData>>[0],
        'body' | 'headers' | 'path' | 'query'
      >
  >(
    // @ts-ignore
    {
      queryFn: async ({ pageParam, queryKey, signal }) => {
        // @ts-ignore
        const page: Pick<
          QueryKey<Options<InternalLeadsTypesListData>>[0],
          'body' | 'headers' | 'path' | 'query'
        > =
          typeof pageParam === 'object'
            ? pageParam
            : {
                query: {
                  page: pageParam
                }
              }
        const params = createInfiniteParams(queryKey, page)
        const { data } = await internalLeadsTypesList({
          ...options,
          ...params,
          signal,
          throwOnError: true
        })

        return data
      },
      queryKey: internalLeadsTypesListInfiniteQueryKey(options)
    }
  )
}

export const internalLeadsTypesCreateQueryKey = (
  options: Options<InternalLeadsTypesCreateData>
) => createQueryKey('internalLeadsTypesCreate', options)

export const internalLeadsTypesCreateOptions = (
  options: Options<InternalLeadsTypesCreateData>
) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await internalLeadsTypesCreate({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true
      })

      return data
    },
    queryKey: internalLeadsTypesCreateQueryKey(options)
  })
}

export const internalLeadsTypesCreateMutation = (
  options?: Partial<Options<InternalLeadsTypesCreateData>>
): UseMutationOptions<
  InternalLeadsTypesCreateResponse,
  AxiosError<DefaultError>,
  Options<InternalLeadsTypesCreateData>
> => {
  const mutationOptions: UseMutationOptions<
    InternalLeadsTypesCreateResponse,
    AxiosError<DefaultError>,
    Options<InternalLeadsTypesCreateData>
  > = {
    mutationFn: async (localOptions) => {
      const { data } = await internalLeadsTypesCreate({
        ...options,
        ...localOptions,
        throwOnError: true
      })

      return data
    }
  }

  return mutationOptions
}

export const internalLeadsTypesDestroyMutation = (
  options?: Partial<Options<InternalLeadsTypesDestroyData>>
): UseMutationOptions<
  InternalLeadsTypesDestroyResponse,
  AxiosError<DefaultError>,
  Options<InternalLeadsTypesDestroyData>
> => {
  const mutationOptions: UseMutationOptions<
    InternalLeadsTypesDestroyResponse,
    AxiosError<DefaultError>,
    Options<InternalLeadsTypesDestroyData>
  > = {
    mutationFn: async (localOptions) => {
      const { data } = await internalLeadsTypesDestroy({
        ...options,
        ...localOptions,
        throwOnError: true
      })

      return data
    }
  }

  return mutationOptions
}

export const internalLeadsTypesRetrieveQueryKey = (
  options: Options<InternalLeadsTypesRetrieveData>
) => createQueryKey('internalLeadsTypesRetrieve', options)

export const internalLeadsTypesRetrieveOptions = (
  options: Options<InternalLeadsTypesRetrieveData>
) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await internalLeadsTypesRetrieve({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true
      })

      return data
    },
    queryKey: internalLeadsTypesRetrieveQueryKey(options)
  })
}

export const internalLeadsTypesPartialUpdateMutation = (
  options?: Partial<Options<InternalLeadsTypesPartialUpdateData>>
): UseMutationOptions<
  InternalLeadsTypesPartialUpdateResponse,
  AxiosError<DefaultError>,
  Options<InternalLeadsTypesPartialUpdateData>
> => {
  const mutationOptions: UseMutationOptions<
    InternalLeadsTypesPartialUpdateResponse,
    AxiosError<DefaultError>,
    Options<InternalLeadsTypesPartialUpdateData>
  > = {
    mutationFn: async (localOptions) => {
      const { data } = await internalLeadsTypesPartialUpdate({
        ...options,
        ...localOptions,
        throwOnError: true
      })

      return data
    }
  }

  return mutationOptions
}

export const internalLeadsTypesUpdateMutation = (
  options?: Partial<Options<InternalLeadsTypesUpdateData>>
): UseMutationOptions<
  InternalLeadsTypesUpdateResponse,
  AxiosError<DefaultError>,
  Options<InternalLeadsTypesUpdateData>
> => {
  const mutationOptions: UseMutationOptions<
    InternalLeadsTypesUpdateResponse,
    AxiosError<DefaultError>,
    Options<InternalLeadsTypesUpdateData>
  > = {
    mutationFn: async (localOptions) => {
      const { data } = await internalLeadsTypesUpdate({
        ...options,
        ...localOptions,
        throwOnError: true
      })

      return data
    }
  }

  return mutationOptions
}

export const internalLeadsTypesListListQueryKey = (
  options?: Options<InternalLeadsTypesListListData>
) => createQueryKey('internalLeadsTypesListList', options)

export const internalLeadsTypesListListOptions = (
  options?: Options<InternalLeadsTypesListListData>
) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await internalLeadsTypesListList({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true
      })

      return data
    },
    queryKey: internalLeadsTypesListListQueryKey(options)
  })
}

export const internalLeadsTypesListListInfiniteQueryKey = (
  options?: Options<InternalLeadsTypesListListData>
): QueryKey<Options<InternalLeadsTypesListListData>> =>
  createQueryKey('internalLeadsTypesListList', options, true)

export const internalLeadsTypesListListInfiniteOptions = (
  options?: Options<InternalLeadsTypesListListData>
) => {
  return infiniteQueryOptions<
    InternalLeadsTypesListListResponse,
    AxiosError<DefaultError>,
    InfiniteData<InternalLeadsTypesListListResponse>,
    QueryKey<Options<InternalLeadsTypesListListData>>,
    | number
    | Pick<
        QueryKey<Options<InternalLeadsTypesListListData>>[0],
        'body' | 'headers' | 'path' | 'query'
      >
  >(
    // @ts-ignore
    {
      queryFn: async ({ pageParam, queryKey, signal }) => {
        // @ts-ignore
        const page: Pick<
          QueryKey<Options<InternalLeadsTypesListListData>>[0],
          'body' | 'headers' | 'path' | 'query'
        > =
          typeof pageParam === 'object'
            ? pageParam
            : {
                query: {
                  page: pageParam
                }
              }
        const params = createInfiniteParams(queryKey, page)
        const { data } = await internalLeadsTypesListList({
          ...options,
          ...params,
          signal,
          throwOnError: true
        })

        return data
      },
      queryKey: internalLeadsTypesListListInfiniteQueryKey(options)
    }
  )
}

export const internalLeadsDestroyMutation = (
  options?: Partial<Options<InternalLeadsDestroyData>>
): UseMutationOptions<
  InternalLeadsDestroyResponse,
  AxiosError<DefaultError>,
  Options<InternalLeadsDestroyData>
> => {
  const mutationOptions: UseMutationOptions<
    InternalLeadsDestroyResponse,
    AxiosError<DefaultError>,
    Options<InternalLeadsDestroyData>
  > = {
    mutationFn: async (localOptions) => {
      const { data } = await internalLeadsDestroy({
        ...options,
        ...localOptions,
        throwOnError: true
      })

      return data
    }
  }

  return mutationOptions
}

export const internalLeadsRetrieveQueryKey = (
  options: Options<InternalLeadsRetrieveData>
) => createQueryKey('internalLeadsRetrieve', options)

export const internalLeadsRetrieveOptions = (
  options: Options<InternalLeadsRetrieveData>
) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await internalLeadsRetrieve({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true
      })

      return data
    },
    queryKey: internalLeadsRetrieveQueryKey(options)
  })
}

export const internalLeadsPartialUpdateMutation = (
  options?: Partial<Options<InternalLeadsPartialUpdateData>>
): UseMutationOptions<
  InternalLeadsPartialUpdateResponse,
  AxiosError<DefaultError>,
  Options<InternalLeadsPartialUpdateData>
> => {
  const mutationOptions: UseMutationOptions<
    InternalLeadsPartialUpdateResponse,
    AxiosError<DefaultError>,
    Options<InternalLeadsPartialUpdateData>
  > = {
    mutationFn: async (localOptions) => {
      const { data } = await internalLeadsPartialUpdate({
        ...options,
        ...localOptions,
        throwOnError: true
      })

      return data
    }
  }

  return mutationOptions
}

export const internalLeadsUpdateMutation = (
  options?: Partial<Options<InternalLeadsUpdateData>>
): UseMutationOptions<
  InternalLeadsUpdateResponse,
  AxiosError<DefaultError>,
  Options<InternalLeadsUpdateData>
> => {
  const mutationOptions: UseMutationOptions<
    InternalLeadsUpdateResponse,
    AxiosError<DefaultError>,
    Options<InternalLeadsUpdateData>
  > = {
    mutationFn: async (localOptions) => {
      const { data } = await internalLeadsUpdate({
        ...options,
        ...localOptions,
        throwOnError: true
      })

      return data
    }
  }

  return mutationOptions
}

export const internalLeadsListListQueryKey = (
  options?: Options<InternalLeadsListListData>
) => createQueryKey('internalLeadsListList', options)

export const internalLeadsListListOptions = (
  options?: Options<InternalLeadsListListData>
) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await internalLeadsListList({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true
      })

      return data
    },
    queryKey: internalLeadsListListQueryKey(options)
  })
}

export const internalLeadsListListInfiniteQueryKey = (
  options?: Options<InternalLeadsListListData>
): QueryKey<Options<InternalLeadsListListData>> =>
  createQueryKey('internalLeadsListList', options, true)

export const internalLeadsListListInfiniteOptions = (
  options?: Options<InternalLeadsListListData>
) => {
  return infiniteQueryOptions<
    InternalLeadsListListResponse,
    AxiosError<DefaultError>,
    InfiniteData<InternalLeadsListListResponse>,
    QueryKey<Options<InternalLeadsListListData>>,
    | number
    | Pick<
        QueryKey<Options<InternalLeadsListListData>>[0],
        'body' | 'headers' | 'path' | 'query'
      >
  >(
    // @ts-ignore
    {
      queryFn: async ({ pageParam, queryKey, signal }) => {
        // @ts-ignore
        const page: Pick<
          QueryKey<Options<InternalLeadsListListData>>[0],
          'body' | 'headers' | 'path' | 'query'
        > =
          typeof pageParam === 'object'
            ? pageParam
            : {
                query: {
                  page: pageParam
                }
              }
        const params = createInfiniteParams(queryKey, page)
        const { data } = await internalLeadsListList({
          ...options,
          ...params,
          signal,
          throwOnError: true
        })

        return data
      },
      queryKey: internalLeadsListListInfiniteQueryKey(options)
    }
  )
}

export const internalLogsListQueryKey = (
  options?: Options<InternalLogsListData>
) => createQueryKey('internalLogsList', options)

export const internalLogsListOptions = (
  options?: Options<InternalLogsListData>
) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await internalLogsList({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true
      })

      return data
    },
    queryKey: internalLogsListQueryKey(options)
  })
}

export const internalLogsListInfiniteQueryKey = (
  options?: Options<InternalLogsListData>
): QueryKey<Options<InternalLogsListData>> =>
  createQueryKey('internalLogsList', options, true)

export const internalLogsListInfiniteOptions = (
  options?: Options<InternalLogsListData>
) => {
  return infiniteQueryOptions<
    InternalLogsListResponse,
    AxiosError<DefaultError>,
    InfiniteData<InternalLogsListResponse>,
    QueryKey<Options<InternalLogsListData>>,
    | number
    | Pick<
        QueryKey<Options<InternalLogsListData>>[0],
        'body' | 'headers' | 'path' | 'query'
      >
  >(
    // @ts-ignore
    {
      queryFn: async ({ pageParam, queryKey, signal }) => {
        // @ts-ignore
        const page: Pick<
          QueryKey<Options<InternalLogsListData>>[0],
          'body' | 'headers' | 'path' | 'query'
        > =
          typeof pageParam === 'object'
            ? pageParam
            : {
                query: {
                  page: pageParam
                }
              }
        const params = createInfiniteParams(queryKey, page)
        const { data } = await internalLogsList({
          ...options,
          ...params,
          signal,
          throwOnError: true
        })

        return data
      },
      queryKey: internalLogsListInfiniteQueryKey(options)
    }
  )
}

export const internalLogsCreateQueryKey = (
  options: Options<InternalLogsCreateData>
) => createQueryKey('internalLogsCreate', options)

export const internalLogsCreateOptions = (
  options: Options<InternalLogsCreateData>
) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await internalLogsCreate({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true
      })

      return data
    },
    queryKey: internalLogsCreateQueryKey(options)
  })
}

export const internalLogsCreateMutation = (
  options?: Partial<Options<InternalLogsCreateData>>
): UseMutationOptions<
  InternalLogsCreateResponse,
  AxiosError<DefaultError>,
  Options<InternalLogsCreateData>
> => {
  const mutationOptions: UseMutationOptions<
    InternalLogsCreateResponse,
    AxiosError<DefaultError>,
    Options<InternalLogsCreateData>
  > = {
    mutationFn: async (localOptions) => {
      const { data } = await internalLogsCreate({
        ...options,
        ...localOptions,
        throwOnError: true
      })

      return data
    }
  }

  return mutationOptions
}

export const internalLogsRetrieveQueryKey = (
  options: Options<InternalLogsRetrieveData>
) => createQueryKey('internalLogsRetrieve', options)

export const internalLogsRetrieveOptions = (
  options: Options<InternalLogsRetrieveData>
) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await internalLogsRetrieve({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true
      })

      return data
    },
    queryKey: internalLogsRetrieveQueryKey(options)
  })
}

export const internalOpportunitiesCreateQueryKey = (
  options: Options<InternalOpportunitiesCreateData>
) => createQueryKey('internalOpportunitiesCreate', options)

export const internalOpportunitiesCreateOptions = (
  options: Options<InternalOpportunitiesCreateData>
) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await internalOpportunitiesCreate({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true
      })

      return data
    },
    queryKey: internalOpportunitiesCreateQueryKey(options)
  })
}

export const internalOpportunitiesCreateMutation = (
  options?: Partial<Options<InternalOpportunitiesCreateData>>
): UseMutationOptions<
  InternalOpportunitiesCreateResponse,
  AxiosError<DefaultError>,
  Options<InternalOpportunitiesCreateData>
> => {
  const mutationOptions: UseMutationOptions<
    InternalOpportunitiesCreateResponse,
    AxiosError<DefaultError>,
    Options<InternalOpportunitiesCreateData>
  > = {
    mutationFn: async (localOptions) => {
      const { data } = await internalOpportunitiesCreate({
        ...options,
        ...localOptions,
        throwOnError: true
      })

      return data
    }
  }

  return mutationOptions
}

export const internalOpportunitiesStatusesListQueryKey = (
  options?: Options<InternalOpportunitiesStatusesListData>
) => createQueryKey('internalOpportunitiesStatusesList', options)

export const internalOpportunitiesStatusesListOptions = (
  options?: Options<InternalOpportunitiesStatusesListData>
) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await internalOpportunitiesStatusesList({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true
      })

      return data
    },
    queryKey: internalOpportunitiesStatusesListQueryKey(options)
  })
}

export const internalOpportunitiesStatusesListInfiniteQueryKey = (
  options?: Options<InternalOpportunitiesStatusesListData>
): QueryKey<Options<InternalOpportunitiesStatusesListData>> =>
  createQueryKey('internalOpportunitiesStatusesList', options, true)

export const internalOpportunitiesStatusesListInfiniteOptions = (
  options?: Options<InternalOpportunitiesStatusesListData>
) => {
  return infiniteQueryOptions<
    InternalOpportunitiesStatusesListResponse,
    AxiosError<DefaultError>,
    InfiniteData<InternalOpportunitiesStatusesListResponse>,
    QueryKey<Options<InternalOpportunitiesStatusesListData>>,
    | number
    | Pick<
        QueryKey<Options<InternalOpportunitiesStatusesListData>>[0],
        'body' | 'headers' | 'path' | 'query'
      >
  >(
    // @ts-ignore
    {
      queryFn: async ({ pageParam, queryKey, signal }) => {
        // @ts-ignore
        const page: Pick<
          QueryKey<Options<InternalOpportunitiesStatusesListData>>[0],
          'body' | 'headers' | 'path' | 'query'
        > =
          typeof pageParam === 'object'
            ? pageParam
            : {
                query: {
                  page: pageParam
                }
              }
        const params = createInfiniteParams(queryKey, page)
        const { data } = await internalOpportunitiesStatusesList({
          ...options,
          ...params,
          signal,
          throwOnError: true
        })

        return data
      },
      queryKey: internalOpportunitiesStatusesListInfiniteQueryKey(options)
    }
  )
}

export const internalOpportunitiesStatusesCreateQueryKey = (
  options: Options<InternalOpportunitiesStatusesCreateData>
) => createQueryKey('internalOpportunitiesStatusesCreate', options)

export const internalOpportunitiesStatusesCreateOptions = (
  options: Options<InternalOpportunitiesStatusesCreateData>
) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await internalOpportunitiesStatusesCreate({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true
      })

      return data
    },
    queryKey: internalOpportunitiesStatusesCreateQueryKey(options)
  })
}

export const internalOpportunitiesStatusesCreateMutation = (
  options?: Partial<Options<InternalOpportunitiesStatusesCreateData>>
): UseMutationOptions<
  InternalOpportunitiesStatusesCreateResponse,
  AxiosError<DefaultError>,
  Options<InternalOpportunitiesStatusesCreateData>
> => {
  const mutationOptions: UseMutationOptions<
    InternalOpportunitiesStatusesCreateResponse,
    AxiosError<DefaultError>,
    Options<InternalOpportunitiesStatusesCreateData>
  > = {
    mutationFn: async (localOptions) => {
      const { data } = await internalOpportunitiesStatusesCreate({
        ...options,
        ...localOptions,
        throwOnError: true
      })

      return data
    }
  }

  return mutationOptions
}

export const internalOpportunitiesStatusesDestroyMutation = (
  options?: Partial<Options<InternalOpportunitiesStatusesDestroyData>>
): UseMutationOptions<
  InternalOpportunitiesStatusesDestroyResponse,
  AxiosError<DefaultError>,
  Options<InternalOpportunitiesStatusesDestroyData>
> => {
  const mutationOptions: UseMutationOptions<
    InternalOpportunitiesStatusesDestroyResponse,
    AxiosError<DefaultError>,
    Options<InternalOpportunitiesStatusesDestroyData>
  > = {
    mutationFn: async (localOptions) => {
      const { data } = await internalOpportunitiesStatusesDestroy({
        ...options,
        ...localOptions,
        throwOnError: true
      })

      return data
    }
  }

  return mutationOptions
}

export const internalOpportunitiesStatusesRetrieveQueryKey = (
  options: Options<InternalOpportunitiesStatusesRetrieveData>
) => createQueryKey('internalOpportunitiesStatusesRetrieve', options)

export const internalOpportunitiesStatusesRetrieveOptions = (
  options: Options<InternalOpportunitiesStatusesRetrieveData>
) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await internalOpportunitiesStatusesRetrieve({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true
      })

      return data
    },
    queryKey: internalOpportunitiesStatusesRetrieveQueryKey(options)
  })
}

export const internalOpportunitiesStatusesPartialUpdateMutation = (
  options?: Partial<Options<InternalOpportunitiesStatusesPartialUpdateData>>
): UseMutationOptions<
  InternalOpportunitiesStatusesPartialUpdateResponse,
  AxiosError<DefaultError>,
  Options<InternalOpportunitiesStatusesPartialUpdateData>
> => {
  const mutationOptions: UseMutationOptions<
    InternalOpportunitiesStatusesPartialUpdateResponse,
    AxiosError<DefaultError>,
    Options<InternalOpportunitiesStatusesPartialUpdateData>
  > = {
    mutationFn: async (localOptions) => {
      const { data } = await internalOpportunitiesStatusesPartialUpdate({
        ...options,
        ...localOptions,
        throwOnError: true
      })

      return data
    }
  }

  return mutationOptions
}

export const internalOpportunitiesStatusesUpdateMutation = (
  options?: Partial<Options<InternalOpportunitiesStatusesUpdateData>>
): UseMutationOptions<
  InternalOpportunitiesStatusesUpdateResponse,
  AxiosError<DefaultError>,
  Options<InternalOpportunitiesStatusesUpdateData>
> => {
  const mutationOptions: UseMutationOptions<
    InternalOpportunitiesStatusesUpdateResponse,
    AxiosError<DefaultError>,
    Options<InternalOpportunitiesStatusesUpdateData>
  > = {
    mutationFn: async (localOptions) => {
      const { data } = await internalOpportunitiesStatusesUpdate({
        ...options,
        ...localOptions,
        throwOnError: true
      })

      return data
    }
  }

  return mutationOptions
}

export const internalOpportunitiesStatusesListListQueryKey = (
  options?: Options<InternalOpportunitiesStatusesListListData>
) => createQueryKey('internalOpportunitiesStatusesListList', options)

export const internalOpportunitiesStatusesListListOptions = (
  options?: Options<InternalOpportunitiesStatusesListListData>
) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await internalOpportunitiesStatusesListList({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true
      })

      return data
    },
    queryKey: internalOpportunitiesStatusesListListQueryKey(options)
  })
}

export const internalOpportunitiesStatusesListListInfiniteQueryKey = (
  options?: Options<InternalOpportunitiesStatusesListListData>
): QueryKey<Options<InternalOpportunitiesStatusesListListData>> =>
  createQueryKey('internalOpportunitiesStatusesListList', options, true)

export const internalOpportunitiesStatusesListListInfiniteOptions = (
  options?: Options<InternalOpportunitiesStatusesListListData>
) => {
  return infiniteQueryOptions<
    InternalOpportunitiesStatusesListListResponse,
    AxiosError<DefaultError>,
    InfiniteData<InternalOpportunitiesStatusesListListResponse>,
    QueryKey<Options<InternalOpportunitiesStatusesListListData>>,
    | number
    | Pick<
        QueryKey<Options<InternalOpportunitiesStatusesListListData>>[0],
        'body' | 'headers' | 'path' | 'query'
      >
  >(
    // @ts-ignore
    {
      queryFn: async ({ pageParam, queryKey, signal }) => {
        // @ts-ignore
        const page: Pick<
          QueryKey<Options<InternalOpportunitiesStatusesListListData>>[0],
          'body' | 'headers' | 'path' | 'query'
        > =
          typeof pageParam === 'object'
            ? pageParam
            : {
                query: {
                  page: pageParam
                }
              }
        const params = createInfiniteParams(queryKey, page)
        const { data } = await internalOpportunitiesStatusesListList({
          ...options,
          ...params,
          signal,
          throwOnError: true
        })

        return data
      },
      queryKey: internalOpportunitiesStatusesListListInfiniteQueryKey(options)
    }
  )
}

export const internalOpportunitiesDestroyMutation = (
  options?: Partial<Options<InternalOpportunitiesDestroyData>>
): UseMutationOptions<
  InternalOpportunitiesDestroyResponse,
  AxiosError<DefaultError>,
  Options<InternalOpportunitiesDestroyData>
> => {
  const mutationOptions: UseMutationOptions<
    InternalOpportunitiesDestroyResponse,
    AxiosError<DefaultError>,
    Options<InternalOpportunitiesDestroyData>
  > = {
    mutationFn: async (localOptions) => {
      const { data } = await internalOpportunitiesDestroy({
        ...options,
        ...localOptions,
        throwOnError: true
      })

      return data
    }
  }

  return mutationOptions
}

export const internalOpportunitiesRetrieveQueryKey = (
  options: Options<InternalOpportunitiesRetrieveData>
) => createQueryKey('internalOpportunitiesRetrieve', options)

export const internalOpportunitiesRetrieveOptions = (
  options: Options<InternalOpportunitiesRetrieveData>
) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await internalOpportunitiesRetrieve({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true
      })

      return data
    },
    queryKey: internalOpportunitiesRetrieveQueryKey(options)
  })
}

export const internalOpportunitiesPartialUpdateMutation = (
  options?: Partial<Options<InternalOpportunitiesPartialUpdateData>>
): UseMutationOptions<
  InternalOpportunitiesPartialUpdateResponse,
  AxiosError<DefaultError>,
  Options<InternalOpportunitiesPartialUpdateData>
> => {
  const mutationOptions: UseMutationOptions<
    InternalOpportunitiesPartialUpdateResponse,
    AxiosError<DefaultError>,
    Options<InternalOpportunitiesPartialUpdateData>
  > = {
    mutationFn: async (localOptions) => {
      const { data } = await internalOpportunitiesPartialUpdate({
        ...options,
        ...localOptions,
        throwOnError: true
      })

      return data
    }
  }

  return mutationOptions
}

export const internalOpportunitiesUpdateMutation = (
  options?: Partial<Options<InternalOpportunitiesUpdateData>>
): UseMutationOptions<
  InternalOpportunitiesUpdateResponse,
  AxiosError<DefaultError>,
  Options<InternalOpportunitiesUpdateData>
> => {
  const mutationOptions: UseMutationOptions<
    InternalOpportunitiesUpdateResponse,
    AxiosError<DefaultError>,
    Options<InternalOpportunitiesUpdateData>
  > = {
    mutationFn: async (localOptions) => {
      const { data } = await internalOpportunitiesUpdate({
        ...options,
        ...localOptions,
        throwOnError: true
      })

      return data
    }
  }

  return mutationOptions
}

export const internalProductsListQueryKey = (
  options?: Options<InternalProductsListData>
) => createQueryKey('internalProductsList', options)

export const internalProductsListOptions = (
  options?: Options<InternalProductsListData>
) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await internalProductsList({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true
      })

      return data
    },
    queryKey: internalProductsListQueryKey(options)
  })
}

export const internalProductsListInfiniteQueryKey = (
  options?: Options<InternalProductsListData>
): QueryKey<Options<InternalProductsListData>> =>
  createQueryKey('internalProductsList', options, true)

export const internalProductsListInfiniteOptions = (
  options?: Options<InternalProductsListData>
) => {
  return infiniteQueryOptions<
    InternalProductsListResponse,
    AxiosError<DefaultError>,
    InfiniteData<InternalProductsListResponse>,
    QueryKey<Options<InternalProductsListData>>,
    | number
    | Pick<
        QueryKey<Options<InternalProductsListData>>[0],
        'body' | 'headers' | 'path' | 'query'
      >
  >(
    // @ts-ignore
    {
      queryFn: async ({ pageParam, queryKey, signal }) => {
        // @ts-ignore
        const page: Pick<
          QueryKey<Options<InternalProductsListData>>[0],
          'body' | 'headers' | 'path' | 'query'
        > =
          typeof pageParam === 'object'
            ? pageParam
            : {
                query: {
                  page: pageParam
                }
              }
        const params = createInfiniteParams(queryKey, page)
        const { data } = await internalProductsList({
          ...options,
          ...params,
          signal,
          throwOnError: true
        })

        return data
      },
      queryKey: internalProductsListInfiniteQueryKey(options)
    }
  )
}

export const internalProductsCreateQueryKey = (
  options: Options<InternalProductsCreateData>
) => createQueryKey('internalProductsCreate', options)

export const internalProductsCreateOptions = (
  options: Options<InternalProductsCreateData>
) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await internalProductsCreate({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true
      })

      return data
    },
    queryKey: internalProductsCreateQueryKey(options)
  })
}

export const internalProductsCreateMutation = (
  options?: Partial<Options<InternalProductsCreateData>>
): UseMutationOptions<
  InternalProductsCreateResponse,
  AxiosError<DefaultError>,
  Options<InternalProductsCreateData>
> => {
  const mutationOptions: UseMutationOptions<
    InternalProductsCreateResponse,
    AxiosError<DefaultError>,
    Options<InternalProductsCreateData>
  > = {
    mutationFn: async (localOptions) => {
      const { data } = await internalProductsCreate({
        ...options,
        ...localOptions,
        throwOnError: true
      })

      return data
    }
  }

  return mutationOptions
}

export const internalProductsDestroyMutation = (
  options?: Partial<Options<InternalProductsDestroyData>>
): UseMutationOptions<
  InternalProductsDestroyResponse,
  AxiosError<DefaultError>,
  Options<InternalProductsDestroyData>
> => {
  const mutationOptions: UseMutationOptions<
    InternalProductsDestroyResponse,
    AxiosError<DefaultError>,
    Options<InternalProductsDestroyData>
  > = {
    mutationFn: async (localOptions) => {
      const { data } = await internalProductsDestroy({
        ...options,
        ...localOptions,
        throwOnError: true
      })

      return data
    }
  }

  return mutationOptions
}

export const internalProductsRetrieveQueryKey = (
  options: Options<InternalProductsRetrieveData>
) => createQueryKey('internalProductsRetrieve', options)

export const internalProductsRetrieveOptions = (
  options: Options<InternalProductsRetrieveData>
) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await internalProductsRetrieve({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true
      })

      return data
    },
    queryKey: internalProductsRetrieveQueryKey(options)
  })
}

export const internalProductsPartialUpdateMutation = (
  options?: Partial<Options<InternalProductsPartialUpdateData>>
): UseMutationOptions<
  InternalProductsPartialUpdateResponse,
  AxiosError<DefaultError>,
  Options<InternalProductsPartialUpdateData>
> => {
  const mutationOptions: UseMutationOptions<
    InternalProductsPartialUpdateResponse,
    AxiosError<DefaultError>,
    Options<InternalProductsPartialUpdateData>
  > = {
    mutationFn: async (localOptions) => {
      const { data } = await internalProductsPartialUpdate({
        ...options,
        ...localOptions,
        throwOnError: true
      })

      return data
    }
  }

  return mutationOptions
}

export const internalProductsUpdateMutation = (
  options?: Partial<Options<InternalProductsUpdateData>>
): UseMutationOptions<
  InternalProductsUpdateResponse,
  AxiosError<DefaultError>,
  Options<InternalProductsUpdateData>
> => {
  const mutationOptions: UseMutationOptions<
    InternalProductsUpdateResponse,
    AxiosError<DefaultError>,
    Options<InternalProductsUpdateData>
  > = {
    mutationFn: async (localOptions) => {
      const { data } = await internalProductsUpdate({
        ...options,
        ...localOptions,
        throwOnError: true
      })

      return data
    }
  }

  return mutationOptions
}

export const internalProductsListListQueryKey = (
  options?: Options<InternalProductsListListData>
) => createQueryKey('internalProductsListList', options)

export const internalProductsListListOptions = (
  options?: Options<InternalProductsListListData>
) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await internalProductsListList({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true
      })

      return data
    },
    queryKey: internalProductsListListQueryKey(options)
  })
}

export const internalProductsListListInfiniteQueryKey = (
  options?: Options<InternalProductsListListData>
): QueryKey<Options<InternalProductsListListData>> =>
  createQueryKey('internalProductsListList', options, true)

export const internalProductsListListInfiniteOptions = (
  options?: Options<InternalProductsListListData>
) => {
  return infiniteQueryOptions<
    InternalProductsListListResponse,
    AxiosError<DefaultError>,
    InfiniteData<InternalProductsListListResponse>,
    QueryKey<Options<InternalProductsListListData>>,
    | number
    | Pick<
        QueryKey<Options<InternalProductsListListData>>[0],
        'body' | 'headers' | 'path' | 'query'
      >
  >(
    // @ts-ignore
    {
      queryFn: async ({ pageParam, queryKey, signal }) => {
        // @ts-ignore
        const page: Pick<
          QueryKey<Options<InternalProductsListListData>>[0],
          'body' | 'headers' | 'path' | 'query'
        > =
          typeof pageParam === 'object'
            ? pageParam
            : {
                query: {
                  page: pageParam
                }
              }
        const params = createInfiniteParams(queryKey, page)
        const { data } = await internalProductsListList({
          ...options,
          ...params,
          signal,
          throwOnError: true
        })

        return data
      },
      queryKey: internalProductsListListInfiniteQueryKey(options)
    }
  )
}

export const internalReasonsListQueryKey = (
  options?: Options<InternalReasonsListData>
) => createQueryKey('internalReasonsList', options)

export const internalReasonsListOptions = (
  options?: Options<InternalReasonsListData>
) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await internalReasonsList({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true
      })

      return data
    },
    queryKey: internalReasonsListQueryKey(options)
  })
}

export const internalReasonsListInfiniteQueryKey = (
  options?: Options<InternalReasonsListData>
): QueryKey<Options<InternalReasonsListData>> =>
  createQueryKey('internalReasonsList', options, true)

export const internalReasonsListInfiniteOptions = (
  options?: Options<InternalReasonsListData>
) => {
  return infiniteQueryOptions<
    InternalReasonsListResponse,
    AxiosError<DefaultError>,
    InfiniteData<InternalReasonsListResponse>,
    QueryKey<Options<InternalReasonsListData>>,
    | number
    | Pick<
        QueryKey<Options<InternalReasonsListData>>[0],
        'body' | 'headers' | 'path' | 'query'
      >
  >(
    // @ts-ignore
    {
      queryFn: async ({ pageParam, queryKey, signal }) => {
        // @ts-ignore
        const page: Pick<
          QueryKey<Options<InternalReasonsListData>>[0],
          'body' | 'headers' | 'path' | 'query'
        > =
          typeof pageParam === 'object'
            ? pageParam
            : {
                query: {
                  page: pageParam
                }
              }
        const params = createInfiniteParams(queryKey, page)
        const { data } = await internalReasonsList({
          ...options,
          ...params,
          signal,
          throwOnError: true
        })

        return data
      },
      queryKey: internalReasonsListInfiniteQueryKey(options)
    }
  )
}

export const internalReasonsCreateQueryKey = (
  options: Options<InternalReasonsCreateData>
) => createQueryKey('internalReasonsCreate', options)

export const internalReasonsCreateOptions = (
  options: Options<InternalReasonsCreateData>
) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await internalReasonsCreate({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true
      })

      return data
    },
    queryKey: internalReasonsCreateQueryKey(options)
  })
}

export const internalReasonsCreateMutation = (
  options?: Partial<Options<InternalReasonsCreateData>>
): UseMutationOptions<
  InternalReasonsCreateResponse,
  AxiosError<DefaultError>,
  Options<InternalReasonsCreateData>
> => {
  const mutationOptions: UseMutationOptions<
    InternalReasonsCreateResponse,
    AxiosError<DefaultError>,
    Options<InternalReasonsCreateData>
  > = {
    mutationFn: async (localOptions) => {
      const { data } = await internalReasonsCreate({
        ...options,
        ...localOptions,
        throwOnError: true
      })

      return data
    }
  }

  return mutationOptions
}

export const internalReasonsDestroyMutation = (
  options?: Partial<Options<InternalReasonsDestroyData>>
): UseMutationOptions<
  InternalReasonsDestroyResponse,
  AxiosError<DefaultError>,
  Options<InternalReasonsDestroyData>
> => {
  const mutationOptions: UseMutationOptions<
    InternalReasonsDestroyResponse,
    AxiosError<DefaultError>,
    Options<InternalReasonsDestroyData>
  > = {
    mutationFn: async (localOptions) => {
      const { data } = await internalReasonsDestroy({
        ...options,
        ...localOptions,
        throwOnError: true
      })

      return data
    }
  }

  return mutationOptions
}

export const internalReasonsRetrieveQueryKey = (
  options: Options<InternalReasonsRetrieveData>
) => createQueryKey('internalReasonsRetrieve', options)

export const internalReasonsRetrieveOptions = (
  options: Options<InternalReasonsRetrieveData>
) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await internalReasonsRetrieve({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true
      })

      return data
    },
    queryKey: internalReasonsRetrieveQueryKey(options)
  })
}

export const internalReasonsPartialUpdateMutation = (
  options?: Partial<Options<InternalReasonsPartialUpdateData>>
): UseMutationOptions<
  InternalReasonsPartialUpdateResponse,
  AxiosError<DefaultError>,
  Options<InternalReasonsPartialUpdateData>
> => {
  const mutationOptions: UseMutationOptions<
    InternalReasonsPartialUpdateResponse,
    AxiosError<DefaultError>,
    Options<InternalReasonsPartialUpdateData>
  > = {
    mutationFn: async (localOptions) => {
      const { data } = await internalReasonsPartialUpdate({
        ...options,
        ...localOptions,
        throwOnError: true
      })

      return data
    }
  }

  return mutationOptions
}

export const internalReasonsUpdateMutation = (
  options?: Partial<Options<InternalReasonsUpdateData>>
): UseMutationOptions<
  InternalReasonsUpdateResponse,
  AxiosError<DefaultError>,
  Options<InternalReasonsUpdateData>
> => {
  const mutationOptions: UseMutationOptions<
    InternalReasonsUpdateResponse,
    AxiosError<DefaultError>,
    Options<InternalReasonsUpdateData>
  > = {
    mutationFn: async (localOptions) => {
      const { data } = await internalReasonsUpdate({
        ...options,
        ...localOptions,
        throwOnError: true
      })

      return data
    }
  }

  return mutationOptions
}

export const internalReasonsListListQueryKey = (
  options?: Options<InternalReasonsListListData>
) => createQueryKey('internalReasonsListList', options)

export const internalReasonsListListOptions = (
  options?: Options<InternalReasonsListListData>
) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await internalReasonsListList({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true
      })

      return data
    },
    queryKey: internalReasonsListListQueryKey(options)
  })
}

export const internalReasonsListListInfiniteQueryKey = (
  options?: Options<InternalReasonsListListData>
): QueryKey<Options<InternalReasonsListListData>> =>
  createQueryKey('internalReasonsListList', options, true)

export const internalReasonsListListInfiniteOptions = (
  options?: Options<InternalReasonsListListData>
) => {
  return infiniteQueryOptions<
    InternalReasonsListListResponse,
    AxiosError<DefaultError>,
    InfiniteData<InternalReasonsListListResponse>,
    QueryKey<Options<InternalReasonsListListData>>,
    | number
    | Pick<
        QueryKey<Options<InternalReasonsListListData>>[0],
        'body' | 'headers' | 'path' | 'query'
      >
  >(
    // @ts-ignore
    {
      queryFn: async ({ pageParam, queryKey, signal }) => {
        // @ts-ignore
        const page: Pick<
          QueryKey<Options<InternalReasonsListListData>>[0],
          'body' | 'headers' | 'path' | 'query'
        > =
          typeof pageParam === 'object'
            ? pageParam
            : {
                query: {
                  page: pageParam
                }
              }
        const params = createInfiniteParams(queryKey, page)
        const { data } = await internalReasonsListList({
          ...options,
          ...params,
          signal,
          throwOnError: true
        })

        return data
      },
      queryKey: internalReasonsListListInfiniteQueryKey(options)
    }
  )
}

export const internalRegionsListQueryKey = (
  options?: Options<InternalRegionsListData>
) => createQueryKey('internalRegionsList', options)

export const internalRegionsListOptions = (
  options?: Options<InternalRegionsListData>
) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await internalRegionsList({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true
      })

      return data
    },
    queryKey: internalRegionsListQueryKey(options)
  })
}

export const internalRegionsListInfiniteQueryKey = (
  options?: Options<InternalRegionsListData>
): QueryKey<Options<InternalRegionsListData>> =>
  createQueryKey('internalRegionsList', options, true)

export const internalRegionsListInfiniteOptions = (
  options?: Options<InternalRegionsListData>
) => {
  return infiniteQueryOptions<
    InternalRegionsListResponse,
    AxiosError<DefaultError>,
    InfiniteData<InternalRegionsListResponse>,
    QueryKey<Options<InternalRegionsListData>>,
    | number
    | Pick<
        QueryKey<Options<InternalRegionsListData>>[0],
        'body' | 'headers' | 'path' | 'query'
      >
  >(
    // @ts-ignore
    {
      queryFn: async ({ pageParam, queryKey, signal }) => {
        // @ts-ignore
        const page: Pick<
          QueryKey<Options<InternalRegionsListData>>[0],
          'body' | 'headers' | 'path' | 'query'
        > =
          typeof pageParam === 'object'
            ? pageParam
            : {
                query: {
                  page: pageParam
                }
              }
        const params = createInfiniteParams(queryKey, page)
        const { data } = await internalRegionsList({
          ...options,
          ...params,
          signal,
          throwOnError: true
        })

        return data
      },
      queryKey: internalRegionsListInfiniteQueryKey(options)
    }
  )
}

export const internalRegionsRetrieveQueryKey = (
  options: Options<InternalRegionsRetrieveData>
) => createQueryKey('internalRegionsRetrieve', options)

export const internalRegionsRetrieveOptions = (
  options: Options<InternalRegionsRetrieveData>
) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await internalRegionsRetrieve({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true
      })

      return data
    },
    queryKey: internalRegionsRetrieveQueryKey(options)
  })
}

export const internalRegionsListListQueryKey = (
  options?: Options<InternalRegionsListListData>
) => createQueryKey('internalRegionsListList', options)

export const internalRegionsListListOptions = (
  options?: Options<InternalRegionsListListData>
) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await internalRegionsListList({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true
      })

      return data
    },
    queryKey: internalRegionsListListQueryKey(options)
  })
}

export const internalRegionsListListInfiniteQueryKey = (
  options?: Options<InternalRegionsListListData>
): QueryKey<Options<InternalRegionsListListData>> =>
  createQueryKey('internalRegionsListList', options, true)

export const internalRegionsListListInfiniteOptions = (
  options?: Options<InternalRegionsListListData>
) => {
  return infiniteQueryOptions<
    InternalRegionsListListResponse,
    AxiosError<DefaultError>,
    InfiniteData<InternalRegionsListListResponse>,
    QueryKey<Options<InternalRegionsListListData>>,
    | number
    | Pick<
        QueryKey<Options<InternalRegionsListListData>>[0],
        'body' | 'headers' | 'path' | 'query'
      >
  >(
    // @ts-ignore
    {
      queryFn: async ({ pageParam, queryKey, signal }) => {
        // @ts-ignore
        const page: Pick<
          QueryKey<Options<InternalRegionsListListData>>[0],
          'body' | 'headers' | 'path' | 'query'
        > =
          typeof pageParam === 'object'
            ? pageParam
            : {
                query: {
                  page: pageParam
                }
              }
        const params = createInfiniteParams(queryKey, page)
        const { data } = await internalRegionsListList({
          ...options,
          ...params,
          signal,
          throwOnError: true
        })

        return data
      },
      queryKey: internalRegionsListListInfiniteQueryKey(options)
    }
  )
}

export const internalSequencesListQueryKey = (
  options?: Options<InternalSequencesListData>
) => createQueryKey('internalSequencesList', options)

export const internalSequencesListOptions = (
  options?: Options<InternalSequencesListData>
) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await internalSequencesList({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true
      })

      return data
    },
    queryKey: internalSequencesListQueryKey(options)
  })
}

export const internalSequencesListInfiniteQueryKey = (
  options?: Options<InternalSequencesListData>
): QueryKey<Options<InternalSequencesListData>> =>
  createQueryKey('internalSequencesList', options, true)

export const internalSequencesListInfiniteOptions = (
  options?: Options<InternalSequencesListData>
) => {
  return infiniteQueryOptions<
    InternalSequencesListResponse,
    AxiosError<DefaultError>,
    InfiniteData<InternalSequencesListResponse>,
    QueryKey<Options<InternalSequencesListData>>,
    | number
    | Pick<
        QueryKey<Options<InternalSequencesListData>>[0],
        'body' | 'headers' | 'path' | 'query'
      >
  >(
    // @ts-ignore
    {
      queryFn: async ({ pageParam, queryKey, signal }) => {
        // @ts-ignore
        const page: Pick<
          QueryKey<Options<InternalSequencesListData>>[0],
          'body' | 'headers' | 'path' | 'query'
        > =
          typeof pageParam === 'object'
            ? pageParam
            : {
                query: {
                  page: pageParam
                }
              }
        const params = createInfiniteParams(queryKey, page)
        const { data } = await internalSequencesList({
          ...options,
          ...params,
          signal,
          throwOnError: true
        })

        return data
      },
      queryKey: internalSequencesListInfiniteQueryKey(options)
    }
  )
}

export const internalSequencesCreateQueryKey = (
  options?: Options<InternalSequencesCreateData>
) => createQueryKey('internalSequencesCreate', options)

export const internalSequencesCreateOptions = (
  options?: Options<InternalSequencesCreateData>
) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await internalSequencesCreate({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true
      })

      return data
    },
    queryKey: internalSequencesCreateQueryKey(options)
  })
}

export const internalSequencesCreateMutation = (
  options?: Partial<Options<InternalSequencesCreateData>>
): UseMutationOptions<
  InternalSequencesCreateResponse,
  AxiosError<DefaultError>,
  Options<InternalSequencesCreateData>
> => {
  const mutationOptions: UseMutationOptions<
    InternalSequencesCreateResponse,
    AxiosError<DefaultError>,
    Options<InternalSequencesCreateData>
  > = {
    mutationFn: async (localOptions) => {
      const { data } = await internalSequencesCreate({
        ...options,
        ...localOptions,
        throwOnError: true
      })

      return data
    }
  }

  return mutationOptions
}

export const internalSequencesDestroyMutation = (
  options?: Partial<Options<InternalSequencesDestroyData>>
): UseMutationOptions<
  InternalSequencesDestroyResponse,
  AxiosError<DefaultError>,
  Options<InternalSequencesDestroyData>
> => {
  const mutationOptions: UseMutationOptions<
    InternalSequencesDestroyResponse,
    AxiosError<DefaultError>,
    Options<InternalSequencesDestroyData>
  > = {
    mutationFn: async (localOptions) => {
      const { data } = await internalSequencesDestroy({
        ...options,
        ...localOptions,
        throwOnError: true
      })

      return data
    }
  }

  return mutationOptions
}

export const internalSequencesRetrieveQueryKey = (
  options: Options<InternalSequencesRetrieveData>
) => createQueryKey('internalSequencesRetrieve', options)

export const internalSequencesRetrieveOptions = (
  options: Options<InternalSequencesRetrieveData>
) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await internalSequencesRetrieve({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true
      })

      return data
    },
    queryKey: internalSequencesRetrieveQueryKey(options)
  })
}

export const internalSequencesPartialUpdateMutation = (
  options?: Partial<Options<InternalSequencesPartialUpdateData>>
): UseMutationOptions<
  InternalSequencesPartialUpdateResponse,
  AxiosError<DefaultError>,
  Options<InternalSequencesPartialUpdateData>
> => {
  const mutationOptions: UseMutationOptions<
    InternalSequencesPartialUpdateResponse,
    AxiosError<DefaultError>,
    Options<InternalSequencesPartialUpdateData>
  > = {
    mutationFn: async (localOptions) => {
      const { data } = await internalSequencesPartialUpdate({
        ...options,
        ...localOptions,
        throwOnError: true
      })

      return data
    }
  }

  return mutationOptions
}

export const internalSequencesUpdateMutation = (
  options?: Partial<Options<InternalSequencesUpdateData>>
): UseMutationOptions<
  InternalSequencesUpdateResponse,
  AxiosError<DefaultError>,
  Options<InternalSequencesUpdateData>
> => {
  const mutationOptions: UseMutationOptions<
    InternalSequencesUpdateResponse,
    AxiosError<DefaultError>,
    Options<InternalSequencesUpdateData>
  > = {
    mutationFn: async (localOptions) => {
      const { data } = await internalSequencesUpdate({
        ...options,
        ...localOptions,
        throwOnError: true
      })

      return data
    }
  }

  return mutationOptions
}

export const internalSequencesAddLeadsCreateQueryKey = (
  options: Options<InternalSequencesAddLeadsCreateData>
) => createQueryKey('internalSequencesAddLeadsCreate', options)

export const internalSequencesAddLeadsCreateOptions = (
  options: Options<InternalSequencesAddLeadsCreateData>
) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await internalSequencesAddLeadsCreate({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true
      })

      return data
    },
    queryKey: internalSequencesAddLeadsCreateQueryKey(options)
  })
}

export const internalSequencesAddLeadsCreateMutation = (
  options?: Partial<Options<InternalSequencesAddLeadsCreateData>>
): UseMutationOptions<
  InternalSequencesAddLeadsCreateResponse,
  AxiosError<DefaultError>,
  Options<InternalSequencesAddLeadsCreateData>
> => {
  const mutationOptions: UseMutationOptions<
    InternalSequencesAddLeadsCreateResponse,
    AxiosError<DefaultError>,
    Options<InternalSequencesAddLeadsCreateData>
  > = {
    mutationFn: async (localOptions) => {
      const { data } = await internalSequencesAddLeadsCreate({
        ...options,
        ...localOptions,
        throwOnError: true
      })

      return data
    }
  }

  return mutationOptions
}

export const internalSequencesDuplicateRetrieveQueryKey = (
  options: Options<InternalSequencesDuplicateRetrieveData>
) => createQueryKey('internalSequencesDuplicateRetrieve', options)

export const internalSequencesDuplicateRetrieveOptions = (
  options: Options<InternalSequencesDuplicateRetrieveData>
) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await internalSequencesDuplicateRetrieve({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true
      })

      return data
    },
    queryKey: internalSequencesDuplicateRetrieveQueryKey(options)
  })
}

export const internalSequencesListListQueryKey = (
  options?: Options<InternalSequencesListListData>
) => createQueryKey('internalSequencesListList', options)

export const internalSequencesListListOptions = (
  options?: Options<InternalSequencesListListData>
) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await internalSequencesListList({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true
      })

      return data
    },
    queryKey: internalSequencesListListQueryKey(options)
  })
}

export const internalSequencesListListInfiniteQueryKey = (
  options?: Options<InternalSequencesListListData>
): QueryKey<Options<InternalSequencesListListData>> =>
  createQueryKey('internalSequencesListList', options, true)

export const internalSequencesListListInfiniteOptions = (
  options?: Options<InternalSequencesListListData>
) => {
  return infiniteQueryOptions<
    InternalSequencesListListResponse,
    AxiosError<DefaultError>,
    InfiniteData<InternalSequencesListListResponse>,
    QueryKey<Options<InternalSequencesListListData>>,
    | number
    | Pick<
        QueryKey<Options<InternalSequencesListListData>>[0],
        'body' | 'headers' | 'path' | 'query'
      >
  >(
    // @ts-ignore
    {
      queryFn: async ({ pageParam, queryKey, signal }) => {
        // @ts-ignore
        const page: Pick<
          QueryKey<Options<InternalSequencesListListData>>[0],
          'body' | 'headers' | 'path' | 'query'
        > =
          typeof pageParam === 'object'
            ? pageParam
            : {
                query: {
                  page: pageParam
                }
              }
        const params = createInfiniteParams(queryKey, page)
        const { data } = await internalSequencesListList({
          ...options,
          ...params,
          signal,
          throwOnError: true
        })

        return data
      },
      queryKey: internalSequencesListListInfiniteQueryKey(options)
    }
  )
}

export const internalSourcesListQueryKey = (
  options?: Options<InternalSourcesListData>
) => createQueryKey('internalSourcesList', options)

export const internalSourcesListOptions = (
  options?: Options<InternalSourcesListData>
) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await internalSourcesList({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true
      })

      return data
    },
    queryKey: internalSourcesListQueryKey(options)
  })
}

export const internalSourcesListInfiniteQueryKey = (
  options?: Options<InternalSourcesListData>
): QueryKey<Options<InternalSourcesListData>> =>
  createQueryKey('internalSourcesList', options, true)

export const internalSourcesListInfiniteOptions = (
  options?: Options<InternalSourcesListData>
) => {
  return infiniteQueryOptions<
    InternalSourcesListResponse,
    AxiosError<DefaultError>,
    InfiniteData<InternalSourcesListResponse>,
    QueryKey<Options<InternalSourcesListData>>,
    | number
    | Pick<
        QueryKey<Options<InternalSourcesListData>>[0],
        'body' | 'headers' | 'path' | 'query'
      >
  >(
    // @ts-ignore
    {
      queryFn: async ({ pageParam, queryKey, signal }) => {
        // @ts-ignore
        const page: Pick<
          QueryKey<Options<InternalSourcesListData>>[0],
          'body' | 'headers' | 'path' | 'query'
        > =
          typeof pageParam === 'object'
            ? pageParam
            : {
                query: {
                  page: pageParam
                }
              }
        const params = createInfiniteParams(queryKey, page)
        const { data } = await internalSourcesList({
          ...options,
          ...params,
          signal,
          throwOnError: true
        })

        return data
      },
      queryKey: internalSourcesListInfiniteQueryKey(options)
    }
  )
}

export const internalSourcesCreateQueryKey = (
  options: Options<InternalSourcesCreateData>
) => createQueryKey('internalSourcesCreate', options)

export const internalSourcesCreateOptions = (
  options: Options<InternalSourcesCreateData>
) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await internalSourcesCreate({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true
      })

      return data
    },
    queryKey: internalSourcesCreateQueryKey(options)
  })
}

export const internalSourcesCreateMutation = (
  options?: Partial<Options<InternalSourcesCreateData>>
): UseMutationOptions<
  InternalSourcesCreateResponse,
  AxiosError<DefaultError>,
  Options<InternalSourcesCreateData>
> => {
  const mutationOptions: UseMutationOptions<
    InternalSourcesCreateResponse,
    AxiosError<DefaultError>,
    Options<InternalSourcesCreateData>
  > = {
    mutationFn: async (localOptions) => {
      const { data } = await internalSourcesCreate({
        ...options,
        ...localOptions,
        throwOnError: true
      })

      return data
    }
  }

  return mutationOptions
}

export const internalSourcesDestroyMutation = (
  options?: Partial<Options<InternalSourcesDestroyData>>
): UseMutationOptions<
  InternalSourcesDestroyResponse,
  AxiosError<DefaultError>,
  Options<InternalSourcesDestroyData>
> => {
  const mutationOptions: UseMutationOptions<
    InternalSourcesDestroyResponse,
    AxiosError<DefaultError>,
    Options<InternalSourcesDestroyData>
  > = {
    mutationFn: async (localOptions) => {
      const { data } = await internalSourcesDestroy({
        ...options,
        ...localOptions,
        throwOnError: true
      })

      return data
    }
  }

  return mutationOptions
}

export const internalSourcesRetrieveQueryKey = (
  options: Options<InternalSourcesRetrieveData>
) => createQueryKey('internalSourcesRetrieve', options)

export const internalSourcesRetrieveOptions = (
  options: Options<InternalSourcesRetrieveData>
) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await internalSourcesRetrieve({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true
      })

      return data
    },
    queryKey: internalSourcesRetrieveQueryKey(options)
  })
}

export const internalSourcesPartialUpdateMutation = (
  options?: Partial<Options<InternalSourcesPartialUpdateData>>
): UseMutationOptions<
  InternalSourcesPartialUpdateResponse,
  AxiosError<DefaultError>,
  Options<InternalSourcesPartialUpdateData>
> => {
  const mutationOptions: UseMutationOptions<
    InternalSourcesPartialUpdateResponse,
    AxiosError<DefaultError>,
    Options<InternalSourcesPartialUpdateData>
  > = {
    mutationFn: async (localOptions) => {
      const { data } = await internalSourcesPartialUpdate({
        ...options,
        ...localOptions,
        throwOnError: true
      })

      return data
    }
  }

  return mutationOptions
}

export const internalSourcesUpdateMutation = (
  options?: Partial<Options<InternalSourcesUpdateData>>
): UseMutationOptions<
  InternalSourcesUpdateResponse,
  AxiosError<DefaultError>,
  Options<InternalSourcesUpdateData>
> => {
  const mutationOptions: UseMutationOptions<
    InternalSourcesUpdateResponse,
    AxiosError<DefaultError>,
    Options<InternalSourcesUpdateData>
  > = {
    mutationFn: async (localOptions) => {
      const { data } = await internalSourcesUpdate({
        ...options,
        ...localOptions,
        throwOnError: true
      })

      return data
    }
  }

  return mutationOptions
}

export const internalSourcesListListQueryKey = (
  options?: Options<InternalSourcesListListData>
) => createQueryKey('internalSourcesListList', options)

export const internalSourcesListListOptions = (
  options?: Options<InternalSourcesListListData>
) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await internalSourcesListList({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true
      })

      return data
    },
    queryKey: internalSourcesListListQueryKey(options)
  })
}

export const internalSourcesListListInfiniteQueryKey = (
  options?: Options<InternalSourcesListListData>
): QueryKey<Options<InternalSourcesListListData>> =>
  createQueryKey('internalSourcesListList', options, true)

export const internalSourcesListListInfiniteOptions = (
  options?: Options<InternalSourcesListListData>
) => {
  return infiniteQueryOptions<
    InternalSourcesListListResponse,
    AxiosError<DefaultError>,
    InfiniteData<InternalSourcesListListResponse>,
    QueryKey<Options<InternalSourcesListListData>>,
    | number
    | Pick<
        QueryKey<Options<InternalSourcesListListData>>[0],
        'body' | 'headers' | 'path' | 'query'
      >
  >(
    // @ts-ignore
    {
      queryFn: async ({ pageParam, queryKey, signal }) => {
        // @ts-ignore
        const page: Pick<
          QueryKey<Options<InternalSourcesListListData>>[0],
          'body' | 'headers' | 'path' | 'query'
        > =
          typeof pageParam === 'object'
            ? pageParam
            : {
                query: {
                  page: pageParam
                }
              }
        const params = createInfiniteParams(queryKey, page)
        const { data } = await internalSourcesListList({
          ...options,
          ...params,
          signal,
          throwOnError: true
        })

        return data
      },
      queryKey: internalSourcesListListInfiniteQueryKey(options)
    }
  )
}

export const internalTagsListQueryKey = (
  options?: Options<InternalTagsListData>
) => createQueryKey('internalTagsList', options)

export const internalTagsListOptions = (
  options?: Options<InternalTagsListData>
) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await internalTagsList({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true
      })

      return data
    },
    queryKey: internalTagsListQueryKey(options)
  })
}

export const internalTagsListInfiniteQueryKey = (
  options?: Options<InternalTagsListData>
): QueryKey<Options<InternalTagsListData>> =>
  createQueryKey('internalTagsList', options, true)

export const internalTagsListInfiniteOptions = (
  options?: Options<InternalTagsListData>
) => {
  return infiniteQueryOptions<
    InternalTagsListResponse,
    AxiosError<DefaultError>,
    InfiniteData<InternalTagsListResponse>,
    QueryKey<Options<InternalTagsListData>>,
    | number
    | Pick<
        QueryKey<Options<InternalTagsListData>>[0],
        'body' | 'headers' | 'path' | 'query'
      >
  >(
    // @ts-ignore
    {
      queryFn: async ({ pageParam, queryKey, signal }) => {
        // @ts-ignore
        const page: Pick<
          QueryKey<Options<InternalTagsListData>>[0],
          'body' | 'headers' | 'path' | 'query'
        > =
          typeof pageParam === 'object'
            ? pageParam
            : {
                query: {
                  page: pageParam
                }
              }
        const params = createInfiniteParams(queryKey, page)
        const { data } = await internalTagsList({
          ...options,
          ...params,
          signal,
          throwOnError: true
        })

        return data
      },
      queryKey: internalTagsListInfiniteQueryKey(options)
    }
  )
}

export const internalTagsCreateQueryKey = (
  options: Options<InternalTagsCreateData>
) => createQueryKey('internalTagsCreate', options)

export const internalTagsCreateOptions = (
  options: Options<InternalTagsCreateData>
) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await internalTagsCreate({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true
      })

      return data
    },
    queryKey: internalTagsCreateQueryKey(options)
  })
}

export const internalTagsCreateMutation = (
  options?: Partial<Options<InternalTagsCreateData>>
): UseMutationOptions<
  InternalTagsCreateResponse,
  AxiosError<DefaultError>,
  Options<InternalTagsCreateData>
> => {
  const mutationOptions: UseMutationOptions<
    InternalTagsCreateResponse,
    AxiosError<DefaultError>,
    Options<InternalTagsCreateData>
  > = {
    mutationFn: async (localOptions) => {
      const { data } = await internalTagsCreate({
        ...options,
        ...localOptions,
        throwOnError: true
      })

      return data
    }
  }

  return mutationOptions
}

export const internalTagsDestroyMutation = (
  options?: Partial<Options<InternalTagsDestroyData>>
): UseMutationOptions<
  InternalTagsDestroyResponse,
  AxiosError<DefaultError>,
  Options<InternalTagsDestroyData>
> => {
  const mutationOptions: UseMutationOptions<
    InternalTagsDestroyResponse,
    AxiosError<DefaultError>,
    Options<InternalTagsDestroyData>
  > = {
    mutationFn: async (localOptions) => {
      const { data } = await internalTagsDestroy({
        ...options,
        ...localOptions,
        throwOnError: true
      })

      return data
    }
  }

  return mutationOptions
}

export const internalTagsRetrieveQueryKey = (
  options: Options<InternalTagsRetrieveData>
) => createQueryKey('internalTagsRetrieve', options)

export const internalTagsRetrieveOptions = (
  options: Options<InternalTagsRetrieveData>
) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await internalTagsRetrieve({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true
      })

      return data
    },
    queryKey: internalTagsRetrieveQueryKey(options)
  })
}

export const internalTagsPartialUpdateMutation = (
  options?: Partial<Options<InternalTagsPartialUpdateData>>
): UseMutationOptions<
  InternalTagsPartialUpdateResponse,
  AxiosError<DefaultError>,
  Options<InternalTagsPartialUpdateData>
> => {
  const mutationOptions: UseMutationOptions<
    InternalTagsPartialUpdateResponse,
    AxiosError<DefaultError>,
    Options<InternalTagsPartialUpdateData>
  > = {
    mutationFn: async (localOptions) => {
      const { data } = await internalTagsPartialUpdate({
        ...options,
        ...localOptions,
        throwOnError: true
      })

      return data
    }
  }

  return mutationOptions
}

export const internalTagsUpdateMutation = (
  options?: Partial<Options<InternalTagsUpdateData>>
): UseMutationOptions<
  InternalTagsUpdateResponse,
  AxiosError<DefaultError>,
  Options<InternalTagsUpdateData>
> => {
  const mutationOptions: UseMutationOptions<
    InternalTagsUpdateResponse,
    AxiosError<DefaultError>,
    Options<InternalTagsUpdateData>
  > = {
    mutationFn: async (localOptions) => {
      const { data } = await internalTagsUpdate({
        ...options,
        ...localOptions,
        throwOnError: true
      })

      return data
    }
  }

  return mutationOptions
}

export const internalTagsColorsRetrieveQueryKey = (
  options?: Options<InternalTagsColorsRetrieveData>
) => createQueryKey('internalTagsColorsRetrieve', options)

export const internalTagsColorsRetrieveOptions = (
  options?: Options<InternalTagsColorsRetrieveData>
) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await internalTagsColorsRetrieve({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true
      })

      return data
    },
    queryKey: internalTagsColorsRetrieveQueryKey(options)
  })
}

export const internalTagsListListQueryKey = (
  options?: Options<InternalTagsListListData>
) => createQueryKey('internalTagsListList', options)

export const internalTagsListListOptions = (
  options?: Options<InternalTagsListListData>
) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await internalTagsListList({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true
      })

      return data
    },
    queryKey: internalTagsListListQueryKey(options)
  })
}

export const internalTagsListListInfiniteQueryKey = (
  options?: Options<InternalTagsListListData>
): QueryKey<Options<InternalTagsListListData>> =>
  createQueryKey('internalTagsListList', options, true)

export const internalTagsListListInfiniteOptions = (
  options?: Options<InternalTagsListListData>
) => {
  return infiniteQueryOptions<
    InternalTagsListListResponse,
    AxiosError<DefaultError>,
    InfiniteData<InternalTagsListListResponse>,
    QueryKey<Options<InternalTagsListListData>>,
    | number
    | Pick<
        QueryKey<Options<InternalTagsListListData>>[0],
        'body' | 'headers' | 'path' | 'query'
      >
  >(
    // @ts-ignore
    {
      queryFn: async ({ pageParam, queryKey, signal }) => {
        // @ts-ignore
        const page: Pick<
          QueryKey<Options<InternalTagsListListData>>[0],
          'body' | 'headers' | 'path' | 'query'
        > =
          typeof pageParam === 'object'
            ? pageParam
            : {
                query: {
                  page: pageParam
                }
              }
        const params = createInfiniteParams(queryKey, page)
        const { data } = await internalTagsListList({
          ...options,
          ...params,
          signal,
          throwOnError: true
        })

        return data
      },
      queryKey: internalTagsListListInfiniteQueryKey(options)
    }
  )
}

export const internalTaskTypesListQueryKey = (
  options?: Options<InternalTaskTypesListData>
) => createQueryKey('internalTaskTypesList', options)

export const internalTaskTypesListOptions = (
  options?: Options<InternalTaskTypesListData>
) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await internalTaskTypesList({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true
      })

      return data
    },
    queryKey: internalTaskTypesListQueryKey(options)
  })
}

export const internalTaskTypesListInfiniteQueryKey = (
  options?: Options<InternalTaskTypesListData>
): QueryKey<Options<InternalTaskTypesListData>> =>
  createQueryKey('internalTaskTypesList', options, true)

export const internalTaskTypesListInfiniteOptions = (
  options?: Options<InternalTaskTypesListData>
) => {
  return infiniteQueryOptions<
    InternalTaskTypesListResponse,
    AxiosError<DefaultError>,
    InfiniteData<InternalTaskTypesListResponse>,
    QueryKey<Options<InternalTaskTypesListData>>,
    | number
    | Pick<
        QueryKey<Options<InternalTaskTypesListData>>[0],
        'body' | 'headers' | 'path' | 'query'
      >
  >(
    // @ts-ignore
    {
      queryFn: async ({ pageParam, queryKey, signal }) => {
        // @ts-ignore
        const page: Pick<
          QueryKey<Options<InternalTaskTypesListData>>[0],
          'body' | 'headers' | 'path' | 'query'
        > =
          typeof pageParam === 'object'
            ? pageParam
            : {
                query: {
                  page: pageParam
                }
              }
        const params = createInfiniteParams(queryKey, page)
        const { data } = await internalTaskTypesList({
          ...options,
          ...params,
          signal,
          throwOnError: true
        })

        return data
      },
      queryKey: internalTaskTypesListInfiniteQueryKey(options)
    }
  )
}

export const internalTaskTypesCreateQueryKey = (
  options: Options<InternalTaskTypesCreateData>
) => createQueryKey('internalTaskTypesCreate', options)

export const internalTaskTypesCreateOptions = (
  options: Options<InternalTaskTypesCreateData>
) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await internalTaskTypesCreate({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true
      })

      return data
    },
    queryKey: internalTaskTypesCreateQueryKey(options)
  })
}

export const internalTaskTypesCreateMutation = (
  options?: Partial<Options<InternalTaskTypesCreateData>>
): UseMutationOptions<
  InternalTaskTypesCreateResponse,
  AxiosError<DefaultError>,
  Options<InternalTaskTypesCreateData>
> => {
  const mutationOptions: UseMutationOptions<
    InternalTaskTypesCreateResponse,
    AxiosError<DefaultError>,
    Options<InternalTaskTypesCreateData>
  > = {
    mutationFn: async (localOptions) => {
      const { data } = await internalTaskTypesCreate({
        ...options,
        ...localOptions,
        throwOnError: true
      })

      return data
    }
  }

  return mutationOptions
}

export const internalTaskTypesDestroyMutation = (
  options?: Partial<Options<InternalTaskTypesDestroyData>>
): UseMutationOptions<
  InternalTaskTypesDestroyResponse,
  AxiosError<DefaultError>,
  Options<InternalTaskTypesDestroyData>
> => {
  const mutationOptions: UseMutationOptions<
    InternalTaskTypesDestroyResponse,
    AxiosError<DefaultError>,
    Options<InternalTaskTypesDestroyData>
  > = {
    mutationFn: async (localOptions) => {
      const { data } = await internalTaskTypesDestroy({
        ...options,
        ...localOptions,
        throwOnError: true
      })

      return data
    }
  }

  return mutationOptions
}

export const internalTaskTypesRetrieveQueryKey = (
  options: Options<InternalTaskTypesRetrieveData>
) => createQueryKey('internalTaskTypesRetrieve', options)

export const internalTaskTypesRetrieveOptions = (
  options: Options<InternalTaskTypesRetrieveData>
) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await internalTaskTypesRetrieve({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true
      })

      return data
    },
    queryKey: internalTaskTypesRetrieveQueryKey(options)
  })
}

export const internalTaskTypesPartialUpdateMutation = (
  options?: Partial<Options<InternalTaskTypesPartialUpdateData>>
): UseMutationOptions<
  InternalTaskTypesPartialUpdateResponse,
  AxiosError<DefaultError>,
  Options<InternalTaskTypesPartialUpdateData>
> => {
  const mutationOptions: UseMutationOptions<
    InternalTaskTypesPartialUpdateResponse,
    AxiosError<DefaultError>,
    Options<InternalTaskTypesPartialUpdateData>
  > = {
    mutationFn: async (localOptions) => {
      const { data } = await internalTaskTypesPartialUpdate({
        ...options,
        ...localOptions,
        throwOnError: true
      })

      return data
    }
  }

  return mutationOptions
}

export const internalTaskTypesUpdateMutation = (
  options?: Partial<Options<InternalTaskTypesUpdateData>>
): UseMutationOptions<
  InternalTaskTypesUpdateResponse,
  AxiosError<DefaultError>,
  Options<InternalTaskTypesUpdateData>
> => {
  const mutationOptions: UseMutationOptions<
    InternalTaskTypesUpdateResponse,
    AxiosError<DefaultError>,
    Options<InternalTaskTypesUpdateData>
  > = {
    mutationFn: async (localOptions) => {
      const { data } = await internalTaskTypesUpdate({
        ...options,
        ...localOptions,
        throwOnError: true
      })

      return data
    }
  }

  return mutationOptions
}

export const internalTaskTypesAllRetrieveQueryKey = (
  options?: Options<InternalTaskTypesAllRetrieveData>
) => createQueryKey('internalTaskTypesAllRetrieve', options)

export const internalTaskTypesAllRetrieveOptions = (
  options?: Options<InternalTaskTypesAllRetrieveData>
) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await internalTaskTypesAllRetrieve({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true
      })

      return data
    },
    queryKey: internalTaskTypesAllRetrieveQueryKey(options)
  })
}

export const internalTaskTypesListListQueryKey = (
  options?: Options<InternalTaskTypesListListData>
) => createQueryKey('internalTaskTypesListList', options)

export const internalTaskTypesListListOptions = (
  options?: Options<InternalTaskTypesListListData>
) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await internalTaskTypesListList({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true
      })

      return data
    },
    queryKey: internalTaskTypesListListQueryKey(options)
  })
}

export const internalTaskTypesListListInfiniteQueryKey = (
  options?: Options<InternalTaskTypesListListData>
): QueryKey<Options<InternalTaskTypesListListData>> =>
  createQueryKey('internalTaskTypesListList', options, true)

export const internalTaskTypesListListInfiniteOptions = (
  options?: Options<InternalTaskTypesListListData>
) => {
  return infiniteQueryOptions<
    InternalTaskTypesListListResponse,
    AxiosError<DefaultError>,
    InfiniteData<InternalTaskTypesListListResponse>,
    QueryKey<Options<InternalTaskTypesListListData>>,
    | number
    | Pick<
        QueryKey<Options<InternalTaskTypesListListData>>[0],
        'body' | 'headers' | 'path' | 'query'
      >
  >(
    // @ts-ignore
    {
      queryFn: async ({ pageParam, queryKey, signal }) => {
        // @ts-ignore
        const page: Pick<
          QueryKey<Options<InternalTaskTypesListListData>>[0],
          'body' | 'headers' | 'path' | 'query'
        > =
          typeof pageParam === 'object'
            ? pageParam
            : {
                query: {
                  page: pageParam
                }
              }
        const params = createInfiniteParams(queryKey, page)
        const { data } = await internalTaskTypesListList({
          ...options,
          ...params,
          signal,
          throwOnError: true
        })

        return data
      },
      queryKey: internalTaskTypesListListInfiniteQueryKey(options)
    }
  )
}

export const invoicesListQueryKey = (options?: Options<InvoicesListData>) =>
  createQueryKey('invoicesList', options)

export const invoicesListOptions = (options?: Options<InvoicesListData>) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await invoicesList({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true
      })

      return data
    },
    queryKey: invoicesListQueryKey(options)
  })
}

export const invoicesListInfiniteQueryKey = (
  options?: Options<InvoicesListData>
): QueryKey<Options<InvoicesListData>> =>
  createQueryKey('invoicesList', options, true)

export const invoicesListInfiniteOptions = (
  options?: Options<InvoicesListData>
) => {
  return infiniteQueryOptions<
    InvoicesListResponse,
    AxiosError<DefaultError>,
    InfiniteData<InvoicesListResponse>,
    QueryKey<Options<InvoicesListData>>,
    | number
    | Pick<
        QueryKey<Options<InvoicesListData>>[0],
        'body' | 'headers' | 'path' | 'query'
      >
  >(
    // @ts-ignore
    {
      queryFn: async ({ pageParam, queryKey, signal }) => {
        // @ts-ignore
        const page: Pick<
          QueryKey<Options<InvoicesListData>>[0],
          'body' | 'headers' | 'path' | 'query'
        > =
          typeof pageParam === 'object'
            ? pageParam
            : {
                query: {
                  page: pageParam
                }
              }
        const params = createInfiniteParams(queryKey, page)
        const { data } = await invoicesList({
          ...options,
          ...params,
          signal,
          throwOnError: true
        })

        return data
      },
      queryKey: invoicesListInfiniteQueryKey(options)
    }
  )
}

export const invoicesCreateQueryKey = (options: Options<InvoicesCreateData>) =>
  createQueryKey('invoicesCreate', options)

export const invoicesCreateOptions = (options: Options<InvoicesCreateData>) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await invoicesCreate({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true
      })

      return data
    },
    queryKey: invoicesCreateQueryKey(options)
  })
}

export const invoicesCreateMutation = (
  options?: Partial<Options<InvoicesCreateData>>
): UseMutationOptions<
  InvoicesCreateResponse,
  AxiosError<DefaultError>,
  Options<InvoicesCreateData>
> => {
  const mutationOptions: UseMutationOptions<
    InvoicesCreateResponse,
    AxiosError<DefaultError>,
    Options<InvoicesCreateData>
  > = {
    mutationFn: async (localOptions) => {
      const { data } = await invoicesCreate({
        ...options,
        ...localOptions,
        throwOnError: true
      })

      return data
    }
  }

  return mutationOptions
}

export const invoicesDestroyMutation = (
  options?: Partial<Options<InvoicesDestroyData>>
): UseMutationOptions<
  InvoicesDestroyResponse,
  AxiosError<DefaultError>,
  Options<InvoicesDestroyData>
> => {
  const mutationOptions: UseMutationOptions<
    InvoicesDestroyResponse,
    AxiosError<DefaultError>,
    Options<InvoicesDestroyData>
  > = {
    mutationFn: async (localOptions) => {
      const { data } = await invoicesDestroy({
        ...options,
        ...localOptions,
        throwOnError: true
      })

      return data
    }
  }

  return mutationOptions
}

export const invoicesRetrieveQueryKey = (
  options: Options<InvoicesRetrieveData>
) => createQueryKey('invoicesRetrieve', options)

export const invoicesRetrieveOptions = (
  options: Options<InvoicesRetrieveData>
) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await invoicesRetrieve({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true
      })

      return data
    },
    queryKey: invoicesRetrieveQueryKey(options)
  })
}

export const invoicesPartialUpdateMutation = (
  options?: Partial<Options<InvoicesPartialUpdateData>>
): UseMutationOptions<
  InvoicesPartialUpdateResponse,
  AxiosError<DefaultError>,
  Options<InvoicesPartialUpdateData>
> => {
  const mutationOptions: UseMutationOptions<
    InvoicesPartialUpdateResponse,
    AxiosError<DefaultError>,
    Options<InvoicesPartialUpdateData>
  > = {
    mutationFn: async (localOptions) => {
      const { data } = await invoicesPartialUpdate({
        ...options,
        ...localOptions,
        throwOnError: true
      })

      return data
    }
  }

  return mutationOptions
}

export const invoicesUpdateMutation = (
  options?: Partial<Options<InvoicesUpdateData>>
): UseMutationOptions<
  InvoicesUpdateResponse,
  AxiosError<DefaultError>,
  Options<InvoicesUpdateData>
> => {
  const mutationOptions: UseMutationOptions<
    InvoicesUpdateResponse,
    AxiosError<DefaultError>,
    Options<InvoicesUpdateData>
  > = {
    mutationFn: async (localOptions) => {
      const { data } = await invoicesUpdate({
        ...options,
        ...localOptions,
        throwOnError: true
      })

      return data
    }
  }

  return mutationOptions
}

export const invoicesChangeStatusPartialUpdateMutation = (
  options?: Partial<Options<InvoicesChangeStatusPartialUpdateData>>
): UseMutationOptions<
  InvoicesChangeStatusPartialUpdateResponse,
  AxiosError<DefaultError>,
  Options<InvoicesChangeStatusPartialUpdateData>
> => {
  const mutationOptions: UseMutationOptions<
    InvoicesChangeStatusPartialUpdateResponse,
    AxiosError<DefaultError>,
    Options<InvoicesChangeStatusPartialUpdateData>
  > = {
    mutationFn: async (localOptions) => {
      const { data } = await invoicesChangeStatusPartialUpdate({
        ...options,
        ...localOptions,
        throwOnError: true
      })

      return data
    }
  }

  return mutationOptions
}

export const invoicesDownloadRetrieveQueryKey = (
  options: Options<InvoicesDownloadRetrieveData>
) => createQueryKey('invoicesDownloadRetrieve', options)

export const invoicesDownloadRetrieveOptions = (
  options: Options<InvoicesDownloadRetrieveData>
) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await invoicesDownloadRetrieve({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true
      })

      return data
    },
    queryKey: invoicesDownloadRetrieveQueryKey(options)
  })
}

export const invoicesEmailRetrieveQueryKey = (
  options: Options<InvoicesEmailRetrieveData>
) => createQueryKey('invoicesEmailRetrieve', options)

export const invoicesEmailRetrieveOptions = (
  options: Options<InvoicesEmailRetrieveData>
) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await invoicesEmailRetrieve({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true
      })

      return data
    },
    queryKey: invoicesEmailRetrieveQueryKey(options)
  })
}

export const invoicesResendEmailRetrieveQueryKey = (
  options: Options<InvoicesResendEmailRetrieveData>
) => createQueryKey('invoicesResendEmailRetrieve', options)

export const invoicesResendEmailRetrieveOptions = (
  options: Options<InvoicesResendEmailRetrieveData>
) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await invoicesResendEmailRetrieve({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true
      })

      return data
    },
    queryKey: invoicesResendEmailRetrieveQueryKey(options)
  })
}

export const invoicesContractorsCreateQueryKey = (
  options: Options<InvoicesContractorsCreateData>
) => createQueryKey('invoicesContractorsCreate', options)

export const invoicesContractorsCreateOptions = (
  options: Options<InvoicesContractorsCreateData>
) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await invoicesContractorsCreate({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true
      })

      return data
    },
    queryKey: invoicesContractorsCreateQueryKey(options)
  })
}

export const invoicesContractorsCreateMutation = (
  options?: Partial<Options<InvoicesContractorsCreateData>>
): UseMutationOptions<
  InvoicesContractorsCreateResponse,
  AxiosError<DefaultError>,
  Options<InvoicesContractorsCreateData>
> => {
  const mutationOptions: UseMutationOptions<
    InvoicesContractorsCreateResponse,
    AxiosError<DefaultError>,
    Options<InvoicesContractorsCreateData>
  > = {
    mutationFn: async (localOptions) => {
      const { data } = await invoicesContractorsCreate({
        ...options,
        ...localOptions,
        throwOnError: true
      })

      return data
    }
  }

  return mutationOptions
}

export const invoicesReportsRetrieveQueryKey = (
  options?: Options<InvoicesReportsRetrieveData>
) => createQueryKey('invoicesReportsRetrieve', options)

export const invoicesReportsRetrieveOptions = (
  options?: Options<InvoicesReportsRetrieveData>
) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await invoicesReportsRetrieve({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true
      })

      return data
    },
    queryKey: invoicesReportsRetrieveQueryKey(options)
  })
}

export const invoicesReportsExportCreateQueryKey = (
  options: Options<InvoicesReportsExportCreateData>
) => createQueryKey('invoicesReportsExportCreate', options)

export const invoicesReportsExportCreateOptions = (
  options: Options<InvoicesReportsExportCreateData>
) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await invoicesReportsExportCreate({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true
      })

      return data
    },
    queryKey: invoicesReportsExportCreateQueryKey(options)
  })
}

export const invoicesReportsExportCreateMutation = (
  options?: Partial<Options<InvoicesReportsExportCreateData>>
): UseMutationOptions<
  InvoicesReportsExportCreateResponse,
  AxiosError<DefaultError>,
  Options<InvoicesReportsExportCreateData>
> => {
  const mutationOptions: UseMutationOptions<
    InvoicesReportsExportCreateResponse,
    AxiosError<DefaultError>,
    Options<InvoicesReportsExportCreateData>
  > = {
    mutationFn: async (localOptions) => {
      const { data } = await invoicesReportsExportCreate({
        ...options,
        ...localOptions,
        throwOnError: true
      })

      return data
    }
  }

  return mutationOptions
}

export const invoicesSettingsRetrieveQueryKey = (
  options?: Options<InvoicesSettingsRetrieveData>
) => createQueryKey('invoicesSettingsRetrieve', options)

export const invoicesSettingsRetrieveOptions = (
  options?: Options<InvoicesSettingsRetrieveData>
) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await invoicesSettingsRetrieve({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true
      })

      return data
    },
    queryKey: invoicesSettingsRetrieveQueryKey(options)
  })
}

export const invoicesSettingsCreateQueryKey = (
  options: Options<InvoicesSettingsCreateData>
) => createQueryKey('invoicesSettingsCreate', options)

export const invoicesSettingsCreateOptions = (
  options: Options<InvoicesSettingsCreateData>
) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await invoicesSettingsCreate({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true
      })

      return data
    },
    queryKey: invoicesSettingsCreateQueryKey(options)
  })
}

export const invoicesSettingsCreateMutation = (
  options?: Partial<Options<InvoicesSettingsCreateData>>
): UseMutationOptions<
  InvoicesSettingsCreateResponse,
  AxiosError<DefaultError>,
  Options<InvoicesSettingsCreateData>
> => {
  const mutationOptions: UseMutationOptions<
    InvoicesSettingsCreateResponse,
    AxiosError<DefaultError>,
    Options<InvoicesSettingsCreateData>
  > = {
    mutationFn: async (localOptions) => {
      const { data } = await invoicesSettingsCreate({
        ...options,
        ...localOptions,
        throwOnError: true
      })

      return data
    }
  }

  return mutationOptions
}

export const leadGenerationCampaignsListQueryKey = (
  options?: Options<LeadGenerationCampaignsListData>
) => createQueryKey('leadGenerationCampaignsList', options)

export const leadGenerationCampaignsListOptions = (
  options?: Options<LeadGenerationCampaignsListData>
) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await leadGenerationCampaignsList({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true
      })

      return data
    },
    queryKey: leadGenerationCampaignsListQueryKey(options)
  })
}

export const leadGenerationCampaignsListInfiniteQueryKey = (
  options?: Options<LeadGenerationCampaignsListData>
): QueryKey<Options<LeadGenerationCampaignsListData>> =>
  createQueryKey('leadGenerationCampaignsList', options, true)

export const leadGenerationCampaignsListInfiniteOptions = (
  options?: Options<LeadGenerationCampaignsListData>
) => {
  return infiniteQueryOptions<
    LeadGenerationCampaignsListResponse,
    AxiosError<DefaultError>,
    InfiniteData<LeadGenerationCampaignsListResponse>,
    QueryKey<Options<LeadGenerationCampaignsListData>>,
    | number
    | Pick<
        QueryKey<Options<LeadGenerationCampaignsListData>>[0],
        'body' | 'headers' | 'path' | 'query'
      >
  >(
    // @ts-ignore
    {
      queryFn: async ({ pageParam, queryKey, signal }) => {
        // @ts-ignore
        const page: Pick<
          QueryKey<Options<LeadGenerationCampaignsListData>>[0],
          'body' | 'headers' | 'path' | 'query'
        > =
          typeof pageParam === 'object'
            ? pageParam
            : {
                query: {
                  page: pageParam
                }
              }
        const params = createInfiniteParams(queryKey, page)
        const { data } = await leadGenerationCampaignsList({
          ...options,
          ...params,
          signal,
          throwOnError: true
        })

        return data
      },
      queryKey: leadGenerationCampaignsListInfiniteQueryKey(options)
    }
  )
}

export const leadGenerationCampaignsRetrieveQueryKey = (
  options: Options<LeadGenerationCampaignsRetrieveData>
) => createQueryKey('leadGenerationCampaignsRetrieve', options)

export const leadGenerationCampaignsRetrieveOptions = (
  options: Options<LeadGenerationCampaignsRetrieveData>
) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await leadGenerationCampaignsRetrieve({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true
      })

      return data
    },
    queryKey: leadGenerationCampaignsRetrieveQueryKey(options)
  })
}

export const leadGenerationCampaignsPartialUpdateMutation = (
  options?: Partial<Options<LeadGenerationCampaignsPartialUpdateData>>
): UseMutationOptions<
  LeadGenerationCampaignsPartialUpdateResponse,
  AxiosError<DefaultError>,
  Options<LeadGenerationCampaignsPartialUpdateData>
> => {
  const mutationOptions: UseMutationOptions<
    LeadGenerationCampaignsPartialUpdateResponse,
    AxiosError<DefaultError>,
    Options<LeadGenerationCampaignsPartialUpdateData>
  > = {
    mutationFn: async (localOptions) => {
      const { data } = await leadGenerationCampaignsPartialUpdate({
        ...options,
        ...localOptions,
        throwOnError: true
      })

      return data
    }
  }

  return mutationOptions
}

export const leadGenerationCampaignsRunsListQueryKey = (
  options: Options<LeadGenerationCampaignsRunsListData>
) => createQueryKey('leadGenerationCampaignsRunsList', options)

/**
 * List this campaign's runs, most recent first (paginated).
 */
export const leadGenerationCampaignsRunsListOptions = (
  options: Options<LeadGenerationCampaignsRunsListData>
) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await leadGenerationCampaignsRunsList({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true
      })

      return data
    },
    queryKey: leadGenerationCampaignsRunsListQueryKey(options)
  })
}

export const leadGenerationCampaignsRunsListInfiniteQueryKey = (
  options: Options<LeadGenerationCampaignsRunsListData>
): QueryKey<Options<LeadGenerationCampaignsRunsListData>> =>
  createQueryKey('leadGenerationCampaignsRunsList', options, true)

/**
 * List this campaign's runs, most recent first (paginated).
 */
export const leadGenerationCampaignsRunsListInfiniteOptions = (
  options: Options<LeadGenerationCampaignsRunsListData>
) => {
  return infiniteQueryOptions<
    LeadGenerationCampaignsRunsListResponse,
    AxiosError<DefaultError>,
    InfiniteData<LeadGenerationCampaignsRunsListResponse>,
    QueryKey<Options<LeadGenerationCampaignsRunsListData>>,
    | number
    | Pick<
        QueryKey<Options<LeadGenerationCampaignsRunsListData>>[0],
        'body' | 'headers' | 'path' | 'query'
      >
  >(
    // @ts-ignore
    {
      queryFn: async ({ pageParam, queryKey, signal }) => {
        // @ts-ignore
        const page: Pick<
          QueryKey<Options<LeadGenerationCampaignsRunsListData>>[0],
          'body' | 'headers' | 'path' | 'query'
        > =
          typeof pageParam === 'object'
            ? pageParam
            : {
                query: {
                  page: pageParam
                }
              }
        const params = createInfiniteParams(queryKey, page)
        const { data } = await leadGenerationCampaignsRunsList({
          ...options,
          ...params,
          signal,
          throwOnError: true
        })

        return data
      },
      queryKey: leadGenerationCampaignsRunsListInfiniteQueryKey(options)
    }
  )
}

export const leadGenerationCampaignsTriggerCreateQueryKey = (
  options: Options<LeadGenerationCampaignsTriggerCreateData>
) => createQueryKey('leadGenerationCampaignsTriggerCreate', options)

/**
 * Start a manual run for the campaign, using the same logic as the scheduled run.
 */
export const leadGenerationCampaignsTriggerCreateOptions = (
  options: Options<LeadGenerationCampaignsTriggerCreateData>
) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await leadGenerationCampaignsTriggerCreate({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true
      })

      return data
    },
    queryKey: leadGenerationCampaignsTriggerCreateQueryKey(options)
  })
}

/**
 * Start a manual run for the campaign, using the same logic as the scheduled run.
 */
export const leadGenerationCampaignsTriggerCreateMutation = (
  options?: Partial<Options<LeadGenerationCampaignsTriggerCreateData>>
): UseMutationOptions<
  LeadGenerationCampaignsTriggerCreateResponse,
  AxiosError<DefaultError>,
  Options<LeadGenerationCampaignsTriggerCreateData>
> => {
  const mutationOptions: UseMutationOptions<
    LeadGenerationCampaignsTriggerCreateResponse,
    AxiosError<DefaultError>,
    Options<LeadGenerationCampaignsTriggerCreateData>
  > = {
    mutationFn: async (localOptions) => {
      const { data } = await leadGenerationCampaignsTriggerCreate({
        ...options,
        ...localOptions,
        throwOnError: true
      })

      return data
    }
  }

  return mutationOptions
}

export const leadGenerationRunsRetrieveQueryKey = (
  options: Options<LeadGenerationRunsRetrieveData>
) => createQueryKey('leadGenerationRunsRetrieve', options)

export const leadGenerationRunsRetrieveOptions = (
  options: Options<LeadGenerationRunsRetrieveData>
) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await leadGenerationRunsRetrieve({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true
      })

      return data
    },
    queryKey: leadGenerationRunsRetrieveQueryKey(options)
  })
}

export const leadScoreListQueryKey = (options?: Options<LeadScoreListData>) =>
  createQueryKey('leadScoreList', options)

export const leadScoreListOptions = (options?: Options<LeadScoreListData>) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await leadScoreList({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true
      })

      return data
    },
    queryKey: leadScoreListQueryKey(options)
  })
}

export const leadScoreListInfiniteQueryKey = (
  options?: Options<LeadScoreListData>
): QueryKey<Options<LeadScoreListData>> =>
  createQueryKey('leadScoreList', options, true)

export const leadScoreListInfiniteOptions = (
  options?: Options<LeadScoreListData>
) => {
  return infiniteQueryOptions<
    LeadScoreListResponse,
    AxiosError<DefaultError>,
    InfiniteData<LeadScoreListResponse>,
    QueryKey<Options<LeadScoreListData>>,
    | number
    | Pick<
        QueryKey<Options<LeadScoreListData>>[0],
        'body' | 'headers' | 'path' | 'query'
      >
  >(
    // @ts-ignore
    {
      queryFn: async ({ pageParam, queryKey, signal }) => {
        // @ts-ignore
        const page: Pick<
          QueryKey<Options<LeadScoreListData>>[0],
          'body' | 'headers' | 'path' | 'query'
        > =
          typeof pageParam === 'object'
            ? pageParam
            : {
                query: {
                  page: pageParam
                }
              }
        const params = createInfiniteParams(queryKey, page)
        const { data } = await leadScoreList({
          ...options,
          ...params,
          signal,
          throwOnError: true
        })

        return data
      },
      queryKey: leadScoreListInfiniteQueryKey(options)
    }
  )
}

export const leadScoreCreateQueryKey = (
  options: Options<LeadScoreCreateData>
) => createQueryKey('leadScoreCreate', options)

export const leadScoreCreateOptions = (
  options: Options<LeadScoreCreateData>
) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await leadScoreCreate({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true
      })

      return data
    },
    queryKey: leadScoreCreateQueryKey(options)
  })
}

export const leadScoreCreateMutation = (
  options?: Partial<Options<LeadScoreCreateData>>
): UseMutationOptions<
  LeadScoreCreateResponse,
  AxiosError<DefaultError>,
  Options<LeadScoreCreateData>
> => {
  const mutationOptions: UseMutationOptions<
    LeadScoreCreateResponse,
    AxiosError<DefaultError>,
    Options<LeadScoreCreateData>
  > = {
    mutationFn: async (localOptions) => {
      const { data } = await leadScoreCreate({
        ...options,
        ...localOptions,
        throwOnError: true
      })

      return data
    }
  }

  return mutationOptions
}

export const leadScoreDestroyMutation = (
  options?: Partial<Options<LeadScoreDestroyData>>
): UseMutationOptions<
  LeadScoreDestroyResponse,
  AxiosError<DefaultError>,
  Options<LeadScoreDestroyData>
> => {
  const mutationOptions: UseMutationOptions<
    LeadScoreDestroyResponse,
    AxiosError<DefaultError>,
    Options<LeadScoreDestroyData>
  > = {
    mutationFn: async (localOptions) => {
      const { data } = await leadScoreDestroy({
        ...options,
        ...localOptions,
        throwOnError: true
      })

      return data
    }
  }

  return mutationOptions
}

export const leadScoreRetrieveQueryKey = (
  options: Options<LeadScoreRetrieveData>
) => createQueryKey('leadScoreRetrieve', options)

export const leadScoreRetrieveOptions = (
  options: Options<LeadScoreRetrieveData>
) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await leadScoreRetrieve({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true
      })

      return data
    },
    queryKey: leadScoreRetrieveQueryKey(options)
  })
}

export const leadScorePartialUpdateMutation = (
  options?: Partial<Options<LeadScorePartialUpdateData>>
): UseMutationOptions<
  LeadScorePartialUpdateResponse,
  AxiosError<DefaultError>,
  Options<LeadScorePartialUpdateData>
> => {
  const mutationOptions: UseMutationOptions<
    LeadScorePartialUpdateResponse,
    AxiosError<DefaultError>,
    Options<LeadScorePartialUpdateData>
  > = {
    mutationFn: async (localOptions) => {
      const { data } = await leadScorePartialUpdate({
        ...options,
        ...localOptions,
        throwOnError: true
      })

      return data
    }
  }

  return mutationOptions
}

export const leadScoreUpdateMutation = (
  options?: Partial<Options<LeadScoreUpdateData>>
): UseMutationOptions<
  LeadScoreUpdateResponse,
  AxiosError<DefaultError>,
  Options<LeadScoreUpdateData>
> => {
  const mutationOptions: UseMutationOptions<
    LeadScoreUpdateResponse,
    AxiosError<DefaultError>,
    Options<LeadScoreUpdateData>
  > = {
    mutationFn: async (localOptions) => {
      const { data } = await leadScoreUpdate({
        ...options,
        ...localOptions,
        throwOnError: true
      })

      return data
    }
  }

  return mutationOptions
}

export const leadScoreFieldsRetrieveQueryKey = (
  options?: Options<LeadScoreFieldsRetrieveData>
) => createQueryKey('leadScoreFieldsRetrieve', options)

export const leadScoreFieldsRetrieveOptions = (
  options?: Options<LeadScoreFieldsRetrieveData>
) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await leadScoreFieldsRetrieve({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true
      })

      return data
    },
    queryKey: leadScoreFieldsRetrieveQueryKey(options)
  })
}

export const leadScoreListListQueryKey = (
  options?: Options<LeadScoreListListData>
) => createQueryKey('leadScoreListList', options)

export const leadScoreListListOptions = (
  options?: Options<LeadScoreListListData>
) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await leadScoreListList({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true
      })

      return data
    },
    queryKey: leadScoreListListQueryKey(options)
  })
}

export const leadScoreListListInfiniteQueryKey = (
  options?: Options<LeadScoreListListData>
): QueryKey<Options<LeadScoreListListData>> =>
  createQueryKey('leadScoreListList', options, true)

export const leadScoreListListInfiniteOptions = (
  options?: Options<LeadScoreListListData>
) => {
  return infiniteQueryOptions<
    LeadScoreListListResponse,
    AxiosError<DefaultError>,
    InfiniteData<LeadScoreListListResponse>,
    QueryKey<Options<LeadScoreListListData>>,
    | number
    | Pick<
        QueryKey<Options<LeadScoreListListData>>[0],
        'body' | 'headers' | 'path' | 'query'
      >
  >(
    // @ts-ignore
    {
      queryFn: async ({ pageParam, queryKey, signal }) => {
        // @ts-ignore
        const page: Pick<
          QueryKey<Options<LeadScoreListListData>>[0],
          'body' | 'headers' | 'path' | 'query'
        > =
          typeof pageParam === 'object'
            ? pageParam
            : {
                query: {
                  page: pageParam
                }
              }
        const params = createInfiniteParams(queryKey, page)
        const { data } = await leadScoreListList({
          ...options,
          ...params,
          signal,
          throwOnError: true
        })

        return data
      },
      queryKey: leadScoreListListInfiniteQueryKey(options)
    }
  )
}

export const leadsListQueryKey = (options?: Options<LeadsListData>) =>
  createQueryKey('leadsList', options)

export const leadsListOptions = (options?: Options<LeadsListData>) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await leadsList({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true
      })

      return data
    },
    queryKey: leadsListQueryKey(options)
  })
}

export const leadsListInfiniteQueryKey = (
  options?: Options<LeadsListData>
): QueryKey<Options<LeadsListData>> =>
  createQueryKey('leadsList', options, true)

export const leadsListInfiniteOptions = (options?: Options<LeadsListData>) => {
  return infiniteQueryOptions<
    LeadsListResponse,
    AxiosError<DefaultError>,
    InfiniteData<LeadsListResponse>,
    QueryKey<Options<LeadsListData>>,
    | number
    | Pick<
        QueryKey<Options<LeadsListData>>[0],
        'body' | 'headers' | 'path' | 'query'
      >
  >(
    // @ts-ignore
    {
      queryFn: async ({ pageParam, queryKey, signal }) => {
        // @ts-ignore
        const page: Pick<
          QueryKey<Options<LeadsListData>>[0],
          'body' | 'headers' | 'path' | 'query'
        > =
          typeof pageParam === 'object'
            ? pageParam
            : {
                query: {
                  page: pageParam
                }
              }
        const params = createInfiniteParams(queryKey, page)
        const { data } = await leadsList({
          ...options,
          ...params,
          signal,
          throwOnError: true
        })

        return data
      },
      queryKey: leadsListInfiniteQueryKey(options)
    }
  )
}

export const leadsCreateQueryKey = (options?: Options<LeadsCreateData>) =>
  createQueryKey('leadsCreate', options)

export const leadsCreateOptions = (options?: Options<LeadsCreateData>) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await leadsCreate({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true
      })

      return data
    },
    queryKey: leadsCreateQueryKey(options)
  })
}

export const leadsCreateMutation = (
  options?: Partial<Options<LeadsCreateData>>
): UseMutationOptions<
  LeadsCreateResponse,
  AxiosError<DefaultError>,
  Options<LeadsCreateData>
> => {
  const mutationOptions: UseMutationOptions<
    LeadsCreateResponse,
    AxiosError<DefaultError>,
    Options<LeadsCreateData>
  > = {
    mutationFn: async (localOptions) => {
      const { data } = await leadsCreate({
        ...options,
        ...localOptions,
        throwOnError: true
      })

      return data
    }
  }

  return mutationOptions
}

export const leadsImportListQueryKey = (
  options?: Options<LeadsImportListData>
) => createQueryKey('leadsImportList', options)

export const leadsImportListOptions = (
  options?: Options<LeadsImportListData>
) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await leadsImportList({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true
      })

      return data
    },
    queryKey: leadsImportListQueryKey(options)
  })
}

export const leadsImportListInfiniteQueryKey = (
  options?: Options<LeadsImportListData>
): QueryKey<Options<LeadsImportListData>> =>
  createQueryKey('leadsImportList', options, true)

export const leadsImportListInfiniteOptions = (
  options?: Options<LeadsImportListData>
) => {
  return infiniteQueryOptions<
    LeadsImportListResponse,
    AxiosError<DefaultError>,
    InfiniteData<LeadsImportListResponse>,
    QueryKey<Options<LeadsImportListData>>,
    | number
    | Pick<
        QueryKey<Options<LeadsImportListData>>[0],
        'body' | 'headers' | 'path' | 'query'
      >
  >(
    // @ts-ignore
    {
      queryFn: async ({ pageParam, queryKey, signal }) => {
        // @ts-ignore
        const page: Pick<
          QueryKey<Options<LeadsImportListData>>[0],
          'body' | 'headers' | 'path' | 'query'
        > =
          typeof pageParam === 'object'
            ? pageParam
            : {
                query: {
                  page: pageParam
                }
              }
        const params = createInfiniteParams(queryKey, page)
        const { data } = await leadsImportList({
          ...options,
          ...params,
          signal,
          throwOnError: true
        })

        return data
      },
      queryKey: leadsImportListInfiniteQueryKey(options)
    }
  )
}

export const leadsImportCreateQueryKey = (
  options?: Options<LeadsImportCreateData>
) => createQueryKey('leadsImportCreate', options)

export const leadsImportCreateOptions = (
  options?: Options<LeadsImportCreateData>
) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await leadsImportCreate({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true
      })

      return data
    },
    queryKey: leadsImportCreateQueryKey(options)
  })
}

export const leadsImportCreateMutation = (
  options?: Partial<Options<LeadsImportCreateData>>
): UseMutationOptions<
  LeadsImportCreateResponse,
  AxiosError<DefaultError>,
  Options<LeadsImportCreateData>
> => {
  const mutationOptions: UseMutationOptions<
    LeadsImportCreateResponse,
    AxiosError<DefaultError>,
    Options<LeadsImportCreateData>
  > = {
    mutationFn: async (localOptions) => {
      const { data } = await leadsImportCreate({
        ...options,
        ...localOptions,
        throwOnError: true
      })

      return data
    }
  }

  return mutationOptions
}

export const leadsImportDestroyMutation = (
  options?: Partial<Options<LeadsImportDestroyData>>
): UseMutationOptions<
  LeadsImportDestroyResponse,
  AxiosError<DefaultError>,
  Options<LeadsImportDestroyData>
> => {
  const mutationOptions: UseMutationOptions<
    LeadsImportDestroyResponse,
    AxiosError<DefaultError>,
    Options<LeadsImportDestroyData>
  > = {
    mutationFn: async (localOptions) => {
      const { data } = await leadsImportDestroy({
        ...options,
        ...localOptions,
        throwOnError: true
      })

      return data
    }
  }

  return mutationOptions
}

export const leadsImportRetrieveQueryKey = (
  options: Options<LeadsImportRetrieveData>
) => createQueryKey('leadsImportRetrieve', options)

export const leadsImportRetrieveOptions = (
  options: Options<LeadsImportRetrieveData>
) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await leadsImportRetrieve({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true
      })

      return data
    },
    queryKey: leadsImportRetrieveQueryKey(options)
  })
}

export const leadsImportPartialUpdateMutation = (
  options?: Partial<Options<LeadsImportPartialUpdateData>>
): UseMutationOptions<
  LeadsImportPartialUpdateResponse,
  AxiosError<DefaultError>,
  Options<LeadsImportPartialUpdateData>
> => {
  const mutationOptions: UseMutationOptions<
    LeadsImportPartialUpdateResponse,
    AxiosError<DefaultError>,
    Options<LeadsImportPartialUpdateData>
  > = {
    mutationFn: async (localOptions) => {
      const { data } = await leadsImportPartialUpdate({
        ...options,
        ...localOptions,
        throwOnError: true
      })

      return data
    }
  }

  return mutationOptions
}

export const leadsImportUpdateMutation = (
  options?: Partial<Options<LeadsImportUpdateData>>
): UseMutationOptions<
  LeadsImportUpdateResponse,
  AxiosError<DefaultError>,
  Options<LeadsImportUpdateData>
> => {
  const mutationOptions: UseMutationOptions<
    LeadsImportUpdateResponse,
    AxiosError<DefaultError>,
    Options<LeadsImportUpdateData>
  > = {
    mutationFn: async (localOptions) => {
      const { data } = await leadsImportUpdate({
        ...options,
        ...localOptions,
        throwOnError: true
      })

      return data
    }
  }

  return mutationOptions
}

export const leadsImportColumnUniqueValuesRetrieveQueryKey = (
  options: Options<LeadsImportColumnUniqueValuesRetrieveData>
) => createQueryKey('leadsImportColumnUniqueValuesRetrieve', options)

export const leadsImportColumnUniqueValuesRetrieveOptions = (
  options: Options<LeadsImportColumnUniqueValuesRetrieveData>
) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await leadsImportColumnUniqueValuesRetrieve({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true
      })

      return data
    },
    queryKey: leadsImportColumnUniqueValuesRetrieveQueryKey(options)
  })
}

export const leadsImportPreviewRetrieveQueryKey = (
  options: Options<LeadsImportPreviewRetrieveData>
) => createQueryKey('leadsImportPreviewRetrieve', options)

/**
 * Endpoint for getting preview from csv/excel files
 */
export const leadsImportPreviewRetrieveOptions = (
  options: Options<LeadsImportPreviewRetrieveData>
) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await leadsImportPreviewRetrieve({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true
      })

      return data
    },
    queryKey: leadsImportPreviewRetrieveQueryKey(options)
  })
}

export const leadsImportHeadersRetrieveQueryKey = (
  options?: Options<LeadsImportHeadersRetrieveData>
) => createQueryKey('leadsImportHeadersRetrieve', options)

/**
 * Returns lead and contact header fields for file preview
 */
export const leadsImportHeadersRetrieveOptions = (
  options?: Options<LeadsImportHeadersRetrieveData>
) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await leadsImportHeadersRetrieve({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true
      })

      return data
    },
    queryKey: leadsImportHeadersRetrieveQueryKey(options)
  })
}

export const leadsImportUniqueFieldsRetrieveQueryKey = (
  options?: Options<LeadsImportUniqueFieldsRetrieveData>
) => createQueryKey('leadsImportUniqueFieldsRetrieve', options)

/**
 * Endpoint for getting unique fields for file check duplicates
 */
export const leadsImportUniqueFieldsRetrieveOptions = (
  options?: Options<LeadsImportUniqueFieldsRetrieveData>
) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await leadsImportUniqueFieldsRetrieve({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true
      })

      return data
    },
    queryKey: leadsImportUniqueFieldsRetrieveQueryKey(options)
  })
}

export const leadsStatusesListQueryKey = (
  options?: Options<LeadsStatusesListData>
) => createQueryKey('leadsStatusesList', options)

export const leadsStatusesListOptions = (
  options?: Options<LeadsStatusesListData>
) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await leadsStatusesList({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true
      })

      return data
    },
    queryKey: leadsStatusesListQueryKey(options)
  })
}

export const leadsStatusesListInfiniteQueryKey = (
  options?: Options<LeadsStatusesListData>
): QueryKey<Options<LeadsStatusesListData>> =>
  createQueryKey('leadsStatusesList', options, true)

export const leadsStatusesListInfiniteOptions = (
  options?: Options<LeadsStatusesListData>
) => {
  return infiniteQueryOptions<
    LeadsStatusesListResponse,
    AxiosError<DefaultError>,
    InfiniteData<LeadsStatusesListResponse>,
    QueryKey<Options<LeadsStatusesListData>>,
    | number
    | Pick<
        QueryKey<Options<LeadsStatusesListData>>[0],
        'body' | 'headers' | 'path' | 'query'
      >
  >(
    // @ts-ignore
    {
      queryFn: async ({ pageParam, queryKey, signal }) => {
        // @ts-ignore
        const page: Pick<
          QueryKey<Options<LeadsStatusesListData>>[0],
          'body' | 'headers' | 'path' | 'query'
        > =
          typeof pageParam === 'object'
            ? pageParam
            : {
                query: {
                  page: pageParam
                }
              }
        const params = createInfiniteParams(queryKey, page)
        const { data } = await leadsStatusesList({
          ...options,
          ...params,
          signal,
          throwOnError: true
        })

        return data
      },
      queryKey: leadsStatusesListInfiniteQueryKey(options)
    }
  )
}

export const leadsStatusesCreateQueryKey = (
  options: Options<LeadsStatusesCreateData>
) => createQueryKey('leadsStatusesCreate', options)

export const leadsStatusesCreateOptions = (
  options: Options<LeadsStatusesCreateData>
) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await leadsStatusesCreate({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true
      })

      return data
    },
    queryKey: leadsStatusesCreateQueryKey(options)
  })
}

export const leadsStatusesCreateMutation = (
  options?: Partial<Options<LeadsStatusesCreateData>>
): UseMutationOptions<
  LeadsStatusesCreateResponse,
  AxiosError<DefaultError>,
  Options<LeadsStatusesCreateData>
> => {
  const mutationOptions: UseMutationOptions<
    LeadsStatusesCreateResponse,
    AxiosError<DefaultError>,
    Options<LeadsStatusesCreateData>
  > = {
    mutationFn: async (localOptions) => {
      const { data } = await leadsStatusesCreate({
        ...options,
        ...localOptions,
        throwOnError: true
      })

      return data
    }
  }

  return mutationOptions
}

export const leadsStatusesDestroyMutation = (
  options?: Partial<Options<LeadsStatusesDestroyData>>
): UseMutationOptions<
  LeadsStatusesDestroyResponse,
  AxiosError<DefaultError>,
  Options<LeadsStatusesDestroyData>
> => {
  const mutationOptions: UseMutationOptions<
    LeadsStatusesDestroyResponse,
    AxiosError<DefaultError>,
    Options<LeadsStatusesDestroyData>
  > = {
    mutationFn: async (localOptions) => {
      const { data } = await leadsStatusesDestroy({
        ...options,
        ...localOptions,
        throwOnError: true
      })

      return data
    }
  }

  return mutationOptions
}

export const leadsStatusesRetrieveQueryKey = (
  options: Options<LeadsStatusesRetrieveData>
) => createQueryKey('leadsStatusesRetrieve', options)

export const leadsStatusesRetrieveOptions = (
  options: Options<LeadsStatusesRetrieveData>
) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await leadsStatusesRetrieve({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true
      })

      return data
    },
    queryKey: leadsStatusesRetrieveQueryKey(options)
  })
}

export const leadsStatusesPartialUpdateMutation = (
  options?: Partial<Options<LeadsStatusesPartialUpdateData>>
): UseMutationOptions<
  LeadsStatusesPartialUpdateResponse,
  AxiosError<DefaultError>,
  Options<LeadsStatusesPartialUpdateData>
> => {
  const mutationOptions: UseMutationOptions<
    LeadsStatusesPartialUpdateResponse,
    AxiosError<DefaultError>,
    Options<LeadsStatusesPartialUpdateData>
  > = {
    mutationFn: async (localOptions) => {
      const { data } = await leadsStatusesPartialUpdate({
        ...options,
        ...localOptions,
        throwOnError: true
      })

      return data
    }
  }

  return mutationOptions
}

export const leadsStatusesUpdateMutation = (
  options?: Partial<Options<LeadsStatusesUpdateData>>
): UseMutationOptions<
  LeadsStatusesUpdateResponse,
  AxiosError<DefaultError>,
  Options<LeadsStatusesUpdateData>
> => {
  const mutationOptions: UseMutationOptions<
    LeadsStatusesUpdateResponse,
    AxiosError<DefaultError>,
    Options<LeadsStatusesUpdateData>
  > = {
    mutationFn: async (localOptions) => {
      const { data } = await leadsStatusesUpdate({
        ...options,
        ...localOptions,
        throwOnError: true
      })

      return data
    }
  }

  return mutationOptions
}

export const leadsStatusesListListQueryKey = (
  options?: Options<LeadsStatusesListListData>
) => createQueryKey('leadsStatusesListList', options)

export const leadsStatusesListListOptions = (
  options?: Options<LeadsStatusesListListData>
) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await leadsStatusesListList({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true
      })

      return data
    },
    queryKey: leadsStatusesListListQueryKey(options)
  })
}

export const leadsStatusesListListInfiniteQueryKey = (
  options?: Options<LeadsStatusesListListData>
): QueryKey<Options<LeadsStatusesListListData>> =>
  createQueryKey('leadsStatusesListList', options, true)

export const leadsStatusesListListInfiniteOptions = (
  options?: Options<LeadsStatusesListListData>
) => {
  return infiniteQueryOptions<
    LeadsStatusesListListResponse,
    AxiosError<DefaultError>,
    InfiniteData<LeadsStatusesListListResponse>,
    QueryKey<Options<LeadsStatusesListListData>>,
    | number
    | Pick<
        QueryKey<Options<LeadsStatusesListListData>>[0],
        'body' | 'headers' | 'path' | 'query'
      >
  >(
    // @ts-ignore
    {
      queryFn: async ({ pageParam, queryKey, signal }) => {
        // @ts-ignore
        const page: Pick<
          QueryKey<Options<LeadsStatusesListListData>>[0],
          'body' | 'headers' | 'path' | 'query'
        > =
          typeof pageParam === 'object'
            ? pageParam
            : {
                query: {
                  page: pageParam
                }
              }
        const params = createInfiniteParams(queryKey, page)
        const { data } = await leadsStatusesListList({
          ...options,
          ...params,
          signal,
          throwOnError: true
        })

        return data
      },
      queryKey: leadsStatusesListListInfiniteQueryKey(options)
    }
  )
}

export const leadsTypesListQueryKey = (options?: Options<LeadsTypesListData>) =>
  createQueryKey('leadsTypesList', options)

export const leadsTypesListOptions = (
  options?: Options<LeadsTypesListData>
) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await leadsTypesList({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true
      })

      return data
    },
    queryKey: leadsTypesListQueryKey(options)
  })
}

export const leadsTypesListInfiniteQueryKey = (
  options?: Options<LeadsTypesListData>
): QueryKey<Options<LeadsTypesListData>> =>
  createQueryKey('leadsTypesList', options, true)

export const leadsTypesListInfiniteOptions = (
  options?: Options<LeadsTypesListData>
) => {
  return infiniteQueryOptions<
    LeadsTypesListResponse,
    AxiosError<DefaultError>,
    InfiniteData<LeadsTypesListResponse>,
    QueryKey<Options<LeadsTypesListData>>,
    | number
    | Pick<
        QueryKey<Options<LeadsTypesListData>>[0],
        'body' | 'headers' | 'path' | 'query'
      >
  >(
    // @ts-ignore
    {
      queryFn: async ({ pageParam, queryKey, signal }) => {
        // @ts-ignore
        const page: Pick<
          QueryKey<Options<LeadsTypesListData>>[0],
          'body' | 'headers' | 'path' | 'query'
        > =
          typeof pageParam === 'object'
            ? pageParam
            : {
                query: {
                  page: pageParam
                }
              }
        const params = createInfiniteParams(queryKey, page)
        const { data } = await leadsTypesList({
          ...options,
          ...params,
          signal,
          throwOnError: true
        })

        return data
      },
      queryKey: leadsTypesListInfiniteQueryKey(options)
    }
  )
}

export const leadsTypesCreateQueryKey = (
  options: Options<LeadsTypesCreateData>
) => createQueryKey('leadsTypesCreate', options)

export const leadsTypesCreateOptions = (
  options: Options<LeadsTypesCreateData>
) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await leadsTypesCreate({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true
      })

      return data
    },
    queryKey: leadsTypesCreateQueryKey(options)
  })
}

export const leadsTypesCreateMutation = (
  options?: Partial<Options<LeadsTypesCreateData>>
): UseMutationOptions<
  LeadsTypesCreateResponse,
  AxiosError<DefaultError>,
  Options<LeadsTypesCreateData>
> => {
  const mutationOptions: UseMutationOptions<
    LeadsTypesCreateResponse,
    AxiosError<DefaultError>,
    Options<LeadsTypesCreateData>
  > = {
    mutationFn: async (localOptions) => {
      const { data } = await leadsTypesCreate({
        ...options,
        ...localOptions,
        throwOnError: true
      })

      return data
    }
  }

  return mutationOptions
}

export const leadsTypesLeadsStatusesListQueryKey = (
  options: Options<LeadsTypesLeadsStatusesListData>
) => createQueryKey('leadsTypesLeadsStatusesList', options)

export const leadsTypesLeadsStatusesListOptions = (
  options: Options<LeadsTypesLeadsStatusesListData>
) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await leadsTypesLeadsStatusesList({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true
      })

      return data
    },
    queryKey: leadsTypesLeadsStatusesListQueryKey(options)
  })
}

export const leadsTypesLeadsStatusesListInfiniteQueryKey = (
  options: Options<LeadsTypesLeadsStatusesListData>
): QueryKey<Options<LeadsTypesLeadsStatusesListData>> =>
  createQueryKey('leadsTypesLeadsStatusesList', options, true)

export const leadsTypesLeadsStatusesListInfiniteOptions = (
  options: Options<LeadsTypesLeadsStatusesListData>
) => {
  return infiniteQueryOptions<
    LeadsTypesLeadsStatusesListResponse,
    AxiosError<DefaultError>,
    InfiniteData<LeadsTypesLeadsStatusesListResponse>,
    QueryKey<Options<LeadsTypesLeadsStatusesListData>>,
    | number
    | Pick<
        QueryKey<Options<LeadsTypesLeadsStatusesListData>>[0],
        'body' | 'headers' | 'path' | 'query'
      >
  >(
    // @ts-ignore
    {
      queryFn: async ({ pageParam, queryKey, signal }) => {
        // @ts-ignore
        const page: Pick<
          QueryKey<Options<LeadsTypesLeadsStatusesListData>>[0],
          'body' | 'headers' | 'path' | 'query'
        > =
          typeof pageParam === 'object'
            ? pageParam
            : {
                query: {
                  page: pageParam
                }
              }
        const params = createInfiniteParams(queryKey, page)
        const { data } = await leadsTypesLeadsStatusesList({
          ...options,
          ...params,
          signal,
          throwOnError: true
        })

        return data
      },
      queryKey: leadsTypesLeadsStatusesListInfiniteQueryKey(options)
    }
  )
}

export const leadsTypesLeadsStatusesCreateQueryKey = (
  options: Options<LeadsTypesLeadsStatusesCreateData>
) => createQueryKey('leadsTypesLeadsStatusesCreate', options)

export const leadsTypesLeadsStatusesCreateOptions = (
  options: Options<LeadsTypesLeadsStatusesCreateData>
) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await leadsTypesLeadsStatusesCreate({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true
      })

      return data
    },
    queryKey: leadsTypesLeadsStatusesCreateQueryKey(options)
  })
}

export const leadsTypesLeadsStatusesCreateMutation = (
  options?: Partial<Options<LeadsTypesLeadsStatusesCreateData>>
): UseMutationOptions<
  LeadsTypesLeadsStatusesCreateResponse,
  AxiosError<DefaultError>,
  Options<LeadsTypesLeadsStatusesCreateData>
> => {
  const mutationOptions: UseMutationOptions<
    LeadsTypesLeadsStatusesCreateResponse,
    AxiosError<DefaultError>,
    Options<LeadsTypesLeadsStatusesCreateData>
  > = {
    mutationFn: async (localOptions) => {
      const { data } = await leadsTypesLeadsStatusesCreate({
        ...options,
        ...localOptions,
        throwOnError: true
      })

      return data
    }
  }

  return mutationOptions
}

export const leadsTypesLeadsStatusesDestroyMutation = (
  options?: Partial<Options<LeadsTypesLeadsStatusesDestroyData>>
): UseMutationOptions<
  LeadsTypesLeadsStatusesDestroyResponse,
  AxiosError<DefaultError>,
  Options<LeadsTypesLeadsStatusesDestroyData>
> => {
  const mutationOptions: UseMutationOptions<
    LeadsTypesLeadsStatusesDestroyResponse,
    AxiosError<DefaultError>,
    Options<LeadsTypesLeadsStatusesDestroyData>
  > = {
    mutationFn: async (localOptions) => {
      const { data } = await leadsTypesLeadsStatusesDestroy({
        ...options,
        ...localOptions,
        throwOnError: true
      })

      return data
    }
  }

  return mutationOptions
}

export const leadsTypesLeadsStatusesRetrieveQueryKey = (
  options: Options<LeadsTypesLeadsStatusesRetrieveData>
) => createQueryKey('leadsTypesLeadsStatusesRetrieve', options)

export const leadsTypesLeadsStatusesRetrieveOptions = (
  options: Options<LeadsTypesLeadsStatusesRetrieveData>
) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await leadsTypesLeadsStatusesRetrieve({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true
      })

      return data
    },
    queryKey: leadsTypesLeadsStatusesRetrieveQueryKey(options)
  })
}

export const leadsTypesLeadsStatusesPartialUpdateMutation = (
  options?: Partial<Options<LeadsTypesLeadsStatusesPartialUpdateData>>
): UseMutationOptions<
  LeadsTypesLeadsStatusesPartialUpdateResponse,
  AxiosError<DefaultError>,
  Options<LeadsTypesLeadsStatusesPartialUpdateData>
> => {
  const mutationOptions: UseMutationOptions<
    LeadsTypesLeadsStatusesPartialUpdateResponse,
    AxiosError<DefaultError>,
    Options<LeadsTypesLeadsStatusesPartialUpdateData>
  > = {
    mutationFn: async (localOptions) => {
      const { data } = await leadsTypesLeadsStatusesPartialUpdate({
        ...options,
        ...localOptions,
        throwOnError: true
      })

      return data
    }
  }

  return mutationOptions
}

export const leadsTypesLeadsStatusesUpdateMutation = (
  options?: Partial<Options<LeadsTypesLeadsStatusesUpdateData>>
): UseMutationOptions<
  LeadsTypesLeadsStatusesUpdateResponse,
  AxiosError<DefaultError>,
  Options<LeadsTypesLeadsStatusesUpdateData>
> => {
  const mutationOptions: UseMutationOptions<
    LeadsTypesLeadsStatusesUpdateResponse,
    AxiosError<DefaultError>,
    Options<LeadsTypesLeadsStatusesUpdateData>
  > = {
    mutationFn: async (localOptions) => {
      const { data } = await leadsTypesLeadsStatusesUpdate({
        ...options,
        ...localOptions,
        throwOnError: true
      })

      return data
    }
  }

  return mutationOptions
}

export const leadsTypesLeadsStatusesListListQueryKey = (
  options: Options<LeadsTypesLeadsStatusesListListData>
) => createQueryKey('leadsTypesLeadsStatusesListList', options)

export const leadsTypesLeadsStatusesListListOptions = (
  options: Options<LeadsTypesLeadsStatusesListListData>
) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await leadsTypesLeadsStatusesListList({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true
      })

      return data
    },
    queryKey: leadsTypesLeadsStatusesListListQueryKey(options)
  })
}

export const leadsTypesLeadsStatusesListListInfiniteQueryKey = (
  options: Options<LeadsTypesLeadsStatusesListListData>
): QueryKey<Options<LeadsTypesLeadsStatusesListListData>> =>
  createQueryKey('leadsTypesLeadsStatusesListList', options, true)

export const leadsTypesLeadsStatusesListListInfiniteOptions = (
  options: Options<LeadsTypesLeadsStatusesListListData>
) => {
  return infiniteQueryOptions<
    LeadsTypesLeadsStatusesListListResponse,
    AxiosError<DefaultError>,
    InfiniteData<LeadsTypesLeadsStatusesListListResponse>,
    QueryKey<Options<LeadsTypesLeadsStatusesListListData>>,
    | number
    | Pick<
        QueryKey<Options<LeadsTypesLeadsStatusesListListData>>[0],
        'body' | 'headers' | 'path' | 'query'
      >
  >(
    // @ts-ignore
    {
      queryFn: async ({ pageParam, queryKey, signal }) => {
        // @ts-ignore
        const page: Pick<
          QueryKey<Options<LeadsTypesLeadsStatusesListListData>>[0],
          'body' | 'headers' | 'path' | 'query'
        > =
          typeof pageParam === 'object'
            ? pageParam
            : {
                query: {
                  page: pageParam
                }
              }
        const params = createInfiniteParams(queryKey, page)
        const { data } = await leadsTypesLeadsStatusesListList({
          ...options,
          ...params,
          signal,
          throwOnError: true
        })

        return data
      },
      queryKey: leadsTypesLeadsStatusesListListInfiniteQueryKey(options)
    }
  )
}

export const leadsTypesDestroyMutation = (
  options?: Partial<Options<LeadsTypesDestroyData>>
): UseMutationOptions<
  LeadsTypesDestroyResponse,
  AxiosError<DefaultError>,
  Options<LeadsTypesDestroyData>
> => {
  const mutationOptions: UseMutationOptions<
    LeadsTypesDestroyResponse,
    AxiosError<DefaultError>,
    Options<LeadsTypesDestroyData>
  > = {
    mutationFn: async (localOptions) => {
      const { data } = await leadsTypesDestroy({
        ...options,
        ...localOptions,
        throwOnError: true
      })

      return data
    }
  }

  return mutationOptions
}

export const leadsTypesRetrieveQueryKey = (
  options: Options<LeadsTypesRetrieveData>
) => createQueryKey('leadsTypesRetrieve', options)

export const leadsTypesRetrieveOptions = (
  options: Options<LeadsTypesRetrieveData>
) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await leadsTypesRetrieve({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true
      })

      return data
    },
    queryKey: leadsTypesRetrieveQueryKey(options)
  })
}

export const leadsTypesPartialUpdateMutation = (
  options?: Partial<Options<LeadsTypesPartialUpdateData>>
): UseMutationOptions<
  LeadsTypesPartialUpdateResponse,
  AxiosError<DefaultError>,
  Options<LeadsTypesPartialUpdateData>
> => {
  const mutationOptions: UseMutationOptions<
    LeadsTypesPartialUpdateResponse,
    AxiosError<DefaultError>,
    Options<LeadsTypesPartialUpdateData>
  > = {
    mutationFn: async (localOptions) => {
      const { data } = await leadsTypesPartialUpdate({
        ...options,
        ...localOptions,
        throwOnError: true
      })

      return data
    }
  }

  return mutationOptions
}

export const leadsTypesUpdateMutation = (
  options?: Partial<Options<LeadsTypesUpdateData>>
): UseMutationOptions<
  LeadsTypesUpdateResponse,
  AxiosError<DefaultError>,
  Options<LeadsTypesUpdateData>
> => {
  const mutationOptions: UseMutationOptions<
    LeadsTypesUpdateResponse,
    AxiosError<DefaultError>,
    Options<LeadsTypesUpdateData>
  > = {
    mutationFn: async (localOptions) => {
      const { data } = await leadsTypesUpdate({
        ...options,
        ...localOptions,
        throwOnError: true
      })

      return data
    }
  }

  return mutationOptions
}

export const leadsTypesListListQueryKey = (
  options?: Options<LeadsTypesListListData>
) => createQueryKey('leadsTypesListList', options)

export const leadsTypesListListOptions = (
  options?: Options<LeadsTypesListListData>
) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await leadsTypesListList({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true
      })

      return data
    },
    queryKey: leadsTypesListListQueryKey(options)
  })
}

export const leadsTypesListListInfiniteQueryKey = (
  options?: Options<LeadsTypesListListData>
): QueryKey<Options<LeadsTypesListListData>> =>
  createQueryKey('leadsTypesListList', options, true)

export const leadsTypesListListInfiniteOptions = (
  options?: Options<LeadsTypesListListData>
) => {
  return infiniteQueryOptions<
    LeadsTypesListListResponse,
    AxiosError<DefaultError>,
    InfiniteData<LeadsTypesListListResponse>,
    QueryKey<Options<LeadsTypesListListData>>,
    | number
    | Pick<
        QueryKey<Options<LeadsTypesListListData>>[0],
        'body' | 'headers' | 'path' | 'query'
      >
  >(
    // @ts-ignore
    {
      queryFn: async ({ pageParam, queryKey, signal }) => {
        // @ts-ignore
        const page: Pick<
          QueryKey<Options<LeadsTypesListListData>>[0],
          'body' | 'headers' | 'path' | 'query'
        > =
          typeof pageParam === 'object'
            ? pageParam
            : {
                query: {
                  page: pageParam
                }
              }
        const params = createInfiniteParams(queryKey, page)
        const { data } = await leadsTypesListList({
          ...options,
          ...params,
          signal,
          throwOnError: true
        })

        return data
      },
      queryKey: leadsTypesListListInfiniteQueryKey(options)
    }
  )
}

export const leadsContactsListQueryKey = (
  options: Options<LeadsContactsListData>
) => createQueryKey('leadsContactsList', options)

export const leadsContactsListOptions = (
  options: Options<LeadsContactsListData>
) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await leadsContactsList({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true
      })

      return data
    },
    queryKey: leadsContactsListQueryKey(options)
  })
}

export const leadsContactsListInfiniteQueryKey = (
  options: Options<LeadsContactsListData>
): QueryKey<Options<LeadsContactsListData>> =>
  createQueryKey('leadsContactsList', options, true)

export const leadsContactsListInfiniteOptions = (
  options: Options<LeadsContactsListData>
) => {
  return infiniteQueryOptions<
    LeadsContactsListResponse,
    AxiosError<DefaultError>,
    InfiniteData<LeadsContactsListResponse>,
    QueryKey<Options<LeadsContactsListData>>,
    | number
    | Pick<
        QueryKey<Options<LeadsContactsListData>>[0],
        'body' | 'headers' | 'path' | 'query'
      >
  >(
    // @ts-ignore
    {
      queryFn: async ({ pageParam, queryKey, signal }) => {
        // @ts-ignore
        const page: Pick<
          QueryKey<Options<LeadsContactsListData>>[0],
          'body' | 'headers' | 'path' | 'query'
        > =
          typeof pageParam === 'object'
            ? pageParam
            : {
                query: {
                  page: pageParam
                }
              }
        const params = createInfiniteParams(queryKey, page)
        const { data } = await leadsContactsList({
          ...options,
          ...params,
          signal,
          throwOnError: true
        })

        return data
      },
      queryKey: leadsContactsListInfiniteQueryKey(options)
    }
  )
}

export const leadsContractsListQueryKey = (
  options: Options<LeadsContractsListData>
) => createQueryKey('leadsContractsList', options)

export const leadsContractsListOptions = (
  options: Options<LeadsContractsListData>
) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await leadsContractsList({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true
      })

      return data
    },
    queryKey: leadsContractsListQueryKey(options)
  })
}

export const leadsContractsListInfiniteQueryKey = (
  options: Options<LeadsContractsListData>
): QueryKey<Options<LeadsContractsListData>> =>
  createQueryKey('leadsContractsList', options, true)

export const leadsContractsListInfiniteOptions = (
  options: Options<LeadsContractsListData>
) => {
  return infiniteQueryOptions<
    LeadsContractsListResponse,
    AxiosError<DefaultError>,
    InfiniteData<LeadsContractsListResponse>,
    QueryKey<Options<LeadsContractsListData>>,
    | number
    | Pick<
        QueryKey<Options<LeadsContractsListData>>[0],
        'body' | 'headers' | 'path' | 'query'
      >
  >(
    // @ts-ignore
    {
      queryFn: async ({ pageParam, queryKey, signal }) => {
        // @ts-ignore
        const page: Pick<
          QueryKey<Options<LeadsContractsListData>>[0],
          'body' | 'headers' | 'path' | 'query'
        > =
          typeof pageParam === 'object'
            ? pageParam
            : {
                query: {
                  page: pageParam
                }
              }
        const params = createInfiniteParams(queryKey, page)
        const { data } = await leadsContractsList({
          ...options,
          ...params,
          signal,
          throwOnError: true
        })

        return data
      },
      queryKey: leadsContractsListInfiniteQueryKey(options)
    }
  )
}

export const leadsDocumentsListQueryKey = (
  options: Options<LeadsDocumentsListData>
) => createQueryKey('leadsDocumentsList', options)

export const leadsDocumentsListOptions = (
  options: Options<LeadsDocumentsListData>
) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await leadsDocumentsList({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true
      })

      return data
    },
    queryKey: leadsDocumentsListQueryKey(options)
  })
}

export const leadsDocumentsListInfiniteQueryKey = (
  options: Options<LeadsDocumentsListData>
): QueryKey<Options<LeadsDocumentsListData>> =>
  createQueryKey('leadsDocumentsList', options, true)

export const leadsDocumentsListInfiniteOptions = (
  options: Options<LeadsDocumentsListData>
) => {
  return infiniteQueryOptions<
    LeadsDocumentsListResponse,
    AxiosError<DefaultError>,
    InfiniteData<LeadsDocumentsListResponse>,
    QueryKey<Options<LeadsDocumentsListData>>,
    | number
    | Pick<
        QueryKey<Options<LeadsDocumentsListData>>[0],
        'body' | 'headers' | 'path' | 'query'
      >
  >(
    // @ts-ignore
    {
      queryFn: async ({ pageParam, queryKey, signal }) => {
        // @ts-ignore
        const page: Pick<
          QueryKey<Options<LeadsDocumentsListData>>[0],
          'body' | 'headers' | 'path' | 'query'
        > =
          typeof pageParam === 'object'
            ? pageParam
            : {
                query: {
                  page: pageParam
                }
              }
        const params = createInfiniteParams(queryKey, page)
        const { data } = await leadsDocumentsList({
          ...options,
          ...params,
          signal,
          throwOnError: true
        })

        return data
      },
      queryKey: leadsDocumentsListInfiniteQueryKey(options)
    }
  )
}

export const leadsLogsListQueryKey = (options: Options<LeadsLogsListData>) =>
  createQueryKey('leadsLogsList', options)

export const leadsLogsListOptions = (options: Options<LeadsLogsListData>) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await leadsLogsList({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true
      })

      return data
    },
    queryKey: leadsLogsListQueryKey(options)
  })
}

export const leadsLogsListInfiniteQueryKey = (
  options: Options<LeadsLogsListData>
): QueryKey<Options<LeadsLogsListData>> =>
  createQueryKey('leadsLogsList', options, true)

export const leadsLogsListInfiniteOptions = (
  options: Options<LeadsLogsListData>
) => {
  return infiniteQueryOptions<
    LeadsLogsListResponse,
    AxiosError<DefaultError>,
    InfiniteData<LeadsLogsListResponse>,
    QueryKey<Options<LeadsLogsListData>>,
    | number
    | Pick<
        QueryKey<Options<LeadsLogsListData>>[0],
        'body' | 'headers' | 'path' | 'query'
      >
  >(
    // @ts-ignore
    {
      queryFn: async ({ pageParam, queryKey, signal }) => {
        // @ts-ignore
        const page: Pick<
          QueryKey<Options<LeadsLogsListData>>[0],
          'body' | 'headers' | 'path' | 'query'
        > =
          typeof pageParam === 'object'
            ? pageParam
            : {
                query: {
                  page: pageParam
                }
              }
        const params = createInfiniteParams(queryKey, page)
        const { data } = await leadsLogsList({
          ...options,
          ...params,
          signal,
          throwOnError: true
        })

        return data
      },
      queryKey: leadsLogsListInfiniteQueryKey(options)
    }
  )
}

export const leadsOpportunitiesListQueryKey = (
  options: Options<LeadsOpportunitiesListData>
) => createQueryKey('leadsOpportunitiesList', options)

export const leadsOpportunitiesListOptions = (
  options: Options<LeadsOpportunitiesListData>
) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await leadsOpportunitiesList({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true
      })

      return data
    },
    queryKey: leadsOpportunitiesListQueryKey(options)
  })
}

export const leadsOpportunitiesListInfiniteQueryKey = (
  options: Options<LeadsOpportunitiesListData>
): QueryKey<Options<LeadsOpportunitiesListData>> =>
  createQueryKey('leadsOpportunitiesList', options, true)

export const leadsOpportunitiesListInfiniteOptions = (
  options: Options<LeadsOpportunitiesListData>
) => {
  return infiniteQueryOptions<
    LeadsOpportunitiesListResponse,
    AxiosError<DefaultError>,
    InfiniteData<LeadsOpportunitiesListResponse>,
    QueryKey<Options<LeadsOpportunitiesListData>>,
    | number
    | Pick<
        QueryKey<Options<LeadsOpportunitiesListData>>[0],
        'body' | 'headers' | 'path' | 'query'
      >
  >(
    // @ts-ignore
    {
      queryFn: async ({ pageParam, queryKey, signal }) => {
        // @ts-ignore
        const page: Pick<
          QueryKey<Options<LeadsOpportunitiesListData>>[0],
          'body' | 'headers' | 'path' | 'query'
        > =
          typeof pageParam === 'object'
            ? pageParam
            : {
                query: {
                  page: pageParam
                }
              }
        const params = createInfiniteParams(queryKey, page)
        const { data } = await leadsOpportunitiesList({
          ...options,
          ...params,
          signal,
          throwOnError: true
        })

        return data
      },
      queryKey: leadsOpportunitiesListInfiniteQueryKey(options)
    }
  )
}

export const leadsSequencesListQueryKey = (
  options: Options<LeadsSequencesListData>
) => createQueryKey('leadsSequencesList', options)

export const leadsSequencesListOptions = (
  options: Options<LeadsSequencesListData>
) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await leadsSequencesList({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true
      })

      return data
    },
    queryKey: leadsSequencesListQueryKey(options)
  })
}

export const leadsSequencesListInfiniteQueryKey = (
  options: Options<LeadsSequencesListData>
): QueryKey<Options<LeadsSequencesListData>> =>
  createQueryKey('leadsSequencesList', options, true)

export const leadsSequencesListInfiniteOptions = (
  options: Options<LeadsSequencesListData>
) => {
  return infiniteQueryOptions<
    LeadsSequencesListResponse,
    AxiosError<DefaultError>,
    InfiniteData<LeadsSequencesListResponse>,
    QueryKey<Options<LeadsSequencesListData>>,
    | number
    | Pick<
        QueryKey<Options<LeadsSequencesListData>>[0],
        'body' | 'headers' | 'path' | 'query'
      >
  >(
    // @ts-ignore
    {
      queryFn: async ({ pageParam, queryKey, signal }) => {
        // @ts-ignore
        const page: Pick<
          QueryKey<Options<LeadsSequencesListData>>[0],
          'body' | 'headers' | 'path' | 'query'
        > =
          typeof pageParam === 'object'
            ? pageParam
            : {
                query: {
                  page: pageParam
                }
              }
        const params = createInfiniteParams(queryKey, page)
        const { data } = await leadsSequencesList({
          ...options,
          ...params,
          signal,
          throwOnError: true
        })

        return data
      },
      queryKey: leadsSequencesListInfiniteQueryKey(options)
    }
  )
}

export const leadsSequencesCreateQueryKey = (
  options: Options<LeadsSequencesCreateData>
) => createQueryKey('leadsSequencesCreate', options)

export const leadsSequencesCreateOptions = (
  options: Options<LeadsSequencesCreateData>
) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await leadsSequencesCreate({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true
      })

      return data
    },
    queryKey: leadsSequencesCreateQueryKey(options)
  })
}

export const leadsSequencesCreateMutation = (
  options?: Partial<Options<LeadsSequencesCreateData>>
): UseMutationOptions<
  LeadsSequencesCreateResponse,
  AxiosError<DefaultError>,
  Options<LeadsSequencesCreateData>
> => {
  const mutationOptions: UseMutationOptions<
    LeadsSequencesCreateResponse,
    AxiosError<DefaultError>,
    Options<LeadsSequencesCreateData>
  > = {
    mutationFn: async (localOptions) => {
      const { data } = await leadsSequencesCreate({
        ...options,
        ...localOptions,
        throwOnError: true
      })

      return data
    }
  }

  return mutationOptions
}

export const leadsSequencesDestroyMutation = (
  options?: Partial<Options<LeadsSequencesDestroyData>>
): UseMutationOptions<
  LeadsSequencesDestroyResponse,
  AxiosError<DefaultError>,
  Options<LeadsSequencesDestroyData>
> => {
  const mutationOptions: UseMutationOptions<
    LeadsSequencesDestroyResponse,
    AxiosError<DefaultError>,
    Options<LeadsSequencesDestroyData>
  > = {
    mutationFn: async (localOptions) => {
      const { data } = await leadsSequencesDestroy({
        ...options,
        ...localOptions,
        throwOnError: true
      })

      return data
    }
  }

  return mutationOptions
}

export const leadsSequencesRetrieveQueryKey = (
  options: Options<LeadsSequencesRetrieveData>
) => createQueryKey('leadsSequencesRetrieve', options)

export const leadsSequencesRetrieveOptions = (
  options: Options<LeadsSequencesRetrieveData>
) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await leadsSequencesRetrieve({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true
      })

      return data
    },
    queryKey: leadsSequencesRetrieveQueryKey(options)
  })
}

export const leadsSequencesPartialUpdateMutation = (
  options?: Partial<Options<LeadsSequencesPartialUpdateData>>
): UseMutationOptions<
  LeadsSequencesPartialUpdateResponse,
  AxiosError<DefaultError>,
  Options<LeadsSequencesPartialUpdateData>
> => {
  const mutationOptions: UseMutationOptions<
    LeadsSequencesPartialUpdateResponse,
    AxiosError<DefaultError>,
    Options<LeadsSequencesPartialUpdateData>
  > = {
    mutationFn: async (localOptions) => {
      const { data } = await leadsSequencesPartialUpdate({
        ...options,
        ...localOptions,
        throwOnError: true
      })

      return data
    }
  }

  return mutationOptions
}

export const leadsSequencesUpdateMutation = (
  options?: Partial<Options<LeadsSequencesUpdateData>>
): UseMutationOptions<
  LeadsSequencesUpdateResponse,
  AxiosError<DefaultError>,
  Options<LeadsSequencesUpdateData>
> => {
  const mutationOptions: UseMutationOptions<
    LeadsSequencesUpdateResponse,
    AxiosError<DefaultError>,
    Options<LeadsSequencesUpdateData>
  > = {
    mutationFn: async (localOptions) => {
      const { data } = await leadsSequencesUpdate({
        ...options,
        ...localOptions,
        throwOnError: true
      })

      return data
    }
  }

  return mutationOptions
}

export const leadsTasksListQueryKey = (options: Options<LeadsTasksListData>) =>
  createQueryKey('leadsTasksList', options)

export const leadsTasksListOptions = (options: Options<LeadsTasksListData>) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await leadsTasksList({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true
      })

      return data
    },
    queryKey: leadsTasksListQueryKey(options)
  })
}

export const leadsTasksListInfiniteQueryKey = (
  options: Options<LeadsTasksListData>
): QueryKey<Options<LeadsTasksListData>> =>
  createQueryKey('leadsTasksList', options, true)

export const leadsTasksListInfiniteOptions = (
  options: Options<LeadsTasksListData>
) => {
  return infiniteQueryOptions<
    LeadsTasksListResponse,
    AxiosError<DefaultError>,
    InfiniteData<LeadsTasksListResponse>,
    QueryKey<Options<LeadsTasksListData>>,
    | number
    | Pick<
        QueryKey<Options<LeadsTasksListData>>[0],
        'body' | 'headers' | 'path' | 'query'
      >
  >(
    // @ts-ignore
    {
      queryFn: async ({ pageParam, queryKey, signal }) => {
        // @ts-ignore
        const page: Pick<
          QueryKey<Options<LeadsTasksListData>>[0],
          'body' | 'headers' | 'path' | 'query'
        > =
          typeof pageParam === 'object'
            ? pageParam
            : {
                query: {
                  page: pageParam
                }
              }
        const params = createInfiniteParams(queryKey, page)
        const { data } = await leadsTasksList({
          ...options,
          ...params,
          signal,
          throwOnError: true
        })

        return data
      },
      queryKey: leadsTasksListInfiniteQueryKey(options)
    }
  )
}

export const leadsDestroyMutation = (
  options?: Partial<Options<LeadsDestroyData>>
): UseMutationOptions<
  LeadsDestroyResponse,
  AxiosError<DefaultError>,
  Options<LeadsDestroyData>
> => {
  const mutationOptions: UseMutationOptions<
    LeadsDestroyResponse,
    AxiosError<DefaultError>,
    Options<LeadsDestroyData>
  > = {
    mutationFn: async (localOptions) => {
      const { data } = await leadsDestroy({
        ...options,
        ...localOptions,
        throwOnError: true
      })

      return data
    }
  }

  return mutationOptions
}

export const leadsRetrieveQueryKey = (options: Options<LeadsRetrieveData>) =>
  createQueryKey('leadsRetrieve', options)

export const leadsRetrieveOptions = (options: Options<LeadsRetrieveData>) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await leadsRetrieve({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true
      })

      return data
    },
    queryKey: leadsRetrieveQueryKey(options)
  })
}

export const leadsPartialUpdateMutation = (
  options?: Partial<Options<LeadsPartialUpdateData>>
): UseMutationOptions<
  LeadsPartialUpdateResponse,
  AxiosError<DefaultError>,
  Options<LeadsPartialUpdateData>
> => {
  const mutationOptions: UseMutationOptions<
    LeadsPartialUpdateResponse,
    AxiosError<DefaultError>,
    Options<LeadsPartialUpdateData>
  > = {
    mutationFn: async (localOptions) => {
      const { data } = await leadsPartialUpdate({
        ...options,
        ...localOptions,
        throwOnError: true
      })

      return data
    }
  }

  return mutationOptions
}

export const leadsUpdateMutation = (
  options?: Partial<Options<LeadsUpdateData>>
): UseMutationOptions<
  LeadsUpdateResponse,
  AxiosError<DefaultError>,
  Options<LeadsUpdateData>
> => {
  const mutationOptions: UseMutationOptions<
    LeadsUpdateResponse,
    AxiosError<DefaultError>,
    Options<LeadsUpdateData>
  > = {
    mutationFn: async (localOptions) => {
      const { data } = await leadsUpdate({
        ...options,
        ...localOptions,
        throwOnError: true
      })

      return data
    }
  }

  return mutationOptions
}

export const leadsConvertToClientCreateQueryKey = (
  options: Options<LeadsConvertToClientCreateData>
) => createQueryKey('leadsConvertToClientCreate', options)

export const leadsConvertToClientCreateOptions = (
  options: Options<LeadsConvertToClientCreateData>
) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await leadsConvertToClientCreate({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true
      })

      return data
    },
    queryKey: leadsConvertToClientCreateQueryKey(options)
  })
}

export const leadsConvertToClientCreateMutation = (
  options?: Partial<Options<LeadsConvertToClientCreateData>>
): UseMutationOptions<
  LeadsConvertToClientCreateResponse,
  AxiosError<DefaultError>,
  Options<LeadsConvertToClientCreateData>
> => {
  const mutationOptions: UseMutationOptions<
    LeadsConvertToClientCreateResponse,
    AxiosError<DefaultError>,
    Options<LeadsConvertToClientCreateData>
  > = {
    mutationFn: async (localOptions) => {
      const { data } = await leadsConvertToClientCreate({
        ...options,
        ...localOptions,
        throwOnError: true
      })

      return data
    }
  }

  return mutationOptions
}

export const leadsInvoiceContactsRetrieveQueryKey = (
  options: Options<LeadsInvoiceContactsRetrieveData>
) => createQueryKey('leadsInvoiceContactsRetrieve', options)

export const leadsInvoiceContactsRetrieveOptions = (
  options: Options<LeadsInvoiceContactsRetrieveData>
) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await leadsInvoiceContactsRetrieve({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true
      })

      return data
    },
    queryKey: leadsInvoiceContactsRetrieveQueryKey(options)
  })
}

export const leadsInvoicesListQueryKey = (
  options: Options<LeadsInvoicesListData>
) => createQueryKey('leadsInvoicesList', options)

export const leadsInvoicesListOptions = (
  options: Options<LeadsInvoicesListData>
) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await leadsInvoicesList({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true
      })

      return data
    },
    queryKey: leadsInvoicesListQueryKey(options)
  })
}

export const leadsInvoicesListInfiniteQueryKey = (
  options: Options<LeadsInvoicesListData>
): QueryKey<Options<LeadsInvoicesListData>> =>
  createQueryKey('leadsInvoicesList', options, true)

export const leadsInvoicesListInfiniteOptions = (
  options: Options<LeadsInvoicesListData>
) => {
  return infiniteQueryOptions<
    LeadsInvoicesListResponse,
    AxiosError<DefaultError>,
    InfiniteData<LeadsInvoicesListResponse>,
    QueryKey<Options<LeadsInvoicesListData>>,
    | number
    | Pick<
        QueryKey<Options<LeadsInvoicesListData>>[0],
        'body' | 'headers' | 'path' | 'query'
      >
  >(
    // @ts-ignore
    {
      queryFn: async ({ pageParam, queryKey, signal }) => {
        // @ts-ignore
        const page: Pick<
          QueryKey<Options<LeadsInvoicesListData>>[0],
          'body' | 'headers' | 'path' | 'query'
        > =
          typeof pageParam === 'object'
            ? pageParam
            : {
                query: {
                  page: pageParam
                }
              }
        const params = createInfiniteParams(queryKey, page)
        const { data } = await leadsInvoicesList({
          ...options,
          ...params,
          signal,
          throwOnError: true
        })

        return data
      },
      queryKey: leadsInvoicesListInfiniteQueryKey(options)
    }
  )
}

export const leadsMergePartialUpdateMutation = (
  options?: Partial<Options<LeadsMergePartialUpdateData>>
): UseMutationOptions<
  LeadsMergePartialUpdateResponse,
  AxiosError<DefaultError>,
  Options<LeadsMergePartialUpdateData>
> => {
  const mutationOptions: UseMutationOptions<
    LeadsMergePartialUpdateResponse,
    AxiosError<DefaultError>,
    Options<LeadsMergePartialUpdateData>
  > = {
    mutationFn: async (localOptions) => {
      const { data } = await leadsMergePartialUpdate({
        ...options,
        ...localOptions,
        throwOnError: true
      })

      return data
    }
  }

  return mutationOptions
}

export const leadsSimilarRetrieveQueryKey = (
  options: Options<LeadsSimilarRetrieveData>
) => createQueryKey('leadsSimilarRetrieve', options)

export const leadsSimilarRetrieveOptions = (
  options: Options<LeadsSimilarRetrieveData>
) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await leadsSimilarRetrieve({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true
      })

      return data
    },
    queryKey: leadsSimilarRetrieveQueryKey(options)
  })
}

export const leadsUndeletePartialUpdateMutation = (
  options?: Partial<Options<LeadsUndeletePartialUpdateData>>
): UseMutationOptions<
  LeadsUndeletePartialUpdateResponse,
  AxiosError<DefaultError>,
  Options<LeadsUndeletePartialUpdateData>
> => {
  const mutationOptions: UseMutationOptions<
    LeadsUndeletePartialUpdateResponse,
    AxiosError<DefaultError>,
    Options<LeadsUndeletePartialUpdateData>
  > = {
    mutationFn: async (localOptions) => {
      const { data } = await leadsUndeletePartialUpdate({
        ...options,
        ...localOptions,
        throwOnError: true
      })

      return data
    }
  }

  return mutationOptions
}

export const leadsBulkAssigneePartialUpdateMutation = (
  options?: Partial<Options<LeadsBulkAssigneePartialUpdateData>>
): UseMutationOptions<
  LeadsBulkAssigneePartialUpdateResponse,
  AxiosError<DefaultError>,
  Options<LeadsBulkAssigneePartialUpdateData>
> => {
  const mutationOptions: UseMutationOptions<
    LeadsBulkAssigneePartialUpdateResponse,
    AxiosError<DefaultError>,
    Options<LeadsBulkAssigneePartialUpdateData>
  > = {
    mutationFn: async (localOptions) => {
      const { data } = await leadsBulkAssigneePartialUpdate({
        ...options,
        ...localOptions,
        throwOnError: true
      })

      return data
    }
  }

  return mutationOptions
}

export const leadsBulkDeleteCreateQueryKey = (
  options: Options<LeadsBulkDeleteCreateData>
) => createQueryKey('leadsBulkDeleteCreate', options)

export const leadsBulkDeleteCreateOptions = (
  options: Options<LeadsBulkDeleteCreateData>
) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await leadsBulkDeleteCreate({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true
      })

      return data
    },
    queryKey: leadsBulkDeleteCreateQueryKey(options)
  })
}

export const leadsBulkDeleteCreateMutation = (
  options?: Partial<Options<LeadsBulkDeleteCreateData>>
): UseMutationOptions<
  LeadsBulkDeleteCreateResponse,
  AxiosError<DefaultError>,
  Options<LeadsBulkDeleteCreateData>
> => {
  const mutationOptions: UseMutationOptions<
    LeadsBulkDeleteCreateResponse,
    AxiosError<DefaultError>,
    Options<LeadsBulkDeleteCreateData>
  > = {
    mutationFn: async (localOptions) => {
      const { data } = await leadsBulkDeleteCreate({
        ...options,
        ...localOptions,
        throwOnError: true
      })

      return data
    }
  }

  return mutationOptions
}

export const leadsBulkSetBranchPartialUpdateMutation = (
  options?: Partial<Options<LeadsBulkSetBranchPartialUpdateData>>
): UseMutationOptions<
  LeadsBulkSetBranchPartialUpdateResponse,
  AxiosError<DefaultError>,
  Options<LeadsBulkSetBranchPartialUpdateData>
> => {
  const mutationOptions: UseMutationOptions<
    LeadsBulkSetBranchPartialUpdateResponse,
    AxiosError<DefaultError>,
    Options<LeadsBulkSetBranchPartialUpdateData>
  > = {
    mutationFn: async (localOptions) => {
      const { data } = await leadsBulkSetBranchPartialUpdate({
        ...options,
        ...localOptions,
        throwOnError: true
      })

      return data
    }
  }

  return mutationOptions
}

export const leadsDeletedListQueryKey = (
  options?: Options<LeadsDeletedListData>
) => createQueryKey('leadsDeletedList', options)

export const leadsDeletedListOptions = (
  options?: Options<LeadsDeletedListData>
) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await leadsDeletedList({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true
      })

      return data
    },
    queryKey: leadsDeletedListQueryKey(options)
  })
}

export const leadsDeletedListInfiniteQueryKey = (
  options?: Options<LeadsDeletedListData>
): QueryKey<Options<LeadsDeletedListData>> =>
  createQueryKey('leadsDeletedList', options, true)

export const leadsDeletedListInfiniteOptions = (
  options?: Options<LeadsDeletedListData>
) => {
  return infiniteQueryOptions<
    LeadsDeletedListResponse,
    AxiosError<DefaultError>,
    InfiniteData<LeadsDeletedListResponse>,
    QueryKey<Options<LeadsDeletedListData>>,
    | number
    | Pick<
        QueryKey<Options<LeadsDeletedListData>>[0],
        'body' | 'headers' | 'path' | 'query'
      >
  >(
    // @ts-ignore
    {
      queryFn: async ({ pageParam, queryKey, signal }) => {
        // @ts-ignore
        const page: Pick<
          QueryKey<Options<LeadsDeletedListData>>[0],
          'body' | 'headers' | 'path' | 'query'
        > =
          typeof pageParam === 'object'
            ? pageParam
            : {
                query: {
                  page: pageParam
                }
              }
        const params = createInfiniteParams(queryKey, page)
        const { data } = await leadsDeletedList({
          ...options,
          ...params,
          signal,
          throwOnError: true
        })

        return data
      },
      queryKey: leadsDeletedListInfiniteQueryKey(options)
    }
  )
}

export const leadsExportRetrieveQueryKey = (
  options?: Options<LeadsExportRetrieveData>
) => createQueryKey('leadsExportRetrieve', options)

export const leadsExportRetrieveOptions = (
  options?: Options<LeadsExportRetrieveData>
) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await leadsExportRetrieve({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true
      })

      return data
    },
    queryKey: leadsExportRetrieveQueryKey(options)
  })
}

export const leadsListListQueryKey = (options?: Options<LeadsListListData>) =>
  createQueryKey('leadsListList', options)

export const leadsListListOptions = (options?: Options<LeadsListListData>) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await leadsListList({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true
      })

      return data
    },
    queryKey: leadsListListQueryKey(options)
  })
}

export const leadsListListInfiniteQueryKey = (
  options?: Options<LeadsListListData>
): QueryKey<Options<LeadsListListData>> =>
  createQueryKey('leadsListList', options, true)

export const leadsListListInfiniteOptions = (
  options?: Options<LeadsListListData>
) => {
  return infiniteQueryOptions<
    LeadsListListResponse,
    AxiosError<DefaultError>,
    InfiniteData<LeadsListListResponse>,
    QueryKey<Options<LeadsListListData>>,
    | number
    | Pick<
        QueryKey<Options<LeadsListListData>>[0],
        'body' | 'headers' | 'path' | 'query'
      >
  >(
    // @ts-ignore
    {
      queryFn: async ({ pageParam, queryKey, signal }) => {
        // @ts-ignore
        const page: Pick<
          QueryKey<Options<LeadsListListData>>[0],
          'body' | 'headers' | 'path' | 'query'
        > =
          typeof pageParam === 'object'
            ? pageParam
            : {
                query: {
                  page: pageParam
                }
              }
        const params = createInfiniteParams(queryKey, page)
        const { data } = await leadsListList({
          ...options,
          ...params,
          signal,
          throwOnError: true
        })

        return data
      },
      queryKey: leadsListListInfiniteQueryKey(options)
    }
  )
}

export const leadsPipelineListQueryKey = (
  options?: Options<LeadsPipelineListData>
) => createQueryKey('leadsPipelineList', options)

export const leadsPipelineListOptions = (
  options?: Options<LeadsPipelineListData>
) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await leadsPipelineList({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true
      })

      return data
    },
    queryKey: leadsPipelineListQueryKey(options)
  })
}

export const leadsPipelineListInfiniteQueryKey = (
  options?: Options<LeadsPipelineListData>
): QueryKey<Options<LeadsPipelineListData>> =>
  createQueryKey('leadsPipelineList', options, true)

export const leadsPipelineListInfiniteOptions = (
  options?: Options<LeadsPipelineListData>
) => {
  return infiniteQueryOptions<
    LeadsPipelineListResponse,
    AxiosError<DefaultError>,
    InfiniteData<LeadsPipelineListResponse>,
    QueryKey<Options<LeadsPipelineListData>>,
    | number
    | Pick<
        QueryKey<Options<LeadsPipelineListData>>[0],
        'body' | 'headers' | 'path' | 'query'
      >
  >(
    // @ts-ignore
    {
      queryFn: async ({ pageParam, queryKey, signal }) => {
        // @ts-ignore
        const page: Pick<
          QueryKey<Options<LeadsPipelineListData>>[0],
          'body' | 'headers' | 'path' | 'query'
        > =
          typeof pageParam === 'object'
            ? pageParam
            : {
                query: {
                  page: pageParam
                }
              }
        const params = createInfiniteParams(queryKey, page)
        const { data } = await leadsPipelineList({
          ...options,
          ...params,
          signal,
          throwOnError: true
        })

        return data
      },
      queryKey: leadsPipelineListInfiniteQueryKey(options)
    }
  )
}

export const leadsSetTagPartialUpdateMutation = (
  options?: Partial<Options<LeadsSetTagPartialUpdateData>>
): UseMutationOptions<
  LeadsSetTagPartialUpdateResponse,
  AxiosError<DefaultError>,
  Options<LeadsSetTagPartialUpdateData>
> => {
  const mutationOptions: UseMutationOptions<
    LeadsSetTagPartialUpdateResponse,
    AxiosError<DefaultError>,
    Options<LeadsSetTagPartialUpdateData>
  > = {
    mutationFn: async (localOptions) => {
      const { data } = await leadsSetTagPartialUpdate({
        ...options,
        ...localOptions,
        throwOnError: true
      })

      return data
    }
  }

  return mutationOptions
}

export const leadsViewedListQueryKey = (
  options?: Options<LeadsViewedListData>
) => createQueryKey('leadsViewedList', options)

export const leadsViewedListOptions = (
  options?: Options<LeadsViewedListData>
) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await leadsViewedList({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true
      })

      return data
    },
    queryKey: leadsViewedListQueryKey(options)
  })
}

export const leadsViewedListInfiniteQueryKey = (
  options?: Options<LeadsViewedListData>
): QueryKey<Options<LeadsViewedListData>> =>
  createQueryKey('leadsViewedList', options, true)

export const leadsViewedListInfiniteOptions = (
  options?: Options<LeadsViewedListData>
) => {
  return infiniteQueryOptions<
    LeadsViewedListResponse,
    AxiosError<DefaultError>,
    InfiniteData<LeadsViewedListResponse>,
    QueryKey<Options<LeadsViewedListData>>,
    | number
    | Pick<
        QueryKey<Options<LeadsViewedListData>>[0],
        'body' | 'headers' | 'path' | 'query'
      >
  >(
    // @ts-ignore
    {
      queryFn: async ({ pageParam, queryKey, signal }) => {
        // @ts-ignore
        const page: Pick<
          QueryKey<Options<LeadsViewedListData>>[0],
          'body' | 'headers' | 'path' | 'query'
        > =
          typeof pageParam === 'object'
            ? pageParam
            : {
                query: {
                  page: pageParam
                }
              }
        const params = createInfiniteParams(queryKey, page)
        const { data } = await leadsViewedList({
          ...options,
          ...params,
          signal,
          throwOnError: true
        })

        return data
      },
      queryKey: leadsViewedListInfiniteQueryKey(options)
    }
  )
}

export const listViewsListQueryKey = (options?: Options<ListViewsListData>) =>
  createQueryKey('listViewsList', options)

export const listViewsListOptions = (options?: Options<ListViewsListData>) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await listViewsList({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true
      })

      return data
    },
    queryKey: listViewsListQueryKey(options)
  })
}

export const listViewsListInfiniteQueryKey = (
  options?: Options<ListViewsListData>
): QueryKey<Options<ListViewsListData>> =>
  createQueryKey('listViewsList', options, true)

export const listViewsListInfiniteOptions = (
  options?: Options<ListViewsListData>
) => {
  return infiniteQueryOptions<
    ListViewsListResponse,
    AxiosError<DefaultError>,
    InfiniteData<ListViewsListResponse>,
    QueryKey<Options<ListViewsListData>>,
    | number
    | Pick<
        QueryKey<Options<ListViewsListData>>[0],
        'body' | 'headers' | 'path' | 'query'
      >
  >(
    // @ts-ignore
    {
      queryFn: async ({ pageParam, queryKey, signal }) => {
        // @ts-ignore
        const page: Pick<
          QueryKey<Options<ListViewsListData>>[0],
          'body' | 'headers' | 'path' | 'query'
        > =
          typeof pageParam === 'object'
            ? pageParam
            : {
                query: {
                  page: pageParam
                }
              }
        const params = createInfiniteParams(queryKey, page)
        const { data } = await listViewsList({
          ...options,
          ...params,
          signal,
          throwOnError: true
        })

        return data
      },
      queryKey: listViewsListInfiniteQueryKey(options)
    }
  )
}

export const listViewsCreateQueryKey = (
  options?: Options<ListViewsCreateData>
) => createQueryKey('listViewsCreate', options)

export const listViewsCreateOptions = (
  options?: Options<ListViewsCreateData>
) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await listViewsCreate({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true
      })

      return data
    },
    queryKey: listViewsCreateQueryKey(options)
  })
}

export const listViewsCreateMutation = (
  options?: Partial<Options<ListViewsCreateData>>
): UseMutationOptions<
  ListViewsCreateResponse,
  AxiosError<DefaultError>,
  Options<ListViewsCreateData>
> => {
  const mutationOptions: UseMutationOptions<
    ListViewsCreateResponse,
    AxiosError<DefaultError>,
    Options<ListViewsCreateData>
  > = {
    mutationFn: async (localOptions) => {
      const { data } = await listViewsCreate({
        ...options,
        ...localOptions,
        throwOnError: true
      })

      return data
    }
  }

  return mutationOptions
}

export const listViewsResultListQueryKey = (
  options: Options<ListViewsResultListData>
) => createQueryKey('listViewsResultList', options)

export const listViewsResultListOptions = (
  options: Options<ListViewsResultListData>
) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await listViewsResultList({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true
      })

      return data
    },
    queryKey: listViewsResultListQueryKey(options)
  })
}

export const listViewsResultListInfiniteQueryKey = (
  options: Options<ListViewsResultListData>
): QueryKey<Options<ListViewsResultListData>> =>
  createQueryKey('listViewsResultList', options, true)

export const listViewsResultListInfiniteOptions = (
  options: Options<ListViewsResultListData>
) => {
  return infiniteQueryOptions<
    ListViewsResultListResponse,
    AxiosError<DefaultError>,
    InfiniteData<ListViewsResultListResponse>,
    QueryKey<Options<ListViewsResultListData>>,
    | number
    | Pick<
        QueryKey<Options<ListViewsResultListData>>[0],
        'body' | 'headers' | 'path' | 'query'
      >
  >(
    // @ts-ignore
    {
      queryFn: async ({ pageParam, queryKey, signal }) => {
        // @ts-ignore
        const page: Pick<
          QueryKey<Options<ListViewsResultListData>>[0],
          'body' | 'headers' | 'path' | 'query'
        > =
          typeof pageParam === 'object'
            ? pageParam
            : {
                query: {
                  page: pageParam
                }
              }
        const params = createInfiniteParams(queryKey, page)
        const { data } = await listViewsResultList({
          ...options,
          ...params,
          signal,
          throwOnError: true
        })

        return data
      },
      queryKey: listViewsResultListInfiniteQueryKey(options)
    }
  )
}

export const listViewsDestroyMutation = (
  options?: Partial<Options<ListViewsDestroyData>>
): UseMutationOptions<
  ListViewsDestroyResponse,
  AxiosError<DefaultError>,
  Options<ListViewsDestroyData>
> => {
  const mutationOptions: UseMutationOptions<
    ListViewsDestroyResponse,
    AxiosError<DefaultError>,
    Options<ListViewsDestroyData>
  > = {
    mutationFn: async (localOptions) => {
      const { data } = await listViewsDestroy({
        ...options,
        ...localOptions,
        throwOnError: true
      })

      return data
    }
  }

  return mutationOptions
}

export const listViewsRetrieveQueryKey = (
  options: Options<ListViewsRetrieveData>
) => createQueryKey('listViewsRetrieve', options)

export const listViewsRetrieveOptions = (
  options: Options<ListViewsRetrieveData>
) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await listViewsRetrieve({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true
      })

      return data
    },
    queryKey: listViewsRetrieveQueryKey(options)
  })
}

export const listViewsPartialUpdateMutation = (
  options?: Partial<Options<ListViewsPartialUpdateData>>
): UseMutationOptions<
  ListViewsPartialUpdateResponse,
  AxiosError<DefaultError>,
  Options<ListViewsPartialUpdateData>
> => {
  const mutationOptions: UseMutationOptions<
    ListViewsPartialUpdateResponse,
    AxiosError<DefaultError>,
    Options<ListViewsPartialUpdateData>
  > = {
    mutationFn: async (localOptions) => {
      const { data } = await listViewsPartialUpdate({
        ...options,
        ...localOptions,
        throwOnError: true
      })

      return data
    }
  }

  return mutationOptions
}

export const listViewsUpdateMutation = (
  options?: Partial<Options<ListViewsUpdateData>>
): UseMutationOptions<
  ListViewsUpdateResponse,
  AxiosError<DefaultError>,
  Options<ListViewsUpdateData>
> => {
  const mutationOptions: UseMutationOptions<
    ListViewsUpdateResponse,
    AxiosError<DefaultError>,
    Options<ListViewsUpdateData>
  > = {
    mutationFn: async (localOptions) => {
      const { data } = await listViewsUpdate({
        ...options,
        ...localOptions,
        throwOnError: true
      })

      return data
    }
  }

  return mutationOptions
}

export const listViewsFieldsRetrieveQueryKey = (
  options?: Options<ListViewsFieldsRetrieveData>
) => createQueryKey('listViewsFieldsRetrieve', options)

export const listViewsFieldsRetrieveOptions = (
  options?: Options<ListViewsFieldsRetrieveData>
) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await listViewsFieldsRetrieve({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true
      })

      return data
    },
    queryKey: listViewsFieldsRetrieveQueryKey(options)
  })
}

export const logsListQueryKey = (options?: Options<LogsListData>) =>
  createQueryKey('logsList', options)

export const logsListOptions = (options?: Options<LogsListData>) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await logsList({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true
      })

      return data
    },
    queryKey: logsListQueryKey(options)
  })
}

export const logsListInfiniteQueryKey = (
  options?: Options<LogsListData>
): QueryKey<Options<LogsListData>> => createQueryKey('logsList', options, true)

export const logsListInfiniteOptions = (options?: Options<LogsListData>) => {
  return infiniteQueryOptions<
    LogsListResponse,
    AxiosError<DefaultError>,
    InfiniteData<LogsListResponse>,
    QueryKey<Options<LogsListData>>,
    | number
    | Pick<
        QueryKey<Options<LogsListData>>[0],
        'body' | 'headers' | 'path' | 'query'
      >
  >(
    // @ts-ignore
    {
      queryFn: async ({ pageParam, queryKey, signal }) => {
        // @ts-ignore
        const page: Pick<
          QueryKey<Options<LogsListData>>[0],
          'body' | 'headers' | 'path' | 'query'
        > =
          typeof pageParam === 'object'
            ? pageParam
            : {
                query: {
                  page: pageParam
                }
              }
        const params = createInfiniteParams(queryKey, page)
        const { data } = await logsList({
          ...options,
          ...params,
          signal,
          throwOnError: true
        })

        return data
      },
      queryKey: logsListInfiniteQueryKey(options)
    }
  )
}

export const logsRetrieveQueryKey = (options: Options<LogsRetrieveData>) =>
  createQueryKey('logsRetrieve', options)

export const logsRetrieveOptions = (options: Options<LogsRetrieveData>) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await logsRetrieve({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true
      })

      return data
    },
    queryKey: logsRetrieveQueryKey(options)
  })
}

export const logsMeetingCreateQueryKey = (
  options: Options<LogsMeetingCreateData>
) => createQueryKey('logsMeetingCreate', options)

export const logsMeetingCreateOptions = (
  options: Options<LogsMeetingCreateData>
) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await logsMeetingCreate({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true
      })

      return data
    },
    queryKey: logsMeetingCreateQueryKey(options)
  })
}

export const logsMeetingCreateMutation = (
  options?: Partial<Options<LogsMeetingCreateData>>
): UseMutationOptions<
  LogsMeetingCreateResponse,
  AxiosError<DefaultError>,
  Options<LogsMeetingCreateData>
> => {
  const mutationOptions: UseMutationOptions<
    LogsMeetingCreateResponse,
    AxiosError<DefaultError>,
    Options<LogsMeetingCreateData>
  > = {
    mutationFn: async (localOptions) => {
      const { data } = await logsMeetingCreate({
        ...options,
        ...localOptions,
        throwOnError: true
      })

      return data
    }
  }

  return mutationOptions
}

export const logsNoteCreateQueryKey = (options: Options<LogsNoteCreateData>) =>
  createQueryKey('logsNoteCreate', options)

export const logsNoteCreateOptions = (options: Options<LogsNoteCreateData>) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await logsNoteCreate({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true
      })

      return data
    },
    queryKey: logsNoteCreateQueryKey(options)
  })
}

export const logsNoteCreateMutation = (
  options?: Partial<Options<LogsNoteCreateData>>
): UseMutationOptions<
  LogsNoteCreateResponse,
  AxiosError<DefaultError>,
  Options<LogsNoteCreateData>
> => {
  const mutationOptions: UseMutationOptions<
    LogsNoteCreateResponse,
    AxiosError<DefaultError>,
    Options<LogsNoteCreateData>
  > = {
    mutationFn: async (localOptions) => {
      const { data } = await logsNoteCreate({
        ...options,
        ...localOptions,
        throwOnError: true
      })

      return data
    }
  }

  return mutationOptions
}

export const mailboxesListQueryKey = (options?: Options<MailboxesListData>) =>
  createQueryKey('mailboxesList', options)

export const mailboxesListOptions = (options?: Options<MailboxesListData>) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await mailboxesList({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true
      })

      return data
    },
    queryKey: mailboxesListQueryKey(options)
  })
}

export const mailboxesListInfiniteQueryKey = (
  options?: Options<MailboxesListData>
): QueryKey<Options<MailboxesListData>> =>
  createQueryKey('mailboxesList', options, true)

export const mailboxesListInfiniteOptions = (
  options?: Options<MailboxesListData>
) => {
  return infiniteQueryOptions<
    MailboxesListResponse,
    AxiosError<DefaultError>,
    InfiniteData<MailboxesListResponse>,
    QueryKey<Options<MailboxesListData>>,
    | number
    | Pick<
        QueryKey<Options<MailboxesListData>>[0],
        'body' | 'headers' | 'path' | 'query'
      >
  >(
    // @ts-ignore
    {
      queryFn: async ({ pageParam, queryKey, signal }) => {
        // @ts-ignore
        const page: Pick<
          QueryKey<Options<MailboxesListData>>[0],
          'body' | 'headers' | 'path' | 'query'
        > =
          typeof pageParam === 'object'
            ? pageParam
            : {
                query: {
                  page: pageParam
                }
              }
        const params = createInfiniteParams(queryKey, page)
        const { data } = await mailboxesList({
          ...options,
          ...params,
          signal,
          throwOnError: true
        })

        return data
      },
      queryKey: mailboxesListInfiniteQueryKey(options)
    }
  )
}

export const mailboxesCreateQueryKey = (
  options: Options<MailboxesCreateData>
) => createQueryKey('mailboxesCreate', options)

export const mailboxesCreateOptions = (
  options: Options<MailboxesCreateData>
) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await mailboxesCreate({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true
      })

      return data
    },
    queryKey: mailboxesCreateQueryKey(options)
  })
}

export const mailboxesCreateMutation = (
  options?: Partial<Options<MailboxesCreateData>>
): UseMutationOptions<
  MailboxesCreateResponse,
  AxiosError<DefaultError>,
  Options<MailboxesCreateData>
> => {
  const mutationOptions: UseMutationOptions<
    MailboxesCreateResponse,
    AxiosError<DefaultError>,
    Options<MailboxesCreateData>
  > = {
    mutationFn: async (localOptions) => {
      const { data } = await mailboxesCreate({
        ...options,
        ...localOptions,
        throwOnError: true
      })

      return data
    }
  }

  return mutationOptions
}

export const mailboxesDestroyMutation = (
  options?: Partial<Options<MailboxesDestroyData>>
): UseMutationOptions<
  MailboxesDestroyResponse,
  AxiosError<DefaultError>,
  Options<MailboxesDestroyData>
> => {
  const mutationOptions: UseMutationOptions<
    MailboxesDestroyResponse,
    AxiosError<DefaultError>,
    Options<MailboxesDestroyData>
  > = {
    mutationFn: async (localOptions) => {
      const { data } = await mailboxesDestroy({
        ...options,
        ...localOptions,
        throwOnError: true
      })

      return data
    }
  }

  return mutationOptions
}

export const mailboxesRetrieveQueryKey = (
  options: Options<MailboxesRetrieveData>
) => createQueryKey('mailboxesRetrieve', options)

export const mailboxesRetrieveOptions = (
  options: Options<MailboxesRetrieveData>
) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await mailboxesRetrieve({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true
      })

      return data
    },
    queryKey: mailboxesRetrieveQueryKey(options)
  })
}

export const mailboxesPartialUpdateMutation = (
  options?: Partial<Options<MailboxesPartialUpdateData>>
): UseMutationOptions<
  MailboxesPartialUpdateResponse,
  AxiosError<DefaultError>,
  Options<MailboxesPartialUpdateData>
> => {
  const mutationOptions: UseMutationOptions<
    MailboxesPartialUpdateResponse,
    AxiosError<DefaultError>,
    Options<MailboxesPartialUpdateData>
  > = {
    mutationFn: async (localOptions) => {
      const { data } = await mailboxesPartialUpdate({
        ...options,
        ...localOptions,
        throwOnError: true
      })

      return data
    }
  }

  return mutationOptions
}

export const mailboxesUpdateMutation = (
  options?: Partial<Options<MailboxesUpdateData>>
): UseMutationOptions<
  MailboxesUpdateResponse,
  AxiosError<DefaultError>,
  Options<MailboxesUpdateData>
> => {
  const mutationOptions: UseMutationOptions<
    MailboxesUpdateResponse,
    AxiosError<DefaultError>,
    Options<MailboxesUpdateData>
  > = {
    mutationFn: async (localOptions) => {
      const { data } = await mailboxesUpdate({
        ...options,
        ...localOptions,
        throwOnError: true
      })

      return data
    }
  }

  return mutationOptions
}

export const mailboxesCheckMailboxRetrieveQueryKey = (
  options: Options<MailboxesCheckMailboxRetrieveData>
) => createQueryKey('mailboxesCheckMailboxRetrieve', options)

export const mailboxesCheckMailboxRetrieveOptions = (
  options: Options<MailboxesCheckMailboxRetrieveData>
) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await mailboxesCheckMailboxRetrieve({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true
      })

      return data
    },
    queryKey: mailboxesCheckMailboxRetrieveQueryKey(options)
  })
}

export const mailboxesLoginRetrieveQueryKey = (
  options: Options<MailboxesLoginRetrieveData>
) => createQueryKey('mailboxesLoginRetrieve', options)

export const mailboxesLoginRetrieveOptions = (
  options: Options<MailboxesLoginRetrieveData>
) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await mailboxesLoginRetrieve({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true
      })

      return data
    },
    queryKey: mailboxesLoginRetrieveQueryKey(options)
  })
}

export const mailboxesListListQueryKey = (
  options?: Options<MailboxesListListData>
) => createQueryKey('mailboxesListList', options)

export const mailboxesListListOptions = (
  options?: Options<MailboxesListListData>
) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await mailboxesListList({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true
      })

      return data
    },
    queryKey: mailboxesListListQueryKey(options)
  })
}

export const mailboxesListListInfiniteQueryKey = (
  options?: Options<MailboxesListListData>
): QueryKey<Options<MailboxesListListData>> =>
  createQueryKey('mailboxesListList', options, true)

export const mailboxesListListInfiniteOptions = (
  options?: Options<MailboxesListListData>
) => {
  return infiniteQueryOptions<
    MailboxesListListResponse,
    AxiosError<DefaultError>,
    InfiniteData<MailboxesListListResponse>,
    QueryKey<Options<MailboxesListListData>>,
    | number
    | Pick<
        QueryKey<Options<MailboxesListListData>>[0],
        'body' | 'headers' | 'path' | 'query'
      >
  >(
    // @ts-ignore
    {
      queryFn: async ({ pageParam, queryKey, signal }) => {
        // @ts-ignore
        const page: Pick<
          QueryKey<Options<MailboxesListListData>>[0],
          'body' | 'headers' | 'path' | 'query'
        > =
          typeof pageParam === 'object'
            ? pageParam
            : {
                query: {
                  page: pageParam
                }
              }
        const params = createInfiniteParams(queryKey, page)
        const { data } = await mailboxesListList({
          ...options,
          ...params,
          signal,
          throwOnError: true
        })

        return data
      },
      queryKey: mailboxesListListInfiniteQueryKey(options)
    }
  )
}

export const mailboxesOauthLogoutCreateQueryKey = (
  options?: Options<MailboxesOauthLogoutCreateData>
) => createQueryKey('mailboxesOauthLogoutCreate', options)

export const mailboxesOauthLogoutCreateOptions = (
  options?: Options<MailboxesOauthLogoutCreateData>
) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await mailboxesOauthLogoutCreate({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true
      })

      return data
    },
    queryKey: mailboxesOauthLogoutCreateQueryKey(options)
  })
}

export const mailboxesOauthLogoutCreateMutation = (
  options?: Partial<Options<MailboxesOauthLogoutCreateData>>
): UseMutationOptions<
  MailboxesOauthLogoutCreateResponse,
  AxiosError<DefaultError>,
  Options<MailboxesOauthLogoutCreateData>
> => {
  const mutationOptions: UseMutationOptions<
    MailboxesOauthLogoutCreateResponse,
    AxiosError<DefaultError>,
    Options<MailboxesOauthLogoutCreateData>
  > = {
    mutationFn: async (localOptions) => {
      const { data } = await mailboxesOauthLogoutCreate({
        ...options,
        ...localOptions,
        throwOnError: true
      })

      return data
    }
  }

  return mutationOptions
}

export const mailboxesOauthLogoutLinkRetrieveQueryKey = (
  options?: Options<MailboxesOauthLogoutLinkRetrieveData>
) => createQueryKey('mailboxesOauthLogoutLinkRetrieve', options)

export const mailboxesOauthLogoutLinkRetrieveOptions = (
  options?: Options<MailboxesOauthLogoutLinkRetrieveData>
) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await mailboxesOauthLogoutLinkRetrieve({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true
      })

      return data
    },
    queryKey: mailboxesOauthLogoutLinkRetrieveQueryKey(options)
  })
}

export const mailboxesOauthOutlookCreateQueryKey = (
  options: Options<MailboxesOauthOutlookCreateData>
) => createQueryKey('mailboxesOauthOutlookCreate', options)

export const mailboxesOauthOutlookCreateOptions = (
  options: Options<MailboxesOauthOutlookCreateData>
) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await mailboxesOauthOutlookCreate({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true
      })

      return data
    },
    queryKey: mailboxesOauthOutlookCreateQueryKey(options)
  })
}

export const mailboxesOauthOutlookCreateMutation = (
  options?: Partial<Options<MailboxesOauthOutlookCreateData>>
): UseMutationOptions<
  MailboxesOauthOutlookCreateResponse,
  AxiosError<DefaultError>,
  Options<MailboxesOauthOutlookCreateData>
> => {
  const mutationOptions: UseMutationOptions<
    MailboxesOauthOutlookCreateResponse,
    AxiosError<DefaultError>,
    Options<MailboxesOauthOutlookCreateData>
  > = {
    mutationFn: async (localOptions) => {
      const { data } = await mailboxesOauthOutlookCreate({
        ...options,
        ...localOptions,
        throwOnError: true
      })

      return data
    }
  }

  return mutationOptions
}

export const mailboxesOutlookLinkRetrieveQueryKey = (
  options?: Options<MailboxesOutlookLinkRetrieveData>
) => createQueryKey('mailboxesOutlookLinkRetrieve', options)

export const mailboxesOutlookLinkRetrieveOptions = (
  options?: Options<MailboxesOutlookLinkRetrieveData>
) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await mailboxesOutlookLinkRetrieve({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true
      })

      return data
    },
    queryKey: mailboxesOutlookLinkRetrieveQueryKey(options)
  })
}

export const mailboxesSendEmailCreateQueryKey = (
  options: Options<MailboxesSendEmailCreateData>
) => createQueryKey('mailboxesSendEmailCreate', options)

export const mailboxesSendEmailCreateOptions = (
  options: Options<MailboxesSendEmailCreateData>
) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await mailboxesSendEmailCreate({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true
      })

      return data
    },
    queryKey: mailboxesSendEmailCreateQueryKey(options)
  })
}

export const mailboxesSendEmailCreateMutation = (
  options?: Partial<Options<MailboxesSendEmailCreateData>>
): UseMutationOptions<
  unknown,
  AxiosError<DefaultError>,
  Options<MailboxesSendEmailCreateData>
> => {
  const mutationOptions: UseMutationOptions<
    unknown,
    AxiosError<DefaultError>,
    Options<MailboxesSendEmailCreateData>
  > = {
    mutationFn: async (localOptions) => {
      const { data } = await mailboxesSendEmailCreate({
        ...options,
        ...localOptions,
        throwOnError: true
      })

      return data
    }
  }

  return mutationOptions
}

export const mailboxesTemplatesListQueryKey = (
  options?: Options<MailboxesTemplatesListData>
) => createQueryKey('mailboxesTemplatesList', options)

export const mailboxesTemplatesListOptions = (
  options?: Options<MailboxesTemplatesListData>
) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await mailboxesTemplatesList({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true
      })

      return data
    },
    queryKey: mailboxesTemplatesListQueryKey(options)
  })
}

export const mailboxesTemplatesListInfiniteQueryKey = (
  options?: Options<MailboxesTemplatesListData>
): QueryKey<Options<MailboxesTemplatesListData>> =>
  createQueryKey('mailboxesTemplatesList', options, true)

export const mailboxesTemplatesListInfiniteOptions = (
  options?: Options<MailboxesTemplatesListData>
) => {
  return infiniteQueryOptions<
    MailboxesTemplatesListResponse,
    AxiosError<DefaultError>,
    InfiniteData<MailboxesTemplatesListResponse>,
    QueryKey<Options<MailboxesTemplatesListData>>,
    | number
    | Pick<
        QueryKey<Options<MailboxesTemplatesListData>>[0],
        'body' | 'headers' | 'path' | 'query'
      >
  >(
    // @ts-ignore
    {
      queryFn: async ({ pageParam, queryKey, signal }) => {
        // @ts-ignore
        const page: Pick<
          QueryKey<Options<MailboxesTemplatesListData>>[0],
          'body' | 'headers' | 'path' | 'query'
        > =
          typeof pageParam === 'object'
            ? pageParam
            : {
                query: {
                  page: pageParam
                }
              }
        const params = createInfiniteParams(queryKey, page)
        const { data } = await mailboxesTemplatesList({
          ...options,
          ...params,
          signal,
          throwOnError: true
        })

        return data
      },
      queryKey: mailboxesTemplatesListInfiniteQueryKey(options)
    }
  )
}

export const mailboxesTemplatesCreateQueryKey = (
  options: Options<MailboxesTemplatesCreateData>
) => createQueryKey('mailboxesTemplatesCreate', options)

export const mailboxesTemplatesCreateOptions = (
  options: Options<MailboxesTemplatesCreateData>
) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await mailboxesTemplatesCreate({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true
      })

      return data
    },
    queryKey: mailboxesTemplatesCreateQueryKey(options)
  })
}

export const mailboxesTemplatesCreateMutation = (
  options?: Partial<Options<MailboxesTemplatesCreateData>>
): UseMutationOptions<
  MailboxesTemplatesCreateResponse,
  AxiosError<DefaultError>,
  Options<MailboxesTemplatesCreateData>
> => {
  const mutationOptions: UseMutationOptions<
    MailboxesTemplatesCreateResponse,
    AxiosError<DefaultError>,
    Options<MailboxesTemplatesCreateData>
  > = {
    mutationFn: async (localOptions) => {
      const { data } = await mailboxesTemplatesCreate({
        ...options,
        ...localOptions,
        throwOnError: true
      })

      return data
    }
  }

  return mutationOptions
}

export const mailboxesTemplatesDestroyMutation = (
  options?: Partial<Options<MailboxesTemplatesDestroyData>>
): UseMutationOptions<
  MailboxesTemplatesDestroyResponse,
  AxiosError<DefaultError>,
  Options<MailboxesTemplatesDestroyData>
> => {
  const mutationOptions: UseMutationOptions<
    MailboxesTemplatesDestroyResponse,
    AxiosError<DefaultError>,
    Options<MailboxesTemplatesDestroyData>
  > = {
    mutationFn: async (localOptions) => {
      const { data } = await mailboxesTemplatesDestroy({
        ...options,
        ...localOptions,
        throwOnError: true
      })

      return data
    }
  }

  return mutationOptions
}

export const mailboxesTemplatesRetrieveQueryKey = (
  options: Options<MailboxesTemplatesRetrieveData>
) => createQueryKey('mailboxesTemplatesRetrieve', options)

export const mailboxesTemplatesRetrieveOptions = (
  options: Options<MailboxesTemplatesRetrieveData>
) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await mailboxesTemplatesRetrieve({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true
      })

      return data
    },
    queryKey: mailboxesTemplatesRetrieveQueryKey(options)
  })
}

export const mailboxesTemplatesPartialUpdateMutation = (
  options?: Partial<Options<MailboxesTemplatesPartialUpdateData>>
): UseMutationOptions<
  MailboxesTemplatesPartialUpdateResponse,
  AxiosError<DefaultError>,
  Options<MailboxesTemplatesPartialUpdateData>
> => {
  const mutationOptions: UseMutationOptions<
    MailboxesTemplatesPartialUpdateResponse,
    AxiosError<DefaultError>,
    Options<MailboxesTemplatesPartialUpdateData>
  > = {
    mutationFn: async (localOptions) => {
      const { data } = await mailboxesTemplatesPartialUpdate({
        ...options,
        ...localOptions,
        throwOnError: true
      })

      return data
    }
  }

  return mutationOptions
}

export const mailboxesTemplatesUpdateMutation = (
  options?: Partial<Options<MailboxesTemplatesUpdateData>>
): UseMutationOptions<
  MailboxesTemplatesUpdateResponse,
  AxiosError<DefaultError>,
  Options<MailboxesTemplatesUpdateData>
> => {
  const mutationOptions: UseMutationOptions<
    MailboxesTemplatesUpdateResponse,
    AxiosError<DefaultError>,
    Options<MailboxesTemplatesUpdateData>
  > = {
    mutationFn: async (localOptions) => {
      const { data } = await mailboxesTemplatesUpdate({
        ...options,
        ...localOptions,
        throwOnError: true
      })

      return data
    }
  }

  return mutationOptions
}

export const opportunitiesListQueryKey = (
  options?: Options<OpportunitiesListData>
) => createQueryKey('opportunitiesList', options)

export const opportunitiesListOptions = (
  options?: Options<OpportunitiesListData>
) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await opportunitiesList({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true
      })

      return data
    },
    queryKey: opportunitiesListQueryKey(options)
  })
}

export const opportunitiesListInfiniteQueryKey = (
  options?: Options<OpportunitiesListData>
): QueryKey<Options<OpportunitiesListData>> =>
  createQueryKey('opportunitiesList', options, true)

export const opportunitiesListInfiniteOptions = (
  options?: Options<OpportunitiesListData>
) => {
  return infiniteQueryOptions<
    OpportunitiesListResponse,
    AxiosError<DefaultError>,
    InfiniteData<OpportunitiesListResponse>,
    QueryKey<Options<OpportunitiesListData>>,
    | number
    | Pick<
        QueryKey<Options<OpportunitiesListData>>[0],
        'body' | 'headers' | 'path' | 'query'
      >
  >(
    // @ts-ignore
    {
      queryFn: async ({ pageParam, queryKey, signal }) => {
        // @ts-ignore
        const page: Pick<
          QueryKey<Options<OpportunitiesListData>>[0],
          'body' | 'headers' | 'path' | 'query'
        > =
          typeof pageParam === 'object'
            ? pageParam
            : {
                query: {
                  page: pageParam
                }
              }
        const params = createInfiniteParams(queryKey, page)
        const { data } = await opportunitiesList({
          ...options,
          ...params,
          signal,
          throwOnError: true
        })

        return data
      },
      queryKey: opportunitiesListInfiniteQueryKey(options)
    }
  )
}

export const opportunitiesCreateQueryKey = (
  options?: Options<OpportunitiesCreateData>
) => createQueryKey('opportunitiesCreate', options)

export const opportunitiesCreateOptions = (
  options?: Options<OpportunitiesCreateData>
) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await opportunitiesCreate({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true
      })

      return data
    },
    queryKey: opportunitiesCreateQueryKey(options)
  })
}

export const opportunitiesCreateMutation = (
  options?: Partial<Options<OpportunitiesCreateData>>
): UseMutationOptions<
  OpportunitiesCreateResponse,
  AxiosError<DefaultError>,
  Options<OpportunitiesCreateData>
> => {
  const mutationOptions: UseMutationOptions<
    OpportunitiesCreateResponse,
    AxiosError<DefaultError>,
    Options<OpportunitiesCreateData>
  > = {
    mutationFn: async (localOptions) => {
      const { data } = await opportunitiesCreate({
        ...options,
        ...localOptions,
        throwOnError: true
      })

      return data
    }
  }

  return mutationOptions
}

export const opportunitiesStatusesListQueryKey = (
  options?: Options<OpportunitiesStatusesListData>
) => createQueryKey('opportunitiesStatusesList', options)

export const opportunitiesStatusesListOptions = (
  options?: Options<OpportunitiesStatusesListData>
) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await opportunitiesStatusesList({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true
      })

      return data
    },
    queryKey: opportunitiesStatusesListQueryKey(options)
  })
}

export const opportunitiesStatusesListInfiniteQueryKey = (
  options?: Options<OpportunitiesStatusesListData>
): QueryKey<Options<OpportunitiesStatusesListData>> =>
  createQueryKey('opportunitiesStatusesList', options, true)

export const opportunitiesStatusesListInfiniteOptions = (
  options?: Options<OpportunitiesStatusesListData>
) => {
  return infiniteQueryOptions<
    OpportunitiesStatusesListResponse,
    AxiosError<DefaultError>,
    InfiniteData<OpportunitiesStatusesListResponse>,
    QueryKey<Options<OpportunitiesStatusesListData>>,
    | number
    | Pick<
        QueryKey<Options<OpportunitiesStatusesListData>>[0],
        'body' | 'headers' | 'path' | 'query'
      >
  >(
    // @ts-ignore
    {
      queryFn: async ({ pageParam, queryKey, signal }) => {
        // @ts-ignore
        const page: Pick<
          QueryKey<Options<OpportunitiesStatusesListData>>[0],
          'body' | 'headers' | 'path' | 'query'
        > =
          typeof pageParam === 'object'
            ? pageParam
            : {
                query: {
                  page: pageParam
                }
              }
        const params = createInfiniteParams(queryKey, page)
        const { data } = await opportunitiesStatusesList({
          ...options,
          ...params,
          signal,
          throwOnError: true
        })

        return data
      },
      queryKey: opportunitiesStatusesListInfiniteQueryKey(options)
    }
  )
}

export const opportunitiesStatusesCreateQueryKey = (
  options: Options<OpportunitiesStatusesCreateData>
) => createQueryKey('opportunitiesStatusesCreate', options)

export const opportunitiesStatusesCreateOptions = (
  options: Options<OpportunitiesStatusesCreateData>
) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await opportunitiesStatusesCreate({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true
      })

      return data
    },
    queryKey: opportunitiesStatusesCreateQueryKey(options)
  })
}

export const opportunitiesStatusesCreateMutation = (
  options?: Partial<Options<OpportunitiesStatusesCreateData>>
): UseMutationOptions<
  OpportunitiesStatusesCreateResponse,
  AxiosError<DefaultError>,
  Options<OpportunitiesStatusesCreateData>
> => {
  const mutationOptions: UseMutationOptions<
    OpportunitiesStatusesCreateResponse,
    AxiosError<DefaultError>,
    Options<OpportunitiesStatusesCreateData>
  > = {
    mutationFn: async (localOptions) => {
      const { data } = await opportunitiesStatusesCreate({
        ...options,
        ...localOptions,
        throwOnError: true
      })

      return data
    }
  }

  return mutationOptions
}

export const opportunitiesStatusesDestroyMutation = (
  options?: Partial<Options<OpportunitiesStatusesDestroyData>>
): UseMutationOptions<
  OpportunitiesStatusesDestroyResponse,
  AxiosError<DefaultError>,
  Options<OpportunitiesStatusesDestroyData>
> => {
  const mutationOptions: UseMutationOptions<
    OpportunitiesStatusesDestroyResponse,
    AxiosError<DefaultError>,
    Options<OpportunitiesStatusesDestroyData>
  > = {
    mutationFn: async (localOptions) => {
      const { data } = await opportunitiesStatusesDestroy({
        ...options,
        ...localOptions,
        throwOnError: true
      })

      return data
    }
  }

  return mutationOptions
}

export const opportunitiesStatusesRetrieveQueryKey = (
  options: Options<OpportunitiesStatusesRetrieveData>
) => createQueryKey('opportunitiesStatusesRetrieve', options)

export const opportunitiesStatusesRetrieveOptions = (
  options: Options<OpportunitiesStatusesRetrieveData>
) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await opportunitiesStatusesRetrieve({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true
      })

      return data
    },
    queryKey: opportunitiesStatusesRetrieveQueryKey(options)
  })
}

export const opportunitiesStatusesPartialUpdateMutation = (
  options?: Partial<Options<OpportunitiesStatusesPartialUpdateData>>
): UseMutationOptions<
  OpportunitiesStatusesPartialUpdateResponse,
  AxiosError<DefaultError>,
  Options<OpportunitiesStatusesPartialUpdateData>
> => {
  const mutationOptions: UseMutationOptions<
    OpportunitiesStatusesPartialUpdateResponse,
    AxiosError<DefaultError>,
    Options<OpportunitiesStatusesPartialUpdateData>
  > = {
    mutationFn: async (localOptions) => {
      const { data } = await opportunitiesStatusesPartialUpdate({
        ...options,
        ...localOptions,
        throwOnError: true
      })

      return data
    }
  }

  return mutationOptions
}

export const opportunitiesStatusesUpdateMutation = (
  options?: Partial<Options<OpportunitiesStatusesUpdateData>>
): UseMutationOptions<
  OpportunitiesStatusesUpdateResponse,
  AxiosError<DefaultError>,
  Options<OpportunitiesStatusesUpdateData>
> => {
  const mutationOptions: UseMutationOptions<
    OpportunitiesStatusesUpdateResponse,
    AxiosError<DefaultError>,
    Options<OpportunitiesStatusesUpdateData>
  > = {
    mutationFn: async (localOptions) => {
      const { data } = await opportunitiesStatusesUpdate({
        ...options,
        ...localOptions,
        throwOnError: true
      })

      return data
    }
  }

  return mutationOptions
}

export const opportunitiesStatusesListListQueryKey = (
  options?: Options<OpportunitiesStatusesListListData>
) => createQueryKey('opportunitiesStatusesListList', options)

export const opportunitiesStatusesListListOptions = (
  options?: Options<OpportunitiesStatusesListListData>
) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await opportunitiesStatusesListList({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true
      })

      return data
    },
    queryKey: opportunitiesStatusesListListQueryKey(options)
  })
}

export const opportunitiesStatusesListListInfiniteQueryKey = (
  options?: Options<OpportunitiesStatusesListListData>
): QueryKey<Options<OpportunitiesStatusesListListData>> =>
  createQueryKey('opportunitiesStatusesListList', options, true)

export const opportunitiesStatusesListListInfiniteOptions = (
  options?: Options<OpportunitiesStatusesListListData>
) => {
  return infiniteQueryOptions<
    OpportunitiesStatusesListListResponse,
    AxiosError<DefaultError>,
    InfiniteData<OpportunitiesStatusesListListResponse>,
    QueryKey<Options<OpportunitiesStatusesListListData>>,
    | number
    | Pick<
        QueryKey<Options<OpportunitiesStatusesListListData>>[0],
        'body' | 'headers' | 'path' | 'query'
      >
  >(
    // @ts-ignore
    {
      queryFn: async ({ pageParam, queryKey, signal }) => {
        // @ts-ignore
        const page: Pick<
          QueryKey<Options<OpportunitiesStatusesListListData>>[0],
          'body' | 'headers' | 'path' | 'query'
        > =
          typeof pageParam === 'object'
            ? pageParam
            : {
                query: {
                  page: pageParam
                }
              }
        const params = createInfiniteParams(queryKey, page)
        const { data } = await opportunitiesStatusesListList({
          ...options,
          ...params,
          signal,
          throwOnError: true
        })

        return data
      },
      queryKey: opportunitiesStatusesListListInfiniteQueryKey(options)
    }
  )
}

export const opportunitiesContactsListQueryKey = (
  options: Options<OpportunitiesContactsListData>
) => createQueryKey('opportunitiesContactsList', options)

export const opportunitiesContactsListOptions = (
  options: Options<OpportunitiesContactsListData>
) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await opportunitiesContactsList({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true
      })

      return data
    },
    queryKey: opportunitiesContactsListQueryKey(options)
  })
}

export const opportunitiesContactsListInfiniteQueryKey = (
  options: Options<OpportunitiesContactsListData>
): QueryKey<Options<OpportunitiesContactsListData>> =>
  createQueryKey('opportunitiesContactsList', options, true)

export const opportunitiesContactsListInfiniteOptions = (
  options: Options<OpportunitiesContactsListData>
) => {
  return infiniteQueryOptions<
    OpportunitiesContactsListResponse,
    AxiosError<DefaultError>,
    InfiniteData<OpportunitiesContactsListResponse>,
    QueryKey<Options<OpportunitiesContactsListData>>,
    | number
    | Pick<
        QueryKey<Options<OpportunitiesContactsListData>>[0],
        'body' | 'headers' | 'path' | 'query'
      >
  >(
    // @ts-ignore
    {
      queryFn: async ({ pageParam, queryKey, signal }) => {
        // @ts-ignore
        const page: Pick<
          QueryKey<Options<OpportunitiesContactsListData>>[0],
          'body' | 'headers' | 'path' | 'query'
        > =
          typeof pageParam === 'object'
            ? pageParam
            : {
                query: {
                  page: pageParam
                }
              }
        const params = createInfiniteParams(queryKey, page)
        const { data } = await opportunitiesContactsList({
          ...options,
          ...params,
          signal,
          throwOnError: true
        })

        return data
      },
      queryKey: opportunitiesContactsListInfiniteQueryKey(options)
    }
  )
}

export const opportunitiesContractsListQueryKey = (
  options: Options<OpportunitiesContractsListData>
) => createQueryKey('opportunitiesContractsList', options)

export const opportunitiesContractsListOptions = (
  options: Options<OpportunitiesContractsListData>
) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await opportunitiesContractsList({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true
      })

      return data
    },
    queryKey: opportunitiesContractsListQueryKey(options)
  })
}

export const opportunitiesContractsListInfiniteQueryKey = (
  options: Options<OpportunitiesContractsListData>
): QueryKey<Options<OpportunitiesContractsListData>> =>
  createQueryKey('opportunitiesContractsList', options, true)

export const opportunitiesContractsListInfiniteOptions = (
  options: Options<OpportunitiesContractsListData>
) => {
  return infiniteQueryOptions<
    OpportunitiesContractsListResponse,
    AxiosError<DefaultError>,
    InfiniteData<OpportunitiesContractsListResponse>,
    QueryKey<Options<OpportunitiesContractsListData>>,
    | number
    | Pick<
        QueryKey<Options<OpportunitiesContractsListData>>[0],
        'body' | 'headers' | 'path' | 'query'
      >
  >(
    // @ts-ignore
    {
      queryFn: async ({ pageParam, queryKey, signal }) => {
        // @ts-ignore
        const page: Pick<
          QueryKey<Options<OpportunitiesContractsListData>>[0],
          'body' | 'headers' | 'path' | 'query'
        > =
          typeof pageParam === 'object'
            ? pageParam
            : {
                query: {
                  page: pageParam
                }
              }
        const params = createInfiniteParams(queryKey, page)
        const { data } = await opportunitiesContractsList({
          ...options,
          ...params,
          signal,
          throwOnError: true
        })

        return data
      },
      queryKey: opportunitiesContractsListInfiniteQueryKey(options)
    }
  )
}

export const opportunitiesDocumentsListQueryKey = (
  options: Options<OpportunitiesDocumentsListData>
) => createQueryKey('opportunitiesDocumentsList', options)

export const opportunitiesDocumentsListOptions = (
  options: Options<OpportunitiesDocumentsListData>
) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await opportunitiesDocumentsList({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true
      })

      return data
    },
    queryKey: opportunitiesDocumentsListQueryKey(options)
  })
}

export const opportunitiesDocumentsListInfiniteQueryKey = (
  options: Options<OpportunitiesDocumentsListData>
): QueryKey<Options<OpportunitiesDocumentsListData>> =>
  createQueryKey('opportunitiesDocumentsList', options, true)

export const opportunitiesDocumentsListInfiniteOptions = (
  options: Options<OpportunitiesDocumentsListData>
) => {
  return infiniteQueryOptions<
    OpportunitiesDocumentsListResponse,
    AxiosError<DefaultError>,
    InfiniteData<OpportunitiesDocumentsListResponse>,
    QueryKey<Options<OpportunitiesDocumentsListData>>,
    | number
    | Pick<
        QueryKey<Options<OpportunitiesDocumentsListData>>[0],
        'body' | 'headers' | 'path' | 'query'
      >
  >(
    // @ts-ignore
    {
      queryFn: async ({ pageParam, queryKey, signal }) => {
        // @ts-ignore
        const page: Pick<
          QueryKey<Options<OpportunitiesDocumentsListData>>[0],
          'body' | 'headers' | 'path' | 'query'
        > =
          typeof pageParam === 'object'
            ? pageParam
            : {
                query: {
                  page: pageParam
                }
              }
        const params = createInfiniteParams(queryKey, page)
        const { data } = await opportunitiesDocumentsList({
          ...options,
          ...params,
          signal,
          throwOnError: true
        })

        return data
      },
      queryKey: opportunitiesDocumentsListInfiniteQueryKey(options)
    }
  )
}

export const opportunitiesLogsListQueryKey = (
  options: Options<OpportunitiesLogsListData>
) => createQueryKey('opportunitiesLogsList', options)

export const opportunitiesLogsListOptions = (
  options: Options<OpportunitiesLogsListData>
) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await opportunitiesLogsList({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true
      })

      return data
    },
    queryKey: opportunitiesLogsListQueryKey(options)
  })
}

export const opportunitiesLogsListInfiniteQueryKey = (
  options: Options<OpportunitiesLogsListData>
): QueryKey<Options<OpportunitiesLogsListData>> =>
  createQueryKey('opportunitiesLogsList', options, true)

export const opportunitiesLogsListInfiniteOptions = (
  options: Options<OpportunitiesLogsListData>
) => {
  return infiniteQueryOptions<
    OpportunitiesLogsListResponse,
    AxiosError<DefaultError>,
    InfiniteData<OpportunitiesLogsListResponse>,
    QueryKey<Options<OpportunitiesLogsListData>>,
    | number
    | Pick<
        QueryKey<Options<OpportunitiesLogsListData>>[0],
        'body' | 'headers' | 'path' | 'query'
      >
  >(
    // @ts-ignore
    {
      queryFn: async ({ pageParam, queryKey, signal }) => {
        // @ts-ignore
        const page: Pick<
          QueryKey<Options<OpportunitiesLogsListData>>[0],
          'body' | 'headers' | 'path' | 'query'
        > =
          typeof pageParam === 'object'
            ? pageParam
            : {
                query: {
                  page: pageParam
                }
              }
        const params = createInfiniteParams(queryKey, page)
        const { data } = await opportunitiesLogsList({
          ...options,
          ...params,
          signal,
          throwOnError: true
        })

        return data
      },
      queryKey: opportunitiesLogsListInfiniteQueryKey(options)
    }
  )
}

export const opportunitiesTasksListQueryKey = (
  options: Options<OpportunitiesTasksListData>
) => createQueryKey('opportunitiesTasksList', options)

export const opportunitiesTasksListOptions = (
  options: Options<OpportunitiesTasksListData>
) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await opportunitiesTasksList({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true
      })

      return data
    },
    queryKey: opportunitiesTasksListQueryKey(options)
  })
}

export const opportunitiesTasksListInfiniteQueryKey = (
  options: Options<OpportunitiesTasksListData>
): QueryKey<Options<OpportunitiesTasksListData>> =>
  createQueryKey('opportunitiesTasksList', options, true)

export const opportunitiesTasksListInfiniteOptions = (
  options: Options<OpportunitiesTasksListData>
) => {
  return infiniteQueryOptions<
    OpportunitiesTasksListResponse,
    AxiosError<DefaultError>,
    InfiniteData<OpportunitiesTasksListResponse>,
    QueryKey<Options<OpportunitiesTasksListData>>,
    | number
    | Pick<
        QueryKey<Options<OpportunitiesTasksListData>>[0],
        'body' | 'headers' | 'path' | 'query'
      >
  >(
    // @ts-ignore
    {
      queryFn: async ({ pageParam, queryKey, signal }) => {
        // @ts-ignore
        const page: Pick<
          QueryKey<Options<OpportunitiesTasksListData>>[0],
          'body' | 'headers' | 'path' | 'query'
        > =
          typeof pageParam === 'object'
            ? pageParam
            : {
                query: {
                  page: pageParam
                }
              }
        const params = createInfiniteParams(queryKey, page)
        const { data } = await opportunitiesTasksList({
          ...options,
          ...params,
          signal,
          throwOnError: true
        })

        return data
      },
      queryKey: opportunitiesTasksListInfiniteQueryKey(options)
    }
  )
}

export const opportunitiesDestroyMutation = (
  options?: Partial<Options<OpportunitiesDestroyData>>
): UseMutationOptions<
  OpportunitiesDestroyResponse,
  AxiosError<DefaultError>,
  Options<OpportunitiesDestroyData>
> => {
  const mutationOptions: UseMutationOptions<
    OpportunitiesDestroyResponse,
    AxiosError<DefaultError>,
    Options<OpportunitiesDestroyData>
  > = {
    mutationFn: async (localOptions) => {
      const { data } = await opportunitiesDestroy({
        ...options,
        ...localOptions,
        throwOnError: true
      })

      return data
    }
  }

  return mutationOptions
}

export const opportunitiesRetrieveQueryKey = (
  options: Options<OpportunitiesRetrieveData>
) => createQueryKey('opportunitiesRetrieve', options)

export const opportunitiesRetrieveOptions = (
  options: Options<OpportunitiesRetrieveData>
) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await opportunitiesRetrieve({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true
      })

      return data
    },
    queryKey: opportunitiesRetrieveQueryKey(options)
  })
}

export const opportunitiesPartialUpdateMutation = (
  options?: Partial<Options<OpportunitiesPartialUpdateData>>
): UseMutationOptions<
  OpportunitiesPartialUpdateResponse,
  AxiosError<DefaultError>,
  Options<OpportunitiesPartialUpdateData>
> => {
  const mutationOptions: UseMutationOptions<
    OpportunitiesPartialUpdateResponse,
    AxiosError<DefaultError>,
    Options<OpportunitiesPartialUpdateData>
  > = {
    mutationFn: async (localOptions) => {
      const { data } = await opportunitiesPartialUpdate({
        ...options,
        ...localOptions,
        throwOnError: true
      })

      return data
    }
  }

  return mutationOptions
}

export const opportunitiesUpdateMutation = (
  options?: Partial<Options<OpportunitiesUpdateData>>
): UseMutationOptions<
  OpportunitiesUpdateResponse,
  AxiosError<DefaultError>,
  Options<OpportunitiesUpdateData>
> => {
  const mutationOptions: UseMutationOptions<
    OpportunitiesUpdateResponse,
    AxiosError<DefaultError>,
    Options<OpportunitiesUpdateData>
  > = {
    mutationFn: async (localOptions) => {
      const { data } = await opportunitiesUpdate({
        ...options,
        ...localOptions,
        throwOnError: true
      })

      return data
    }
  }

  return mutationOptions
}

export const opportunitiesConvertToClientCreateQueryKey = (
  options: Options<OpportunitiesConvertToClientCreateData>
) => createQueryKey('opportunitiesConvertToClientCreate', options)

export const opportunitiesConvertToClientCreateOptions = (
  options: Options<OpportunitiesConvertToClientCreateData>
) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await opportunitiesConvertToClientCreate({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true
      })

      return data
    },
    queryKey: opportunitiesConvertToClientCreateQueryKey(options)
  })
}

export const opportunitiesConvertToClientCreateMutation = (
  options?: Partial<Options<OpportunitiesConvertToClientCreateData>>
): UseMutationOptions<
  OpportunitiesConvertToClientCreateResponse,
  AxiosError<DefaultError>,
  Options<OpportunitiesConvertToClientCreateData>
> => {
  const mutationOptions: UseMutationOptions<
    OpportunitiesConvertToClientCreateResponse,
    AxiosError<DefaultError>,
    Options<OpportunitiesConvertToClientCreateData>
  > = {
    mutationFn: async (localOptions) => {
      const { data } = await opportunitiesConvertToClientCreate({
        ...options,
        ...localOptions,
        throwOnError: true
      })

      return data
    }
  }

  return mutationOptions
}

export const opportunitiesDuplicateCreateQueryKey = (
  options: Options<OpportunitiesDuplicateCreateData>
) => createQueryKey('opportunitiesDuplicateCreate', options)

export const opportunitiesDuplicateCreateOptions = (
  options: Options<OpportunitiesDuplicateCreateData>
) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await opportunitiesDuplicateCreate({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true
      })

      return data
    },
    queryKey: opportunitiesDuplicateCreateQueryKey(options)
  })
}

export const opportunitiesDuplicateCreateMutation = (
  options?: Partial<Options<OpportunitiesDuplicateCreateData>>
): UseMutationOptions<
  OpportunitiesDuplicateCreateResponse,
  AxiosError<DefaultError>,
  Options<OpportunitiesDuplicateCreateData>
> => {
  const mutationOptions: UseMutationOptions<
    OpportunitiesDuplicateCreateResponse,
    AxiosError<DefaultError>,
    Options<OpportunitiesDuplicateCreateData>
  > = {
    mutationFn: async (localOptions) => {
      const { data } = await opportunitiesDuplicateCreate({
        ...options,
        ...localOptions,
        throwOnError: true
      })

      return data
    }
  }

  return mutationOptions
}

export const opportunitiesMergePartialUpdateMutation = (
  options?: Partial<Options<OpportunitiesMergePartialUpdateData>>
): UseMutationOptions<
  OpportunitiesMergePartialUpdateResponse,
  AxiosError<DefaultError>,
  Options<OpportunitiesMergePartialUpdateData>
> => {
  const mutationOptions: UseMutationOptions<
    OpportunitiesMergePartialUpdateResponse,
    AxiosError<DefaultError>,
    Options<OpportunitiesMergePartialUpdateData>
  > = {
    mutationFn: async (localOptions) => {
      const { data } = await opportunitiesMergePartialUpdate({
        ...options,
        ...localOptions,
        throwOnError: true
      })

      return data
    }
  }

  return mutationOptions
}

export const opportunitiesPipelineListQueryKey = (
  options?: Options<OpportunitiesPipelineListData>
) => createQueryKey('opportunitiesPipelineList', options)

export const opportunitiesPipelineListOptions = (
  options?: Options<OpportunitiesPipelineListData>
) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await opportunitiesPipelineList({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true
      })

      return data
    },
    queryKey: opportunitiesPipelineListQueryKey(options)
  })
}

export const opportunitiesPipelineListInfiniteQueryKey = (
  options?: Options<OpportunitiesPipelineListData>
): QueryKey<Options<OpportunitiesPipelineListData>> =>
  createQueryKey('opportunitiesPipelineList', options, true)

export const opportunitiesPipelineListInfiniteOptions = (
  options?: Options<OpportunitiesPipelineListData>
) => {
  return infiniteQueryOptions<
    OpportunitiesPipelineListResponse,
    AxiosError<DefaultError>,
    InfiniteData<OpportunitiesPipelineListResponse>,
    QueryKey<Options<OpportunitiesPipelineListData>>,
    | number
    | Pick<
        QueryKey<Options<OpportunitiesPipelineListData>>[0],
        'body' | 'headers' | 'path' | 'query'
      >
  >(
    // @ts-ignore
    {
      queryFn: async ({ pageParam, queryKey, signal }) => {
        // @ts-ignore
        const page: Pick<
          QueryKey<Options<OpportunitiesPipelineListData>>[0],
          'body' | 'headers' | 'path' | 'query'
        > =
          typeof pageParam === 'object'
            ? pageParam
            : {
                query: {
                  page: pageParam
                }
              }
        const params = createInfiniteParams(queryKey, page)
        const { data } = await opportunitiesPipelineList({
          ...options,
          ...params,
          signal,
          throwOnError: true
        })

        return data
      },
      queryKey: opportunitiesPipelineListInfiniteQueryKey(options)
    }
  )
}

export const opportunitiesPipelinesListQueryKey = (
  options?: Options<OpportunitiesPipelinesListData>
) => createQueryKey('opportunitiesPipelinesList', options)

export const opportunitiesPipelinesListOptions = (
  options?: Options<OpportunitiesPipelinesListData>
) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await opportunitiesPipelinesList({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true
      })

      return data
    },
    queryKey: opportunitiesPipelinesListQueryKey(options)
  })
}

export const opportunitiesPipelinesListInfiniteQueryKey = (
  options?: Options<OpportunitiesPipelinesListData>
): QueryKey<Options<OpportunitiesPipelinesListData>> =>
  createQueryKey('opportunitiesPipelinesList', options, true)

export const opportunitiesPipelinesListInfiniteOptions = (
  options?: Options<OpportunitiesPipelinesListData>
) => {
  return infiniteQueryOptions<
    OpportunitiesPipelinesListResponse,
    AxiosError<DefaultError>,
    InfiniteData<OpportunitiesPipelinesListResponse>,
    QueryKey<Options<OpportunitiesPipelinesListData>>,
    | number
    | Pick<
        QueryKey<Options<OpportunitiesPipelinesListData>>[0],
        'body' | 'headers' | 'path' | 'query'
      >
  >(
    // @ts-ignore
    {
      queryFn: async ({ pageParam, queryKey, signal }) => {
        // @ts-ignore
        const page: Pick<
          QueryKey<Options<OpportunitiesPipelinesListData>>[0],
          'body' | 'headers' | 'path' | 'query'
        > =
          typeof pageParam === 'object'
            ? pageParam
            : {
                query: {
                  page: pageParam
                }
              }
        const params = createInfiniteParams(queryKey, page)
        const { data } = await opportunitiesPipelinesList({
          ...options,
          ...params,
          signal,
          throwOnError: true
        })

        return data
      },
      queryKey: opportunitiesPipelinesListInfiniteQueryKey(options)
    }
  )
}

export const opportunitiesPipelinesCreateQueryKey = (
  options: Options<OpportunitiesPipelinesCreateData>
) => createQueryKey('opportunitiesPipelinesCreate', options)

export const opportunitiesPipelinesCreateOptions = (
  options: Options<OpportunitiesPipelinesCreateData>
) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await opportunitiesPipelinesCreate({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true
      })

      return data
    },
    queryKey: opportunitiesPipelinesCreateQueryKey(options)
  })
}

export const opportunitiesPipelinesCreateMutation = (
  options?: Partial<Options<OpportunitiesPipelinesCreateData>>
): UseMutationOptions<
  OpportunitiesPipelinesCreateResponse,
  AxiosError<DefaultError>,
  Options<OpportunitiesPipelinesCreateData>
> => {
  const mutationOptions: UseMutationOptions<
    OpportunitiesPipelinesCreateResponse,
    AxiosError<DefaultError>,
    Options<OpportunitiesPipelinesCreateData>
  > = {
    mutationFn: async (localOptions) => {
      const { data } = await opportunitiesPipelinesCreate({
        ...options,
        ...localOptions,
        throwOnError: true
      })

      return data
    }
  }

  return mutationOptions
}

export const opportunitiesPipelinesStatusesListQueryKey = (
  options: Options<OpportunitiesPipelinesStatusesListData>
) => createQueryKey('opportunitiesPipelinesStatusesList', options)

export const opportunitiesPipelinesStatusesListOptions = (
  options: Options<OpportunitiesPipelinesStatusesListData>
) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await opportunitiesPipelinesStatusesList({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true
      })

      return data
    },
    queryKey: opportunitiesPipelinesStatusesListQueryKey(options)
  })
}

export const opportunitiesPipelinesStatusesListInfiniteQueryKey = (
  options: Options<OpportunitiesPipelinesStatusesListData>
): QueryKey<Options<OpportunitiesPipelinesStatusesListData>> =>
  createQueryKey('opportunitiesPipelinesStatusesList', options, true)

export const opportunitiesPipelinesStatusesListInfiniteOptions = (
  options: Options<OpportunitiesPipelinesStatusesListData>
) => {
  return infiniteQueryOptions<
    OpportunitiesPipelinesStatusesListResponse,
    AxiosError<DefaultError>,
    InfiniteData<OpportunitiesPipelinesStatusesListResponse>,
    QueryKey<Options<OpportunitiesPipelinesStatusesListData>>,
    | number
    | Pick<
        QueryKey<Options<OpportunitiesPipelinesStatusesListData>>[0],
        'body' | 'headers' | 'path' | 'query'
      >
  >(
    // @ts-ignore
    {
      queryFn: async ({ pageParam, queryKey, signal }) => {
        // @ts-ignore
        const page: Pick<
          QueryKey<Options<OpportunitiesPipelinesStatusesListData>>[0],
          'body' | 'headers' | 'path' | 'query'
        > =
          typeof pageParam === 'object'
            ? pageParam
            : {
                query: {
                  page: pageParam
                }
              }
        const params = createInfiniteParams(queryKey, page)
        const { data } = await opportunitiesPipelinesStatusesList({
          ...options,
          ...params,
          signal,
          throwOnError: true
        })

        return data
      },
      queryKey: opportunitiesPipelinesStatusesListInfiniteQueryKey(options)
    }
  )
}

export const opportunitiesPipelinesStatusesCreateQueryKey = (
  options: Options<OpportunitiesPipelinesStatusesCreateData>
) => createQueryKey('opportunitiesPipelinesStatusesCreate', options)

export const opportunitiesPipelinesStatusesCreateOptions = (
  options: Options<OpportunitiesPipelinesStatusesCreateData>
) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await opportunitiesPipelinesStatusesCreate({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true
      })

      return data
    },
    queryKey: opportunitiesPipelinesStatusesCreateQueryKey(options)
  })
}

export const opportunitiesPipelinesStatusesCreateMutation = (
  options?: Partial<Options<OpportunitiesPipelinesStatusesCreateData>>
): UseMutationOptions<
  OpportunitiesPipelinesStatusesCreateResponse,
  AxiosError<DefaultError>,
  Options<OpportunitiesPipelinesStatusesCreateData>
> => {
  const mutationOptions: UseMutationOptions<
    OpportunitiesPipelinesStatusesCreateResponse,
    AxiosError<DefaultError>,
    Options<OpportunitiesPipelinesStatusesCreateData>
  > = {
    mutationFn: async (localOptions) => {
      const { data } = await opportunitiesPipelinesStatusesCreate({
        ...options,
        ...localOptions,
        throwOnError: true
      })

      return data
    }
  }

  return mutationOptions
}

export const opportunitiesPipelinesStatusesDestroyMutation = (
  options?: Partial<Options<OpportunitiesPipelinesStatusesDestroyData>>
): UseMutationOptions<
  OpportunitiesPipelinesStatusesDestroyResponse,
  AxiosError<DefaultError>,
  Options<OpportunitiesPipelinesStatusesDestroyData>
> => {
  const mutationOptions: UseMutationOptions<
    OpportunitiesPipelinesStatusesDestroyResponse,
    AxiosError<DefaultError>,
    Options<OpportunitiesPipelinesStatusesDestroyData>
  > = {
    mutationFn: async (localOptions) => {
      const { data } = await opportunitiesPipelinesStatusesDestroy({
        ...options,
        ...localOptions,
        throwOnError: true
      })

      return data
    }
  }

  return mutationOptions
}

export const opportunitiesPipelinesStatusesRetrieveQueryKey = (
  options: Options<OpportunitiesPipelinesStatusesRetrieveData>
) => createQueryKey('opportunitiesPipelinesStatusesRetrieve', options)

export const opportunitiesPipelinesStatusesRetrieveOptions = (
  options: Options<OpportunitiesPipelinesStatusesRetrieveData>
) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await opportunitiesPipelinesStatusesRetrieve({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true
      })

      return data
    },
    queryKey: opportunitiesPipelinesStatusesRetrieveQueryKey(options)
  })
}

export const opportunitiesPipelinesStatusesPartialUpdateMutation = (
  options?: Partial<Options<OpportunitiesPipelinesStatusesPartialUpdateData>>
): UseMutationOptions<
  OpportunitiesPipelinesStatusesPartialUpdateResponse,
  AxiosError<DefaultError>,
  Options<OpportunitiesPipelinesStatusesPartialUpdateData>
> => {
  const mutationOptions: UseMutationOptions<
    OpportunitiesPipelinesStatusesPartialUpdateResponse,
    AxiosError<DefaultError>,
    Options<OpportunitiesPipelinesStatusesPartialUpdateData>
  > = {
    mutationFn: async (localOptions) => {
      const { data } = await opportunitiesPipelinesStatusesPartialUpdate({
        ...options,
        ...localOptions,
        throwOnError: true
      })

      return data
    }
  }

  return mutationOptions
}

export const opportunitiesPipelinesStatusesUpdateMutation = (
  options?: Partial<Options<OpportunitiesPipelinesStatusesUpdateData>>
): UseMutationOptions<
  OpportunitiesPipelinesStatusesUpdateResponse,
  AxiosError<DefaultError>,
  Options<OpportunitiesPipelinesStatusesUpdateData>
> => {
  const mutationOptions: UseMutationOptions<
    OpportunitiesPipelinesStatusesUpdateResponse,
    AxiosError<DefaultError>,
    Options<OpportunitiesPipelinesStatusesUpdateData>
  > = {
    mutationFn: async (localOptions) => {
      const { data } = await opportunitiesPipelinesStatusesUpdate({
        ...options,
        ...localOptions,
        throwOnError: true
      })

      return data
    }
  }

  return mutationOptions
}

export const opportunitiesPipelinesStatusesListListQueryKey = (
  options: Options<OpportunitiesPipelinesStatusesListListData>
) => createQueryKey('opportunitiesPipelinesStatusesListList', options)

export const opportunitiesPipelinesStatusesListListOptions = (
  options: Options<OpportunitiesPipelinesStatusesListListData>
) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await opportunitiesPipelinesStatusesListList({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true
      })

      return data
    },
    queryKey: opportunitiesPipelinesStatusesListListQueryKey(options)
  })
}

export const opportunitiesPipelinesStatusesListListInfiniteQueryKey = (
  options: Options<OpportunitiesPipelinesStatusesListListData>
): QueryKey<Options<OpportunitiesPipelinesStatusesListListData>> =>
  createQueryKey('opportunitiesPipelinesStatusesListList', options, true)

export const opportunitiesPipelinesStatusesListListInfiniteOptions = (
  options: Options<OpportunitiesPipelinesStatusesListListData>
) => {
  return infiniteQueryOptions<
    OpportunitiesPipelinesStatusesListListResponse,
    AxiosError<DefaultError>,
    InfiniteData<OpportunitiesPipelinesStatusesListListResponse>,
    QueryKey<Options<OpportunitiesPipelinesStatusesListListData>>,
    | number
    | Pick<
        QueryKey<Options<OpportunitiesPipelinesStatusesListListData>>[0],
        'body' | 'headers' | 'path' | 'query'
      >
  >(
    // @ts-ignore
    {
      queryFn: async ({ pageParam, queryKey, signal }) => {
        // @ts-ignore
        const page: Pick<
          QueryKey<Options<OpportunitiesPipelinesStatusesListListData>>[0],
          'body' | 'headers' | 'path' | 'query'
        > =
          typeof pageParam === 'object'
            ? pageParam
            : {
                query: {
                  page: pageParam
                }
              }
        const params = createInfiniteParams(queryKey, page)
        const { data } = await opportunitiesPipelinesStatusesListList({
          ...options,
          ...params,
          signal,
          throwOnError: true
        })

        return data
      },
      queryKey: opportunitiesPipelinesStatusesListListInfiniteQueryKey(options)
    }
  )
}

export const opportunitiesPipelinesDestroyMutation = (
  options?: Partial<Options<OpportunitiesPipelinesDestroyData>>
): UseMutationOptions<
  OpportunitiesPipelinesDestroyResponse,
  AxiosError<DefaultError>,
  Options<OpportunitiesPipelinesDestroyData>
> => {
  const mutationOptions: UseMutationOptions<
    OpportunitiesPipelinesDestroyResponse,
    AxiosError<DefaultError>,
    Options<OpportunitiesPipelinesDestroyData>
  > = {
    mutationFn: async (localOptions) => {
      const { data } = await opportunitiesPipelinesDestroy({
        ...options,
        ...localOptions,
        throwOnError: true
      })

      return data
    }
  }

  return mutationOptions
}

export const opportunitiesPipelinesRetrieveQueryKey = (
  options: Options<OpportunitiesPipelinesRetrieveData>
) => createQueryKey('opportunitiesPipelinesRetrieve', options)

export const opportunitiesPipelinesRetrieveOptions = (
  options: Options<OpportunitiesPipelinesRetrieveData>
) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await opportunitiesPipelinesRetrieve({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true
      })

      return data
    },
    queryKey: opportunitiesPipelinesRetrieveQueryKey(options)
  })
}

export const opportunitiesPipelinesPartialUpdateMutation = (
  options?: Partial<Options<OpportunitiesPipelinesPartialUpdateData>>
): UseMutationOptions<
  OpportunitiesPipelinesPartialUpdateResponse,
  AxiosError<DefaultError>,
  Options<OpportunitiesPipelinesPartialUpdateData>
> => {
  const mutationOptions: UseMutationOptions<
    OpportunitiesPipelinesPartialUpdateResponse,
    AxiosError<DefaultError>,
    Options<OpportunitiesPipelinesPartialUpdateData>
  > = {
    mutationFn: async (localOptions) => {
      const { data } = await opportunitiesPipelinesPartialUpdate({
        ...options,
        ...localOptions,
        throwOnError: true
      })

      return data
    }
  }

  return mutationOptions
}

export const opportunitiesPipelinesUpdateMutation = (
  options?: Partial<Options<OpportunitiesPipelinesUpdateData>>
): UseMutationOptions<
  OpportunitiesPipelinesUpdateResponse,
  AxiosError<DefaultError>,
  Options<OpportunitiesPipelinesUpdateData>
> => {
  const mutationOptions: UseMutationOptions<
    OpportunitiesPipelinesUpdateResponse,
    AxiosError<DefaultError>,
    Options<OpportunitiesPipelinesUpdateData>
  > = {
    mutationFn: async (localOptions) => {
      const { data } = await opportunitiesPipelinesUpdate({
        ...options,
        ...localOptions,
        throwOnError: true
      })

      return data
    }
  }

  return mutationOptions
}

export const opportunitiesPipelinesListListQueryKey = (
  options?: Options<OpportunitiesPipelinesListListData>
) => createQueryKey('opportunitiesPipelinesListList', options)

export const opportunitiesPipelinesListListOptions = (
  options?: Options<OpportunitiesPipelinesListListData>
) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await opportunitiesPipelinesListList({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true
      })

      return data
    },
    queryKey: opportunitiesPipelinesListListQueryKey(options)
  })
}

export const opportunitiesPipelinesListListInfiniteQueryKey = (
  options?: Options<OpportunitiesPipelinesListListData>
): QueryKey<Options<OpportunitiesPipelinesListListData>> =>
  createQueryKey('opportunitiesPipelinesListList', options, true)

export const opportunitiesPipelinesListListInfiniteOptions = (
  options?: Options<OpportunitiesPipelinesListListData>
) => {
  return infiniteQueryOptions<
    OpportunitiesPipelinesListListResponse,
    AxiosError<DefaultError>,
    InfiniteData<OpportunitiesPipelinesListListResponse>,
    QueryKey<Options<OpportunitiesPipelinesListListData>>,
    | number
    | Pick<
        QueryKey<Options<OpportunitiesPipelinesListListData>>[0],
        'body' | 'headers' | 'path' | 'query'
      >
  >(
    // @ts-ignore
    {
      queryFn: async ({ pageParam, queryKey, signal }) => {
        // @ts-ignore
        const page: Pick<
          QueryKey<Options<OpportunitiesPipelinesListListData>>[0],
          'body' | 'headers' | 'path' | 'query'
        > =
          typeof pageParam === 'object'
            ? pageParam
            : {
                query: {
                  page: pageParam
                }
              }
        const params = createInfiniteParams(queryKey, page)
        const { data } = await opportunitiesPipelinesListList({
          ...options,
          ...params,
          signal,
          throwOnError: true
        })

        return data
      },
      queryKey: opportunitiesPipelinesListListInfiniteQueryKey(options)
    }
  )
}

export const opportunitiesProductsListQueryKey = (
  options?: Options<OpportunitiesProductsListData>
) => createQueryKey('opportunitiesProductsList', options)

export const opportunitiesProductsListOptions = (
  options?: Options<OpportunitiesProductsListData>
) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await opportunitiesProductsList({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true
      })

      return data
    },
    queryKey: opportunitiesProductsListQueryKey(options)
  })
}

export const opportunitiesProductsListInfiniteQueryKey = (
  options?: Options<OpportunitiesProductsListData>
): QueryKey<Options<OpportunitiesProductsListData>> =>
  createQueryKey('opportunitiesProductsList', options, true)

export const opportunitiesProductsListInfiniteOptions = (
  options?: Options<OpportunitiesProductsListData>
) => {
  return infiniteQueryOptions<
    OpportunitiesProductsListResponse,
    AxiosError<DefaultError>,
    InfiniteData<OpportunitiesProductsListResponse>,
    QueryKey<Options<OpportunitiesProductsListData>>,
    | number
    | Pick<
        QueryKey<Options<OpportunitiesProductsListData>>[0],
        'body' | 'headers' | 'path' | 'query'
      >
  >(
    // @ts-ignore
    {
      queryFn: async ({ pageParam, queryKey, signal }) => {
        // @ts-ignore
        const page: Pick<
          QueryKey<Options<OpportunitiesProductsListData>>[0],
          'body' | 'headers' | 'path' | 'query'
        > =
          typeof pageParam === 'object'
            ? pageParam
            : {
                query: {
                  page: pageParam
                }
              }
        const params = createInfiniteParams(queryKey, page)
        const { data } = await opportunitiesProductsList({
          ...options,
          ...params,
          signal,
          throwOnError: true
        })

        return data
      },
      queryKey: opportunitiesProductsListInfiniteQueryKey(options)
    }
  )
}

export const opportunitiesProductsCreateQueryKey = (
  options: Options<OpportunitiesProductsCreateData>
) => createQueryKey('opportunitiesProductsCreate', options)

export const opportunitiesProductsCreateOptions = (
  options: Options<OpportunitiesProductsCreateData>
) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await opportunitiesProductsCreate({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true
      })

      return data
    },
    queryKey: opportunitiesProductsCreateQueryKey(options)
  })
}

export const opportunitiesProductsCreateMutation = (
  options?: Partial<Options<OpportunitiesProductsCreateData>>
): UseMutationOptions<
  OpportunitiesProductsCreateResponse,
  AxiosError<DefaultError>,
  Options<OpportunitiesProductsCreateData>
> => {
  const mutationOptions: UseMutationOptions<
    OpportunitiesProductsCreateResponse,
    AxiosError<DefaultError>,
    Options<OpportunitiesProductsCreateData>
  > = {
    mutationFn: async (localOptions) => {
      const { data } = await opportunitiesProductsCreate({
        ...options,
        ...localOptions,
        throwOnError: true
      })

      return data
    }
  }

  return mutationOptions
}

export const opportunitiesProductsDestroyMutation = (
  options?: Partial<Options<OpportunitiesProductsDestroyData>>
): UseMutationOptions<
  OpportunitiesProductsDestroyResponse,
  AxiosError<DefaultError>,
  Options<OpportunitiesProductsDestroyData>
> => {
  const mutationOptions: UseMutationOptions<
    OpportunitiesProductsDestroyResponse,
    AxiosError<DefaultError>,
    Options<OpportunitiesProductsDestroyData>
  > = {
    mutationFn: async (localOptions) => {
      const { data } = await opportunitiesProductsDestroy({
        ...options,
        ...localOptions,
        throwOnError: true
      })

      return data
    }
  }

  return mutationOptions
}

export const opportunitiesProductsRetrieveQueryKey = (
  options: Options<OpportunitiesProductsRetrieveData>
) => createQueryKey('opportunitiesProductsRetrieve', options)

export const opportunitiesProductsRetrieveOptions = (
  options: Options<OpportunitiesProductsRetrieveData>
) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await opportunitiesProductsRetrieve({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true
      })

      return data
    },
    queryKey: opportunitiesProductsRetrieveQueryKey(options)
  })
}

export const opportunitiesProductsPartialUpdateMutation = (
  options?: Partial<Options<OpportunitiesProductsPartialUpdateData>>
): UseMutationOptions<
  OpportunitiesProductsPartialUpdateResponse,
  AxiosError<DefaultError>,
  Options<OpportunitiesProductsPartialUpdateData>
> => {
  const mutationOptions: UseMutationOptions<
    OpportunitiesProductsPartialUpdateResponse,
    AxiosError<DefaultError>,
    Options<OpportunitiesProductsPartialUpdateData>
  > = {
    mutationFn: async (localOptions) => {
      const { data } = await opportunitiesProductsPartialUpdate({
        ...options,
        ...localOptions,
        throwOnError: true
      })

      return data
    }
  }

  return mutationOptions
}

export const opportunitiesProductsUpdateMutation = (
  options?: Partial<Options<OpportunitiesProductsUpdateData>>
): UseMutationOptions<
  OpportunitiesProductsUpdateResponse,
  AxiosError<DefaultError>,
  Options<OpportunitiesProductsUpdateData>
> => {
  const mutationOptions: UseMutationOptions<
    OpportunitiesProductsUpdateResponse,
    AxiosError<DefaultError>,
    Options<OpportunitiesProductsUpdateData>
  > = {
    mutationFn: async (localOptions) => {
      const { data } = await opportunitiesProductsUpdate({
        ...options,
        ...localOptions,
        throwOnError: true
      })

      return data
    }
  }

  return mutationOptions
}

export const opportunitiesProductsBulkCreateCreateQueryKey = (
  options: Options<OpportunitiesProductsBulkCreateCreateData>
) => createQueryKey('opportunitiesProductsBulkCreateCreate', options)

export const opportunitiesProductsBulkCreateCreateOptions = (
  options: Options<OpportunitiesProductsBulkCreateCreateData>
) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await opportunitiesProductsBulkCreateCreate({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true
      })

      return data
    },
    queryKey: opportunitiesProductsBulkCreateCreateQueryKey(options)
  })
}

export const opportunitiesProductsBulkCreateCreateMutation = (
  options?: Partial<Options<OpportunitiesProductsBulkCreateCreateData>>
): UseMutationOptions<
  OpportunitiesProductsBulkCreateCreateResponse,
  AxiosError<DefaultError>,
  Options<OpportunitiesProductsBulkCreateCreateData>
> => {
  const mutationOptions: UseMutationOptions<
    OpportunitiesProductsBulkCreateCreateResponse,
    AxiosError<DefaultError>,
    Options<OpportunitiesProductsBulkCreateCreateData>
  > = {
    mutationFn: async (localOptions) => {
      const { data } = await opportunitiesProductsBulkCreateCreate({
        ...options,
        ...localOptions,
        throwOnError: true
      })

      return data
    }
  }

  return mutationOptions
}

export const opportunitiesProductsBulkUpdatePartialUpdateMutation = (
  options?: Partial<Options<OpportunitiesProductsBulkUpdatePartialUpdateData>>
): UseMutationOptions<
  OpportunitiesProductsBulkUpdatePartialUpdateResponse,
  AxiosError<DefaultError>,
  Options<OpportunitiesProductsBulkUpdatePartialUpdateData>
> => {
  const mutationOptions: UseMutationOptions<
    OpportunitiesProductsBulkUpdatePartialUpdateResponse,
    AxiosError<DefaultError>,
    Options<OpportunitiesProductsBulkUpdatePartialUpdateData>
  > = {
    mutationFn: async (localOptions) => {
      const { data } = await opportunitiesProductsBulkUpdatePartialUpdate({
        ...options,
        ...localOptions,
        throwOnError: true
      })

      return data
    }
  }

  return mutationOptions
}

export const presetTasksListQueryKey = (
  options?: Options<PresetTasksListData>
) => createQueryKey('presetTasksList', options)

export const presetTasksListOptions = (
  options?: Options<PresetTasksListData>
) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await presetTasksList({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true
      })

      return data
    },
    queryKey: presetTasksListQueryKey(options)
  })
}

export const presetTasksListInfiniteQueryKey = (
  options?: Options<PresetTasksListData>
): QueryKey<Options<PresetTasksListData>> =>
  createQueryKey('presetTasksList', options, true)

export const presetTasksListInfiniteOptions = (
  options?: Options<PresetTasksListData>
) => {
  return infiniteQueryOptions<
    PresetTasksListResponse,
    AxiosError<DefaultError>,
    InfiniteData<PresetTasksListResponse>,
    QueryKey<Options<PresetTasksListData>>,
    | number
    | Pick<
        QueryKey<Options<PresetTasksListData>>[0],
        'body' | 'headers' | 'path' | 'query'
      >
  >(
    // @ts-ignore
    {
      queryFn: async ({ pageParam, queryKey, signal }) => {
        // @ts-ignore
        const page: Pick<
          QueryKey<Options<PresetTasksListData>>[0],
          'body' | 'headers' | 'path' | 'query'
        > =
          typeof pageParam === 'object'
            ? pageParam
            : {
                query: {
                  page: pageParam
                }
              }
        const params = createInfiniteParams(queryKey, page)
        const { data } = await presetTasksList({
          ...options,
          ...params,
          signal,
          throwOnError: true
        })

        return data
      },
      queryKey: presetTasksListInfiniteQueryKey(options)
    }
  )
}

export const presetTasksCreateQueryKey = (
  options: Options<PresetTasksCreateData>
) => createQueryKey('presetTasksCreate', options)

export const presetTasksCreateOptions = (
  options: Options<PresetTasksCreateData>
) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await presetTasksCreate({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true
      })

      return data
    },
    queryKey: presetTasksCreateQueryKey(options)
  })
}

export const presetTasksCreateMutation = (
  options?: Partial<Options<PresetTasksCreateData>>
): UseMutationOptions<
  PresetTasksCreateResponse,
  AxiosError<DefaultError>,
  Options<PresetTasksCreateData>
> => {
  const mutationOptions: UseMutationOptions<
    PresetTasksCreateResponse,
    AxiosError<DefaultError>,
    Options<PresetTasksCreateData>
  > = {
    mutationFn: async (localOptions) => {
      const { data } = await presetTasksCreate({
        ...options,
        ...localOptions,
        throwOnError: true
      })

      return data
    }
  }

  return mutationOptions
}

export const presetTasksDestroyMutation = (
  options?: Partial<Options<PresetTasksDestroyData>>
): UseMutationOptions<
  PresetTasksDestroyResponse,
  AxiosError<DefaultError>,
  Options<PresetTasksDestroyData>
> => {
  const mutationOptions: UseMutationOptions<
    PresetTasksDestroyResponse,
    AxiosError<DefaultError>,
    Options<PresetTasksDestroyData>
  > = {
    mutationFn: async (localOptions) => {
      const { data } = await presetTasksDestroy({
        ...options,
        ...localOptions,
        throwOnError: true
      })

      return data
    }
  }

  return mutationOptions
}

export const presetTasksRetrieveQueryKey = (
  options: Options<PresetTasksRetrieveData>
) => createQueryKey('presetTasksRetrieve', options)

export const presetTasksRetrieveOptions = (
  options: Options<PresetTasksRetrieveData>
) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await presetTasksRetrieve({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true
      })

      return data
    },
    queryKey: presetTasksRetrieveQueryKey(options)
  })
}

export const presetTasksPartialUpdateMutation = (
  options?: Partial<Options<PresetTasksPartialUpdateData>>
): UseMutationOptions<
  PresetTasksPartialUpdateResponse,
  AxiosError<DefaultError>,
  Options<PresetTasksPartialUpdateData>
> => {
  const mutationOptions: UseMutationOptions<
    PresetTasksPartialUpdateResponse,
    AxiosError<DefaultError>,
    Options<PresetTasksPartialUpdateData>
  > = {
    mutationFn: async (localOptions) => {
      const { data } = await presetTasksPartialUpdate({
        ...options,
        ...localOptions,
        throwOnError: true
      })

      return data
    }
  }

  return mutationOptions
}

export const presetTasksUpdateMutation = (
  options?: Partial<Options<PresetTasksUpdateData>>
): UseMutationOptions<
  PresetTasksUpdateResponse,
  AxiosError<DefaultError>,
  Options<PresetTasksUpdateData>
> => {
  const mutationOptions: UseMutationOptions<
    PresetTasksUpdateResponse,
    AxiosError<DefaultError>,
    Options<PresetTasksUpdateData>
  > = {
    mutationFn: async (localOptions) => {
      const { data } = await presetTasksUpdate({
        ...options,
        ...localOptions,
        throwOnError: true
      })

      return data
    }
  }

  return mutationOptions
}

export const productsListQueryKey = (options?: Options<ProductsListData>) =>
  createQueryKey('productsList', options)

export const productsListOptions = (options?: Options<ProductsListData>) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await productsList({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true
      })

      return data
    },
    queryKey: productsListQueryKey(options)
  })
}

export const productsListInfiniteQueryKey = (
  options?: Options<ProductsListData>
): QueryKey<Options<ProductsListData>> =>
  createQueryKey('productsList', options, true)

export const productsListInfiniteOptions = (
  options?: Options<ProductsListData>
) => {
  return infiniteQueryOptions<
    ProductsListResponse,
    AxiosError<DefaultError>,
    InfiniteData<ProductsListResponse>,
    QueryKey<Options<ProductsListData>>,
    | number
    | Pick<
        QueryKey<Options<ProductsListData>>[0],
        'body' | 'headers' | 'path' | 'query'
      >
  >(
    // @ts-ignore
    {
      queryFn: async ({ pageParam, queryKey, signal }) => {
        // @ts-ignore
        const page: Pick<
          QueryKey<Options<ProductsListData>>[0],
          'body' | 'headers' | 'path' | 'query'
        > =
          typeof pageParam === 'object'
            ? pageParam
            : {
                query: {
                  page: pageParam
                }
              }
        const params = createInfiniteParams(queryKey, page)
        const { data } = await productsList({
          ...options,
          ...params,
          signal,
          throwOnError: true
        })

        return data
      },
      queryKey: productsListInfiniteQueryKey(options)
    }
  )
}

export const productsCreateQueryKey = (options: Options<ProductsCreateData>) =>
  createQueryKey('productsCreate', options)

export const productsCreateOptions = (options: Options<ProductsCreateData>) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await productsCreate({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true
      })

      return data
    },
    queryKey: productsCreateQueryKey(options)
  })
}

export const productsCreateMutation = (
  options?: Partial<Options<ProductsCreateData>>
): UseMutationOptions<
  ProductsCreateResponse,
  AxiosError<DefaultError>,
  Options<ProductsCreateData>
> => {
  const mutationOptions: UseMutationOptions<
    ProductsCreateResponse,
    AxiosError<DefaultError>,
    Options<ProductsCreateData>
  > = {
    mutationFn: async (localOptions) => {
      const { data } = await productsCreate({
        ...options,
        ...localOptions,
        throwOnError: true
      })

      return data
    }
  }

  return mutationOptions
}

export const productsDestroyMutation = (
  options?: Partial<Options<ProductsDestroyData>>
): UseMutationOptions<
  ProductsDestroyResponse,
  AxiosError<DefaultError>,
  Options<ProductsDestroyData>
> => {
  const mutationOptions: UseMutationOptions<
    ProductsDestroyResponse,
    AxiosError<DefaultError>,
    Options<ProductsDestroyData>
  > = {
    mutationFn: async (localOptions) => {
      const { data } = await productsDestroy({
        ...options,
        ...localOptions,
        throwOnError: true
      })

      return data
    }
  }

  return mutationOptions
}

export const productsRetrieveQueryKey = (
  options: Options<ProductsRetrieveData>
) => createQueryKey('productsRetrieve', options)

export const productsRetrieveOptions = (
  options: Options<ProductsRetrieveData>
) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await productsRetrieve({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true
      })

      return data
    },
    queryKey: productsRetrieveQueryKey(options)
  })
}

export const productsPartialUpdateMutation = (
  options?: Partial<Options<ProductsPartialUpdateData>>
): UseMutationOptions<
  ProductsPartialUpdateResponse,
  AxiosError<DefaultError>,
  Options<ProductsPartialUpdateData>
> => {
  const mutationOptions: UseMutationOptions<
    ProductsPartialUpdateResponse,
    AxiosError<DefaultError>,
    Options<ProductsPartialUpdateData>
  > = {
    mutationFn: async (localOptions) => {
      const { data } = await productsPartialUpdate({
        ...options,
        ...localOptions,
        throwOnError: true
      })

      return data
    }
  }

  return mutationOptions
}

export const productsUpdateMutation = (
  options?: Partial<Options<ProductsUpdateData>>
): UseMutationOptions<
  ProductsUpdateResponse,
  AxiosError<DefaultError>,
  Options<ProductsUpdateData>
> => {
  const mutationOptions: UseMutationOptions<
    ProductsUpdateResponse,
    AxiosError<DefaultError>,
    Options<ProductsUpdateData>
  > = {
    mutationFn: async (localOptions) => {
      const { data } = await productsUpdate({
        ...options,
        ...localOptions,
        throwOnError: true
      })

      return data
    }
  }

  return mutationOptions
}

export const productsCategoriesListQueryKey = (
  options?: Options<ProductsCategoriesListData>
) => createQueryKey('productsCategoriesList', options)

export const productsCategoriesListOptions = (
  options?: Options<ProductsCategoriesListData>
) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await productsCategoriesList({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true
      })

      return data
    },
    queryKey: productsCategoriesListQueryKey(options)
  })
}

export const productsCategoriesListInfiniteQueryKey = (
  options?: Options<ProductsCategoriesListData>
): QueryKey<Options<ProductsCategoriesListData>> =>
  createQueryKey('productsCategoriesList', options, true)

export const productsCategoriesListInfiniteOptions = (
  options?: Options<ProductsCategoriesListData>
) => {
  return infiniteQueryOptions<
    ProductsCategoriesListResponse,
    AxiosError<DefaultError>,
    InfiniteData<ProductsCategoriesListResponse>,
    QueryKey<Options<ProductsCategoriesListData>>,
    | number
    | Pick<
        QueryKey<Options<ProductsCategoriesListData>>[0],
        'body' | 'headers' | 'path' | 'query'
      >
  >(
    // @ts-ignore
    {
      queryFn: async ({ pageParam, queryKey, signal }) => {
        // @ts-ignore
        const page: Pick<
          QueryKey<Options<ProductsCategoriesListData>>[0],
          'body' | 'headers' | 'path' | 'query'
        > =
          typeof pageParam === 'object'
            ? pageParam
            : {
                query: {
                  page: pageParam
                }
              }
        const params = createInfiniteParams(queryKey, page)
        const { data } = await productsCategoriesList({
          ...options,
          ...params,
          signal,
          throwOnError: true
        })

        return data
      },
      queryKey: productsCategoriesListInfiniteQueryKey(options)
    }
  )
}

export const productsCategoriesCreateQueryKey = (
  options: Options<ProductsCategoriesCreateData>
) => createQueryKey('productsCategoriesCreate', options)

export const productsCategoriesCreateOptions = (
  options: Options<ProductsCategoriesCreateData>
) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await productsCategoriesCreate({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true
      })

      return data
    },
    queryKey: productsCategoriesCreateQueryKey(options)
  })
}

export const productsCategoriesCreateMutation = (
  options?: Partial<Options<ProductsCategoriesCreateData>>
): UseMutationOptions<
  ProductsCategoriesCreateResponse,
  AxiosError<DefaultError>,
  Options<ProductsCategoriesCreateData>
> => {
  const mutationOptions: UseMutationOptions<
    ProductsCategoriesCreateResponse,
    AxiosError<DefaultError>,
    Options<ProductsCategoriesCreateData>
  > = {
    mutationFn: async (localOptions) => {
      const { data } = await productsCategoriesCreate({
        ...options,
        ...localOptions,
        throwOnError: true
      })

      return data
    }
  }

  return mutationOptions
}

export const productsCategoriesDestroyMutation = (
  options?: Partial<Options<ProductsCategoriesDestroyData>>
): UseMutationOptions<
  ProductsCategoriesDestroyResponse,
  AxiosError<DefaultError>,
  Options<ProductsCategoriesDestroyData>
> => {
  const mutationOptions: UseMutationOptions<
    ProductsCategoriesDestroyResponse,
    AxiosError<DefaultError>,
    Options<ProductsCategoriesDestroyData>
  > = {
    mutationFn: async (localOptions) => {
      const { data } = await productsCategoriesDestroy({
        ...options,
        ...localOptions,
        throwOnError: true
      })

      return data
    }
  }

  return mutationOptions
}

export const productsCategoriesRetrieveQueryKey = (
  options: Options<ProductsCategoriesRetrieveData>
) => createQueryKey('productsCategoriesRetrieve', options)

export const productsCategoriesRetrieveOptions = (
  options: Options<ProductsCategoriesRetrieveData>
) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await productsCategoriesRetrieve({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true
      })

      return data
    },
    queryKey: productsCategoriesRetrieveQueryKey(options)
  })
}

export const productsCategoriesPartialUpdateMutation = (
  options?: Partial<Options<ProductsCategoriesPartialUpdateData>>
): UseMutationOptions<
  ProductsCategoriesPartialUpdateResponse,
  AxiosError<DefaultError>,
  Options<ProductsCategoriesPartialUpdateData>
> => {
  const mutationOptions: UseMutationOptions<
    ProductsCategoriesPartialUpdateResponse,
    AxiosError<DefaultError>,
    Options<ProductsCategoriesPartialUpdateData>
  > = {
    mutationFn: async (localOptions) => {
      const { data } = await productsCategoriesPartialUpdate({
        ...options,
        ...localOptions,
        throwOnError: true
      })

      return data
    }
  }

  return mutationOptions
}

export const productsCategoriesUpdateMutation = (
  options?: Partial<Options<ProductsCategoriesUpdateData>>
): UseMutationOptions<
  ProductsCategoriesUpdateResponse,
  AxiosError<DefaultError>,
  Options<ProductsCategoriesUpdateData>
> => {
  const mutationOptions: UseMutationOptions<
    ProductsCategoriesUpdateResponse,
    AxiosError<DefaultError>,
    Options<ProductsCategoriesUpdateData>
  > = {
    mutationFn: async (localOptions) => {
      const { data } = await productsCategoriesUpdate({
        ...options,
        ...localOptions,
        throwOnError: true
      })

      return data
    }
  }

  return mutationOptions
}

export const productsCategoriesListListQueryKey = (
  options?: Options<ProductsCategoriesListListData>
) => createQueryKey('productsCategoriesListList', options)

export const productsCategoriesListListOptions = (
  options?: Options<ProductsCategoriesListListData>
) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await productsCategoriesListList({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true
      })

      return data
    },
    queryKey: productsCategoriesListListQueryKey(options)
  })
}

export const productsCategoriesListListInfiniteQueryKey = (
  options?: Options<ProductsCategoriesListListData>
): QueryKey<Options<ProductsCategoriesListListData>> =>
  createQueryKey('productsCategoriesListList', options, true)

export const productsCategoriesListListInfiniteOptions = (
  options?: Options<ProductsCategoriesListListData>
) => {
  return infiniteQueryOptions<
    ProductsCategoriesListListResponse,
    AxiosError<DefaultError>,
    InfiniteData<ProductsCategoriesListListResponse>,
    QueryKey<Options<ProductsCategoriesListListData>>,
    | number
    | Pick<
        QueryKey<Options<ProductsCategoriesListListData>>[0],
        'body' | 'headers' | 'path' | 'query'
      >
  >(
    // @ts-ignore
    {
      queryFn: async ({ pageParam, queryKey, signal }) => {
        // @ts-ignore
        const page: Pick<
          QueryKey<Options<ProductsCategoriesListListData>>[0],
          'body' | 'headers' | 'path' | 'query'
        > =
          typeof pageParam === 'object'
            ? pageParam
            : {
                query: {
                  page: pageParam
                }
              }
        const params = createInfiniteParams(queryKey, page)
        const { data } = await productsCategoriesListList({
          ...options,
          ...params,
          signal,
          throwOnError: true
        })

        return data
      },
      queryKey: productsCategoriesListListInfiniteQueryKey(options)
    }
  )
}

export const productsListListQueryKey = (
  options?: Options<ProductsListListData>
) => createQueryKey('productsListList', options)

export const productsListListOptions = (
  options?: Options<ProductsListListData>
) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await productsListList({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true
      })

      return data
    },
    queryKey: productsListListQueryKey(options)
  })
}

export const productsListListInfiniteQueryKey = (
  options?: Options<ProductsListListData>
): QueryKey<Options<ProductsListListData>> =>
  createQueryKey('productsListList', options, true)

export const productsListListInfiniteOptions = (
  options?: Options<ProductsListListData>
) => {
  return infiniteQueryOptions<
    ProductsListListResponse,
    AxiosError<DefaultError>,
    InfiniteData<ProductsListListResponse>,
    QueryKey<Options<ProductsListListData>>,
    | number
    | Pick<
        QueryKey<Options<ProductsListListData>>[0],
        'body' | 'headers' | 'path' | 'query'
      >
  >(
    // @ts-ignore
    {
      queryFn: async ({ pageParam, queryKey, signal }) => {
        // @ts-ignore
        const page: Pick<
          QueryKey<Options<ProductsListListData>>[0],
          'body' | 'headers' | 'path' | 'query'
        > =
          typeof pageParam === 'object'
            ? pageParam
            : {
                query: {
                  page: pageParam
                }
              }
        const params = createInfiniteParams(queryKey, page)
        const { data } = await productsListList({
          ...options,
          ...params,
          signal,
          throwOnError: true
        })

        return data
      },
      queryKey: productsListListInfiniteQueryKey(options)
    }
  )
}

export const productsUnitsOfMeasureListQueryKey = (
  options?: Options<ProductsUnitsOfMeasureListData>
) => createQueryKey('productsUnitsOfMeasureList', options)

export const productsUnitsOfMeasureListOptions = (
  options?: Options<ProductsUnitsOfMeasureListData>
) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await productsUnitsOfMeasureList({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true
      })

      return data
    },
    queryKey: productsUnitsOfMeasureListQueryKey(options)
  })
}

export const productsUnitsOfMeasureListInfiniteQueryKey = (
  options?: Options<ProductsUnitsOfMeasureListData>
): QueryKey<Options<ProductsUnitsOfMeasureListData>> =>
  createQueryKey('productsUnitsOfMeasureList', options, true)

export const productsUnitsOfMeasureListInfiniteOptions = (
  options?: Options<ProductsUnitsOfMeasureListData>
) => {
  return infiniteQueryOptions<
    ProductsUnitsOfMeasureListResponse,
    AxiosError<DefaultError>,
    InfiniteData<ProductsUnitsOfMeasureListResponse>,
    QueryKey<Options<ProductsUnitsOfMeasureListData>>,
    | number
    | Pick<
        QueryKey<Options<ProductsUnitsOfMeasureListData>>[0],
        'body' | 'headers' | 'path' | 'query'
      >
  >(
    // @ts-ignore
    {
      queryFn: async ({ pageParam, queryKey, signal }) => {
        // @ts-ignore
        const page: Pick<
          QueryKey<Options<ProductsUnitsOfMeasureListData>>[0],
          'body' | 'headers' | 'path' | 'query'
        > =
          typeof pageParam === 'object'
            ? pageParam
            : {
                query: {
                  page: pageParam
                }
              }
        const params = createInfiniteParams(queryKey, page)
        const { data } = await productsUnitsOfMeasureList({
          ...options,
          ...params,
          signal,
          throwOnError: true
        })

        return data
      },
      queryKey: productsUnitsOfMeasureListInfiniteQueryKey(options)
    }
  )
}

export const productsUnitsOfMeasureCreateQueryKey = (
  options: Options<ProductsUnitsOfMeasureCreateData>
) => createQueryKey('productsUnitsOfMeasureCreate', options)

export const productsUnitsOfMeasureCreateOptions = (
  options: Options<ProductsUnitsOfMeasureCreateData>
) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await productsUnitsOfMeasureCreate({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true
      })

      return data
    },
    queryKey: productsUnitsOfMeasureCreateQueryKey(options)
  })
}

export const productsUnitsOfMeasureCreateMutation = (
  options?: Partial<Options<ProductsUnitsOfMeasureCreateData>>
): UseMutationOptions<
  ProductsUnitsOfMeasureCreateResponse,
  AxiosError<DefaultError>,
  Options<ProductsUnitsOfMeasureCreateData>
> => {
  const mutationOptions: UseMutationOptions<
    ProductsUnitsOfMeasureCreateResponse,
    AxiosError<DefaultError>,
    Options<ProductsUnitsOfMeasureCreateData>
  > = {
    mutationFn: async (localOptions) => {
      const { data } = await productsUnitsOfMeasureCreate({
        ...options,
        ...localOptions,
        throwOnError: true
      })

      return data
    }
  }

  return mutationOptions
}

export const productsUnitsOfMeasureDestroyMutation = (
  options?: Partial<Options<ProductsUnitsOfMeasureDestroyData>>
): UseMutationOptions<
  ProductsUnitsOfMeasureDestroyResponse,
  AxiosError<DefaultError>,
  Options<ProductsUnitsOfMeasureDestroyData>
> => {
  const mutationOptions: UseMutationOptions<
    ProductsUnitsOfMeasureDestroyResponse,
    AxiosError<DefaultError>,
    Options<ProductsUnitsOfMeasureDestroyData>
  > = {
    mutationFn: async (localOptions) => {
      const { data } = await productsUnitsOfMeasureDestroy({
        ...options,
        ...localOptions,
        throwOnError: true
      })

      return data
    }
  }

  return mutationOptions
}

export const productsUnitsOfMeasureRetrieveQueryKey = (
  options: Options<ProductsUnitsOfMeasureRetrieveData>
) => createQueryKey('productsUnitsOfMeasureRetrieve', options)

export const productsUnitsOfMeasureRetrieveOptions = (
  options: Options<ProductsUnitsOfMeasureRetrieveData>
) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await productsUnitsOfMeasureRetrieve({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true
      })

      return data
    },
    queryKey: productsUnitsOfMeasureRetrieveQueryKey(options)
  })
}

export const productsUnitsOfMeasurePartialUpdateMutation = (
  options?: Partial<Options<ProductsUnitsOfMeasurePartialUpdateData>>
): UseMutationOptions<
  ProductsUnitsOfMeasurePartialUpdateResponse,
  AxiosError<DefaultError>,
  Options<ProductsUnitsOfMeasurePartialUpdateData>
> => {
  const mutationOptions: UseMutationOptions<
    ProductsUnitsOfMeasurePartialUpdateResponse,
    AxiosError<DefaultError>,
    Options<ProductsUnitsOfMeasurePartialUpdateData>
  > = {
    mutationFn: async (localOptions) => {
      const { data } = await productsUnitsOfMeasurePartialUpdate({
        ...options,
        ...localOptions,
        throwOnError: true
      })

      return data
    }
  }

  return mutationOptions
}

export const productsUnitsOfMeasureUpdateMutation = (
  options?: Partial<Options<ProductsUnitsOfMeasureUpdateData>>
): UseMutationOptions<
  ProductsUnitsOfMeasureUpdateResponse,
  AxiosError<DefaultError>,
  Options<ProductsUnitsOfMeasureUpdateData>
> => {
  const mutationOptions: UseMutationOptions<
    ProductsUnitsOfMeasureUpdateResponse,
    AxiosError<DefaultError>,
    Options<ProductsUnitsOfMeasureUpdateData>
  > = {
    mutationFn: async (localOptions) => {
      const { data } = await productsUnitsOfMeasureUpdate({
        ...options,
        ...localOptions,
        throwOnError: true
      })

      return data
    }
  }

  return mutationOptions
}

export const productsUnitsOfMeasureListListQueryKey = (
  options?: Options<ProductsUnitsOfMeasureListListData>
) => createQueryKey('productsUnitsOfMeasureListList', options)

export const productsUnitsOfMeasureListListOptions = (
  options?: Options<ProductsUnitsOfMeasureListListData>
) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await productsUnitsOfMeasureListList({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true
      })

      return data
    },
    queryKey: productsUnitsOfMeasureListListQueryKey(options)
  })
}

export const productsUnitsOfMeasureListListInfiniteQueryKey = (
  options?: Options<ProductsUnitsOfMeasureListListData>
): QueryKey<Options<ProductsUnitsOfMeasureListListData>> =>
  createQueryKey('productsUnitsOfMeasureListList', options, true)

export const productsUnitsOfMeasureListListInfiniteOptions = (
  options?: Options<ProductsUnitsOfMeasureListListData>
) => {
  return infiniteQueryOptions<
    ProductsUnitsOfMeasureListListResponse,
    AxiosError<DefaultError>,
    InfiniteData<ProductsUnitsOfMeasureListListResponse>,
    QueryKey<Options<ProductsUnitsOfMeasureListListData>>,
    | number
    | Pick<
        QueryKey<Options<ProductsUnitsOfMeasureListListData>>[0],
        'body' | 'headers' | 'path' | 'query'
      >
  >(
    // @ts-ignore
    {
      queryFn: async ({ pageParam, queryKey, signal }) => {
        // @ts-ignore
        const page: Pick<
          QueryKey<Options<ProductsUnitsOfMeasureListListData>>[0],
          'body' | 'headers' | 'path' | 'query'
        > =
          typeof pageParam === 'object'
            ? pageParam
            : {
                query: {
                  page: pageParam
                }
              }
        const params = createInfiniteParams(queryKey, page)
        const { data } = await productsUnitsOfMeasureListList({
          ...options,
          ...params,
          signal,
          throwOnError: true
        })

        return data
      },
      queryKey: productsUnitsOfMeasureListListInfiniteQueryKey(options)
    }
  )
}

export const reasonsListQueryKey = (options?: Options<ReasonsListData>) =>
  createQueryKey('reasonsList', options)

export const reasonsListOptions = (options?: Options<ReasonsListData>) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await reasonsList({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true
      })

      return data
    },
    queryKey: reasonsListQueryKey(options)
  })
}

export const reasonsListInfiniteQueryKey = (
  options?: Options<ReasonsListData>
): QueryKey<Options<ReasonsListData>> =>
  createQueryKey('reasonsList', options, true)

export const reasonsListInfiniteOptions = (
  options?: Options<ReasonsListData>
) => {
  return infiniteQueryOptions<
    ReasonsListResponse,
    AxiosError<DefaultError>,
    InfiniteData<ReasonsListResponse>,
    QueryKey<Options<ReasonsListData>>,
    | number
    | Pick<
        QueryKey<Options<ReasonsListData>>[0],
        'body' | 'headers' | 'path' | 'query'
      >
  >(
    // @ts-ignore
    {
      queryFn: async ({ pageParam, queryKey, signal }) => {
        // @ts-ignore
        const page: Pick<
          QueryKey<Options<ReasonsListData>>[0],
          'body' | 'headers' | 'path' | 'query'
        > =
          typeof pageParam === 'object'
            ? pageParam
            : {
                query: {
                  page: pageParam
                }
              }
        const params = createInfiniteParams(queryKey, page)
        const { data } = await reasonsList({
          ...options,
          ...params,
          signal,
          throwOnError: true
        })

        return data
      },
      queryKey: reasonsListInfiniteQueryKey(options)
    }
  )
}

export const reasonsCreateQueryKey = (options: Options<ReasonsCreateData>) =>
  createQueryKey('reasonsCreate', options)

export const reasonsCreateOptions = (options: Options<ReasonsCreateData>) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await reasonsCreate({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true
      })

      return data
    },
    queryKey: reasonsCreateQueryKey(options)
  })
}

export const reasonsCreateMutation = (
  options?: Partial<Options<ReasonsCreateData>>
): UseMutationOptions<
  ReasonsCreateResponse,
  AxiosError<DefaultError>,
  Options<ReasonsCreateData>
> => {
  const mutationOptions: UseMutationOptions<
    ReasonsCreateResponse,
    AxiosError<DefaultError>,
    Options<ReasonsCreateData>
  > = {
    mutationFn: async (localOptions) => {
      const { data } = await reasonsCreate({
        ...options,
        ...localOptions,
        throwOnError: true
      })

      return data
    }
  }

  return mutationOptions
}

export const reasonsDestroyMutation = (
  options?: Partial<Options<ReasonsDestroyData>>
): UseMutationOptions<
  ReasonsDestroyResponse,
  AxiosError<DefaultError>,
  Options<ReasonsDestroyData>
> => {
  const mutationOptions: UseMutationOptions<
    ReasonsDestroyResponse,
    AxiosError<DefaultError>,
    Options<ReasonsDestroyData>
  > = {
    mutationFn: async (localOptions) => {
      const { data } = await reasonsDestroy({
        ...options,
        ...localOptions,
        throwOnError: true
      })

      return data
    }
  }

  return mutationOptions
}

export const reasonsRetrieveQueryKey = (
  options: Options<ReasonsRetrieveData>
) => createQueryKey('reasonsRetrieve', options)

export const reasonsRetrieveOptions = (
  options: Options<ReasonsRetrieveData>
) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await reasonsRetrieve({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true
      })

      return data
    },
    queryKey: reasonsRetrieveQueryKey(options)
  })
}

export const reasonsPartialUpdateMutation = (
  options?: Partial<Options<ReasonsPartialUpdateData>>
): UseMutationOptions<
  ReasonsPartialUpdateResponse,
  AxiosError<DefaultError>,
  Options<ReasonsPartialUpdateData>
> => {
  const mutationOptions: UseMutationOptions<
    ReasonsPartialUpdateResponse,
    AxiosError<DefaultError>,
    Options<ReasonsPartialUpdateData>
  > = {
    mutationFn: async (localOptions) => {
      const { data } = await reasonsPartialUpdate({
        ...options,
        ...localOptions,
        throwOnError: true
      })

      return data
    }
  }

  return mutationOptions
}

export const reasonsUpdateMutation = (
  options?: Partial<Options<ReasonsUpdateData>>
): UseMutationOptions<
  ReasonsUpdateResponse,
  AxiosError<DefaultError>,
  Options<ReasonsUpdateData>
> => {
  const mutationOptions: UseMutationOptions<
    ReasonsUpdateResponse,
    AxiosError<DefaultError>,
    Options<ReasonsUpdateData>
  > = {
    mutationFn: async (localOptions) => {
      const { data } = await reasonsUpdate({
        ...options,
        ...localOptions,
        throwOnError: true
      })

      return data
    }
  }

  return mutationOptions
}

export const reasonsListListQueryKey = (
  options?: Options<ReasonsListListData>
) => createQueryKey('reasonsListList', options)

export const reasonsListListOptions = (
  options?: Options<ReasonsListListData>
) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await reasonsListList({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true
      })

      return data
    },
    queryKey: reasonsListListQueryKey(options)
  })
}

export const reasonsListListInfiniteQueryKey = (
  options?: Options<ReasonsListListData>
): QueryKey<Options<ReasonsListListData>> =>
  createQueryKey('reasonsListList', options, true)

export const reasonsListListInfiniteOptions = (
  options?: Options<ReasonsListListData>
) => {
  return infiniteQueryOptions<
    ReasonsListListResponse,
    AxiosError<DefaultError>,
    InfiniteData<ReasonsListListResponse>,
    QueryKey<Options<ReasonsListListData>>,
    | number
    | Pick<
        QueryKey<Options<ReasonsListListData>>[0],
        'body' | 'headers' | 'path' | 'query'
      >
  >(
    // @ts-ignore
    {
      queryFn: async ({ pageParam, queryKey, signal }) => {
        // @ts-ignore
        const page: Pick<
          QueryKey<Options<ReasonsListListData>>[0],
          'body' | 'headers' | 'path' | 'query'
        > =
          typeof pageParam === 'object'
            ? pageParam
            : {
                query: {
                  page: pageParam
                }
              }
        const params = createInfiniteParams(queryKey, page)
        const { data } = await reasonsListList({
          ...options,
          ...params,
          signal,
          throwOnError: true
        })

        return data
      },
      queryKey: reasonsListListInfiniteQueryKey(options)
    }
  )
}

export const regionsListQueryKey = (options?: Options<RegionsListData>) =>
  createQueryKey('regionsList', options)

export const regionsListOptions = (options?: Options<RegionsListData>) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await regionsList({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true
      })

      return data
    },
    queryKey: regionsListQueryKey(options)
  })
}

export const regionsListInfiniteQueryKey = (
  options?: Options<RegionsListData>
): QueryKey<Options<RegionsListData>> =>
  createQueryKey('regionsList', options, true)

export const regionsListInfiniteOptions = (
  options?: Options<RegionsListData>
) => {
  return infiniteQueryOptions<
    RegionsListResponse,
    AxiosError<DefaultError>,
    InfiniteData<RegionsListResponse>,
    QueryKey<Options<RegionsListData>>,
    | number
    | Pick<
        QueryKey<Options<RegionsListData>>[0],
        'body' | 'headers' | 'path' | 'query'
      >
  >(
    // @ts-ignore
    {
      queryFn: async ({ pageParam, queryKey, signal }) => {
        // @ts-ignore
        const page: Pick<
          QueryKey<Options<RegionsListData>>[0],
          'body' | 'headers' | 'path' | 'query'
        > =
          typeof pageParam === 'object'
            ? pageParam
            : {
                query: {
                  page: pageParam
                }
              }
        const params = createInfiniteParams(queryKey, page)
        const { data } = await regionsList({
          ...options,
          ...params,
          signal,
          throwOnError: true
        })

        return data
      },
      queryKey: regionsListInfiniteQueryKey(options)
    }
  )
}

export const regionsRetrieveQueryKey = (
  options: Options<RegionsRetrieveData>
) => createQueryKey('regionsRetrieve', options)

export const regionsRetrieveOptions = (
  options: Options<RegionsRetrieveData>
) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await regionsRetrieve({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true
      })

      return data
    },
    queryKey: regionsRetrieveQueryKey(options)
  })
}

export const regionsListListQueryKey = (
  options?: Options<RegionsListListData>
) => createQueryKey('regionsListList', options)

export const regionsListListOptions = (
  options?: Options<RegionsListListData>
) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await regionsListList({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true
      })

      return data
    },
    queryKey: regionsListListQueryKey(options)
  })
}

export const regionsListListInfiniteQueryKey = (
  options?: Options<RegionsListListData>
): QueryKey<Options<RegionsListListData>> =>
  createQueryKey('regionsListList', options, true)

export const regionsListListInfiniteOptions = (
  options?: Options<RegionsListListData>
) => {
  return infiniteQueryOptions<
    RegionsListListResponse,
    AxiosError<DefaultError>,
    InfiniteData<RegionsListListResponse>,
    QueryKey<Options<RegionsListListData>>,
    | number
    | Pick<
        QueryKey<Options<RegionsListListData>>[0],
        'body' | 'headers' | 'path' | 'query'
      >
  >(
    // @ts-ignore
    {
      queryFn: async ({ pageParam, queryKey, signal }) => {
        // @ts-ignore
        const page: Pick<
          QueryKey<Options<RegionsListListData>>[0],
          'body' | 'headers' | 'path' | 'query'
        > =
          typeof pageParam === 'object'
            ? pageParam
            : {
                query: {
                  page: pageParam
                }
              }
        const params = createInfiniteParams(queryKey, page)
        const { data } = await regionsListList({
          ...options,
          ...params,
          signal,
          throwOnError: true
        })

        return data
      },
      queryKey: regionsListListInfiniteQueryKey(options)
    }
  )
}

export const reportsListQueryKey = (options?: Options<ReportsListData>) =>
  createQueryKey('reportsList', options)

export const reportsListOptions = (options?: Options<ReportsListData>) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await reportsList({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true
      })

      return data
    },
    queryKey: reportsListQueryKey(options)
  })
}

export const reportsCreateQueryKey = (options?: Options<ReportsCreateData>) =>
  createQueryKey('reportsCreate', options)

export const reportsCreateOptions = (options?: Options<ReportsCreateData>) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await reportsCreate({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true
      })

      return data
    },
    queryKey: reportsCreateQueryKey(options)
  })
}

export const reportsCreateMutation = (
  options?: Partial<Options<ReportsCreateData>>
): UseMutationOptions<
  ReportsCreateResponse,
  AxiosError<DefaultError>,
  Options<ReportsCreateData>
> => {
  const mutationOptions: UseMutationOptions<
    ReportsCreateResponse,
    AxiosError<DefaultError>,
    Options<ReportsCreateData>
  > = {
    mutationFn: async (localOptions) => {
      const { data } = await reportsCreate({
        ...options,
        ...localOptions,
        throwOnError: true
      })

      return data
    }
  }

  return mutationOptions
}

export const reportsDestroyMutation = (
  options?: Partial<Options<ReportsDestroyData>>
): UseMutationOptions<
  ReportsDestroyResponse,
  AxiosError<DefaultError>,
  Options<ReportsDestroyData>
> => {
  const mutationOptions: UseMutationOptions<
    ReportsDestroyResponse,
    AxiosError<DefaultError>,
    Options<ReportsDestroyData>
  > = {
    mutationFn: async (localOptions) => {
      const { data } = await reportsDestroy({
        ...options,
        ...localOptions,
        throwOnError: true
      })

      return data
    }
  }

  return mutationOptions
}

export const reportsRetrieveQueryKey = (
  options: Options<ReportsRetrieveData>
) => createQueryKey('reportsRetrieve', options)

export const reportsRetrieveOptions = (
  options: Options<ReportsRetrieveData>
) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await reportsRetrieve({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true
      })

      return data
    },
    queryKey: reportsRetrieveQueryKey(options)
  })
}

export const reportsPartialUpdateMutation = (
  options?: Partial<Options<ReportsPartialUpdateData>>
): UseMutationOptions<
  ReportsPartialUpdateResponse,
  AxiosError<DefaultError>,
  Options<ReportsPartialUpdateData>
> => {
  const mutationOptions: UseMutationOptions<
    ReportsPartialUpdateResponse,
    AxiosError<DefaultError>,
    Options<ReportsPartialUpdateData>
  > = {
    mutationFn: async (localOptions) => {
      const { data } = await reportsPartialUpdate({
        ...options,
        ...localOptions,
        throwOnError: true
      })

      return data
    }
  }

  return mutationOptions
}

export const reportsUpdateMutation = (
  options?: Partial<Options<ReportsUpdateData>>
): UseMutationOptions<
  ReportsUpdateResponse,
  AxiosError<DefaultError>,
  Options<ReportsUpdateData>
> => {
  const mutationOptions: UseMutationOptions<
    ReportsUpdateResponse,
    AxiosError<DefaultError>,
    Options<ReportsUpdateData>
  > = {
    mutationFn: async (localOptions) => {
      const { data } = await reportsUpdate({
        ...options,
        ...localOptions,
        throwOnError: true
      })

      return data
    }
  }

  return mutationOptions
}

export const reportsChartRetrieveQueryKey = (
  options: Options<ReportsChartRetrieveData>
) => createQueryKey('reportsChartRetrieve', options)

export const reportsChartRetrieveOptions = (
  options: Options<ReportsChartRetrieveData>
) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await reportsChartRetrieve({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true
      })

      return data
    },
    queryKey: reportsChartRetrieveQueryKey(options)
  })
}

export const reportsDuplicateCreateQueryKey = (
  options: Options<ReportsDuplicateCreateData>
) => createQueryKey('reportsDuplicateCreate', options)

export const reportsDuplicateCreateOptions = (
  options: Options<ReportsDuplicateCreateData>
) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await reportsDuplicateCreate({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true
      })

      return data
    },
    queryKey: reportsDuplicateCreateQueryKey(options)
  })
}

export const reportsDuplicateCreateMutation = (
  options?: Partial<Options<ReportsDuplicateCreateData>>
): UseMutationOptions<
  ReportsDuplicateCreateResponse,
  AxiosError<DefaultError>,
  Options<ReportsDuplicateCreateData>
> => {
  const mutationOptions: UseMutationOptions<
    ReportsDuplicateCreateResponse,
    AxiosError<DefaultError>,
    Options<ReportsDuplicateCreateData>
  > = {
    mutationFn: async (localOptions) => {
      const { data } = await reportsDuplicateCreate({
        ...options,
        ...localOptions,
        throwOnError: true
      })

      return data
    }
  }

  return mutationOptions
}

export const reportsModelFieldsRetrieveQueryKey = (
  options: Options<ReportsModelFieldsRetrieveData>
) => createQueryKey('reportsModelFieldsRetrieve', options)

export const reportsModelFieldsRetrieveOptions = (
  options: Options<ReportsModelFieldsRetrieveData>
) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await reportsModelFieldsRetrieve({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true
      })

      return data
    },
    queryKey: reportsModelFieldsRetrieveQueryKey(options)
  })
}

export const reportsTableRetrieveQueryKey = (
  options: Options<ReportsTableRetrieveData>
) => createQueryKey('reportsTableRetrieve', options)

export const reportsTableRetrieveOptions = (
  options: Options<ReportsTableRetrieveData>
) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await reportsTableRetrieve({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true
      })

      return data
    },
    queryKey: reportsTableRetrieveQueryKey(options)
  })
}

export const reportsAggTypesRetrieveQueryKey = (
  options?: Options<ReportsAggTypesRetrieveData>
) => createQueryKey('reportsAggTypesRetrieve', options)

export const reportsAggTypesRetrieveOptions = (
  options?: Options<ReportsAggTypesRetrieveData>
) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await reportsAggTypesRetrieve({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true
      })

      return data
    },
    queryKey: reportsAggTypesRetrieveQueryKey(options)
  })
}

export const reportsCallsReportsListQueryKey = (
  options?: Options<ReportsCallsReportsListData>
) => createQueryKey('reportsCallsReportsList', options)

export const reportsCallsReportsListOptions = (
  options?: Options<ReportsCallsReportsListData>
) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await reportsCallsReportsList({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true
      })

      return data
    },
    queryKey: reportsCallsReportsListQueryKey(options)
  })
}

export const reportsCountryWeightDiagramRetrieveQueryKey = (
  options?: Options<ReportsCountryWeightDiagramRetrieveData>
) => createQueryKey('reportsCountryWeightDiagramRetrieve', options)

export const reportsCountryWeightDiagramRetrieveOptions = (
  options?: Options<ReportsCountryWeightDiagramRetrieveData>
) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await reportsCountryWeightDiagramRetrieve({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true
      })

      return data
    },
    queryKey: reportsCountryWeightDiagramRetrieveQueryKey(options)
  })
}

export const reportsDemoChartListQueryKey = (
  options?: Options<ReportsDemoChartListData>
) => createQueryKey('reportsDemoChartList', options)

export const reportsDemoChartListOptions = (
  options?: Options<ReportsDemoChartListData>
) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await reportsDemoChartList({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true
      })

      return data
    },
    queryKey: reportsDemoChartListQueryKey(options)
  })
}

export const reportsExportsListQueryKey = (
  options?: Options<ReportsExportsListData>
) => createQueryKey('reportsExportsList', options)

export const reportsExportsListOptions = (
  options?: Options<ReportsExportsListData>
) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await reportsExportsList({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true
      })

      return data
    },
    queryKey: reportsExportsListQueryKey(options)
  })
}

export const reportsExportsListInfiniteQueryKey = (
  options?: Options<ReportsExportsListData>
): QueryKey<Options<ReportsExportsListData>> =>
  createQueryKey('reportsExportsList', options, true)

export const reportsExportsListInfiniteOptions = (
  options?: Options<ReportsExportsListData>
) => {
  return infiniteQueryOptions<
    ReportsExportsListResponse,
    AxiosError<DefaultError>,
    InfiniteData<ReportsExportsListResponse>,
    QueryKey<Options<ReportsExportsListData>>,
    | number
    | Pick<
        QueryKey<Options<ReportsExportsListData>>[0],
        'body' | 'headers' | 'path' | 'query'
      >
  >(
    // @ts-ignore
    {
      queryFn: async ({ pageParam, queryKey, signal }) => {
        // @ts-ignore
        const page: Pick<
          QueryKey<Options<ReportsExportsListData>>[0],
          'body' | 'headers' | 'path' | 'query'
        > =
          typeof pageParam === 'object'
            ? pageParam
            : {
                query: {
                  page: pageParam
                }
              }
        const params = createInfiniteParams(queryKey, page)
        const { data } = await reportsExportsList({
          ...options,
          ...params,
          signal,
          throwOnError: true
        })

        return data
      },
      queryKey: reportsExportsListInfiniteQueryKey(options)
    }
  )
}

export const reportsExportsRetrieveQueryKey = (
  options: Options<ReportsExportsRetrieveData>
) => createQueryKey('reportsExportsRetrieve', options)

export const reportsExportsRetrieveOptions = (
  options: Options<ReportsExportsRetrieveData>
) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await reportsExportsRetrieve({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true
      })

      return data
    },
    queryKey: reportsExportsRetrieveQueryKey(options)
  })
}

export const reportsLeadChartListQueryKey = (
  options?: Options<ReportsLeadChartListData>
) => createQueryKey('reportsLeadChartList', options)

export const reportsLeadChartListOptions = (
  options?: Options<ReportsLeadChartListData>
) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await reportsLeadChartList({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true
      })

      return data
    },
    queryKey: reportsLeadChartListQueryKey(options)
  })
}

export const reportsOfflineReportsListQueryKey = (
  options?: Options<ReportsOfflineReportsListData>
) => createQueryKey('reportsOfflineReportsList', options)

export const reportsOfflineReportsListOptions = (
  options?: Options<ReportsOfflineReportsListData>
) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await reportsOfflineReportsList({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true
      })

      return data
    },
    queryKey: reportsOfflineReportsListQueryKey(options)
  })
}

export const reportsOnlineReportsListQueryKey = (
  options?: Options<ReportsOnlineReportsListData>
) => createQueryKey('reportsOnlineReportsList', options)

export const reportsOnlineReportsListOptions = (
  options?: Options<ReportsOnlineReportsListData>
) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await reportsOnlineReportsList({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true
      })

      return data
    },
    queryKey: reportsOnlineReportsListQueryKey(options)
  })
}

export const reportsPhoneCallsChartListQueryKey = (
  options?: Options<ReportsPhoneCallsChartListData>
) => createQueryKey('reportsPhoneCallsChartList', options)

export const reportsPhoneCallsChartListOptions = (
  options?: Options<ReportsPhoneCallsChartListData>
) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await reportsPhoneCallsChartList({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true
      })

      return data
    },
    queryKey: reportsPhoneCallsChartListQueryKey(options)
  })
}

export const reportsPreviewChartCreateQueryKey = (
  options?: Options<ReportsPreviewChartCreateData>
) => createQueryKey('reportsPreviewChartCreate', options)

export const reportsPreviewChartCreateOptions = (
  options?: Options<ReportsPreviewChartCreateData>
) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await reportsPreviewChartCreate({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true
      })

      return data
    },
    queryKey: reportsPreviewChartCreateQueryKey(options)
  })
}

export const reportsPreviewChartCreateMutation = (
  options?: Partial<Options<ReportsPreviewChartCreateData>>
): UseMutationOptions<
  ReportsPreviewChartCreateResponse,
  AxiosError<DefaultError>,
  Options<ReportsPreviewChartCreateData>
> => {
  const mutationOptions: UseMutationOptions<
    ReportsPreviewChartCreateResponse,
    AxiosError<DefaultError>,
    Options<ReportsPreviewChartCreateData>
  > = {
    mutationFn: async (localOptions) => {
      const { data } = await reportsPreviewChartCreate({
        ...options,
        ...localOptions,
        throwOnError: true
      })

      return data
    }
  }

  return mutationOptions
}

export const reportsPreviewTableCreateQueryKey = (
  options?: Options<ReportsPreviewTableCreateData>
) => createQueryKey('reportsPreviewTableCreate', options)

export const reportsPreviewTableCreateOptions = (
  options?: Options<ReportsPreviewTableCreateData>
) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await reportsPreviewTableCreate({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true
      })

      return data
    },
    queryKey: reportsPreviewTableCreateQueryKey(options)
  })
}

export const reportsPreviewTableCreateMutation = (
  options?: Partial<Options<ReportsPreviewTableCreateData>>
): UseMutationOptions<
  ReportsPreviewTableCreateResponse,
  AxiosError<DefaultError>,
  Options<ReportsPreviewTableCreateData>
> => {
  const mutationOptions: UseMutationOptions<
    ReportsPreviewTableCreateResponse,
    AxiosError<DefaultError>,
    Options<ReportsPreviewTableCreateData>
  > = {
    mutationFn: async (localOptions) => {
      const { data } = await reportsPreviewTableCreate({
        ...options,
        ...localOptions,
        throwOnError: true
      })

      return data
    }
  }

  return mutationOptions
}

export const reportsReasonWeightDiagramRetrieveQueryKey = (
  options?: Options<ReportsReasonWeightDiagramRetrieveData>
) => createQueryKey('reportsReasonWeightDiagramRetrieve', options)

export const reportsReasonWeightDiagramRetrieveOptions = (
  options?: Options<ReportsReasonWeightDiagramRetrieveData>
) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await reportsReasonWeightDiagramRetrieve({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true
      })

      return data
    },
    queryKey: reportsReasonWeightDiagramRetrieveQueryKey(options)
  })
}

export const reportsSalesFunnelListQueryKey = (
  options?: Options<ReportsSalesFunnelListData>
) => createQueryKey('reportsSalesFunnelList', options)

export const reportsSalesFunnelListOptions = (
  options?: Options<ReportsSalesFunnelListData>
) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await reportsSalesFunnelList({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true
      })

      return data
    },
    queryKey: reportsSalesFunnelListQueryKey(options)
  })
}

export const reportsScoreWeightDiagramRetrieveQueryKey = (
  options?: Options<ReportsScoreWeightDiagramRetrieveData>
) => createQueryKey('reportsScoreWeightDiagramRetrieve', options)

export const reportsScoreWeightDiagramRetrieveOptions = (
  options?: Options<ReportsScoreWeightDiagramRetrieveData>
) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await reportsScoreWeightDiagramRetrieve({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true
      })

      return data
    },
    queryKey: reportsScoreWeightDiagramRetrieveQueryKey(options)
  })
}

export const reportsSourcePageWeightDiagramRetrieveQueryKey = (
  options?: Options<ReportsSourcePageWeightDiagramRetrieveData>
) => createQueryKey('reportsSourcePageWeightDiagramRetrieve', options)

export const reportsSourcePageWeightDiagramRetrieveOptions = (
  options?: Options<ReportsSourcePageWeightDiagramRetrieveData>
) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await reportsSourcePageWeightDiagramRetrieve({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true
      })

      return data
    },
    queryKey: reportsSourcePageWeightDiagramRetrieveQueryKey(options)
  })
}

export const reportsSourceWebsiteWeightDiagramRetrieveQueryKey = (
  options?: Options<ReportsSourceWebsiteWeightDiagramRetrieveData>
) => createQueryKey('reportsSourceWebsiteWeightDiagramRetrieve', options)

export const reportsSourceWebsiteWeightDiagramRetrieveOptions = (
  options?: Options<ReportsSourceWebsiteWeightDiagramRetrieveData>
) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await reportsSourceWebsiteWeightDiagramRetrieve({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true
      })

      return data
    },
    queryKey: reportsSourceWebsiteWeightDiagramRetrieveQueryKey(options)
  })
}

export const reportsSourceWeightDiagramRetrieveQueryKey = (
  options?: Options<ReportsSourceWeightDiagramRetrieveData>
) => createQueryKey('reportsSourceWeightDiagramRetrieve', options)

export const reportsSourceWeightDiagramRetrieveOptions = (
  options?: Options<ReportsSourceWeightDiagramRetrieveData>
) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await reportsSourceWeightDiagramRetrieve({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true
      })

      return data
    },
    queryKey: reportsSourceWeightDiagramRetrieveQueryKey(options)
  })
}

export const reportsStatusWeightDiagramRetrieveQueryKey = (
  options?: Options<ReportsStatusWeightDiagramRetrieveData>
) => createQueryKey('reportsStatusWeightDiagramRetrieve', options)

export const reportsStatusWeightDiagramRetrieveOptions = (
  options?: Options<ReportsStatusWeightDiagramRetrieveData>
) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await reportsStatusWeightDiagramRetrieve({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true
      })

      return data
    },
    queryKey: reportsStatusWeightDiagramRetrieveQueryKey(options)
  })
}

export const reportsTopProductsRetrieveQueryKey = (
  options: Options<ReportsTopProductsRetrieveData>
) => createQueryKey('reportsTopProductsRetrieve', options)

export const reportsTopProductsRetrieveOptions = (
  options: Options<ReportsTopProductsRetrieveData>
) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await reportsTopProductsRetrieve({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true
      })

      return data
    },
    queryKey: reportsTopProductsRetrieveQueryKey(options)
  })
}

export const reportsTopProductsCategoryDistributionRetrieveQueryKey = (
  options: Options<ReportsTopProductsCategoryDistributionRetrieveData>
) => createQueryKey('reportsTopProductsCategoryDistributionRetrieve', options)

export const reportsTopProductsCategoryDistributionRetrieveOptions = (
  options: Options<ReportsTopProductsCategoryDistributionRetrieveData>
) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await reportsTopProductsCategoryDistributionRetrieve({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true
      })

      return data
    },
    queryKey: reportsTopProductsCategoryDistributionRetrieveQueryKey(options)
  })
}

export const reportsTopProductsCategoryDistributionExportCreateQueryKey = (
  options: Options<ReportsTopProductsCategoryDistributionExportCreateData>
) =>
  createQueryKey('reportsTopProductsCategoryDistributionExportCreate', options)

export const reportsTopProductsCategoryDistributionExportCreateOptions = (
  options: Options<ReportsTopProductsCategoryDistributionExportCreateData>
) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await reportsTopProductsCategoryDistributionExportCreate(
        {
          ...options,
          ...queryKey[0],
          signal,
          throwOnError: true
        }
      )

      return data
    },
    queryKey:
      reportsTopProductsCategoryDistributionExportCreateQueryKey(options)
  })
}

export const reportsTopProductsCategoryDistributionExportCreateMutation = (
  options?: Partial<
    Options<ReportsTopProductsCategoryDistributionExportCreateData>
  >
): UseMutationOptions<
  ReportsTopProductsCategoryDistributionExportCreateResponse,
  AxiosError<DefaultError>,
  Options<ReportsTopProductsCategoryDistributionExportCreateData>
> => {
  const mutationOptions: UseMutationOptions<
    ReportsTopProductsCategoryDistributionExportCreateResponse,
    AxiosError<DefaultError>,
    Options<ReportsTopProductsCategoryDistributionExportCreateData>
  > = {
    mutationFn: async (localOptions) => {
      const { data } = await reportsTopProductsCategoryDistributionExportCreate(
        {
          ...options,
          ...localOptions,
          throwOnError: true
        }
      )

      return data
    }
  }

  return mutationOptions
}

export const reportsTopProductsExportCreateQueryKey = (
  options: Options<ReportsTopProductsExportCreateData>
) => createQueryKey('reportsTopProductsExportCreate', options)

export const reportsTopProductsExportCreateOptions = (
  options: Options<ReportsTopProductsExportCreateData>
) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await reportsTopProductsExportCreate({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true
      })

      return data
    },
    queryKey: reportsTopProductsExportCreateQueryKey(options)
  })
}

export const reportsTopProductsExportCreateMutation = (
  options?: Partial<Options<ReportsTopProductsExportCreateData>>
): UseMutationOptions<
  ReportsTopProductsExportCreateResponse,
  AxiosError<DefaultError>,
  Options<ReportsTopProductsExportCreateData>
> => {
  const mutationOptions: UseMutationOptions<
    ReportsTopProductsExportCreateResponse,
    AxiosError<DefaultError>,
    Options<ReportsTopProductsExportCreateData>
  > = {
    mutationFn: async (localOptions) => {
      const { data } = await reportsTopProductsExportCreate({
        ...options,
        ...localOptions,
        throwOnError: true
      })

      return data
    }
  }

  return mutationOptions
}

export const reportsTypesRetrieveQueryKey = (
  options?: Options<ReportsTypesRetrieveData>
) => createQueryKey('reportsTypesRetrieve', options)

export const reportsTypesRetrieveOptions = (
  options?: Options<ReportsTypesRetrieveData>
) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await reportsTypesRetrieve({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true
      })

      return data
    },
    queryKey: reportsTypesRetrieveQueryKey(options)
  })
}

export const schemaRetrieveQueryKey = (options?: Options<SchemaRetrieveData>) =>
  createQueryKey('schemaRetrieve', options)

/**
 * OpenApi3 schema for this API. Format can be selected via content negotiation.
 *
 * - YAML: application/vnd.oai.openapi
 * - JSON: application/vnd.oai.openapi+json
 */
export const schemaRetrieveOptions = (
  options?: Options<SchemaRetrieveData>
) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await schemaRetrieve({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true
      })

      return data
    },
    queryKey: schemaRetrieveQueryKey(options)
  })
}

export const searchListQueryKey = (options?: Options<SearchListData>) =>
  createQueryKey('searchList', options)

export const searchListOptions = (options?: Options<SearchListData>) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await searchList({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true
      })

      return data
    },
    queryKey: searchListQueryKey(options)
  })
}

export const searchListInfiniteQueryKey = (
  options?: Options<SearchListData>
): QueryKey<Options<SearchListData>> =>
  createQueryKey('searchList', options, true)

export const searchListInfiniteOptions = (
  options?: Options<SearchListData>
) => {
  return infiniteQueryOptions<
    SearchListResponse,
    AxiosError<DefaultError>,
    InfiniteData<SearchListResponse>,
    QueryKey<Options<SearchListData>>,
    | number
    | Pick<
        QueryKey<Options<SearchListData>>[0],
        'body' | 'headers' | 'path' | 'query'
      >
  >(
    // @ts-ignore
    {
      queryFn: async ({ pageParam, queryKey, signal }) => {
        // @ts-ignore
        const page: Pick<
          QueryKey<Options<SearchListData>>[0],
          'body' | 'headers' | 'path' | 'query'
        > =
          typeof pageParam === 'object'
            ? pageParam
            : {
                query: {
                  page: pageParam
                }
              }
        const params = createInfiniteParams(queryKey, page)
        const { data } = await searchList({
          ...options,
          ...params,
          signal,
          throwOnError: true
        })

        return data
      },
      queryKey: searchListInfiniteQueryKey(options)
    }
  )
}

export const searchDynamicListQueryKey = (
  options?: Options<SearchDynamicListData>
) => createQueryKey('searchDynamicList', options)

export const searchDynamicListOptions = (
  options?: Options<SearchDynamicListData>
) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await searchDynamicList({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true
      })

      return data
    },
    queryKey: searchDynamicListQueryKey(options)
  })
}

export const searchDynamicListInfiniteQueryKey = (
  options?: Options<SearchDynamicListData>
): QueryKey<Options<SearchDynamicListData>> =>
  createQueryKey('searchDynamicList', options, true)

export const searchDynamicListInfiniteOptions = (
  options?: Options<SearchDynamicListData>
) => {
  return infiniteQueryOptions<
    SearchDynamicListResponse,
    AxiosError<DefaultError>,
    InfiniteData<SearchDynamicListResponse>,
    QueryKey<Options<SearchDynamicListData>>,
    | number
    | Pick<
        QueryKey<Options<SearchDynamicListData>>[0],
        'body' | 'headers' | 'path' | 'query'
      >
  >(
    // @ts-ignore
    {
      queryFn: async ({ pageParam, queryKey, signal }) => {
        // @ts-ignore
        const page: Pick<
          QueryKey<Options<SearchDynamicListData>>[0],
          'body' | 'headers' | 'path' | 'query'
        > =
          typeof pageParam === 'object'
            ? pageParam
            : {
                query: {
                  page: pageParam
                }
              }
        const params = createInfiniteParams(queryKey, page)
        const { data } = await searchDynamicList({
          ...options,
          ...params,
          signal,
          throwOnError: true
        })

        return data
      },
      queryKey: searchDynamicListInfiniteQueryKey(options)
    }
  )
}

export const searchDynamicExportRetrieveQueryKey = (
  options?: Options<SearchDynamicExportRetrieveData>
) => createQueryKey('searchDynamicExportRetrieve', options)

export const searchDynamicExportRetrieveOptions = (
  options?: Options<SearchDynamicExportRetrieveData>
) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await searchDynamicExportRetrieve({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true
      })

      return data
    },
    queryKey: searchDynamicExportRetrieveQueryKey(options)
  })
}

export const searchDynamicModelFieldsRetrieveQueryKey = (
  options?: Options<SearchDynamicModelFieldsRetrieveData>
) => createQueryKey('searchDynamicModelFieldsRetrieve', options)

export const searchDynamicModelFieldsRetrieveOptions = (
  options?: Options<SearchDynamicModelFieldsRetrieveData>
) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await searchDynamicModelFieldsRetrieve({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true
      })

      return data
    },
    queryKey: searchDynamicModelFieldsRetrieveQueryKey(options)
  })
}

export const searchDynamicModelsRetrieveQueryKey = (
  options?: Options<SearchDynamicModelsRetrieveData>
) => createQueryKey('searchDynamicModelsRetrieve', options)

export const searchDynamicModelsRetrieveOptions = (
  options?: Options<SearchDynamicModelsRetrieveData>
) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await searchDynamicModelsRetrieve({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true
      })

      return data
    },
    queryKey: searchDynamicModelsRetrieveQueryKey(options)
  })
}

export const seniorPositionsListQueryKey = (
  options?: Options<SeniorPositionsListData>
) => createQueryKey('seniorPositionsList', options)

export const seniorPositionsListOptions = (
  options?: Options<SeniorPositionsListData>
) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await seniorPositionsList({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true
      })

      return data
    },
    queryKey: seniorPositionsListQueryKey(options)
  })
}

export const seniorPositionsListInfiniteQueryKey = (
  options?: Options<SeniorPositionsListData>
): QueryKey<Options<SeniorPositionsListData>> =>
  createQueryKey('seniorPositionsList', options, true)

export const seniorPositionsListInfiniteOptions = (
  options?: Options<SeniorPositionsListData>
) => {
  return infiniteQueryOptions<
    SeniorPositionsListResponse,
    AxiosError<DefaultError>,
    InfiniteData<SeniorPositionsListResponse>,
    QueryKey<Options<SeniorPositionsListData>>,
    | number
    | Pick<
        QueryKey<Options<SeniorPositionsListData>>[0],
        'body' | 'headers' | 'path' | 'query'
      >
  >(
    // @ts-ignore
    {
      queryFn: async ({ pageParam, queryKey, signal }) => {
        // @ts-ignore
        const page: Pick<
          QueryKey<Options<SeniorPositionsListData>>[0],
          'body' | 'headers' | 'path' | 'query'
        > =
          typeof pageParam === 'object'
            ? pageParam
            : {
                query: {
                  page: pageParam
                }
              }
        const params = createInfiniteParams(queryKey, page)
        const { data } = await seniorPositionsList({
          ...options,
          ...params,
          signal,
          throwOnError: true
        })

        return data
      },
      queryKey: seniorPositionsListInfiniteQueryKey(options)
    }
  )
}

export const seniorPositionsCreateQueryKey = (
  options: Options<SeniorPositionsCreateData>
) => createQueryKey('seniorPositionsCreate', options)

export const seniorPositionsCreateOptions = (
  options: Options<SeniorPositionsCreateData>
) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await seniorPositionsCreate({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true
      })

      return data
    },
    queryKey: seniorPositionsCreateQueryKey(options)
  })
}

export const seniorPositionsCreateMutation = (
  options?: Partial<Options<SeniorPositionsCreateData>>
): UseMutationOptions<
  SeniorPositionsCreateResponse,
  AxiosError<DefaultError>,
  Options<SeniorPositionsCreateData>
> => {
  const mutationOptions: UseMutationOptions<
    SeniorPositionsCreateResponse,
    AxiosError<DefaultError>,
    Options<SeniorPositionsCreateData>
  > = {
    mutationFn: async (localOptions) => {
      const { data } = await seniorPositionsCreate({
        ...options,
        ...localOptions,
        throwOnError: true
      })

      return data
    }
  }

  return mutationOptions
}

export const seniorPositionsDestroyMutation = (
  options?: Partial<Options<SeniorPositionsDestroyData>>
): UseMutationOptions<
  SeniorPositionsDestroyResponse,
  AxiosError<DefaultError>,
  Options<SeniorPositionsDestroyData>
> => {
  const mutationOptions: UseMutationOptions<
    SeniorPositionsDestroyResponse,
    AxiosError<DefaultError>,
    Options<SeniorPositionsDestroyData>
  > = {
    mutationFn: async (localOptions) => {
      const { data } = await seniorPositionsDestroy({
        ...options,
        ...localOptions,
        throwOnError: true
      })

      return data
    }
  }

  return mutationOptions
}

export const seniorPositionsRetrieveQueryKey = (
  options: Options<SeniorPositionsRetrieveData>
) => createQueryKey('seniorPositionsRetrieve', options)

export const seniorPositionsRetrieveOptions = (
  options: Options<SeniorPositionsRetrieveData>
) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await seniorPositionsRetrieve({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true
      })

      return data
    },
    queryKey: seniorPositionsRetrieveQueryKey(options)
  })
}

export const seniorPositionsPartialUpdateMutation = (
  options?: Partial<Options<SeniorPositionsPartialUpdateData>>
): UseMutationOptions<
  SeniorPositionsPartialUpdateResponse,
  AxiosError<DefaultError>,
  Options<SeniorPositionsPartialUpdateData>
> => {
  const mutationOptions: UseMutationOptions<
    SeniorPositionsPartialUpdateResponse,
    AxiosError<DefaultError>,
    Options<SeniorPositionsPartialUpdateData>
  > = {
    mutationFn: async (localOptions) => {
      const { data } = await seniorPositionsPartialUpdate({
        ...options,
        ...localOptions,
        throwOnError: true
      })

      return data
    }
  }

  return mutationOptions
}

export const seniorPositionsUpdateMutation = (
  options?: Partial<Options<SeniorPositionsUpdateData>>
): UseMutationOptions<
  SeniorPositionsUpdateResponse,
  AxiosError<DefaultError>,
  Options<SeniorPositionsUpdateData>
> => {
  const mutationOptions: UseMutationOptions<
    SeniorPositionsUpdateResponse,
    AxiosError<DefaultError>,
    Options<SeniorPositionsUpdateData>
  > = {
    mutationFn: async (localOptions) => {
      const { data } = await seniorPositionsUpdate({
        ...options,
        ...localOptions,
        throwOnError: true
      })

      return data
    }
  }

  return mutationOptions
}

export const seniorPositionsJobPositionsListQueryKey = (
  options: Options<SeniorPositionsJobPositionsListData>
) => createQueryKey('seniorPositionsJobPositionsList', options)

export const seniorPositionsJobPositionsListOptions = (
  options: Options<SeniorPositionsJobPositionsListData>
) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await seniorPositionsJobPositionsList({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true
      })

      return data
    },
    queryKey: seniorPositionsJobPositionsListQueryKey(options)
  })
}

export const seniorPositionsJobPositionsListInfiniteQueryKey = (
  options: Options<SeniorPositionsJobPositionsListData>
): QueryKey<Options<SeniorPositionsJobPositionsListData>> =>
  createQueryKey('seniorPositionsJobPositionsList', options, true)

export const seniorPositionsJobPositionsListInfiniteOptions = (
  options: Options<SeniorPositionsJobPositionsListData>
) => {
  return infiniteQueryOptions<
    SeniorPositionsJobPositionsListResponse,
    AxiosError<DefaultError>,
    InfiniteData<SeniorPositionsJobPositionsListResponse>,
    QueryKey<Options<SeniorPositionsJobPositionsListData>>,
    | number
    | Pick<
        QueryKey<Options<SeniorPositionsJobPositionsListData>>[0],
        'body' | 'headers' | 'path' | 'query'
      >
  >(
    // @ts-ignore
    {
      queryFn: async ({ pageParam, queryKey, signal }) => {
        // @ts-ignore
        const page: Pick<
          QueryKey<Options<SeniorPositionsJobPositionsListData>>[0],
          'body' | 'headers' | 'path' | 'query'
        > =
          typeof pageParam === 'object'
            ? pageParam
            : {
                query: {
                  page: pageParam
                }
              }
        const params = createInfiniteParams(queryKey, page)
        const { data } = await seniorPositionsJobPositionsList({
          ...options,
          ...params,
          signal,
          throwOnError: true
        })

        return data
      },
      queryKey: seniorPositionsJobPositionsListInfiniteQueryKey(options)
    }
  )
}

export const seniorPositionsJobPositionsCreateQueryKey = (
  options: Options<SeniorPositionsJobPositionsCreateData>
) => createQueryKey('seniorPositionsJobPositionsCreate', options)

export const seniorPositionsJobPositionsCreateOptions = (
  options: Options<SeniorPositionsJobPositionsCreateData>
) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await seniorPositionsJobPositionsCreate({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true
      })

      return data
    },
    queryKey: seniorPositionsJobPositionsCreateQueryKey(options)
  })
}

export const seniorPositionsJobPositionsCreateMutation = (
  options?: Partial<Options<SeniorPositionsJobPositionsCreateData>>
): UseMutationOptions<
  SeniorPositionsJobPositionsCreateResponse,
  AxiosError<DefaultError>,
  Options<SeniorPositionsJobPositionsCreateData>
> => {
  const mutationOptions: UseMutationOptions<
    SeniorPositionsJobPositionsCreateResponse,
    AxiosError<DefaultError>,
    Options<SeniorPositionsJobPositionsCreateData>
  > = {
    mutationFn: async (localOptions) => {
      const { data } = await seniorPositionsJobPositionsCreate({
        ...options,
        ...localOptions,
        throwOnError: true
      })

      return data
    }
  }

  return mutationOptions
}

export const seniorPositionsJobPositionsDestroyMutation = (
  options?: Partial<Options<SeniorPositionsJobPositionsDestroyData>>
): UseMutationOptions<
  SeniorPositionsJobPositionsDestroyResponse,
  AxiosError<DefaultError>,
  Options<SeniorPositionsJobPositionsDestroyData>
> => {
  const mutationOptions: UseMutationOptions<
    SeniorPositionsJobPositionsDestroyResponse,
    AxiosError<DefaultError>,
    Options<SeniorPositionsJobPositionsDestroyData>
  > = {
    mutationFn: async (localOptions) => {
      const { data } = await seniorPositionsJobPositionsDestroy({
        ...options,
        ...localOptions,
        throwOnError: true
      })

      return data
    }
  }

  return mutationOptions
}

export const seniorPositionsJobPositionsRetrieveQueryKey = (
  options: Options<SeniorPositionsJobPositionsRetrieveData>
) => createQueryKey('seniorPositionsJobPositionsRetrieve', options)

export const seniorPositionsJobPositionsRetrieveOptions = (
  options: Options<SeniorPositionsJobPositionsRetrieveData>
) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await seniorPositionsJobPositionsRetrieve({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true
      })

      return data
    },
    queryKey: seniorPositionsJobPositionsRetrieveQueryKey(options)
  })
}

export const seniorPositionsJobPositionsPartialUpdateMutation = (
  options?: Partial<Options<SeniorPositionsJobPositionsPartialUpdateData>>
): UseMutationOptions<
  SeniorPositionsJobPositionsPartialUpdateResponse,
  AxiosError<DefaultError>,
  Options<SeniorPositionsJobPositionsPartialUpdateData>
> => {
  const mutationOptions: UseMutationOptions<
    SeniorPositionsJobPositionsPartialUpdateResponse,
    AxiosError<DefaultError>,
    Options<SeniorPositionsJobPositionsPartialUpdateData>
  > = {
    mutationFn: async (localOptions) => {
      const { data } = await seniorPositionsJobPositionsPartialUpdate({
        ...options,
        ...localOptions,
        throwOnError: true
      })

      return data
    }
  }

  return mutationOptions
}

export const seniorPositionsJobPositionsUpdateMutation = (
  options?: Partial<Options<SeniorPositionsJobPositionsUpdateData>>
): UseMutationOptions<
  SeniorPositionsJobPositionsUpdateResponse,
  AxiosError<DefaultError>,
  Options<SeniorPositionsJobPositionsUpdateData>
> => {
  const mutationOptions: UseMutationOptions<
    SeniorPositionsJobPositionsUpdateResponse,
    AxiosError<DefaultError>,
    Options<SeniorPositionsJobPositionsUpdateData>
  > = {
    mutationFn: async (localOptions) => {
      const { data } = await seniorPositionsJobPositionsUpdate({
        ...options,
        ...localOptions,
        throwOnError: true
      })

      return data
    }
  }

  return mutationOptions
}

export const seniorPositionsJobPositionsListListQueryKey = (
  options: Options<SeniorPositionsJobPositionsListListData>
) => createQueryKey('seniorPositionsJobPositionsListList', options)

export const seniorPositionsJobPositionsListListOptions = (
  options: Options<SeniorPositionsJobPositionsListListData>
) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await seniorPositionsJobPositionsListList({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true
      })

      return data
    },
    queryKey: seniorPositionsJobPositionsListListQueryKey(options)
  })
}

export const seniorPositionsJobPositionsListListInfiniteQueryKey = (
  options: Options<SeniorPositionsJobPositionsListListData>
): QueryKey<Options<SeniorPositionsJobPositionsListListData>> =>
  createQueryKey('seniorPositionsJobPositionsListList', options, true)

export const seniorPositionsJobPositionsListListInfiniteOptions = (
  options: Options<SeniorPositionsJobPositionsListListData>
) => {
  return infiniteQueryOptions<
    SeniorPositionsJobPositionsListListResponse,
    AxiosError<DefaultError>,
    InfiniteData<SeniorPositionsJobPositionsListListResponse>,
    QueryKey<Options<SeniorPositionsJobPositionsListListData>>,
    | number
    | Pick<
        QueryKey<Options<SeniorPositionsJobPositionsListListData>>[0],
        'body' | 'headers' | 'path' | 'query'
      >
  >(
    // @ts-ignore
    {
      queryFn: async ({ pageParam, queryKey, signal }) => {
        // @ts-ignore
        const page: Pick<
          QueryKey<Options<SeniorPositionsJobPositionsListListData>>[0],
          'body' | 'headers' | 'path' | 'query'
        > =
          typeof pageParam === 'object'
            ? pageParam
            : {
                query: {
                  page: pageParam
                }
              }
        const params = createInfiniteParams(queryKey, page)
        const { data } = await seniorPositionsJobPositionsListList({
          ...options,
          ...params,
          signal,
          throwOnError: true
        })

        return data
      },
      queryKey: seniorPositionsJobPositionsListListInfiniteQueryKey(options)
    }
  )
}

export const seniorPositionsListListQueryKey = (
  options?: Options<SeniorPositionsListListData>
) => createQueryKey('seniorPositionsListList', options)

export const seniorPositionsListListOptions = (
  options?: Options<SeniorPositionsListListData>
) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await seniorPositionsListList({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true
      })

      return data
    },
    queryKey: seniorPositionsListListQueryKey(options)
  })
}

export const seniorPositionsListListInfiniteQueryKey = (
  options?: Options<SeniorPositionsListListData>
): QueryKey<Options<SeniorPositionsListListData>> =>
  createQueryKey('seniorPositionsListList', options, true)

export const seniorPositionsListListInfiniteOptions = (
  options?: Options<SeniorPositionsListListData>
) => {
  return infiniteQueryOptions<
    SeniorPositionsListListResponse,
    AxiosError<DefaultError>,
    InfiniteData<SeniorPositionsListListResponse>,
    QueryKey<Options<SeniorPositionsListListData>>,
    | number
    | Pick<
        QueryKey<Options<SeniorPositionsListListData>>[0],
        'body' | 'headers' | 'path' | 'query'
      >
  >(
    // @ts-ignore
    {
      queryFn: async ({ pageParam, queryKey, signal }) => {
        // @ts-ignore
        const page: Pick<
          QueryKey<Options<SeniorPositionsListListData>>[0],
          'body' | 'headers' | 'path' | 'query'
        > =
          typeof pageParam === 'object'
            ? pageParam
            : {
                query: {
                  page: pageParam
                }
              }
        const params = createInfiniteParams(queryKey, page)
        const { data } = await seniorPositionsListList({
          ...options,
          ...params,
          signal,
          throwOnError: true
        })

        return data
      },
      queryKey: seniorPositionsListListInfiniteQueryKey(options)
    }
  )
}

export const sequencesListQueryKey = (options?: Options<SequencesListData>) =>
  createQueryKey('sequencesList', options)

export const sequencesListOptions = (options?: Options<SequencesListData>) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await sequencesList({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true
      })

      return data
    },
    queryKey: sequencesListQueryKey(options)
  })
}

export const sequencesListInfiniteQueryKey = (
  options?: Options<SequencesListData>
): QueryKey<Options<SequencesListData>> =>
  createQueryKey('sequencesList', options, true)

export const sequencesListInfiniteOptions = (
  options?: Options<SequencesListData>
) => {
  return infiniteQueryOptions<
    SequencesListResponse,
    AxiosError<DefaultError>,
    InfiniteData<SequencesListResponse>,
    QueryKey<Options<SequencesListData>>,
    | number
    | Pick<
        QueryKey<Options<SequencesListData>>[0],
        'body' | 'headers' | 'path' | 'query'
      >
  >(
    // @ts-ignore
    {
      queryFn: async ({ pageParam, queryKey, signal }) => {
        // @ts-ignore
        const page: Pick<
          QueryKey<Options<SequencesListData>>[0],
          'body' | 'headers' | 'path' | 'query'
        > =
          typeof pageParam === 'object'
            ? pageParam
            : {
                query: {
                  page: pageParam
                }
              }
        const params = createInfiniteParams(queryKey, page)
        const { data } = await sequencesList({
          ...options,
          ...params,
          signal,
          throwOnError: true
        })

        return data
      },
      queryKey: sequencesListInfiniteQueryKey(options)
    }
  )
}

export const sequencesCreateQueryKey = (
  options?: Options<SequencesCreateData>
) => createQueryKey('sequencesCreate', options)

export const sequencesCreateOptions = (
  options?: Options<SequencesCreateData>
) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await sequencesCreate({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true
      })

      return data
    },
    queryKey: sequencesCreateQueryKey(options)
  })
}

export const sequencesCreateMutation = (
  options?: Partial<Options<SequencesCreateData>>
): UseMutationOptions<
  SequencesCreateResponse,
  AxiosError<DefaultError>,
  Options<SequencesCreateData>
> => {
  const mutationOptions: UseMutationOptions<
    SequencesCreateResponse,
    AxiosError<DefaultError>,
    Options<SequencesCreateData>
  > = {
    mutationFn: async (localOptions) => {
      const { data } = await sequencesCreate({
        ...options,
        ...localOptions,
        throwOnError: true
      })

      return data
    }
  }

  return mutationOptions
}

export const sequencesDestroyMutation = (
  options?: Partial<Options<SequencesDestroyData>>
): UseMutationOptions<
  SequencesDestroyResponse,
  AxiosError<DefaultError>,
  Options<SequencesDestroyData>
> => {
  const mutationOptions: UseMutationOptions<
    SequencesDestroyResponse,
    AxiosError<DefaultError>,
    Options<SequencesDestroyData>
  > = {
    mutationFn: async (localOptions) => {
      const { data } = await sequencesDestroy({
        ...options,
        ...localOptions,
        throwOnError: true
      })

      return data
    }
  }

  return mutationOptions
}

export const sequencesRetrieveQueryKey = (
  options: Options<SequencesRetrieveData>
) => createQueryKey('sequencesRetrieve', options)

export const sequencesRetrieveOptions = (
  options: Options<SequencesRetrieveData>
) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await sequencesRetrieve({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true
      })

      return data
    },
    queryKey: sequencesRetrieveQueryKey(options)
  })
}

export const sequencesPartialUpdateMutation = (
  options?: Partial<Options<SequencesPartialUpdateData>>
): UseMutationOptions<
  SequencesPartialUpdateResponse,
  AxiosError<DefaultError>,
  Options<SequencesPartialUpdateData>
> => {
  const mutationOptions: UseMutationOptions<
    SequencesPartialUpdateResponse,
    AxiosError<DefaultError>,
    Options<SequencesPartialUpdateData>
  > = {
    mutationFn: async (localOptions) => {
      const { data } = await sequencesPartialUpdate({
        ...options,
        ...localOptions,
        throwOnError: true
      })

      return data
    }
  }

  return mutationOptions
}

export const sequencesUpdateMutation = (
  options?: Partial<Options<SequencesUpdateData>>
): UseMutationOptions<
  SequencesUpdateResponse,
  AxiosError<DefaultError>,
  Options<SequencesUpdateData>
> => {
  const mutationOptions: UseMutationOptions<
    SequencesUpdateResponse,
    AxiosError<DefaultError>,
    Options<SequencesUpdateData>
  > = {
    mutationFn: async (localOptions) => {
      const { data } = await sequencesUpdate({
        ...options,
        ...localOptions,
        throwOnError: true
      })

      return data
    }
  }

  return mutationOptions
}

export const sequencesAddLeadsCreateQueryKey = (
  options: Options<SequencesAddLeadsCreateData>
) => createQueryKey('sequencesAddLeadsCreate', options)

export const sequencesAddLeadsCreateOptions = (
  options: Options<SequencesAddLeadsCreateData>
) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await sequencesAddLeadsCreate({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true
      })

      return data
    },
    queryKey: sequencesAddLeadsCreateQueryKey(options)
  })
}

export const sequencesAddLeadsCreateMutation = (
  options?: Partial<Options<SequencesAddLeadsCreateData>>
): UseMutationOptions<
  SequencesAddLeadsCreateResponse,
  AxiosError<DefaultError>,
  Options<SequencesAddLeadsCreateData>
> => {
  const mutationOptions: UseMutationOptions<
    SequencesAddLeadsCreateResponse,
    AxiosError<DefaultError>,
    Options<SequencesAddLeadsCreateData>
  > = {
    mutationFn: async (localOptions) => {
      const { data } = await sequencesAddLeadsCreate({
        ...options,
        ...localOptions,
        throwOnError: true
      })

      return data
    }
  }

  return mutationOptions
}

export const sequencesDuplicateRetrieveQueryKey = (
  options: Options<SequencesDuplicateRetrieveData>
) => createQueryKey('sequencesDuplicateRetrieve', options)

export const sequencesDuplicateRetrieveOptions = (
  options: Options<SequencesDuplicateRetrieveData>
) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await sequencesDuplicateRetrieve({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true
      })

      return data
    },
    queryKey: sequencesDuplicateRetrieveQueryKey(options)
  })
}

export const sequencesLeadsListQueryKey = (
  options: Options<SequencesLeadsListData>
) => createQueryKey('sequencesLeadsList', options)

export const sequencesLeadsListOptions = (
  options: Options<SequencesLeadsListData>
) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await sequencesLeadsList({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true
      })

      return data
    },
    queryKey: sequencesLeadsListQueryKey(options)
  })
}

export const sequencesLeadsListInfiniteQueryKey = (
  options: Options<SequencesLeadsListData>
): QueryKey<Options<SequencesLeadsListData>> =>
  createQueryKey('sequencesLeadsList', options, true)

export const sequencesLeadsListInfiniteOptions = (
  options: Options<SequencesLeadsListData>
) => {
  return infiniteQueryOptions<
    SequencesLeadsListResponse,
    AxiosError<DefaultError>,
    InfiniteData<SequencesLeadsListResponse>,
    QueryKey<Options<SequencesLeadsListData>>,
    | number
    | Pick<
        QueryKey<Options<SequencesLeadsListData>>[0],
        'body' | 'headers' | 'path' | 'query'
      >
  >(
    // @ts-ignore
    {
      queryFn: async ({ pageParam, queryKey, signal }) => {
        // @ts-ignore
        const page: Pick<
          QueryKey<Options<SequencesLeadsListData>>[0],
          'body' | 'headers' | 'path' | 'query'
        > =
          typeof pageParam === 'object'
            ? pageParam
            : {
                query: {
                  page: pageParam
                }
              }
        const params = createInfiniteParams(queryKey, page)
        const { data } = await sequencesLeadsList({
          ...options,
          ...params,
          signal,
          throwOnError: true
        })

        return data
      },
      queryKey: sequencesLeadsListInfiniteQueryKey(options)
    }
  )
}

export const sequencesStepsListQueryKey = (
  options: Options<SequencesStepsListData>
) => createQueryKey('sequencesStepsList', options)

export const sequencesStepsListOptions = (
  options: Options<SequencesStepsListData>
) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await sequencesStepsList({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true
      })

      return data
    },
    queryKey: sequencesStepsListQueryKey(options)
  })
}

export const sequencesStepsListInfiniteQueryKey = (
  options: Options<SequencesStepsListData>
): QueryKey<Options<SequencesStepsListData>> =>
  createQueryKey('sequencesStepsList', options, true)

export const sequencesStepsListInfiniteOptions = (
  options: Options<SequencesStepsListData>
) => {
  return infiniteQueryOptions<
    SequencesStepsListResponse,
    AxiosError<DefaultError>,
    InfiniteData<SequencesStepsListResponse>,
    QueryKey<Options<SequencesStepsListData>>,
    | number
    | Pick<
        QueryKey<Options<SequencesStepsListData>>[0],
        'body' | 'headers' | 'path' | 'query'
      >
  >(
    // @ts-ignore
    {
      queryFn: async ({ pageParam, queryKey, signal }) => {
        // @ts-ignore
        const page: Pick<
          QueryKey<Options<SequencesStepsListData>>[0],
          'body' | 'headers' | 'path' | 'query'
        > =
          typeof pageParam === 'object'
            ? pageParam
            : {
                query: {
                  page: pageParam
                }
              }
        const params = createInfiniteParams(queryKey, page)
        const { data } = await sequencesStepsList({
          ...options,
          ...params,
          signal,
          throwOnError: true
        })

        return data
      },
      queryKey: sequencesStepsListInfiniteQueryKey(options)
    }
  )
}

export const sequencesStepsCreateQueryKey = (
  options: Options<SequencesStepsCreateData>
) => createQueryKey('sequencesStepsCreate', options)

export const sequencesStepsCreateOptions = (
  options: Options<SequencesStepsCreateData>
) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await sequencesStepsCreate({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true
      })

      return data
    },
    queryKey: sequencesStepsCreateQueryKey(options)
  })
}

export const sequencesStepsCreateMutation = (
  options?: Partial<Options<SequencesStepsCreateData>>
): UseMutationOptions<
  SequencesStepsCreateResponse,
  AxiosError<DefaultError>,
  Options<SequencesStepsCreateData>
> => {
  const mutationOptions: UseMutationOptions<
    SequencesStepsCreateResponse,
    AxiosError<DefaultError>,
    Options<SequencesStepsCreateData>
  > = {
    mutationFn: async (localOptions) => {
      const { data } = await sequencesStepsCreate({
        ...options,
        ...localOptions,
        throwOnError: true
      })

      return data
    }
  }

  return mutationOptions
}

export const sequencesStepsDestroyMutation = (
  options?: Partial<Options<SequencesStepsDestroyData>>
): UseMutationOptions<
  SequencesStepsDestroyResponse,
  AxiosError<DefaultError>,
  Options<SequencesStepsDestroyData>
> => {
  const mutationOptions: UseMutationOptions<
    SequencesStepsDestroyResponse,
    AxiosError<DefaultError>,
    Options<SequencesStepsDestroyData>
  > = {
    mutationFn: async (localOptions) => {
      const { data } = await sequencesStepsDestroy({
        ...options,
        ...localOptions,
        throwOnError: true
      })

      return data
    }
  }

  return mutationOptions
}

export const sequencesStepsRetrieveQueryKey = (
  options: Options<SequencesStepsRetrieveData>
) => createQueryKey('sequencesStepsRetrieve', options)

export const sequencesStepsRetrieveOptions = (
  options: Options<SequencesStepsRetrieveData>
) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await sequencesStepsRetrieve({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true
      })

      return data
    },
    queryKey: sequencesStepsRetrieveQueryKey(options)
  })
}

export const sequencesStepsPartialUpdateMutation = (
  options?: Partial<Options<SequencesStepsPartialUpdateData>>
): UseMutationOptions<
  SequencesStepsPartialUpdateResponse,
  AxiosError<DefaultError>,
  Options<SequencesStepsPartialUpdateData>
> => {
  const mutationOptions: UseMutationOptions<
    SequencesStepsPartialUpdateResponse,
    AxiosError<DefaultError>,
    Options<SequencesStepsPartialUpdateData>
  > = {
    mutationFn: async (localOptions) => {
      const { data } = await sequencesStepsPartialUpdate({
        ...options,
        ...localOptions,
        throwOnError: true
      })

      return data
    }
  }

  return mutationOptions
}

export const sequencesStepsUpdateMutation = (
  options?: Partial<Options<SequencesStepsUpdateData>>
): UseMutationOptions<
  SequencesStepsUpdateResponse,
  AxiosError<DefaultError>,
  Options<SequencesStepsUpdateData>
> => {
  const mutationOptions: UseMutationOptions<
    SequencesStepsUpdateResponse,
    AxiosError<DefaultError>,
    Options<SequencesStepsUpdateData>
  > = {
    mutationFn: async (localOptions) => {
      const { data } = await sequencesStepsUpdate({
        ...options,
        ...localOptions,
        throwOnError: true
      })

      return data
    }
  }

  return mutationOptions
}

export const sequencesStepsListListQueryKey = (
  options: Options<SequencesStepsListListData>
) => createQueryKey('sequencesStepsListList', options)

export const sequencesStepsListListOptions = (
  options: Options<SequencesStepsListListData>
) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await sequencesStepsListList({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true
      })

      return data
    },
    queryKey: sequencesStepsListListQueryKey(options)
  })
}

export const sequencesStepsListListInfiniteQueryKey = (
  options: Options<SequencesStepsListListData>
): QueryKey<Options<SequencesStepsListListData>> =>
  createQueryKey('sequencesStepsListList', options, true)

export const sequencesStepsListListInfiniteOptions = (
  options: Options<SequencesStepsListListData>
) => {
  return infiniteQueryOptions<
    SequencesStepsListListResponse,
    AxiosError<DefaultError>,
    InfiniteData<SequencesStepsListListResponse>,
    QueryKey<Options<SequencesStepsListListData>>,
    | number
    | Pick<
        QueryKey<Options<SequencesStepsListListData>>[0],
        'body' | 'headers' | 'path' | 'query'
      >
  >(
    // @ts-ignore
    {
      queryFn: async ({ pageParam, queryKey, signal }) => {
        // @ts-ignore
        const page: Pick<
          QueryKey<Options<SequencesStepsListListData>>[0],
          'body' | 'headers' | 'path' | 'query'
        > =
          typeof pageParam === 'object'
            ? pageParam
            : {
                query: {
                  page: pageParam
                }
              }
        const params = createInfiniteParams(queryKey, page)
        const { data } = await sequencesStepsListList({
          ...options,
          ...params,
          signal,
          throwOnError: true
        })

        return data
      },
      queryKey: sequencesStepsListListInfiniteQueryKey(options)
    }
  )
}

export const sequencesListListQueryKey = (
  options?: Options<SequencesListListData>
) => createQueryKey('sequencesListList', options)

export const sequencesListListOptions = (
  options?: Options<SequencesListListData>
) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await sequencesListList({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true
      })

      return data
    },
    queryKey: sequencesListListQueryKey(options)
  })
}

export const sequencesListListInfiniteQueryKey = (
  options?: Options<SequencesListListData>
): QueryKey<Options<SequencesListListData>> =>
  createQueryKey('sequencesListList', options, true)

export const sequencesListListInfiniteOptions = (
  options?: Options<SequencesListListData>
) => {
  return infiniteQueryOptions<
    SequencesListListResponse,
    AxiosError<DefaultError>,
    InfiniteData<SequencesListListResponse>,
    QueryKey<Options<SequencesListListData>>,
    | number
    | Pick<
        QueryKey<Options<SequencesListListData>>[0],
        'body' | 'headers' | 'path' | 'query'
      >
  >(
    // @ts-ignore
    {
      queryFn: async ({ pageParam, queryKey, signal }) => {
        // @ts-ignore
        const page: Pick<
          QueryKey<Options<SequencesListListData>>[0],
          'body' | 'headers' | 'path' | 'query'
        > =
          typeof pageParam === 'object'
            ? pageParam
            : {
                query: {
                  page: pageParam
                }
              }
        const params = createInfiniteParams(queryKey, page)
        const { data } = await sequencesListList({
          ...options,
          ...params,
          signal,
          throwOnError: true
        })

        return data
      },
      queryKey: sequencesListListInfiniteQueryKey(options)
    }
  )
}

export const settingsRetrieveQueryKey = (
  options?: Options<SettingsRetrieveData>
) => createQueryKey('settingsRetrieve', options)

export const settingsRetrieveOptions = (
  options?: Options<SettingsRetrieveData>
) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await settingsRetrieve({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true
      })

      return data
    },
    queryKey: settingsRetrieveQueryKey(options)
  })
}

export const settingsCreateQueryKey = (options?: Options<SettingsCreateData>) =>
  createQueryKey('settingsCreate', options)

export const settingsCreateOptions = (
  options?: Options<SettingsCreateData>
) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await settingsCreate({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true
      })

      return data
    },
    queryKey: settingsCreateQueryKey(options)
  })
}

export const settingsCreateMutation = (
  options?: Partial<Options<SettingsCreateData>>
): UseMutationOptions<
  SettingsCreateResponse,
  AxiosError<DefaultError>,
  Options<SettingsCreateData>
> => {
  const mutationOptions: UseMutationOptions<
    SettingsCreateResponse,
    AxiosError<DefaultError>,
    Options<SettingsCreateData>
  > = {
    mutationFn: async (localOptions) => {
      const { data } = await settingsCreate({
        ...options,
        ...localOptions,
        throwOnError: true
      })

      return data
    }
  }

  return mutationOptions
}

export const sourcesListQueryKey = (options?: Options<SourcesListData>) =>
  createQueryKey('sourcesList', options)

export const sourcesListOptions = (options?: Options<SourcesListData>) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await sourcesList({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true
      })

      return data
    },
    queryKey: sourcesListQueryKey(options)
  })
}

export const sourcesListInfiniteQueryKey = (
  options?: Options<SourcesListData>
): QueryKey<Options<SourcesListData>> =>
  createQueryKey('sourcesList', options, true)

export const sourcesListInfiniteOptions = (
  options?: Options<SourcesListData>
) => {
  return infiniteQueryOptions<
    SourcesListResponse,
    AxiosError<DefaultError>,
    InfiniteData<SourcesListResponse>,
    QueryKey<Options<SourcesListData>>,
    | number
    | Pick<
        QueryKey<Options<SourcesListData>>[0],
        'body' | 'headers' | 'path' | 'query'
      >
  >(
    // @ts-ignore
    {
      queryFn: async ({ pageParam, queryKey, signal }) => {
        // @ts-ignore
        const page: Pick<
          QueryKey<Options<SourcesListData>>[0],
          'body' | 'headers' | 'path' | 'query'
        > =
          typeof pageParam === 'object'
            ? pageParam
            : {
                query: {
                  page: pageParam
                }
              }
        const params = createInfiniteParams(queryKey, page)
        const { data } = await sourcesList({
          ...options,
          ...params,
          signal,
          throwOnError: true
        })

        return data
      },
      queryKey: sourcesListInfiniteQueryKey(options)
    }
  )
}

export const sourcesCreateQueryKey = (options: Options<SourcesCreateData>) =>
  createQueryKey('sourcesCreate', options)

export const sourcesCreateOptions = (options: Options<SourcesCreateData>) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await sourcesCreate({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true
      })

      return data
    },
    queryKey: sourcesCreateQueryKey(options)
  })
}

export const sourcesCreateMutation = (
  options?: Partial<Options<SourcesCreateData>>
): UseMutationOptions<
  SourcesCreateResponse,
  AxiosError<DefaultError>,
  Options<SourcesCreateData>
> => {
  const mutationOptions: UseMutationOptions<
    SourcesCreateResponse,
    AxiosError<DefaultError>,
    Options<SourcesCreateData>
  > = {
    mutationFn: async (localOptions) => {
      const { data } = await sourcesCreate({
        ...options,
        ...localOptions,
        throwOnError: true
      })

      return data
    }
  }

  return mutationOptions
}

export const sourcesDestroyMutation = (
  options?: Partial<Options<SourcesDestroyData>>
): UseMutationOptions<
  SourcesDestroyResponse,
  AxiosError<DefaultError>,
  Options<SourcesDestroyData>
> => {
  const mutationOptions: UseMutationOptions<
    SourcesDestroyResponse,
    AxiosError<DefaultError>,
    Options<SourcesDestroyData>
  > = {
    mutationFn: async (localOptions) => {
      const { data } = await sourcesDestroy({
        ...options,
        ...localOptions,
        throwOnError: true
      })

      return data
    }
  }

  return mutationOptions
}

export const sourcesRetrieveQueryKey = (
  options: Options<SourcesRetrieveData>
) => createQueryKey('sourcesRetrieve', options)

export const sourcesRetrieveOptions = (
  options: Options<SourcesRetrieveData>
) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await sourcesRetrieve({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true
      })

      return data
    },
    queryKey: sourcesRetrieveQueryKey(options)
  })
}

export const sourcesPartialUpdateMutation = (
  options?: Partial<Options<SourcesPartialUpdateData>>
): UseMutationOptions<
  SourcesPartialUpdateResponse,
  AxiosError<DefaultError>,
  Options<SourcesPartialUpdateData>
> => {
  const mutationOptions: UseMutationOptions<
    SourcesPartialUpdateResponse,
    AxiosError<DefaultError>,
    Options<SourcesPartialUpdateData>
  > = {
    mutationFn: async (localOptions) => {
      const { data } = await sourcesPartialUpdate({
        ...options,
        ...localOptions,
        throwOnError: true
      })

      return data
    }
  }

  return mutationOptions
}

export const sourcesUpdateMutation = (
  options?: Partial<Options<SourcesUpdateData>>
): UseMutationOptions<
  SourcesUpdateResponse,
  AxiosError<DefaultError>,
  Options<SourcesUpdateData>
> => {
  const mutationOptions: UseMutationOptions<
    SourcesUpdateResponse,
    AxiosError<DefaultError>,
    Options<SourcesUpdateData>
  > = {
    mutationFn: async (localOptions) => {
      const { data } = await sourcesUpdate({
        ...options,
        ...localOptions,
        throwOnError: true
      })

      return data
    }
  }

  return mutationOptions
}

export const sourcesListListQueryKey = (
  options?: Options<SourcesListListData>
) => createQueryKey('sourcesListList', options)

export const sourcesListListOptions = (
  options?: Options<SourcesListListData>
) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await sourcesListList({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true
      })

      return data
    },
    queryKey: sourcesListListQueryKey(options)
  })
}

export const sourcesListListInfiniteQueryKey = (
  options?: Options<SourcesListListData>
): QueryKey<Options<SourcesListListData>> =>
  createQueryKey('sourcesListList', options, true)

export const sourcesListListInfiniteOptions = (
  options?: Options<SourcesListListData>
) => {
  return infiniteQueryOptions<
    SourcesListListResponse,
    AxiosError<DefaultError>,
    InfiniteData<SourcesListListResponse>,
    QueryKey<Options<SourcesListListData>>,
    | number
    | Pick<
        QueryKey<Options<SourcesListListData>>[0],
        'body' | 'headers' | 'path' | 'query'
      >
  >(
    // @ts-ignore
    {
      queryFn: async ({ pageParam, queryKey, signal }) => {
        // @ts-ignore
        const page: Pick<
          QueryKey<Options<SourcesListListData>>[0],
          'body' | 'headers' | 'path' | 'query'
        > =
          typeof pageParam === 'object'
            ? pageParam
            : {
                query: {
                  page: pageParam
                }
              }
        const params = createInfiniteParams(queryKey, page)
        const { data } = await sourcesListList({
          ...options,
          ...params,
          signal,
          throwOnError: true
        })

        return data
      },
      queryKey: sourcesListListInfiniteQueryKey(options)
    }
  )
}

export const tagsListQueryKey = (options?: Options<TagsListData>) =>
  createQueryKey('tagsList', options)

export const tagsListOptions = (options?: Options<TagsListData>) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await tagsList({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true
      })

      return data
    },
    queryKey: tagsListQueryKey(options)
  })
}

export const tagsListInfiniteQueryKey = (
  options?: Options<TagsListData>
): QueryKey<Options<TagsListData>> => createQueryKey('tagsList', options, true)

export const tagsListInfiniteOptions = (options?: Options<TagsListData>) => {
  return infiniteQueryOptions<
    TagsListResponse,
    AxiosError<DefaultError>,
    InfiniteData<TagsListResponse>,
    QueryKey<Options<TagsListData>>,
    | number
    | Pick<
        QueryKey<Options<TagsListData>>[0],
        'body' | 'headers' | 'path' | 'query'
      >
  >(
    // @ts-ignore
    {
      queryFn: async ({ pageParam, queryKey, signal }) => {
        // @ts-ignore
        const page: Pick<
          QueryKey<Options<TagsListData>>[0],
          'body' | 'headers' | 'path' | 'query'
        > =
          typeof pageParam === 'object'
            ? pageParam
            : {
                query: {
                  page: pageParam
                }
              }
        const params = createInfiniteParams(queryKey, page)
        const { data } = await tagsList({
          ...options,
          ...params,
          signal,
          throwOnError: true
        })

        return data
      },
      queryKey: tagsListInfiniteQueryKey(options)
    }
  )
}

export const tagsCreateQueryKey = (options: Options<TagsCreateData>) =>
  createQueryKey('tagsCreate', options)

export const tagsCreateOptions = (options: Options<TagsCreateData>) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await tagsCreate({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true
      })

      return data
    },
    queryKey: tagsCreateQueryKey(options)
  })
}

export const tagsCreateMutation = (
  options?: Partial<Options<TagsCreateData>>
): UseMutationOptions<
  TagsCreateResponse,
  AxiosError<DefaultError>,
  Options<TagsCreateData>
> => {
  const mutationOptions: UseMutationOptions<
    TagsCreateResponse,
    AxiosError<DefaultError>,
    Options<TagsCreateData>
  > = {
    mutationFn: async (localOptions) => {
      const { data } = await tagsCreate({
        ...options,
        ...localOptions,
        throwOnError: true
      })

      return data
    }
  }

  return mutationOptions
}

export const tagsDestroyMutation = (
  options?: Partial<Options<TagsDestroyData>>
): UseMutationOptions<
  TagsDestroyResponse,
  AxiosError<DefaultError>,
  Options<TagsDestroyData>
> => {
  const mutationOptions: UseMutationOptions<
    TagsDestroyResponse,
    AxiosError<DefaultError>,
    Options<TagsDestroyData>
  > = {
    mutationFn: async (localOptions) => {
      const { data } = await tagsDestroy({
        ...options,
        ...localOptions,
        throwOnError: true
      })

      return data
    }
  }

  return mutationOptions
}

export const tagsRetrieveQueryKey = (options: Options<TagsRetrieveData>) =>
  createQueryKey('tagsRetrieve', options)

export const tagsRetrieveOptions = (options: Options<TagsRetrieveData>) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await tagsRetrieve({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true
      })

      return data
    },
    queryKey: tagsRetrieveQueryKey(options)
  })
}

export const tagsPartialUpdateMutation = (
  options?: Partial<Options<TagsPartialUpdateData>>
): UseMutationOptions<
  TagsPartialUpdateResponse,
  AxiosError<DefaultError>,
  Options<TagsPartialUpdateData>
> => {
  const mutationOptions: UseMutationOptions<
    TagsPartialUpdateResponse,
    AxiosError<DefaultError>,
    Options<TagsPartialUpdateData>
  > = {
    mutationFn: async (localOptions) => {
      const { data } = await tagsPartialUpdate({
        ...options,
        ...localOptions,
        throwOnError: true
      })

      return data
    }
  }

  return mutationOptions
}

export const tagsUpdateMutation = (
  options?: Partial<Options<TagsUpdateData>>
): UseMutationOptions<
  TagsUpdateResponse,
  AxiosError<DefaultError>,
  Options<TagsUpdateData>
> => {
  const mutationOptions: UseMutationOptions<
    TagsUpdateResponse,
    AxiosError<DefaultError>,
    Options<TagsUpdateData>
  > = {
    mutationFn: async (localOptions) => {
      const { data } = await tagsUpdate({
        ...options,
        ...localOptions,
        throwOnError: true
      })

      return data
    }
  }

  return mutationOptions
}

export const tagsColorsRetrieveQueryKey = (
  options?: Options<TagsColorsRetrieveData>
) => createQueryKey('tagsColorsRetrieve', options)

export const tagsColorsRetrieveOptions = (
  options?: Options<TagsColorsRetrieveData>
) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await tagsColorsRetrieve({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true
      })

      return data
    },
    queryKey: tagsColorsRetrieveQueryKey(options)
  })
}

export const tagsListListQueryKey = (options?: Options<TagsListListData>) =>
  createQueryKey('tagsListList', options)

export const tagsListListOptions = (options?: Options<TagsListListData>) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await tagsListList({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true
      })

      return data
    },
    queryKey: tagsListListQueryKey(options)
  })
}

export const tagsListListInfiniteQueryKey = (
  options?: Options<TagsListListData>
): QueryKey<Options<TagsListListData>> =>
  createQueryKey('tagsListList', options, true)

export const tagsListListInfiniteOptions = (
  options?: Options<TagsListListData>
) => {
  return infiniteQueryOptions<
    TagsListListResponse,
    AxiosError<DefaultError>,
    InfiniteData<TagsListListResponse>,
    QueryKey<Options<TagsListListData>>,
    | number
    | Pick<
        QueryKey<Options<TagsListListData>>[0],
        'body' | 'headers' | 'path' | 'query'
      >
  >(
    // @ts-ignore
    {
      queryFn: async ({ pageParam, queryKey, signal }) => {
        // @ts-ignore
        const page: Pick<
          QueryKey<Options<TagsListListData>>[0],
          'body' | 'headers' | 'path' | 'query'
        > =
          typeof pageParam === 'object'
            ? pageParam
            : {
                query: {
                  page: pageParam
                }
              }
        const params = createInfiniteParams(queryKey, page)
        const { data } = await tagsListList({
          ...options,
          ...params,
          signal,
          throwOnError: true
        })

        return data
      },
      queryKey: tagsListListInfiniteQueryKey(options)
    }
  )
}

export const taskStatusesListQueryKey = (
  options?: Options<TaskStatusesListData>
) => createQueryKey('taskStatusesList', options)

export const taskStatusesListOptions = (
  options?: Options<TaskStatusesListData>
) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await taskStatusesList({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true
      })

      return data
    },
    queryKey: taskStatusesListQueryKey(options)
  })
}

export const taskStatusesListInfiniteQueryKey = (
  options?: Options<TaskStatusesListData>
): QueryKey<Options<TaskStatusesListData>> =>
  createQueryKey('taskStatusesList', options, true)

export const taskStatusesListInfiniteOptions = (
  options?: Options<TaskStatusesListData>
) => {
  return infiniteQueryOptions<
    TaskStatusesListResponse,
    AxiosError<DefaultError>,
    InfiniteData<TaskStatusesListResponse>,
    QueryKey<Options<TaskStatusesListData>>,
    | number
    | Pick<
        QueryKey<Options<TaskStatusesListData>>[0],
        'body' | 'headers' | 'path' | 'query'
      >
  >(
    // @ts-ignore
    {
      queryFn: async ({ pageParam, queryKey, signal }) => {
        // @ts-ignore
        const page: Pick<
          QueryKey<Options<TaskStatusesListData>>[0],
          'body' | 'headers' | 'path' | 'query'
        > =
          typeof pageParam === 'object'
            ? pageParam
            : {
                query: {
                  page: pageParam
                }
              }
        const params = createInfiniteParams(queryKey, page)
        const { data } = await taskStatusesList({
          ...options,
          ...params,
          signal,
          throwOnError: true
        })

        return data
      },
      queryKey: taskStatusesListInfiniteQueryKey(options)
    }
  )
}

export const taskStatusesCreateQueryKey = (
  options: Options<TaskStatusesCreateData>
) => createQueryKey('taskStatusesCreate', options)

export const taskStatusesCreateOptions = (
  options: Options<TaskStatusesCreateData>
) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await taskStatusesCreate({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true
      })

      return data
    },
    queryKey: taskStatusesCreateQueryKey(options)
  })
}

export const taskStatusesCreateMutation = (
  options?: Partial<Options<TaskStatusesCreateData>>
): UseMutationOptions<
  TaskStatusesCreateResponse,
  AxiosError<DefaultError>,
  Options<TaskStatusesCreateData>
> => {
  const mutationOptions: UseMutationOptions<
    TaskStatusesCreateResponse,
    AxiosError<DefaultError>,
    Options<TaskStatusesCreateData>
  > = {
    mutationFn: async (localOptions) => {
      const { data } = await taskStatusesCreate({
        ...options,
        ...localOptions,
        throwOnError: true
      })

      return data
    }
  }

  return mutationOptions
}

export const taskStatusesDestroyMutation = (
  options?: Partial<Options<TaskStatusesDestroyData>>
): UseMutationOptions<
  TaskStatusesDestroyResponse,
  AxiosError<DefaultError>,
  Options<TaskStatusesDestroyData>
> => {
  const mutationOptions: UseMutationOptions<
    TaskStatusesDestroyResponse,
    AxiosError<DefaultError>,
    Options<TaskStatusesDestroyData>
  > = {
    mutationFn: async (localOptions) => {
      const { data } = await taskStatusesDestroy({
        ...options,
        ...localOptions,
        throwOnError: true
      })

      return data
    }
  }

  return mutationOptions
}

export const taskStatusesRetrieveQueryKey = (
  options: Options<TaskStatusesRetrieveData>
) => createQueryKey('taskStatusesRetrieve', options)

export const taskStatusesRetrieveOptions = (
  options: Options<TaskStatusesRetrieveData>
) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await taskStatusesRetrieve({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true
      })

      return data
    },
    queryKey: taskStatusesRetrieveQueryKey(options)
  })
}

export const taskStatusesPartialUpdateMutation = (
  options?: Partial<Options<TaskStatusesPartialUpdateData>>
): UseMutationOptions<
  TaskStatusesPartialUpdateResponse,
  AxiosError<DefaultError>,
  Options<TaskStatusesPartialUpdateData>
> => {
  const mutationOptions: UseMutationOptions<
    TaskStatusesPartialUpdateResponse,
    AxiosError<DefaultError>,
    Options<TaskStatusesPartialUpdateData>
  > = {
    mutationFn: async (localOptions) => {
      const { data } = await taskStatusesPartialUpdate({
        ...options,
        ...localOptions,
        throwOnError: true
      })

      return data
    }
  }

  return mutationOptions
}

export const taskStatusesUpdateMutation = (
  options?: Partial<Options<TaskStatusesUpdateData>>
): UseMutationOptions<
  TaskStatusesUpdateResponse,
  AxiosError<DefaultError>,
  Options<TaskStatusesUpdateData>
> => {
  const mutationOptions: UseMutationOptions<
    TaskStatusesUpdateResponse,
    AxiosError<DefaultError>,
    Options<TaskStatusesUpdateData>
  > = {
    mutationFn: async (localOptions) => {
      const { data } = await taskStatusesUpdate({
        ...options,
        ...localOptions,
        throwOnError: true
      })

      return data
    }
  }

  return mutationOptions
}

export const taskStatusesListListQueryKey = (
  options?: Options<TaskStatusesListListData>
) => createQueryKey('taskStatusesListList', options)

export const taskStatusesListListOptions = (
  options?: Options<TaskStatusesListListData>
) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await taskStatusesListList({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true
      })

      return data
    },
    queryKey: taskStatusesListListQueryKey(options)
  })
}

export const taskStatusesListListInfiniteQueryKey = (
  options?: Options<TaskStatusesListListData>
): QueryKey<Options<TaskStatusesListListData>> =>
  createQueryKey('taskStatusesListList', options, true)

export const taskStatusesListListInfiniteOptions = (
  options?: Options<TaskStatusesListListData>
) => {
  return infiniteQueryOptions<
    TaskStatusesListListResponse,
    AxiosError<DefaultError>,
    InfiniteData<TaskStatusesListListResponse>,
    QueryKey<Options<TaskStatusesListListData>>,
    | number
    | Pick<
        QueryKey<Options<TaskStatusesListListData>>[0],
        'body' | 'headers' | 'path' | 'query'
      >
  >(
    // @ts-ignore
    {
      queryFn: async ({ pageParam, queryKey, signal }) => {
        // @ts-ignore
        const page: Pick<
          QueryKey<Options<TaskStatusesListListData>>[0],
          'body' | 'headers' | 'path' | 'query'
        > =
          typeof pageParam === 'object'
            ? pageParam
            : {
                query: {
                  page: pageParam
                }
              }
        const params = createInfiniteParams(queryKey, page)
        const { data } = await taskStatusesListList({
          ...options,
          ...params,
          signal,
          throwOnError: true
        })

        return data
      },
      queryKey: taskStatusesListListInfiniteQueryKey(options)
    }
  )
}

export const taskTypesListQueryKey = (options?: Options<TaskTypesListData>) =>
  createQueryKey('taskTypesList', options)

export const taskTypesListOptions = (options?: Options<TaskTypesListData>) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await taskTypesList({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true
      })

      return data
    },
    queryKey: taskTypesListQueryKey(options)
  })
}

export const taskTypesListInfiniteQueryKey = (
  options?: Options<TaskTypesListData>
): QueryKey<Options<TaskTypesListData>> =>
  createQueryKey('taskTypesList', options, true)

export const taskTypesListInfiniteOptions = (
  options?: Options<TaskTypesListData>
) => {
  return infiniteQueryOptions<
    TaskTypesListResponse,
    AxiosError<DefaultError>,
    InfiniteData<TaskTypesListResponse>,
    QueryKey<Options<TaskTypesListData>>,
    | number
    | Pick<
        QueryKey<Options<TaskTypesListData>>[0],
        'body' | 'headers' | 'path' | 'query'
      >
  >(
    // @ts-ignore
    {
      queryFn: async ({ pageParam, queryKey, signal }) => {
        // @ts-ignore
        const page: Pick<
          QueryKey<Options<TaskTypesListData>>[0],
          'body' | 'headers' | 'path' | 'query'
        > =
          typeof pageParam === 'object'
            ? pageParam
            : {
                query: {
                  page: pageParam
                }
              }
        const params = createInfiniteParams(queryKey, page)
        const { data } = await taskTypesList({
          ...options,
          ...params,
          signal,
          throwOnError: true
        })

        return data
      },
      queryKey: taskTypesListInfiniteQueryKey(options)
    }
  )
}

export const taskTypesCreateQueryKey = (
  options: Options<TaskTypesCreateData>
) => createQueryKey('taskTypesCreate', options)

export const taskTypesCreateOptions = (
  options: Options<TaskTypesCreateData>
) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await taskTypesCreate({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true
      })

      return data
    },
    queryKey: taskTypesCreateQueryKey(options)
  })
}

export const taskTypesCreateMutation = (
  options?: Partial<Options<TaskTypesCreateData>>
): UseMutationOptions<
  TaskTypesCreateResponse,
  AxiosError<DefaultError>,
  Options<TaskTypesCreateData>
> => {
  const mutationOptions: UseMutationOptions<
    TaskTypesCreateResponse,
    AxiosError<DefaultError>,
    Options<TaskTypesCreateData>
  > = {
    mutationFn: async (localOptions) => {
      const { data } = await taskTypesCreate({
        ...options,
        ...localOptions,
        throwOnError: true
      })

      return data
    }
  }

  return mutationOptions
}

export const taskTypesDestroyMutation = (
  options?: Partial<Options<TaskTypesDestroyData>>
): UseMutationOptions<
  TaskTypesDestroyResponse,
  AxiosError<DefaultError>,
  Options<TaskTypesDestroyData>
> => {
  const mutationOptions: UseMutationOptions<
    TaskTypesDestroyResponse,
    AxiosError<DefaultError>,
    Options<TaskTypesDestroyData>
  > = {
    mutationFn: async (localOptions) => {
      const { data } = await taskTypesDestroy({
        ...options,
        ...localOptions,
        throwOnError: true
      })

      return data
    }
  }

  return mutationOptions
}

export const taskTypesRetrieveQueryKey = (
  options: Options<TaskTypesRetrieveData>
) => createQueryKey('taskTypesRetrieve', options)

export const taskTypesRetrieveOptions = (
  options: Options<TaskTypesRetrieveData>
) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await taskTypesRetrieve({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true
      })

      return data
    },
    queryKey: taskTypesRetrieveQueryKey(options)
  })
}

export const taskTypesPartialUpdateMutation = (
  options?: Partial<Options<TaskTypesPartialUpdateData>>
): UseMutationOptions<
  TaskTypesPartialUpdateResponse,
  AxiosError<DefaultError>,
  Options<TaskTypesPartialUpdateData>
> => {
  const mutationOptions: UseMutationOptions<
    TaskTypesPartialUpdateResponse,
    AxiosError<DefaultError>,
    Options<TaskTypesPartialUpdateData>
  > = {
    mutationFn: async (localOptions) => {
      const { data } = await taskTypesPartialUpdate({
        ...options,
        ...localOptions,
        throwOnError: true
      })

      return data
    }
  }

  return mutationOptions
}

export const taskTypesUpdateMutation = (
  options?: Partial<Options<TaskTypesUpdateData>>
): UseMutationOptions<
  TaskTypesUpdateResponse,
  AxiosError<DefaultError>,
  Options<TaskTypesUpdateData>
> => {
  const mutationOptions: UseMutationOptions<
    TaskTypesUpdateResponse,
    AxiosError<DefaultError>,
    Options<TaskTypesUpdateData>
  > = {
    mutationFn: async (localOptions) => {
      const { data } = await taskTypesUpdate({
        ...options,
        ...localOptions,
        throwOnError: true
      })

      return data
    }
  }

  return mutationOptions
}

export const taskTypesAllRetrieveQueryKey = (
  options?: Options<TaskTypesAllRetrieveData>
) => createQueryKey('taskTypesAllRetrieve', options)

export const taskTypesAllRetrieveOptions = (
  options?: Options<TaskTypesAllRetrieveData>
) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await taskTypesAllRetrieve({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true
      })

      return data
    },
    queryKey: taskTypesAllRetrieveQueryKey(options)
  })
}

export const taskTypesGenericListQueryKey = (
  options?: Options<TaskTypesGenericListData>
) => createQueryKey('taskTypesGenericList', options)

export const taskTypesGenericListOptions = (
  options?: Options<TaskTypesGenericListData>
) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await taskTypesGenericList({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true
      })

      return data
    },
    queryKey: taskTypesGenericListQueryKey(options)
  })
}

export const taskTypesGenericListInfiniteQueryKey = (
  options?: Options<TaskTypesGenericListData>
): QueryKey<Options<TaskTypesGenericListData>> =>
  createQueryKey('taskTypesGenericList', options, true)

export const taskTypesGenericListInfiniteOptions = (
  options?: Options<TaskTypesGenericListData>
) => {
  return infiniteQueryOptions<
    TaskTypesGenericListResponse,
    AxiosError<DefaultError>,
    InfiniteData<TaskTypesGenericListResponse>,
    QueryKey<Options<TaskTypesGenericListData>>,
    | number
    | Pick<
        QueryKey<Options<TaskTypesGenericListData>>[0],
        'body' | 'headers' | 'path' | 'query'
      >
  >(
    // @ts-ignore
    {
      queryFn: async ({ pageParam, queryKey, signal }) => {
        // @ts-ignore
        const page: Pick<
          QueryKey<Options<TaskTypesGenericListData>>[0],
          'body' | 'headers' | 'path' | 'query'
        > =
          typeof pageParam === 'object'
            ? pageParam
            : {
                query: {
                  page: pageParam
                }
              }
        const params = createInfiniteParams(queryKey, page)
        const { data } = await taskTypesGenericList({
          ...options,
          ...params,
          signal,
          throwOnError: true
        })

        return data
      },
      queryKey: taskTypesGenericListInfiniteQueryKey(options)
    }
  )
}

export const taskTypesListListQueryKey = (
  options?: Options<TaskTypesListListData>
) => createQueryKey('taskTypesListList', options)

export const taskTypesListListOptions = (
  options?: Options<TaskTypesListListData>
) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await taskTypesListList({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true
      })

      return data
    },
    queryKey: taskTypesListListQueryKey(options)
  })
}

export const taskTypesListListInfiniteQueryKey = (
  options?: Options<TaskTypesListListData>
): QueryKey<Options<TaskTypesListListData>> =>
  createQueryKey('taskTypesListList', options, true)

export const taskTypesListListInfiniteOptions = (
  options?: Options<TaskTypesListListData>
) => {
  return infiniteQueryOptions<
    TaskTypesListListResponse,
    AxiosError<DefaultError>,
    InfiniteData<TaskTypesListListResponse>,
    QueryKey<Options<TaskTypesListListData>>,
    | number
    | Pick<
        QueryKey<Options<TaskTypesListListData>>[0],
        'body' | 'headers' | 'path' | 'query'
      >
  >(
    // @ts-ignore
    {
      queryFn: async ({ pageParam, queryKey, signal }) => {
        // @ts-ignore
        const page: Pick<
          QueryKey<Options<TaskTypesListListData>>[0],
          'body' | 'headers' | 'path' | 'query'
        > =
          typeof pageParam === 'object'
            ? pageParam
            : {
                query: {
                  page: pageParam
                }
              }
        const params = createInfiniteParams(queryKey, page)
        const { data } = await taskTypesListList({
          ...options,
          ...params,
          signal,
          throwOnError: true
        })

        return data
      },
      queryKey: taskTypesListListInfiniteQueryKey(options)
    }
  )
}

export const taskTypesSystemListQueryKey = (
  options?: Options<TaskTypesSystemListData>
) => createQueryKey('taskTypesSystemList', options)

export const taskTypesSystemListOptions = (
  options?: Options<TaskTypesSystemListData>
) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await taskTypesSystemList({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true
      })

      return data
    },
    queryKey: taskTypesSystemListQueryKey(options)
  })
}

export const taskTypesSystemListInfiniteQueryKey = (
  options?: Options<TaskTypesSystemListData>
): QueryKey<Options<TaskTypesSystemListData>> =>
  createQueryKey('taskTypesSystemList', options, true)

export const taskTypesSystemListInfiniteOptions = (
  options?: Options<TaskTypesSystemListData>
) => {
  return infiniteQueryOptions<
    TaskTypesSystemListResponse,
    AxiosError<DefaultError>,
    InfiniteData<TaskTypesSystemListResponse>,
    QueryKey<Options<TaskTypesSystemListData>>,
    | number
    | Pick<
        QueryKey<Options<TaskTypesSystemListData>>[0],
        'body' | 'headers' | 'path' | 'query'
      >
  >(
    // @ts-ignore
    {
      queryFn: async ({ pageParam, queryKey, signal }) => {
        // @ts-ignore
        const page: Pick<
          QueryKey<Options<TaskTypesSystemListData>>[0],
          'body' | 'headers' | 'path' | 'query'
        > =
          typeof pageParam === 'object'
            ? pageParam
            : {
                query: {
                  page: pageParam
                }
              }
        const params = createInfiniteParams(queryKey, page)
        const { data } = await taskTypesSystemList({
          ...options,
          ...params,
          signal,
          throwOnError: true
        })

        return data
      },
      queryKey: taskTypesSystemListInfiniteQueryKey(options)
    }
  )
}

export const tasksListQueryKey = (options?: Options<TasksListData>) =>
  createQueryKey('tasksList', options)

export const tasksListOptions = (options?: Options<TasksListData>) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await tasksList({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true
      })

      return data
    },
    queryKey: tasksListQueryKey(options)
  })
}

export const tasksListInfiniteQueryKey = (
  options?: Options<TasksListData>
): QueryKey<Options<TasksListData>> =>
  createQueryKey('tasksList', options, true)

export const tasksListInfiniteOptions = (options?: Options<TasksListData>) => {
  return infiniteQueryOptions<
    TasksListResponse,
    AxiosError<DefaultError>,
    InfiniteData<TasksListResponse>,
    QueryKey<Options<TasksListData>>,
    | number
    | Pick<
        QueryKey<Options<TasksListData>>[0],
        'body' | 'headers' | 'path' | 'query'
      >
  >(
    // @ts-ignore
    {
      queryFn: async ({ pageParam, queryKey, signal }) => {
        // @ts-ignore
        const page: Pick<
          QueryKey<Options<TasksListData>>[0],
          'body' | 'headers' | 'path' | 'query'
        > =
          typeof pageParam === 'object'
            ? pageParam
            : {
                query: {
                  page: pageParam
                }
              }
        const params = createInfiniteParams(queryKey, page)
        const { data } = await tasksList({
          ...options,
          ...params,
          signal,
          throwOnError: true
        })

        return data
      },
      queryKey: tasksListInfiniteQueryKey(options)
    }
  )
}

export const tasksCreateQueryKey = (options: Options<TasksCreateData>) =>
  createQueryKey('tasksCreate', options)

export const tasksCreateOptions = (options: Options<TasksCreateData>) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await tasksCreate({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true
      })

      return data
    },
    queryKey: tasksCreateQueryKey(options)
  })
}

export const tasksCreateMutation = (
  options?: Partial<Options<TasksCreateData>>
): UseMutationOptions<
  TasksCreateResponse,
  AxiosError<DefaultError>,
  Options<TasksCreateData>
> => {
  const mutationOptions: UseMutationOptions<
    TasksCreateResponse,
    AxiosError<DefaultError>,
    Options<TasksCreateData>
  > = {
    mutationFn: async (localOptions) => {
      const { data } = await tasksCreate({
        ...options,
        ...localOptions,
        throwOnError: true
      })

      return data
    }
  }

  return mutationOptions
}

export const tasksDestroyMutation = (
  options?: Partial<Options<TasksDestroyData>>
): UseMutationOptions<
  TasksDestroyResponse,
  AxiosError<DefaultError>,
  Options<TasksDestroyData>
> => {
  const mutationOptions: UseMutationOptions<
    TasksDestroyResponse,
    AxiosError<DefaultError>,
    Options<TasksDestroyData>
  > = {
    mutationFn: async (localOptions) => {
      const { data } = await tasksDestroy({
        ...options,
        ...localOptions,
        throwOnError: true
      })

      return data
    }
  }

  return mutationOptions
}

export const tasksRetrieveQueryKey = (options: Options<TasksRetrieveData>) =>
  createQueryKey('tasksRetrieve', options)

export const tasksRetrieveOptions = (options: Options<TasksRetrieveData>) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await tasksRetrieve({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true
      })

      return data
    },
    queryKey: tasksRetrieveQueryKey(options)
  })
}

export const tasksPartialUpdateMutation = (
  options?: Partial<Options<TasksPartialUpdateData>>
): UseMutationOptions<
  TasksPartialUpdateResponse,
  AxiosError<DefaultError>,
  Options<TasksPartialUpdateData>
> => {
  const mutationOptions: UseMutationOptions<
    TasksPartialUpdateResponse,
    AxiosError<DefaultError>,
    Options<TasksPartialUpdateData>
  > = {
    mutationFn: async (localOptions) => {
      const { data } = await tasksPartialUpdate({
        ...options,
        ...localOptions,
        throwOnError: true
      })

      return data
    }
  }

  return mutationOptions
}

export const tasksUpdateMutation = (
  options?: Partial<Options<TasksUpdateData>>
): UseMutationOptions<
  TasksUpdateResponse,
  AxiosError<DefaultError>,
  Options<TasksUpdateData>
> => {
  const mutationOptions: UseMutationOptions<
    TasksUpdateResponse,
    AxiosError<DefaultError>,
    Options<TasksUpdateData>
  > = {
    mutationFn: async (localOptions) => {
      const { data } = await tasksUpdate({
        ...options,
        ...localOptions,
        throwOnError: true
      })

      return data
    }
  }

  return mutationOptions
}

export const tasksCompleteCreateQueryKey = (
  options: Options<TasksCompleteCreateData>
) => createQueryKey('tasksCompleteCreate', options)

export const tasksCompleteCreateOptions = (
  options: Options<TasksCompleteCreateData>
) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await tasksCompleteCreate({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true
      })

      return data
    },
    queryKey: tasksCompleteCreateQueryKey(options)
  })
}

export const tasksCompleteCreateMutation = (
  options?: Partial<Options<TasksCompleteCreateData>>
): UseMutationOptions<
  TasksCompleteCreateResponse,
  AxiosError<DefaultError>,
  Options<TasksCompleteCreateData>
> => {
  const mutationOptions: UseMutationOptions<
    TasksCompleteCreateResponse,
    AxiosError<DefaultError>,
    Options<TasksCompleteCreateData>
  > = {
    mutationFn: async (localOptions) => {
      const { data } = await tasksCompleteCreate({
        ...options,
        ...localOptions,
        throwOnError: true
      })

      return data
    }
  }

  return mutationOptions
}

export const tasksKanbanListQueryKey = (
  options?: Options<TasksKanbanListData>
) => createQueryKey('tasksKanbanList', options)

export const tasksKanbanListOptions = (
  options?: Options<TasksKanbanListData>
) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await tasksKanbanList({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true
      })

      return data
    },
    queryKey: tasksKanbanListQueryKey(options)
  })
}

export const tasksKanbanListInfiniteQueryKey = (
  options?: Options<TasksKanbanListData>
): QueryKey<Options<TasksKanbanListData>> =>
  createQueryKey('tasksKanbanList', options, true)

export const tasksKanbanListInfiniteOptions = (
  options?: Options<TasksKanbanListData>
) => {
  return infiniteQueryOptions<
    TasksKanbanListResponse,
    AxiosError<DefaultError>,
    InfiniteData<TasksKanbanListResponse>,
    QueryKey<Options<TasksKanbanListData>>,
    | number
    | Pick<
        QueryKey<Options<TasksKanbanListData>>[0],
        'body' | 'headers' | 'path' | 'query'
      >
  >(
    // @ts-ignore
    {
      queryFn: async ({ pageParam, queryKey, signal }) => {
        // @ts-ignore
        const page: Pick<
          QueryKey<Options<TasksKanbanListData>>[0],
          'body' | 'headers' | 'path' | 'query'
        > =
          typeof pageParam === 'object'
            ? pageParam
            : {
                query: {
                  page: pageParam
                }
              }
        const params = createInfiniteParams(queryKey, page)
        const { data } = await tasksKanbanList({
          ...options,
          ...params,
          signal,
          throwOnError: true
        })

        return data
      },
      queryKey: tasksKanbanListInfiniteQueryKey(options)
    }
  )
}

export const usersListQueryKey = (options?: Options<UsersListData>) =>
  createQueryKey('usersList', options)

export const usersListOptions = (options?: Options<UsersListData>) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await usersList({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true
      })

      return data
    },
    queryKey: usersListQueryKey(options)
  })
}

export const usersListInfiniteQueryKey = (
  options?: Options<UsersListData>
): QueryKey<Options<UsersListData>> =>
  createQueryKey('usersList', options, true)

export const usersListInfiniteOptions = (options?: Options<UsersListData>) => {
  return infiniteQueryOptions<
    UsersListResponse,
    AxiosError<DefaultError>,
    InfiniteData<UsersListResponse>,
    QueryKey<Options<UsersListData>>,
    | number
    | Pick<
        QueryKey<Options<UsersListData>>[0],
        'body' | 'headers' | 'path' | 'query'
      >
  >(
    // @ts-ignore
    {
      queryFn: async ({ pageParam, queryKey, signal }) => {
        // @ts-ignore
        const page: Pick<
          QueryKey<Options<UsersListData>>[0],
          'body' | 'headers' | 'path' | 'query'
        > =
          typeof pageParam === 'object'
            ? pageParam
            : {
                query: {
                  page: pageParam
                }
              }
        const params = createInfiniteParams(queryKey, page)
        const { data } = await usersList({
          ...options,
          ...params,
          signal,
          throwOnError: true
        })

        return data
      },
      queryKey: usersListInfiniteQueryKey(options)
    }
  )
}

export const usersPartialUpdateMutation = (
  options?: Partial<Options<UsersPartialUpdateData>>
): UseMutationOptions<
  UsersPartialUpdateResponse,
  AxiosError<DefaultError>,
  Options<UsersPartialUpdateData>
> => {
  const mutationOptions: UseMutationOptions<
    UsersPartialUpdateResponse,
    AxiosError<DefaultError>,
    Options<UsersPartialUpdateData>
  > = {
    mutationFn: async (localOptions) => {
      const { data } = await usersPartialUpdate({
        ...options,
        ...localOptions,
        throwOnError: true
      })

      return data
    }
  }

  return mutationOptions
}

export const usersUpdateMutation = (
  options?: Partial<Options<UsersUpdateData>>
): UseMutationOptions<
  UsersUpdateResponse,
  AxiosError<DefaultError>,
  Options<UsersUpdateData>
> => {
  const mutationOptions: UseMutationOptions<
    UsersUpdateResponse,
    AxiosError<DefaultError>,
    Options<UsersUpdateData>
  > = {
    mutationFn: async (localOptions) => {
      const { data } = await usersUpdate({
        ...options,
        ...localOptions,
        throwOnError: true
      })

      return data
    }
  }

  return mutationOptions
}

export const usersAllListQueryKey = (options?: Options<UsersAllListData>) =>
  createQueryKey('usersAllList', options)

export const usersAllListOptions = (options?: Options<UsersAllListData>) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await usersAllList({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true
      })

      return data
    },
    queryKey: usersAllListQueryKey(options)
  })
}

export const usersAllListInfiniteQueryKey = (
  options?: Options<UsersAllListData>
): QueryKey<Options<UsersAllListData>> =>
  createQueryKey('usersAllList', options, true)

export const usersAllListInfiniteOptions = (
  options?: Options<UsersAllListData>
) => {
  return infiniteQueryOptions<
    UsersAllListResponse,
    AxiosError<DefaultError>,
    InfiniteData<UsersAllListResponse>,
    QueryKey<Options<UsersAllListData>>,
    | number
    | Pick<
        QueryKey<Options<UsersAllListData>>[0],
        'body' | 'headers' | 'path' | 'query'
      >
  >(
    // @ts-ignore
    {
      queryFn: async ({ pageParam, queryKey, signal }) => {
        // @ts-ignore
        const page: Pick<
          QueryKey<Options<UsersAllListData>>[0],
          'body' | 'headers' | 'path' | 'query'
        > =
          typeof pageParam === 'object'
            ? pageParam
            : {
                query: {
                  page: pageParam
                }
              }
        const params = createInfiniteParams(queryKey, page)
        const { data } = await usersAllList({
          ...options,
          ...params,
          signal,
          throwOnError: true
        })

        return data
      },
      queryKey: usersAllListInfiniteQueryKey(options)
    }
  )
}

export const usersAllowedModulesRetrieveQueryKey = (
  options?: Options<UsersAllowedModulesRetrieveData>
) => createQueryKey('usersAllowedModulesRetrieve', options)

export const usersAllowedModulesRetrieveOptions = (
  options?: Options<UsersAllowedModulesRetrieveData>
) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await usersAllowedModulesRetrieve({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true
      })

      return data
    },
    queryKey: usersAllowedModulesRetrieveQueryKey(options)
  })
}

export const usersListListQueryKey = (options?: Options<UsersListListData>) =>
  createQueryKey('usersListList', options)

export const usersListListOptions = (options?: Options<UsersListListData>) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await usersListList({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true
      })

      return data
    },
    queryKey: usersListListQueryKey(options)
  })
}

export const usersListListInfiniteQueryKey = (
  options?: Options<UsersListListData>
): QueryKey<Options<UsersListListData>> =>
  createQueryKey('usersListList', options, true)

export const usersListListInfiniteOptions = (
  options?: Options<UsersListListData>
) => {
  return infiniteQueryOptions<
    UsersListListResponse,
    AxiosError<DefaultError>,
    InfiniteData<UsersListListResponse>,
    QueryKey<Options<UsersListListData>>,
    | number
    | Pick<
        QueryKey<Options<UsersListListData>>[0],
        'body' | 'headers' | 'path' | 'query'
      >
  >(
    // @ts-ignore
    {
      queryFn: async ({ pageParam, queryKey, signal }) => {
        // @ts-ignore
        const page: Pick<
          QueryKey<Options<UsersListListData>>[0],
          'body' | 'headers' | 'path' | 'query'
        > =
          typeof pageParam === 'object'
            ? pageParam
            : {
                query: {
                  page: pageParam
                }
              }
        const params = createInfiniteParams(queryKey, page)
        const { data } = await usersListList({
          ...options,
          ...params,
          signal,
          throwOnError: true
        })

        return data
      },
      queryKey: usersListListInfiniteQueryKey(options)
    }
  )
}

export const usersProfileRetrieveQueryKey = (
  options?: Options<UsersProfileRetrieveData>
) => createQueryKey('usersProfileRetrieve', options)

export const usersProfileRetrieveOptions = (
  options?: Options<UsersProfileRetrieveData>
) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await usersProfileRetrieve({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true
      })

      return data
    },
    queryKey: usersProfileRetrieveQueryKey(options)
  })
}

export const voipConfigurationListQueryKey = (
  options?: Options<VoipConfigurationListData>
) => createQueryKey('voipConfigurationList', options)

export const voipConfigurationListOptions = (
  options?: Options<VoipConfigurationListData>
) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await voipConfigurationList({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true
      })

      return data
    },
    queryKey: voipConfigurationListQueryKey(options)
  })
}

export const voipConfigurationListInfiniteQueryKey = (
  options?: Options<VoipConfigurationListData>
): QueryKey<Options<VoipConfigurationListData>> =>
  createQueryKey('voipConfigurationList', options, true)

export const voipConfigurationListInfiniteOptions = (
  options?: Options<VoipConfigurationListData>
) => {
  return infiniteQueryOptions<
    VoipConfigurationListResponse,
    AxiosError<DefaultError>,
    InfiniteData<VoipConfigurationListResponse>,
    QueryKey<Options<VoipConfigurationListData>>,
    | number
    | Pick<
        QueryKey<Options<VoipConfigurationListData>>[0],
        'body' | 'headers' | 'path' | 'query'
      >
  >(
    // @ts-ignore
    {
      queryFn: async ({ pageParam, queryKey, signal }) => {
        // @ts-ignore
        const page: Pick<
          QueryKey<Options<VoipConfigurationListData>>[0],
          'body' | 'headers' | 'path' | 'query'
        > =
          typeof pageParam === 'object'
            ? pageParam
            : {
                query: {
                  page: pageParam
                }
              }
        const params = createInfiniteParams(queryKey, page)
        const { data } = await voipConfigurationList({
          ...options,
          ...params,
          signal,
          throwOnError: true
        })

        return data
      },
      queryKey: voipConfigurationListInfiniteQueryKey(options)
    }
  )
}

export const voipConfigurationCreateQueryKey = (
  options: Options<VoipConfigurationCreateData>
) => createQueryKey('voipConfigurationCreate', options)

export const voipConfigurationCreateOptions = (
  options: Options<VoipConfigurationCreateData>
) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await voipConfigurationCreate({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true
      })

      return data
    },
    queryKey: voipConfigurationCreateQueryKey(options)
  })
}

export const voipConfigurationCreateMutation = (
  options?: Partial<Options<VoipConfigurationCreateData>>
): UseMutationOptions<
  VoipConfigurationCreateResponse,
  AxiosError<DefaultError>,
  Options<VoipConfigurationCreateData>
> => {
  const mutationOptions: UseMutationOptions<
    VoipConfigurationCreateResponse,
    AxiosError<DefaultError>,
    Options<VoipConfigurationCreateData>
  > = {
    mutationFn: async (localOptions) => {
      const { data } = await voipConfigurationCreate({
        ...options,
        ...localOptions,
        throwOnError: true
      })

      return data
    }
  }

  return mutationOptions
}

export const voipConfigurationDestroyMutation = (
  options?: Partial<Options<VoipConfigurationDestroyData>>
): UseMutationOptions<
  VoipConfigurationDestroyResponse,
  AxiosError<DefaultError>,
  Options<VoipConfigurationDestroyData>
> => {
  const mutationOptions: UseMutationOptions<
    VoipConfigurationDestroyResponse,
    AxiosError<DefaultError>,
    Options<VoipConfigurationDestroyData>
  > = {
    mutationFn: async (localOptions) => {
      const { data } = await voipConfigurationDestroy({
        ...options,
        ...localOptions,
        throwOnError: true
      })

      return data
    }
  }

  return mutationOptions
}

export const voipConfigurationRetrieveQueryKey = (
  options: Options<VoipConfigurationRetrieveData>
) => createQueryKey('voipConfigurationRetrieve', options)

export const voipConfigurationRetrieveOptions = (
  options: Options<VoipConfigurationRetrieveData>
) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await voipConfigurationRetrieve({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true
      })

      return data
    },
    queryKey: voipConfigurationRetrieveQueryKey(options)
  })
}

export const voipConfigurationPartialUpdateMutation = (
  options?: Partial<Options<VoipConfigurationPartialUpdateData>>
): UseMutationOptions<
  VoipConfigurationPartialUpdateResponse,
  AxiosError<DefaultError>,
  Options<VoipConfigurationPartialUpdateData>
> => {
  const mutationOptions: UseMutationOptions<
    VoipConfigurationPartialUpdateResponse,
    AxiosError<DefaultError>,
    Options<VoipConfigurationPartialUpdateData>
  > = {
    mutationFn: async (localOptions) => {
      const { data } = await voipConfigurationPartialUpdate({
        ...options,
        ...localOptions,
        throwOnError: true
      })

      return data
    }
  }

  return mutationOptions
}

export const voipConfigurationUpdateMutation = (
  options?: Partial<Options<VoipConfigurationUpdateData>>
): UseMutationOptions<
  VoipConfigurationUpdateResponse,
  AxiosError<DefaultError>,
  Options<VoipConfigurationUpdateData>
> => {
  const mutationOptions: UseMutationOptions<
    VoipConfigurationUpdateResponse,
    AxiosError<DefaultError>,
    Options<VoipConfigurationUpdateData>
  > = {
    mutationFn: async (localOptions) => {
      const { data } = await voipConfigurationUpdate({
        ...options,
        ...localOptions,
        throwOnError: true
      })

      return data
    }
  }

  return mutationOptions
}

export const voipConfigurationStatusRetrieveQueryKey = (
  options?: Options<VoipConfigurationStatusRetrieveData>
) => createQueryKey('voipConfigurationStatusRetrieve', options)

export const voipConfigurationStatusRetrieveOptions = (
  options?: Options<VoipConfigurationStatusRetrieveData>
) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await voipConfigurationStatusRetrieve({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true
      })

      return data
    },
    queryKey: voipConfigurationStatusRetrieveQueryKey(options)
  })
}

export const webhookLeadCreateQueryKey = (
  options?: Options<WebhookLeadCreateData>
) => createQueryKey('webhookLeadCreate', options)

export const webhookLeadCreateOptions = (
  options?: Options<WebhookLeadCreateData>
) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await webhookLeadCreate({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true
      })

      return data
    },
    queryKey: webhookLeadCreateQueryKey(options)
  })
}

export const webhookLeadCreateMutation = (
  options?: Partial<Options<WebhookLeadCreateData>>
): UseMutationOptions<
  WebhookLeadCreateResponse,
  AxiosError<DefaultError>,
  Options<WebhookLeadCreateData>
> => {
  const mutationOptions: UseMutationOptions<
    WebhookLeadCreateResponse,
    AxiosError<DefaultError>,
    Options<WebhookLeadCreateData>
  > = {
    mutationFn: async (localOptions) => {
      const { data } = await webhookLeadCreate({
        ...options,
        ...localOptions,
        throwOnError: true
      })

      return data
    }
  }

  return mutationOptions
}

export const webhookMinioCreateQueryKey = (
  options?: Options<WebhookMinioCreateData>
) => createQueryKey('webhookMinioCreate', options)

/**
 * Handle MINIO put and delete events webhook
 * Expected payload format:
 * {
 * "EventName": "s3:ObjectCreated:Put" | "s3:ObjectRemoved:Delete",
 * "Key": "object_name",
 * "Records": [{
 * "s3": {
 * "bucket": {
 * "name": "bucket-name"
 * },
 * "object": {
 * "key": "object_name",
 * "size": 1234,
 * "contentType": "application/pdf"
 * }
 * },
 * "source": {
 * "host": "minio-host",
 * "port": "9000"
 * }
 * }]
 * }
 */
export const webhookMinioCreateOptions = (
  options?: Options<WebhookMinioCreateData>
) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await webhookMinioCreate({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true
      })

      return data
    },
    queryKey: webhookMinioCreateQueryKey(options)
  })
}

/**
 * Handle MINIO put and delete events webhook
 * Expected payload format:
 * {
 * "EventName": "s3:ObjectCreated:Put" | "s3:ObjectRemoved:Delete",
 * "Key": "object_name",
 * "Records": [{
 * "s3": {
 * "bucket": {
 * "name": "bucket-name"
 * },
 * "object": {
 * "key": "object_name",
 * "size": 1234,
 * "contentType": "application/pdf"
 * }
 * },
 * "source": {
 * "host": "minio-host",
 * "port": "9000"
 * }
 * }]
 * }
 */
export const webhookMinioCreateMutation = (
  options?: Partial<Options<WebhookMinioCreateData>>
): UseMutationOptions<
  WebhookMinioCreateResponse,
  AxiosError<DefaultError>,
  Options<WebhookMinioCreateData>
> => {
  const mutationOptions: UseMutationOptions<
    WebhookMinioCreateResponse,
    AxiosError<DefaultError>,
    Options<WebhookMinioCreateData>
  > = {
    mutationFn: async (localOptions) => {
      const { data } = await webhookMinioCreate({
        ...options,
        ...localOptions,
        throwOnError: true
      })

      return data
    }
  }

  return mutationOptions
}

export const webhookTaskCreateQueryKey = (
  options?: Options<WebhookTaskCreateData>
) => createQueryKey('webhookTaskCreate', options)

export const webhookTaskCreateOptions = (
  options?: Options<WebhookTaskCreateData>
) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await webhookTaskCreate({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true
      })

      return data
    },
    queryKey: webhookTaskCreateQueryKey(options)
  })
}

export const webhookTaskCreateMutation = (
  options?: Partial<Options<WebhookTaskCreateData>>
): UseMutationOptions<
  WebhookTaskCreateResponse,
  AxiosError<DefaultError>,
  Options<WebhookTaskCreateData>
> => {
  const mutationOptions: UseMutationOptions<
    WebhookTaskCreateResponse,
    AxiosError<DefaultError>,
    Options<WebhookTaskCreateData>
  > = {
    mutationFn: async (localOptions) => {
      const { data } = await webhookTaskCreate({
        ...options,
        ...localOptions,
        throwOnError: true
      })

      return data
    }
  }

  return mutationOptions
}

export const webhookVoipCreateQueryKey = (
  options?: Options<WebhookVoipCreateData>
) => createQueryKey('webhookVoipCreate', options)

export const webhookVoipCreateOptions = (
  options?: Options<WebhookVoipCreateData>
) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await webhookVoipCreate({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true
      })

      return data
    },
    queryKey: webhookVoipCreateQueryKey(options)
  })
}

export const webhookVoipCreateMutation = (
  options?: Partial<Options<WebhookVoipCreateData>>
): UseMutationOptions<
  unknown,
  AxiosError<DefaultError>,
  Options<WebhookVoipCreateData>
> => {
  const mutationOptions: UseMutationOptions<
    unknown,
    AxiosError<DefaultError>,
    Options<WebhookVoipCreateData>
  > = {
    mutationFn: async (localOptions) => {
      const { data } = await webhookVoipCreate({
        ...options,
        ...localOptions,
        throwOnError: true
      })

      return data
    }
  }

  return mutationOptions
}

export const webhookWhatsappRetrieveQueryKey = (
  options?: Options<WebhookWhatsappRetrieveData>
) => createQueryKey('webhookWhatsappRetrieve', options)

export const webhookWhatsappRetrieveOptions = (
  options?: Options<WebhookWhatsappRetrieveData>
) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await webhookWhatsappRetrieve({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true
      })

      return data
    },
    queryKey: webhookWhatsappRetrieveQueryKey(options)
  })
}

export const webhookWhatsappCreateQueryKey = (
  options?: Options<WebhookWhatsappCreateData>
) => createQueryKey('webhookWhatsappCreate', options)

export const webhookWhatsappCreateOptions = (
  options?: Options<WebhookWhatsappCreateData>
) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await webhookWhatsappCreate({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true
      })

      return data
    },
    queryKey: webhookWhatsappCreateQueryKey(options)
  })
}

export const webhookWhatsappCreateMutation = (
  options?: Partial<Options<WebhookWhatsappCreateData>>
): UseMutationOptions<
  unknown,
  AxiosError<DefaultError>,
  Options<WebhookWhatsappCreateData>
> => {
  const mutationOptions: UseMutationOptions<
    unknown,
    AxiosError<DefaultError>,
    Options<WebhookWhatsappCreateData>
  > = {
    mutationFn: async (localOptions) => {
      const { data } = await webhookWhatsappCreate({
        ...options,
        ...localOptions,
        throwOnError: true
      })

      return data
    }
  }

  return mutationOptions
}

export const widgetsRetrieveQueryKey = (
  options?: Options<WidgetsRetrieveData>
) => createQueryKey('widgetsRetrieve', options)

export const widgetsRetrieveOptions = (
  options?: Options<WidgetsRetrieveData>
) => {
  return queryOptions({
    queryFn: async ({ queryKey, signal }) => {
      const { data } = await widgetsRetrieve({
        ...options,
        ...queryKey[0],
        signal,
        throwOnError: true
      })

      return data
    },
    queryKey: widgetsRetrieveQueryKey(options)
  })
}
